"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var pinyin_dict = exports.pinyin_dict = {
    "〇": "líng",
    "一": "yī",
    "丁": "dīng,zhēng",
    "丂": "kǎo,qiǎo,yú",
    "七": "qī",
    "丄": "shàng",
    "丅": "xià",
    "丆": "hǎn",
    "万": "wàn,mò",
    "丈": "zhàng",
    "三": "sān",
    "上": "shàng,shǎng",
    "下": "xià",
    "丌": "qí,jī",
    "不": "bù,fǒu",
    "与": "yǔ,yù,yú",
    "丏": "miǎn",
    "丐": "gài",
    "丑": "chǒu",
    "丒": "chǒu",
    "专": "zhuān",
    "且": "qiě,jū",
    "丕": "pī",
    "世": "shì",
    "丗": "shì",
    "丘": "qiū",
    "丙": "bǐng",
    "业": "yè",
    "丛": "cóng",
    "东": "dōng",
    "丝": "sī",
    "丞": "chéng",
    "丟": "diū",
    "丠": "qiū",
    "両": "liǎng",
    "丢": "diū",
    "丣": "yǒu",
    "两": "liǎng",
    "严": "yán",
    "並": "bìng",
    "丧": "sàng,sāng",
    "丨": "gǔn",
    "丩": "jiū",
    "个": "gè,gě",
    "丫": "yā",
    "丬": "pán",
    "中": "zhōng,zhòng",
    "丮": "jǐ",
    "丯": "jiè",
    "丰": "fēng",
    "丱": "guàn,kuàng",
    "串": "chuàn",
    "丳": "chǎn",
    "临": "lín",
    "丵": "zhuó",
    "丶": "zhǔ",
    "丷": "bā",
    "丸": "wán",
    "丹": "dān",
    "为": "wèi,wéi",
    "主": "zhǔ",
    "丼": "jǐng",
    "丽": "lì,lí",
    "举": "jǔ",
    "丿": "piě",
    "乀": "fú",
    "乁": "yí,jí",
    "乂": "yì",
    "乃": "nǎi",
    "乄": "wǔ",
    "久": "jiǔ",
    "乆": "jiǔ",
    "乇": "tuō,zhé",
    "么": "me,mó,ma,yāo",
    "义": "yì",
    "乊": "yī",
    "之": "zhī",
    "乌": "wū",
    "乍": "zhà",
    "乎": "hū",
    "乏": "fá",
    "乐": "lè,yuè,yào,lào",
    "乑": "yín",
    "乒": "pīng",
    "乓": "pāng",
    "乔": "qiáo",
    "乕": "hǔ",
    "乖": "guāi",
    "乗": "chéng,shèng",
    "乘": "chéng,shèng",
    "乙": "yǐ",
    "乚": "háo,yǐ",
    "乛": "yǐ",
    "乜": "miē,niè",
    "九": "jiǔ",
    "乞": "qǐ",
    "也": "yě",
    "习": "xí",
    "乡": "xiāng",
    "乢": "gài",
    "乣": "jiǔ",
    "乤": "xià",
    "乥": "null",
    "书": "shū",
    "乧": "dǒu",
    "乨": "shǐ",
    "乩": "jī",
    "乪": "náng",
    "乫": "jiā",
    "乬": "jù",
    "乭": "shí",
    "乮": "mǎo",
    "乯": "hū",
    "买": "mǎi",
    "乱": "luàn",
    "乲": "null",
    "乳": "rǔ",
    "乴": "xué",
    "乵": "yǎn",
    "乶": "fǔ",
    "乷": "shā",
    "乸": "nǎ",
    "乹": "qián",
    "乺": "suǒ",
    "乻": "yú",
    "乼": "zhù",
    "乽": "zhě",
    "乾": "qián,gān",
    "乿": "zhì,luàn",
    "亀": "guī",
    "亁": "qián",
    "亂": "luàn",
    "亃": "lǐn,lìn",
    "亄": "yì",
    "亅": "jué",
    "了": "le,liǎo",
    "亇": "gè,mā",
    "予": "yú,yǔ",
    "争": "zhēng",
    "亊": "shì",
    "事": "shì",
    "二": "èr",
    "亍": "chù",
    "于": "yú",
    "亏": "kuī",
    "亐": "yú",
    "云": "yún",
    "互": "hù",
    "亓": "qí",
    "五": "wǔ",
    "井": "jǐng",
    "亖": "sì",
    "亗": "suì",
    "亘": "gèn",
    "亙": "gèn",
    "亚": "yà",
    "些": "xiē,suò",
    "亜": "yà",
    "亝": "qí,zhāi",
    "亞": "yà,yā",
    "亟": "jí,qì",
    "亠": "tóu",
    "亡": "wáng,wú",
    "亢": "kàng",
    "亣": "dà",
    "交": "jiāo",
    "亥": "hài",
    "亦": "yì",
    "产": "chǎn",
    "亨": "hēng,pēng",
    "亩": "mǔ",
    "亪": "ye",
    "享": "xiǎng",
    "京": "jīng",
    "亭": "tíng",
    "亮": "liàng",
    "亯": "xiǎng",
    "亰": "jīng",
    "亱": "yè",
    "亲": "qīn,qìng",
    "亳": "bó",
    "亴": "yòu",
    "亵": "xiè",
    "亶": "dǎn,dàn",
    "亷": "lián",
    "亸": "duǒ",
    "亹": "wěi,mén",
    "人": "rén",
    "亻": "rén",
    "亼": "jí",
    "亽": "jí",
    "亾": "wáng",
    "亿": "yì",
    "什": "shén,shí",
    "仁": "rén",
    "仂": "lè",
    "仃": "dīng",
    "仄": "zè",
    "仅": "jǐn,jìn",
    "仆": "pū,pú",
    "仇": "chóu,qiú",
    "仈": "bā",
    "仉": "zhǎng",
    "今": "jīn",
    "介": "jiè",
    "仌": "bīng",
    "仍": "réng",
    "从": "cóng,zòng",
    "仏": "fó",
    "仐": "jīn,sǎn",
    "仑": "lún",
    "仒": "bīng",
    "仓": "cāng",
    "仔": "zǐ,zī,zǎi",
    "仕": "shì",
    "他": "tā",
    "仗": "zhàng",
    "付": "fù",
    "仙": "xiān",
    "仚": "xiān",
    "仛": "tuō,chà,duó",
    "仜": "hóng",
    "仝": "tóng",
    "仞": "rèn",
    "仟": "qiān",
    "仠": "gǎn,hàn",
    "仡": "yì,gē",
    "仢": "bó",
    "代": "dài",
    "令": "lìng,líng,lǐng",
    "以": "yǐ",
    "仦": "chào",
    "仧": "cháng,zhǎng",
    "仨": "sā",
    "仩": "cháng",
    "仪": "yí",
    "仫": "mù",
    "们": "mén",
    "仭": "rèn",
    "仮": "fǎn",
    "仯": "chào,miǎo",
    "仰": "yǎng,áng",
    "仱": "qián",
    "仲": "zhòng",
    "仳": "pǐ,pí",
    "仴": "wò",
    "仵": "wǔ",
    "件": "jiàn",
    "价": "jià,jiè,jie",
    "仸": "yǎo,fó",
    "仹": "fēng",
    "仺": "cāng",
    "任": "rèn,rén",
    "仼": "wáng",
    "份": "fèn,bīn",
    "仾": "dī",
    "仿": "fǎng",
    "伀": "zhōng",
    "企": "qǐ",
    "伂": "pèi",
    "伃": "yú",
    "伄": "diào",
    "伅": "dùn",
    "伆": "wěn",
    "伇": "yì",
    "伈": "xǐn",
    "伉": "kàng",
    "伊": "yī",
    "伋": "jí",
    "伌": "ài",
    "伍": "wǔ",
    "伎": "jì,qí",
    "伏": "fú",
    "伐": "fá",
    "休": "xiū,xǔ",
    "伒": "jìn,yín",
    "伓": "pī",
    "伔": "dǎn",
    "伕": "fū",
    "伖": "tǎng",
    "众": "zhòng",
    "优": "yōu",
    "伙": "huǒ",
    "会": "huì,kuài",
    "伛": "yǔ",
    "伜": "cuì",
    "伝": "yún",
    "伞": "sǎn",
    "伟": "wěi",
    "传": "chuán,zhuàn",
    "伡": "chē,jū",
    "伢": "yá",
    "伣": "qiàn",
    "伤": "shāng",
    "伥": "chāng",
    "伦": "lún",
    "伧": "cāng,chen",
    "伨": "xùn",
    "伩": "xìn",
    "伪": "wěi",
    "伫": "zhù",
    "伬": "chǐ",
    "伭": "xián,xuán",
    "伮": "nú,nǔ",
    "伯": "bó,bǎi,bà",
    "估": "gū,gù",
    "伱": "nǐ",
    "伲": "nǐ,nì",
    "伳": "xiè",
    "伴": "bàn",
    "伵": "xù",
    "伶": "líng",
    "伷": "zhòu",
    "伸": "shēn",
    "伹": "qū",
    "伺": "cì,sì",
    "伻": "bēng",
    "似": "sì,shì",
    "伽": "jiā,qié,gā",
    "伾": "pī",
    "伿": "yì",
    "佀": "sì",
    "佁": "yǐ,chì",
    "佂": "zhēng",
    "佃": "diàn,tián",
    "佄": "hān,gàn",
    "佅": "mài",
    "但": "dàn",
    "佇": "zhù",
    "佈": "bù",
    "佉": "qū",
    "佊": "bǐ",
    "佋": "zhāo,shào",
    "佌": "cǐ",
    "位": "wèi",
    "低": "dī",
    "住": "zhù",
    "佐": "zuǒ",
    "佑": "yòu",
    "佒": "yǎng",
    "体": "tǐ,tī",
    "佔": "zhàn,diān",
    "何": "hé,hē,hè",
    "佖": "bì",
    "佗": "tuó",
    "佘": "shé",
    "余": "yú",
    "佚": "yì,dié",
    "佛": "fó,fú,bì,bó",
    "作": "zuò",
    "佝": "gōu,kòu",
    "佞": "nìng",
    "佟": "tóng",
    "你": "nǐ",
    "佡": "xiān",
    "佢": "qú",
    "佣": "yōng,yòng",
    "佤": "wǎ",
    "佥": "qiān",
    "佦": "yòu",
    "佧": "kǎ",
    "佨": "bāo",
    "佩": "pèi",
    "佪": "huí,huái",
    "佫": "gé",
    "佬": "lǎo",
    "佭": "xiáng",
    "佮": "gé",
    "佯": "yáng",
    "佰": "bǎi",
    "佱": "fǎ",
    "佲": "mǐng",
    "佳": "jiā",
    "佴": "èr,nài",
    "併": "bìng",
    "佶": "jí",
    "佷": "hěn",
    "佸": "huó",
    "佹": "guǐ",
    "佺": "quán",
    "佻": "tiāo",
    "佼": "jiǎo",
    "佽": "cì",
    "佾": "yì",
    "使": "shǐ",
    "侀": "xíng",
    "侁": "shēn",
    "侂": "tuō",
    "侃": "kǎn",
    "侄": "zhí",
    "侅": "gāi",
    "來": "lái",
    "侇": "yí",
    "侈": "chǐ",
    "侉": "kuǎ",
    "侊": "gōng",
    "例": "lì",
    "侌": "yīn",
    "侍": "shì",
    "侎": "mǐ",
    "侏": "zhū",
    "侐": "xù",
    "侑": "yòu",
    "侒": "ān",
    "侓": "lù",
    "侔": "móu",
    "侕": "ér",
    "侖": "lún",
    "侗": "dòng,tóng,tǒng",
    "侘": "chà",
    "侙": "chì",
    "侚": "xùn",
    "供": "gòng,gōng",
    "侜": "zhōu",
    "依": "yī",
    "侞": "rú",
    "侟": "cún,jiàn",
    "侠": "xiá",
    "価": "sì",
    "侢": "dài",
    "侣": "lǚ",
    "侤": "ta",
    "侥": "jiǎo,yáo",
    "侦": "zhēn",
    "侧": "cè,zè,zhāi",
    "侨": "qiáo",
    "侩": "kuài",
    "侪": "chái",
    "侫": "nìng",
    "侬": "nóng",
    "侭": "jǐn",
    "侮": "wǔ",
    "侯": "hóu,hòu",
    "侰": "jiǒng",
    "侱": "chěng,tǐng",
    "侲": "zhèn,zhēn",
    "侳": "zuò",
    "侴": "hào",
    "侵": "qīn",
    "侶": "lǚ",
    "侷": "jú",
    "侸": "shù,dōu",
    "侹": "tǐng",
    "侺": "shèn",
    "侻": "tuó,tuì",
    "侼": "bó",
    "侽": "nán",
    "侾": "xiāo",
    "便": "biàn,pián",
    "俀": "tuǐ",
    "俁": "yǔ",
    "係": "xì",
    "促": "cù",
    "俄": "é",
    "俅": "qiú",
    "俆": "xú",
    "俇": "guàng",
    "俈": "kù",
    "俉": "wù",
    "俊": "jùn",
    "俋": "yì",
    "俌": "fǔ",
    "俍": "liáng",
    "俎": "zǔ",
    "俏": "qiào,xiào",
    "俐": "lì",
    "俑": "yǒng",
    "俒": "hùn",
    "俓": "jìng",
    "俔": "qiàn",
    "俕": "sàn",
    "俖": "pěi",
    "俗": "sú",
    "俘": "fú",
    "俙": "xī",
    "俚": "lǐ",
    "俛": "fǔ",
    "俜": "pīng",
    "保": "bǎo",
    "俞": "yú,yù,shù",
    "俟": "sì,qí",
    "俠": "xiá",
    "信": "xìn,shēn",
    "俢": "xiū",
    "俣": "yǔ",
    "俤": "dì",
    "俥": "chē,jū",
    "俦": "chóu",
    "俧": "zhì",
    "俨": "yǎn",
    "俩": "liǎng,liǎ",
    "俪": "lì",
    "俫": "lái",
    "俬": "sī",
    "俭": "jiǎn",
    "修": "xiū",
    "俯": "fǔ",
    "俰": "huò",
    "俱": "jù",
    "俲": "xiào",
    "俳": "pái",
    "俴": "jiàn",
    "俵": "biào",
    "俶": "chù,tì",
    "俷": "fèi",
    "俸": "fèng",
    "俹": "yà",
    "俺": "ǎn",
    "俻": "bèi",
    "俼": "yù",
    "俽": "xīn",
    "俾": "bǐ",
    "俿": "hǔ,chí",
    "倀": "chāng",
    "倁": "zhī",
    "倂": "bìng",
    "倃": "jiù",
    "倄": "yáo",
    "倅": "cuì,zú",
    "倆": "liǎng,liǎ",
    "倇": "wǎn",
    "倈": "lái",
    "倉": "cāng",
    "倊": "zǒng",
    "個": "gè,gě",
    "倌": "guān",
    "倍": "bèi",
    "倎": "tiǎn",
    "倏": "shū",
    "倐": "shū",
    "們": "mén",
    "倒": "dǎo,dào",
    "倓": "tán,tàn",
    "倔": "juè,jué",
    "倕": "chuí",
    "倖": "xìng",
    "倗": "péng",
    "倘": "tǎng,cháng",
    "候": "hòu",
    "倚": "yǐ",
    "倛": "qī",
    "倜": "tì",
    "倝": "gàn",
    "倞": "liàng,jìng",
    "借": "jiè",
    "倠": "suī",
    "倡": "chàng,chāng",
    "倢": "jié",
    "倣": "fǎng",
    "値": "zhí",
    "倥": "kōng,kǒng",
    "倦": "juàn",
    "倧": "zōng",
    "倨": "jù",
    "倩": "qiàn",
    "倪": "ní",
    "倫": "lún",
    "倬": "zhuō",
    "倭": "wō,wēi",
    "倮": "luǒ",
    "倯": "sōng",
    "倰": "lèng",
    "倱": "hùn",
    "倲": "dōng",
    "倳": "zì",
    "倴": "bèn",
    "倵": "wǔ",
    "倶": "jù",
    "倷": "nǎi",
    "倸": "cǎi",
    "倹": "jiǎn",
    "债": "zhài",
    "倻": "yē",
    "值": "zhí",
    "倽": "shà",
    "倾": "qīng",
    "倿": "nìng",
    "偀": "yīng",
    "偁": "chēng,chèn",
    "偂": "qián",
    "偃": "yǎn",
    "偄": "ruǎn",
    "偅": "zhòng,tóng",
    "偆": "chǔn",
    "假": "jiǎ,jià",
    "偈": "jì,jié",
    "偉": "wěi",
    "偊": "yǔ",
    "偋": "bǐng,bìng",
    "偌": "ruò",
    "偍": "tí",
    "偎": "wēi",
    "偏": "piān",
    "偐": "yàn",
    "偑": "fēng",
    "偒": "tǎng,dàng",
    "偓": "wò",
    "偔": "è",
    "偕": "xié",
    "偖": "chě",
    "偗": "shěng",
    "偘": "kǎn",
    "偙": "dì",
    "做": "zuò",
    "偛": "chā",
    "停": "tíng",
    "偝": "bèi",
    "偞": "xiè",
    "偟": "huáng",
    "偠": "yǎo",
    "偡": "zhàn",
    "偢": "chǒu,qiào",
    "偣": "ān",
    "偤": "yóu",
    "健": "jiàn",
    "偦": "xū",
    "偧": "zhā",
    "偨": "cī",
    "偩": "fù",
    "偪": "bī",
    "偫": "zhì",
    "偬": "zǒng",
    "偭": "miǎn",
    "偮": "jí",
    "偯": "yǐ",
    "偰": "xiè",
    "偱": "xún",
    "偲": "cāi,sī",
    "偳": "duān",
    "側": "cè,zè,zhāi",
    "偵": "zhēn",
    "偶": "ǒu",
    "偷": "tōu",
    "偸": "tōu",
    "偹": "bèi",
    "偺": "zán,zá,zǎ",
    "偻": "lǚ,lóu",
    "偼": "jié",
    "偽": "wěi",
    "偾": "fèn",
    "偿": "cháng",
    "傀": "kuǐ,guī",
    "傁": "sǒu",
    "傂": "zhì,sī",
    "傃": "sù",
    "傄": "xiā",
    "傅": "fù",
    "傆": "yuàn,yuán",
    "傇": "rǒng",
    "傈": "lì",
    "傉": "nù",
    "傊": "yùn",
    "傋": "jiǎng,gòu",
    "傌": "mà",
    "傍": "bàng",
    "傎": "diān",
    "傏": "táng",
    "傐": "hào",
    "傑": "jié",
    "傒": "xī,xì",
    "傓": "shān",
    "傔": "qiàn,jiān",
    "傕": "què,jué",
    "傖": "cāng,chen",
    "傗": "chù",
    "傘": "sǎn",
    "備": "bèi",
    "傚": "xiào",
    "傛": "róng",
    "傜": "yáo",
    "傝": "tà,tàn",
    "傞": "suō",
    "傟": "yǎng",
    "傠": "fá",
    "傡": "bìng",
    "傢": "jiā",
    "傣": "dǎi",
    "傤": "zài",
    "傥": "tǎng",
    "傦": "gǔ",
    "傧": "bīn",
    "储": "chǔ",
    "傩": "nuó",
    "傪": "cān,càn",
    "傫": "lěi",
    "催": "cuī",
    "傭": "yōng",
    "傮": "zāo,cáo",
    "傯": "zǒng",
    "傰": "péng",
    "傱": "sǒng",
    "傲": "ào",
    "傳": "chuán,zhuàn",
    "傴": "yǔ",
    "債": "zhài",
    "傶": "qī,còu",
    "傷": "shāng",
    "傸": "chuǎng",
    "傹": "jìng",
    "傺": "chì",
    "傻": "shǎ",
    "傼": "hàn",
    "傽": "zhāng",
    "傾": "qīng",
    "傿": "yān,yàn",
    "僀": "dì",
    "僁": "xiè",
    "僂": "lǚ,lóu",
    "僃": "bèi",
    "僄": "piào,biāo",
    "僅": "jǐn,jìn",
    "僆": "liàn",
    "僇": "lù",
    "僈": "màn",
    "僉": "qiān",
    "僊": "xiān",
    "僋": "tǎn,tàn",
    "僌": "yíng",
    "働": "dòng",
    "僎": "zhuàn",
    "像": "xiàng",
    "僐": "shàn",
    "僑": "qiáo",
    "僒": "jiǒng",
    "僓": "tuǐ,tuí",
    "僔": "zǔn",
    "僕": "pú",
    "僖": "xī",
    "僗": "láo",
    "僘": "chǎng",
    "僙": "guāng",
    "僚": "liáo",
    "僛": "qī",
    "僜": "chēng,dēng",
    "僝": "zhàn,zhuàn,chán",
    "僞": "wěi",
    "僟": "jī",
    "僠": "bō",
    "僡": "huì",
    "僢": "chuǎn",
    "僣": "tiě,jiàn",
    "僤": "dàn",
    "僥": "jiǎo,yáo",
    "僦": "jiù",
    "僧": "sēng",
    "僨": "fèn",
    "僩": "xiàn",
    "僪": "yù,jú",
    "僫": "è,wù,wū",
    "僬": "jiāo",
    "僭": "jiàn",
    "僮": "tóng,zhuàng",
    "僯": "lǐn",
    "僰": "bó",
    "僱": "gù",
    "僲": "xiān",
    "僳": "sù",
    "僴": "xiàn",
    "僵": "jiāng",
    "僶": "mǐn",
    "僷": "yè",
    "僸": "jìn",
    "價": "jià,jie",
    "僺": "qiào",
    "僻": "pì",
    "僼": "fēng",
    "僽": "zhòu",
    "僾": "ài",
    "僿": "sài",
    "儀": "yí",
    "儁": "jùn",
    "儂": "nóng",
    "儃": "chán,tǎn,shàn",
    "億": "yì",
    "儅": "dāng,dàng",
    "儆": "jǐng",
    "儇": "xuān",
    "儈": "kuài",
    "儉": "jiǎn",
    "儊": "chù",
    "儋": "dān,dàn",
    "儌": "jiǎo",
    "儍": "shǎ",
    "儎": "zài",
    "儏": "càn",
    "儐": "bīn,bìn",
    "儑": "án,àn",
    "儒": "rú",
    "儓": "tái",
    "儔": "chóu",
    "儕": "chái",
    "儖": "lán",
    "儗": "nǐ,yì",
    "儘": "jǐn",
    "儙": "qiàn",
    "儚": "méng",
    "儛": "wǔ",
    "儜": "níng",
    "儝": "qióng",
    "儞": "nǐ",
    "償": "cháng",
    "儠": "liè",
    "儡": "lěi",
    "儢": "lǚ",
    "儣": "kuǎng",
    "儤": "bào",
    "儥": "yù",
    "儦": "biāo",
    "儧": "zǎn",
    "儨": "zhì",
    "儩": "sì",
    "優": "yōu",
    "儫": "háo",
    "儬": "qìng",
    "儭": "chèn",
    "儮": "lì",
    "儯": "téng",
    "儰": "wěi",
    "儱": "lǒng,lóng,lòng",
    "儲": "chǔ",
    "儳": "chán,chàn",
    "儴": "ráng,xiāng",
    "儵": "shū",
    "儶": "huì,xié",
    "儷": "lì",
    "儸": "luó",
    "儹": "zǎn",
    "儺": "nuó",
    "儻": "tǎng",
    "儼": "yǎn",
    "儽": "léi",
    "儾": "nàng,nāng",
    "儿": "ér",
    "兀": "wù",
    "允": "yǔn",
    "兂": "zān",
    "元": "yuán",
    "兄": "xiōng",
    "充": "chōng",
    "兆": "zhào",
    "兇": "xiōng",
    "先": "xiān",
    "光": "guāng",
    "兊": "duì,ruì,yuè",
    "克": "kè",
    "兌": "duì,ruì,yuè",
    "免": "miǎn",
    "兎": "tù",
    "兏": "cháng,zhǎng",
    "児": "ér",
    "兑": "duì,ruì,yuè",
    "兒": "ér",
    "兓": "qīn",
    "兔": "tù",
    "兕": "sì",
    "兖": "yǎn",
    "兗": "yǎn",
    "兘": "shǐ",
    "兙": "null",
    "党": "dǎng",
    "兛": "null",
    "兜": "dōu",
    "兝": "null",
    "兞": "null",
    "兟": "shēn",
    "兠": "dōu",
    "兡": "null",
    "兢": "jīng",
    "兣": "null",
    "兤": "huǎng",
    "入": "rù",
    "兦": "wáng",
    "內": "nèi",
    "全": "quán",
    "兩": "liǎng",
    "兪": "yú,shù",
    "八": "bā",
    "公": "gōng",
    "六": "liù,lù",
    "兮": "xī",
    "兯": "han",
    "兰": "lán",
    "共": "gòng,gōng",
    "兲": "tiān",
    "关": "guān",
    "兴": "xìng,xīng",
    "兵": "bīng",
    "其": "qí,jī",
    "具": "jù",
    "典": "diǎn",
    "兹": "zī,cí",
    "兺": "null",
    "养": "yǎng",
    "兼": "jiān",
    "兽": "shòu",
    "兾": "jì",
    "兿": "yì",
    "冀": "jì",
    "冁": "chǎn",
    "冂": "jiōng",
    "冃": "mào",
    "冄": "rǎn",
    "内": "nèi,nà",
    "円": "yuán",
    "冇": "mǎo",
    "冈": "gāng",
    "冉": "rǎn",
    "冊": "cè",
    "冋": "jiōng",
    "册": "cè",
    "再": "zài",
    "冎": "guǎ",
    "冏": "jiǒng",
    "冐": "mào",
    "冑": "zhòu",
    "冒": "mào,mò",
    "冓": "gòu",
    "冔": "xú",
    "冕": "miǎn",
    "冖": "mì",
    "冗": "rǒng",
    "冘": "yín,yóu",
    "写": "xiě",
    "冚": "kǎn",
    "军": "jūn",
    "农": "nóng",
    "冝": "yí",
    "冞": "mí",
    "冟": "shì",
    "冠": "guàn,guān",
    "冡": "měng",
    "冢": "zhǒng",
    "冣": "zuì",
    "冤": "yuān",
    "冥": "míng",
    "冦": "kòu",
    "冧": "lín",
    "冨": "fù",
    "冩": "xiě",
    "冪": "mì",
    "冫": "bīng",
    "冬": "dōng",
    "冭": "tài",
    "冮": "gāng",
    "冯": "féng,píng",
    "冰": "bīng",
    "冱": "hù",
    "冲": "chōng,chòng",
    "决": "jué",
    "冴": "yà",
    "况": "kuàng",
    "冶": "yě",
    "冷": "lěng",
    "冸": "pàn",
    "冹": "fā",
    "冺": "mǐn",
    "冻": "dòng",
    "冼": "xiǎn",
    "冽": "liè",
    "冾": "qià",
    "冿": "jiān",
    "净": "jìng,chēng",
    "凁": "sōu",
    "凂": "měi",
    "凃": "tú",
    "凄": "qī",
    "凅": "gù",
    "准": "zhǔn",
    "凇": "sōng",
    "凈": "jìng,chēng",
    "凉": "liáng,liàng",
    "凊": "qìng",
    "凋": "diāo",
    "凌": "líng",
    "凍": "dòng",
    "凎": "gàn",
    "减": "jiǎn",
    "凐": "yīn",
    "凑": "còu",
    "凒": "ái",
    "凓": "lì",
    "凔": "cāng",
    "凕": "mǐng",
    "凖": "zhǔn",
    "凗": "cuī",
    "凘": "sī",
    "凙": "duó",
    "凚": "jìn",
    "凛": "lǐn",
    "凜": "lǐn",
    "凝": "níng",
    "凞": "xī",
    "凟": "dú",
    "几": "jǐ,jī",
    "凡": "fán",
    "凢": "fán",
    "凣": "fán",
    "凤": "fèng",
    "凥": "jū",
    "処": "chù,chǔ",
    "凧": "zhēng",
    "凨": "fēng",
    "凩": "mù",
    "凪": "zhǐ",
    "凫": "fú",
    "凬": "fēng",
    "凭": "píng",
    "凮": "fēng",
    "凯": "kǎi",
    "凰": "huáng",
    "凱": "kǎi",
    "凲": "gān",
    "凳": "dèng",
    "凴": "píng",
    "凵": "kǎn,qiǎn",
    "凶": "xiōng",
    "凷": "kuài",
    "凸": "tū",
    "凹": "āo,wā",
    "出": "chū",
    "击": "jī",
    "凼": "dàng",
    "函": "hán",
    "凾": "hán",
    "凿": "záo",
    "刀": "dāo",
    "刁": "diāo",
    "刂": "dāo",
    "刃": "rèn",
    "刄": "rèn",
    "刅": "chuāng",
    "分": "fēn,fèn",
    "切": "qiē,qiè",
    "刈": "yì",
    "刉": "jī",
    "刊": "kān",
    "刋": "qiàn",
    "刌": "cǔn",
    "刍": "chú",
    "刎": "wěn",
    "刏": "jī",
    "刐": "dǎn",
    "刑": "xíng",
    "划": "huá,huà",
    "刓": "wán",
    "刔": "jué",
    "刕": "lí",
    "刖": "yuè",
    "列": "liè",
    "刘": "liú",
    "则": "zé",
    "刚": "gāng",
    "创": "chuàng,chuāng",
    "刜": "fú",
    "初": "chū",
    "刞": "qù",
    "刟": "diāo",
    "删": "shān",
    "刡": "mǐn",
    "刢": "líng",
    "刣": "zhōng",
    "判": "pàn",
    "別": "bié,biè",
    "刦": "jié",
    "刧": "jié",
    "刨": "páo,bào",
    "利": "lì",
    "刪": "shān",
    "别": "bié,biè",
    "刬": "chǎn,chàn",
    "刭": "jǐng",
    "刮": "guā",
    "刯": "gēng",
    "到": "dào",
    "刱": "chuàng",
    "刲": "kuī",
    "刳": "kū",
    "刴": "duò",
    "刵": "èr",
    "制": "zhì",
    "刷": "shuā,shuà",
    "券": "quàn,xuàn",
    "刹": "chà,shā",
    "刺": "cì,cī",
    "刻": "kè",
    "刼": "jié",
    "刽": "guì",
    "刾": "cì",
    "刿": "guì",
    "剀": "kǎi",
    "剁": "duò",
    "剂": "jì",
    "剃": "tì",
    "剄": "jǐng",
    "剅": "lóu",
    "剆": "luǒ",
    "則": "zé",
    "剈": "yuān",
    "剉": "cuò",
    "削": "xiāo,xuē",
    "剋": "kēi,kè",
    "剌": "là,lá",
    "前": "qián",
    "剎": "chà,shā",
    "剏": "chuàng",
    "剐": "guǎ",
    "剑": "jiàn",
    "剒": "cuò",
    "剓": "lí",
    "剔": "tī",
    "剕": "fèi",
    "剖": "pōu",
    "剗": "chǎn,chàn",
    "剘": "qí",
    "剙": "chuàng",
    "剚": "zì",
    "剛": "gāng",
    "剜": "wān",
    "剝": "bāo,bō",
    "剞": "jī",
    "剟": "duō",
    "剠": "qíng",
    "剡": "yǎn,shàn",
    "剢": "dū,zhuó",
    "剣": "jiàn",
    "剤": "jì",
    "剥": "bō,bāo",
    "剦": "yān",
    "剧": "jù",
    "剨": "huò",
    "剩": "shèng",
    "剪": "jiǎn",
    "剫": "duó",
    "剬": "zhì,duān",
    "剭": "wū",
    "剮": "guǎ",
    "副": "fù,pì",
    "剰": "shèng",
    "剱": "jiàn",
    "割": "gē",
    "剳": "dá,zhá",
    "剴": "kǎi",
    "創": "chuàng,chuāng",
    "剶": "chuán",
    "剷": "chǎn",
    "剸": "tuán,zhuān",
    "剹": "lù,jiū",
    "剺": "lí",
    "剻": "pēng",
    "剼": "shān",
    "剽": "piāo",
    "剾": "kōu",
    "剿": "jiǎo,chāo",
    "劀": "guā",
    "劁": "qiāo",
    "劂": "jué",
    "劃": "huá,huà",
    "劄": "zhā,zhá",
    "劅": "zhuó",
    "劆": "lián",
    "劇": "jù",
    "劈": "pī,pǐ",
    "劉": "liú",
    "劊": "guì",
    "劋": "jiǎo,chāo",
    "劌": "guì",
    "劍": "jiàn",
    "劎": "jiàn",
    "劏": "tāng",
    "劐": "huō",
    "劑": "jì",
    "劒": "jiàn",
    "劓": "yì",
    "劔": "jiàn",
    "劕": "zhì",
    "劖": "chán",
    "劗": "zuān",
    "劘": "mó",
    "劙": "lí",
    "劚": "zhú",
    "力": "lì",
    "劜": "yà",
    "劝": "quàn",
    "办": "bàn",
    "功": "gōng",
    "加": "jiā",
    "务": "wù",
    "劢": "mài",
    "劣": "liè",
    "劤": "jìn,jìng",
    "劥": "kēng",
    "劦": "xié,liè",
    "劧": "zhǐ",
    "动": "dòng",
    "助": "zhù,chú",
    "努": "nǔ",
    "劫": "jié",
    "劬": "qú",
    "劭": "shào",
    "劮": "yì",
    "劯": "zhǔ",
    "劰": "miǎo",
    "励": "lì",
    "劲": "jìn,jìng",
    "劳": "láo",
    "労": "láo",
    "劵": "juàn",
    "劶": "kǒu",
    "劷": "yáng",
    "劸": "wā",
    "効": "xiào",
    "劺": "móu",
    "劻": "kuāng",
    "劼": "jié",
    "劽": "liè",
    "劾": "hé",
    "势": "shì",
    "勀": "kè",
    "勁": "jìn,jìng",
    "勂": "gào",
    "勃": "bó,bèi",
    "勄": "mǐn",
    "勅": "chì",
    "勆": "láng",
    "勇": "yǒng",
    "勈": "yǒng",
    "勉": "miǎn",
    "勊": "kè",
    "勋": "xūn",
    "勌": "juàn,juān",
    "勍": "qíng",
    "勎": "lù",
    "勏": "bù",
    "勐": "měng",
    "勑": "chì",
    "勒": "lè,lēi",
    "勓": "kài",
    "勔": "miǎn",
    "動": "dòng",
    "勖": "xù",
    "勗": "xù",
    "勘": "kān",
    "務": "wù",
    "勚": "yì",
    "勛": "xūn",
    "勜": "wěng,yǎng",
    "勝": "shèng",
    "勞": "láo",
    "募": "mù",
    "勠": "lù",
    "勡": "piāo",
    "勢": "shì",
    "勣": "jì",
    "勤": "qín",
    "勥": "jiàng",
    "勦": "jiǎo,chāo",
    "勧": "quàn",
    "勨": "xiàng",
    "勩": "yì",
    "勪": "qiāo",
    "勫": "fān",
    "勬": "juān",
    "勭": "tóng,dòng",
    "勮": "jù",
    "勯": "dān",
    "勰": "xié",
    "勱": "mài",
    "勲": "xūn",
    "勳": "xūn",
    "勴": "lǜ",
    "勵": "lì",
    "勶": "chè",
    "勷": "ráng,xiāng",
    "勸": "quàn",
    "勹": "bāo",
    "勺": "sháo",
    "勻": "yún",
    "勼": "jiū",
    "勽": "bào",
    "勾": "gōu,gòu",
    "勿": "wù",
    "匀": "yún",
    "匁": "null",
    "匂": "xiōng",
    "匃": "gài",
    "匄": "gài",
    "包": "bāo",
    "匆": "cōng",
    "匇": "yì",
    "匈": "xiōng",
    "匉": "pēng",
    "匊": "jū",
    "匋": "táo,yáo",
    "匌": "gé",
    "匍": "pú",
    "匎": "è",
    "匏": "páo",
    "匐": "fú",
    "匑": "gōng",
    "匒": "dá",
    "匓": "jiù",
    "匔": "gōng",
    "匕": "bǐ",
    "化": "huà,huā",
    "北": "běi,bèi",
    "匘": "nǎo",
    "匙": "chí,shi",
    "匚": "fāng",
    "匛": "jiù",
    "匜": "yí",
    "匝": "zā",
    "匞": "jiàng",
    "匟": "kàng",
    "匠": "jiàng",
    "匡": "kuāng",
    "匢": "hū",
    "匣": "xiá",
    "匤": "qū",
    "匥": "fán",
    "匦": "guǐ",
    "匧": "qiè",
    "匨": "zāng,cáng",
    "匩": "kuāng",
    "匪": "fěi",
    "匫": "hū",
    "匬": "yǔ",
    "匭": "guǐ",
    "匮": "kuì,guì",
    "匯": "huì",
    "匰": "dān",
    "匱": "kuì,guì",
    "匲": "lián",
    "匳": "lián",
    "匴": "suǎn",
    "匵": "dú",
    "匶": "jiù",
    "匷": "jué",
    "匸": "xì",
    "匹": "pǐ",
    "区": "qū,ōu",
    "医": "yī",
    "匼": "kē,qià",
    "匽": "yǎn,yàn",
    "匾": "biǎn",
    "匿": "nì",
    "區": "qū,ōu",
    "十": "shí",
    "卂": "xùn",
    "千": "qiān",
    "卄": "niàn",
    "卅": "sà",
    "卆": "zú",
    "升": "shēng",
    "午": "wǔ",
    "卉": "huì",
    "半": "bàn",
    "卋": "shì",
    "卌": "xì",
    "卍": "wàn",
    "华": "huá,huà,huā",
    "协": "xié",
    "卐": "wàn",
    "卑": "bēi",
    "卒": "zú,cù",
    "卓": "zhuó",
    "協": "xié",
    "单": "dān,shàn,chán",
    "卖": "mài",
    "南": "nán,nā",
    "単": "dān",
    "卙": "jí",
    "博": "bó",
    "卛": "shuài,lǜ",
    "卜": "bǔ,bo",
    "卝": "guàn,kuàng",
    "卞": "biàn",
    "卟": "bǔ",
    "占": "zhàn,zhān",
    "卡": "kǎ,qiǎ",
    "卢": "lú",
    "卣": "yǒu",
    "卤": "lǔ",
    "卥": "xī",
    "卦": "guà",
    "卧": "wò",
    "卨": "xiè",
    "卩": "jié",
    "卪": "jié",
    "卫": "wèi",
    "卬": "yǎng,áng",
    "卭": "qióng",
    "卮": "zhī",
    "卯": "mǎo",
    "印": "yìn",
    "危": "wēi",
    "卲": "shào",
    "即": "jí",
    "却": "què",
    "卵": "luǎn",
    "卶": "chǐ",
    "卷": "juǎn,juàn",
    "卸": "xiè",
    "卹": "xù",
    "卺": "jǐn",
    "卻": "què",
    "卼": "wù",
    "卽": "jí",
    "卾": "è",
    "卿": "qīng",
    "厀": "xī",
    "厁": "sān",
    "厂": "chǎng,ān,hàn",
    "厃": "wēi,yán",
    "厄": "è",
    "厅": "tīng",
    "历": "lì",
    "厇": "zhé,zhái",
    "厈": "hàn,àn",
    "厉": "lì",
    "厊": "yǎ",
    "压": "yā,yà",
    "厌": "yàn",
    "厍": "shè",
    "厎": "dǐ",
    "厏": "zhǎ,zhǎi",
    "厐": "páng",
    "厑": "yá",
    "厒": "qiè",
    "厓": "yá",
    "厔": "zhì,shī",
    "厕": "cè",
    "厖": "máng",
    "厗": "tí",
    "厘": "lí",
    "厙": "shè",
    "厚": "hòu",
    "厛": "tīng",
    "厜": "zuī",
    "厝": "cuò",
    "厞": "fèi",
    "原": "yuán",
    "厠": "cè",
    "厡": "yuán",
    "厢": "xiāng",
    "厣": "yǎn",
    "厤": "lì",
    "厥": "jué",
    "厦": "shà,xià",
    "厧": "diān",
    "厨": "chú",
    "厩": "jiù",
    "厪": "jǐn",
    "厫": "áo",
    "厬": "guǐ",
    "厭": "yàn",
    "厮": "sī",
    "厯": "lì",
    "厰": "chǎng",
    "厱": "qiān,lán",
    "厲": "lì",
    "厳": "yán",
    "厴": "yǎn",
    "厵": "yuán",
    "厶": "sī,mǒu",
    "厷": "gōng,hóng",
    "厸": "lín,miǎo",
    "厹": "róu,qiú",
    "厺": "qù",
    "去": "qù",
    "厼": "null",
    "厽": "lěi",
    "厾": "dū",
    "县": "xiàn,xuán",
    "叀": "zhuān",
    "叁": "sān",
    "参": "cān,shēn,cēn,sān",
    "參": "cān,shēn,cēn,sān",
    "叄": "cān,shēn,cēn,sān",
    "叅": "cān,shēn,cēn,sān",
    "叆": "ài",
    "叇": "dài",
    "又": "yòu",
    "叉": "chā,chá,chǎ",
    "及": "jí",
    "友": "yǒu",
    "双": "shuāng",
    "反": "fǎn",
    "収": "shōu",
    "叏": "guái",
    "叐": "bá",
    "发": "fā,fà",
    "叒": "ruò",
    "叓": "lì",
    "叔": "shū",
    "叕": "zhuó,yǐ,lì,jué",
    "取": "qǔ",
    "受": "shòu",
    "变": "biàn",
    "叙": "xù",
    "叚": "jiǎ",
    "叛": "pàn",
    "叜": "sǒu",
    "叝": "jí",
    "叞": "wèi,yù",
    "叟": "sǒu",
    "叠": "dié",
    "叡": "ruì",
    "叢": "cóng",
    "口": "kǒu",
    "古": "gǔ",
    "句": "jù,gōu",
    "另": "lìng",
    "叧": "guǎ",
    "叨": "dāo,tāo",
    "叩": "kòu",
    "只": "zhǐ,zhī",
    "叫": "jiào",
    "召": "zhào,shào",
    "叭": "bā",
    "叮": "dīng",
    "可": "kě,kè",
    "台": "tái,tāi",
    "叱": "chì",
    "史": "shǐ",
    "右": "yòu",
    "叴": "qiú",
    "叵": "pǒ",
    "叶": "yè,xié",
    "号": "hào,háo",
    "司": "sī",
    "叹": "tàn",
    "叺": "chǐ",
    "叻": "lè",
    "叼": "diāo",
    "叽": "jī",
    "叾": "null",
    "叿": "hōng,hóng",
    "吀": "miē",
    "吁": "xū,yù",
    "吂": "máng",
    "吃": "chī",
    "各": "gè,gě",
    "吅": "xuān,sòng",
    "吆": "yāo",
    "吇": "zǐ",
    "合": "hé,gě",
    "吉": "jí",
    "吊": "diào",
    "吋": "dòu,cùn",
    "同": "tóng,tòng",
    "名": "míng",
    "后": "hòu",
    "吏": "lì",
    "吐": "tǔ,tù",
    "向": "xiàng",
    "吒": "zhà,zhā",
    "吓": "xià,hè",
    "吔": "yē",
    "吕": "lǚ",
    "吖": "yā,ā",
    "吗": "ma,má,mǎ",
    "吘": "ǒu",
    "吙": "huō",
    "吚": "yī",
    "君": "jūn",
    "吜": "chǒu",
    "吝": "lìn",
    "吞": "tūn",
    "吟": "yín",
    "吠": "fèi",
    "吡": "pǐ,bǐ",
    "吢": "qìn",
    "吣": "qìn",
    "吤": "jiè,gè",
    "吥": "bù",
    "否": "fǒu,pǐ",
    "吧": "bā,ba",
    "吨": "dūn",
    "吩": "fēn",
    "吪": "é,huā",
    "含": "hán",
    "听": "tīng",
    "吭": "háng,kēng",
    "吮": "shǔn",
    "启": "qǐ",
    "吰": "hóng",
    "吱": "zhī,zī",
    "吲": "yǐn,shěn",
    "吳": "wú",
    "吴": "wú",
    "吵": "chǎo,chāo",
    "吶": "nà,nè",
    "吷": "xuè,chuò,jué",
    "吸": "xī",
    "吹": "chuī",
    "吺": "dōu,rú",
    "吻": "wěn",
    "吼": "hǒu",
    "吽": "hǒu,hōng,ōu",
    "吾": "wú,yù",
    "吿": "gào",
    "呀": "yā,ya",
    "呁": "jùn",
    "呂": "lǚ",
    "呃": "è",
    "呄": "gé",
    "呅": "wěn",
    "呆": "dāi",
    "呇": "qǐ",
    "呈": "chéng",
    "呉": "wú",
    "告": "gào",
    "呋": "fū",
    "呌": "jiào",
    "呍": "hōng",
    "呎": "chǐ",
    "呏": "shēng",
    "呐": "nà,nè",
    "呑": "tūn,tiān",
    "呒": "fǔ",
    "呓": "yì",
    "呔": "dāi",
    "呕": "ǒu,ōu,òu",
    "呖": "lì",
    "呗": "bei,bài",
    "员": "yuán,yún,yùn",
    "呙": "wāi,hé,wǒ,wā,guǎ,guō",
    "呚": "huá,qì",
    "呛": "qiāng,qiàng",
    "呜": "wū",
    "呝": "è",
    "呞": "shī",
    "呟": "juǎn",
    "呠": "pěn",
    "呡": "wěn,mǐn",
    "呢": "ne,ní",
    "呣": "móu",
    "呤": "líng",
    "呥": "rán",
    "呦": "yōu",
    "呧": "dǐ",
    "周": "zhōu",
    "呩": "shì",
    "呪": "zhòu",
    "呫": "tiè,chè",
    "呬": "xì",
    "呭": "yì",
    "呮": "qì,zhī",
    "呯": "píng",
    "呰": "zǐ,cī",
    "呱": "guā,gū,guǎ",
    "呲": "zī,cī",
    "味": "wèi",
    "呴": "xǔ,hǒu,gòu",
    "呵": "hē,a,kē",
    "呶": "náo",
    "呷": "xiā",
    "呸": "pēi",
    "呹": "yì",
    "呺": "xiāo,háo",
    "呻": "shēn",
    "呼": "hū",
    "命": "mìng",
    "呾": "dá,dàn",
    "呿": "qū",
    "咀": "jǔ,zuǐ",
    "咁": "xián,gān",
    "咂": "zā",
    "咃": "tuō",
    "咄": "duō",
    "咅": "pǒu",
    "咆": "páo",
    "咇": "bì",
    "咈": "fú",
    "咉": "yǎng",
    "咊": "hé,hè",
    "咋": "zǎ,zé,zhā",
    "和": "hé,hè,huó,huò,hú",
    "咍": "hāi",
    "咎": "jiù",
    "咏": "yǒng",
    "咐": "fù",
    "咑": "dā",
    "咒": "zhòu",
    "咓": "wǎ",
    "咔": "kǎ",
    "咕": "gū",
    "咖": "kā,gā",
    "咗": "zuo",
    "咘": "bù",
    "咙": "lóng",
    "咚": "dōng",
    "咛": "níng",
    "咜": "tuō",
    "咝": "sī",
    "咞": "xiàn,xián",
    "咟": "huò",
    "咠": "qì",
    "咡": "èr",
    "咢": "è",
    "咣": "guāng",
    "咤": "zhà",
    "咥": "dié,xī",
    "咦": "yí",
    "咧": "liē,liě,lié,lie",
    "咨": "zī",
    "咩": "miē",
    "咪": "mī",
    "咫": "zhǐ",
    "咬": "yǎo",
    "咭": "jī,xī,qià",
    "咮": "zhòu",
    "咯": "kǎ,luò,lo,gē",
    "咰": "shù,xún",
    "咱": "zán,zá,zǎ",
    "咲": "xiào",
    "咳": "ké,hāi",
    "咴": "huī",
    "咵": "kuā",
    "咶": "huài,shì",
    "咷": "táo",
    "咸": "xián",
    "咹": "è,àn",
    "咺": "xuǎn,xuān",
    "咻": "xiū",
    "咼": "wāi,hé,wǒ,wā,guǎ,guō",
    "咽": "yàn,yān,yè",
    "咾": "lǎo",
    "咿": "yī",
    "哀": "āi",
    "品": "pǐn",
    "哂": "shěn",
    "哃": "tóng",
    "哄": "hōng,hǒng,hòng",
    "哅": "xiōng",
    "哆": "duō",
    "哇": "wā,wa",
    "哈": "hā,hǎ,hà",
    "哉": "zāi",
    "哊": "yòu",
    "哋": "diè,dì",
    "哌": "pài",
    "响": "xiǎng",
    "哎": "āi",
    "哏": "gén,hěn",
    "哐": "kuāng",
    "哑": "yǎ,yā",
    "哒": "dā",
    "哓": "xiāo",
    "哔": "bì",
    "哕": "yuě,huì",
    "哖": "nián",
    "哗": "huá,huā",
    "哘": "xíng",
    "哙": "kuài",
    "哚": "duǒ",
    "哛": "null",
    "哜": "jì,jiē,zhāi",
    "哝": "nóng",
    "哞": "mōu",
    "哟": "yō,yo",
    "哠": "hào",
    "員": "yuán,yún,yùn",
    "哢": "lòng",
    "哣": "pǒu",
    "哤": "máng",
    "哥": "gē",
    "哦": "ò,ó,é",
    "哧": "chī",
    "哨": "shào",
    "哩": "li,lǐ,lī",
    "哪": "nǎ,něi,na,né",
    "哫": "zú",
    "哬": "hè",
    "哭": "kū",
    "哮": "xiào",
    "哯": "xiàn",
    "哰": "láo",
    "哱": "pò,bā,bō",
    "哲": "zhé",
    "哳": "zhā",
    "哴": "liàng,láng",
    "哵": "bā",
    "哶": "miē",
    "哷": "liè,lǜ",
    "哸": "suī",
    "哹": "fú",
    "哺": "bǔ",
    "哻": "hān",
    "哼": "hēng",
    "哽": "gěng",
    "哾": "chuò,yuè",
    "哿": "gě,jiā",
    "唀": "yòu",
    "唁": "yàn",
    "唂": "gū",
    "唃": "gū",
    "唄": "bei,bài",
    "唅": "hán,hàn",
    "唆": "suō",
    "唇": "chún",
    "唈": "yì",
    "唉": "āi,ài",
    "唊": "jiá,qiǎn",
    "唋": "tǔ,tù",
    "唌": "dàn,xián,yán",
    "唍": "wǎn",
    "唎": "lì",
    "唏": "xī",
    "唐": "táng",
    "唑": "zuò",
    "唒": "qiú",
    "唓": "chē",
    "唔": "wù,wú",
    "唕": "zào",
    "唖": "yǎ",
    "唗": "dōu",
    "唘": "qǐ",
    "唙": "dí",
    "唚": "qìn",
    "唛": "mài",
    "唜": "null",
    "唝": "gòng,hǒng,gǒng",
    "唞": "dóu",
    "唟": "null",
    "唠": "lào,láo",
    "唡": "liǎng",
    "唢": "suǒ",
    "唣": "zào",
    "唤": "huàn",
    "唥": "léng",
    "唦": "shā",
    "唧": "jī",
    "唨": "zǔ",
    "唩": "wō,wěi",
    "唪": "fěng",
    "唫": "jìn,yín",
    "唬": "hǔ,xià",
    "唭": "qì",
    "售": "shòu",
    "唯": "wéi",
    "唰": "shuā",
    "唱": "chàng",
    "唲": "ér,wā",
    "唳": "lì",
    "唴": "qiàng",
    "唵": "ǎn",
    "唶": "jiè,zé,jí",
    "唷": "yō",
    "唸": "niàn",
    "唹": "yū",
    "唺": "tiǎn",
    "唻": "lài",
    "唼": "shà",
    "唽": "xī",
    "唾": "tuò",
    "唿": "hū",
    "啀": "ái",
    "啁": "zhōu,zhāo,tiào",
    "啂": "gòu",
    "啃": "kěn",
    "啄": "zhuó",
    "啅": "zhuó,zhào",
    "商": "shāng",
    "啇": "dí",
    "啈": "hèng",
    "啉": "lán,lín",
    "啊": "ā,á,ǎ,à,a",
    "啋": "cǎi",
    "啌": "qiāng",
    "啍": "zhūn,tūn,xiāng,duǐ",
    "啎": "wǔ",
    "問": "wèn",
    "啐": "cuì,qi",
    "啑": "shà,jié,dié,tì",
    "啒": "gǔ",
    "啓": "qǐ",
    "啔": "qǐ",
    "啕": "táo",
    "啖": "dàn",
    "啗": "dàn",
    "啘": "yuē,wā",
    "啙": "zǐ,cǐ",
    "啚": "bǐ,tú",
    "啛": "cuì",
    "啜": "chuò,chuài",
    "啝": "hé",
    "啞": "yǎ,yā",
    "啟": "qǐ",
    "啠": "zhé",
    "啡": "fēi",
    "啢": "liǎng",
    "啣": "xián",
    "啤": "pí",
    "啥": "shá",
    "啦": "lā,la",
    "啧": "zé",
    "啨": "qíng,yīng",
    "啩": "guà",
    "啪": "pā",
    "啫": "zé,shì",
    "啬": "sè",
    "啭": "zhuàn",
    "啮": "niè",
    "啯": "guō",
    "啰": "luō,luó,luo",
    "啱": "yán",
    "啲": "dī",
    "啳": "quán",
    "啴": "tān,chǎn,tuō",
    "啵": "bo",
    "啶": "dìng",
    "啷": "lāng",
    "啸": "xiào",
    "啹": "jú",
    "啺": "táng",
    "啻": "chì",
    "啼": "tí",
    "啽": "ān,án",
    "啾": "jiū",
    "啿": "dàn",
    "喀": "kā",
    "喁": "yóng",
    "喂": "wèi",
    "喃": "nán",
    "善": "shàn",
    "喅": "yù",
    "喆": "zhé",
    "喇": "lǎ",
    "喈": "jiē",
    "喉": "hóu",
    "喊": "hǎn",
    "喋": "dié,zhá",
    "喌": "zhōu",
    "喍": "chái",
    "喎": "wāi",
    "喏": "nuò,rě",
    "喐": "huò,guó,xù",
    "喑": "yīn",
    "喒": "zán,zá,zǎ",
    "喓": "yāo",
    "喔": "ō,wō",
    "喕": "miǎn",
    "喖": "hú",
    "喗": "yǔn",
    "喘": "chuǎn",
    "喙": "huì",
    "喚": "huàn",
    "喛": "huàn,yuán,xuǎn,hé",
    "喜": "xǐ",
    "喝": "hē,hè,yè",
    "喞": "jī",
    "喟": "kuì",
    "喠": "zhǒng,chuáng",
    "喡": "wéi,wèi",
    "喢": "shà",
    "喣": "xǔ",
    "喤": "huáng",
    "喥": "duó,zhà",
    "喦": "yán",
    "喧": "xuān",
    "喨": "liàng",
    "喩": "yù",
    "喪": "sàng,sāng",
    "喫": "chī",
    "喬": "qiáo,jiāo",
    "喭": "yàn",
    "單": "dān,shàn,chán",
    "喯": "bēn,pèn",
    "喰": "cān,sūn,qī",
    "喱": "lí",
    "喲": "yō,yo",
    "喳": "zhā,chā",
    "喴": "wēi",
    "喵": "miāo",
    "営": "yíng",
    "喷": "pēn,pèn",
    "喸": "null",
    "喹": "kuí",
    "喺": "xí",
    "喻": "yù",
    "喼": "jiē",
    "喽": "lóu,lou",
    "喾": "kù",
    "喿": "zào,qiāo",
    "嗀": "hù",
    "嗁": "tí",
    "嗂": "yáo",
    "嗃": "hè,xiāo,xiào,hù",
    "嗄": "shà,á",
    "嗅": "xiù",
    "嗆": "qiāng,qiàng",
    "嗇": "sè",
    "嗈": "yōng",
    "嗉": "sù",
    "嗊": "gòng,hǒng,gǒng",
    "嗋": "xié",
    "嗌": "yì,ài",
    "嗍": "suō",
    "嗎": "ma,má,mǎ",
    "嗏": "chā",
    "嗐": "hài",
    "嗑": "kē,kè",
    "嗒": "dā,tà",
    "嗓": "sǎng",
    "嗔": "chēn",
    "嗕": "rù",
    "嗖": "sōu",
    "嗗": "wā,gǔ",
    "嗘": "jī",
    "嗙": "bēng,pǎng",
    "嗚": "wū",
    "嗛": "xián,qiàn,qiè",
    "嗜": "shì",
    "嗝": "gé",
    "嗞": "zī",
    "嗟": "jiē",
    "嗠": "lào",
    "嗡": "wēng",
    "嗢": "wà",
    "嗣": "sì",
    "嗤": "chī",
    "嗥": "háo",
    "嗦": "suō",
    "嗧": "null",
    "嗨": "hāi,hēi",
    "嗩": "suǒ",
    "嗪": "qín",
    "嗫": "niè",
    "嗬": "hē",
    "嗭": "zi",
    "嗮": "sǎi",
    "嗯": "èn",
    "嗰": "gě",
    "嗱": "ná",
    "嗲": "diǎ",
    "嗳": "ài,ǎi,āi",
    "嗴": "qiāng",
    "嗵": "tōng",
    "嗶": "bì",
    "嗷": "áo",
    "嗸": "áo",
    "嗹": "lián",
    "嗺": "zuī,suī",
    "嗻": "zhē,zhè,zhù,zhe",
    "嗼": "mò",
    "嗽": "sòu",
    "嗾": "sǒu",
    "嗿": "tǎn",
    "嘀": "dí",
    "嘁": "qī",
    "嘂": "jiào",
    "嘃": "chōng",
    "嘄": "jiào,dǎo",
    "嘅": "kǎi,gě",
    "嘆": "tàn",
    "嘇": "shān,càn",
    "嘈": "cáo",
    "嘉": "jiā",
    "嘊": "ái",
    "嘋": "xiào",
    "嘌": "piāo",
    "嘍": "lóu,lou",
    "嘎": "gā,gá,gǎ",
    "嘏": "gǔ",
    "嘐": "xiāo,jiāo",
    "嘑": "hū",
    "嘒": "huì",
    "嘓": "guō",
    "嘔": "ǒu,ōu,òu",
    "嘕": "xiān",
    "嘖": "zé",
    "嘗": "cháng",
    "嘘": "xū,shī",
    "嘙": "pó",
    "嘚": "dē,dēi",
    "嘛": "má,ma",
    "嘜": "mà",
    "嘝": "hú",
    "嘞": "lei,lē",
    "嘟": "dū",
    "嘠": "gā,gá,gǎ",
    "嘡": "tāng",
    "嘢": "yě",
    "嘣": "bēng",
    "嘤": "yīng",
    "嘥": "sāi",
    "嘦": "jiào",
    "嘧": "mì",
    "嘨": "xiào",
    "嘩": "huá,huā",
    "嘪": "mǎi",
    "嘫": "rán",
    "嘬": "zuō",
    "嘭": "pēng",
    "嘮": "lào,láo",
    "嘯": "xiào",
    "嘰": "jī",
    "嘱": "zhǔ",
    "嘲": "cháo,zhāo",
    "嘳": "kuì",
    "嘴": "zuǐ",
    "嘵": "xiāo",
    "嘶": "sī",
    "嘷": "háo",
    "嘸": "fǔ",
    "嘹": "liáo",
    "嘺": "qiáo,qiào",
    "嘻": "xī",
    "嘼": "shòu,chù,xù",
    "嘽": "tān,chǎn",
    "嘾": "dàn,tán",
    "嘿": "hēi,mò",
    "噀": "xùn",
    "噁": "ě",
    "噂": "zūn",
    "噃": "fān,bo",
    "噄": "chī",
    "噅": "huī",
    "噆": "zǎn",
    "噇": "chuáng",
    "噈": "cù,zā,hé",
    "噉": "dàn",
    "噊": "jué",
    "噋": "tūn,kuò",
    "噌": "cēng",
    "噍": "jiào",
    "噎": "yē",
    "噏": "xī",
    "噐": "qì",
    "噑": "háo",
    "噒": "lián",
    "噓": "xū,shī",
    "噔": "dēng",
    "噕": "huī",
    "噖": "yín",
    "噗": "pū",
    "噘": "juē",
    "噙": "qín",
    "噚": "xún",
    "噛": "niè",
    "噜": "lū",
    "噝": "sī",
    "噞": "yǎn",
    "噟": "yīng",
    "噠": "dā",
    "噡": "zhān",
    "噢": "ō",
    "噣": "zhòu,zhuó",
    "噤": "jìn",
    "噥": "nóng",
    "噦": "yuě,huì",
    "噧": "xiè",
    "器": "qì",
    "噩": "è",
    "噪": "zào",
    "噫": "yī",
    "噬": "shì",
    "噭": "jiào,qiào,chī",
    "噮": "yuàn",
    "噯": "ài,ǎi,āi",
    "噰": "yōng,yǒng",
    "噱": "jué,xué",
    "噲": "kuài",
    "噳": "yǔ",
    "噴": "pēn,pèn",
    "噵": "dào",
    "噶": "gá",
    "噷": "xīn,hěn,hèn",
    "噸": "dūn",
    "噹": "dāng",
    "噺": "xīn",
    "噻": "sāi",
    "噼": "pī",
    "噽": "pǐ",
    "噾": "yīn",
    "噿": "zuǐ",
    "嚀": "níng",
    "嚁": "dí",
    "嚂": "làn",
    "嚃": "tà",
    "嚄": "huò,ǒ",
    "嚅": "rú",
    "嚆": "hāo",
    "嚇": "hè,xià",
    "嚈": "yàn",
    "嚉": "duō",
    "嚊": "xiù,pì",
    "嚋": "zhōu,chóu",
    "嚌": "jì,jiē,zhāi",
    "嚍": "jìn",
    "嚎": "háo",
    "嚏": "tì",
    "嚐": "cháng",
    "嚑": "xūn",
    "嚒": "mē",
    "嚓": "cā,chā",
    "嚔": "tì",
    "嚕": "lū",
    "嚖": "huì",
    "嚗": "bào,bó,pào",
    "嚘": "yōu",
    "嚙": "niè",
    "嚚": "yín",
    "嚛": "hù",
    "嚜": "mèi,me,mò",
    "嚝": "hōng",
    "嚞": "zhé",
    "嚟": "lí",
    "嚠": "liú",
    "嚡": "xié,hái",
    "嚢": "náng",
    "嚣": "xiāo",
    "嚤": "mō",
    "嚥": "yàn",
    "嚦": "lì",
    "嚧": "lú",
    "嚨": "lóng",
    "嚩": "pó",
    "嚪": "dàn",
    "嚫": "chèn",
    "嚬": "pín",
    "嚭": "pǐ",
    "嚮": "xiàng",
    "嚯": "huò",
    "嚰": "mè",
    "嚱": "xī",
    "嚲": "duǒ",
    "嚳": "kù",
    "嚴": "yán",
    "嚵": "chán",
    "嚶": "yīng",
    "嚷": "rǎng,rāng",
    "嚸": "diǎn",
    "嚹": "lá",
    "嚺": "tà",
    "嚻": "xiāo",
    "嚼": "jiáo,jué,jiào",
    "嚽": "chuò",
    "嚾": "huàn,huān",
    "嚿": "huò",
    "囀": "zhuàn",
    "囁": "niè",
    "囂": "xiāo",
    "囃": "zá,cà",
    "囄": "lí",
    "囅": "chǎn",
    "囆": "chài",
    "囇": "lì",
    "囈": "yì",
    "囉": "luō,luó,luo",
    "囊": "náng,nāng",
    "囋": "zàn,zá,cān",
    "囌": "sū",
    "囍": "xǐ",
    "囎": "zèng",
    "囏": "jiān",
    "囐": "yàn,zá,niè",
    "囑": "zhǔ",
    "囒": "lán",
    "囓": "niè",
    "囔": "nāng",
    "囕": "null",
    "囖": "luó,luō,luo",
    "囗": "wéi,guó",
    "囘": "huí",
    "囙": "yīn",
    "囚": "qiú",
    "四": "sì",
    "囜": "nín",
    "囝": "jiǎn,nān",
    "回": "huí",
    "囟": "xìn",
    "因": "yīn",
    "囡": "nān",
    "团": "tuán",
    "団": "tuán",
    "囤": "tún,dùn",
    "囥": "kàng",
    "囦": "yuān",
    "囧": "jiǒng",
    "囨": "piān",
    "囩": "yún",
    "囪": "cōng",
    "囫": "hú",
    "囬": "huí",
    "园": "yuán",
    "囮": "é",
    "囯": "guó",
    "困": "kùn",
    "囱": "cōng",
    "囲": "wéi,tōng",
    "図": "tú",
    "围": "wéi",
    "囵": "lún",
    "囶": "guó",
    "囷": "qūn",
    "囸": "rì",
    "囹": "líng",
    "固": "gù",
    "囻": "guó",
    "囼": "tāi",
    "国": "guó",
    "图": "tú",
    "囿": "yòu",
    "圀": "guó",
    "圁": "yín",
    "圂": "hùn",
    "圃": "pǔ",
    "圄": "yǔ",
    "圅": "hán",
    "圆": "yuán",
    "圇": "lún",
    "圈": "quān,juàn,juān",
    "圉": "yǔ",
    "圊": "qīng",
    "國": "guó",
    "圌": "chuán,chuí",
    "圍": "wéi",
    "圎": "yuán",
    "圏": "quān,juàn,juān",
    "圐": "kū",
    "圑": "pǔ",
    "園": "yuán",
    "圓": "yuán",
    "圔": "yà",
    "圕": "tuān",
    "圖": "tú",
    "圗": "tú",
    "團": "tuán",
    "圙": "lüè",
    "圚": "huì",
    "圛": "yì",
    "圜": "huán,yuán",
    "圝": "luán",
    "圞": "luán",
    "土": "tǔ",
    "圠": "yà",
    "圡": "tǔ",
    "圢": "tǐng",
    "圣": "shèng",
    "圤": "pú",
    "圥": "lù",
    "圦": "kuài",
    "圧": "yā",
    "在": "zài",
    "圩": "xū,wéi",
    "圪": "gē",
    "圫": "yù,zhūn",
    "圬": "wū",
    "圭": "guī",
    "圮": "pǐ",
    "圯": "yí",
    "地": "dì,de",
    "圱": "qiān,sú",
    "圲": "qiān",
    "圳": "zhèn",
    "圴": "zhuó",
    "圵": "dàng",
    "圶": "qià",
    "圷": "xià",
    "圸": "shān",
    "圹": "kuàng",
    "场": "chǎng,cháng",
    "圻": "qí,yín",
    "圼": "niè",
    "圽": "mò",
    "圾": "jī",
    "圿": "jiá",
    "址": "zhǐ",
    "坁": "zhǐ,zhì",
    "坂": "bǎn",
    "坃": "xūn",
    "坄": "yì",
    "坅": "qǐn",
    "坆": "méi,fén",
    "均": "jūn",
    "坈": "rǒng,kēng",
    "坉": "tún,dùn",
    "坊": "fāng,fáng",
    "坋": "bèn,fèn",
    "坌": "bèn",
    "坍": "tān",
    "坎": "kǎn",
    "坏": "huài",
    "坐": "zuò",
    "坑": "kēng",
    "坒": "bì",
    "坓": "jǐng",
    "坔": "dì,làn",
    "坕": "jīng",
    "坖": "jì",
    "块": "kuài",
    "坘": "dǐ",
    "坙": "jīng",
    "坚": "jiān",
    "坛": "tán",
    "坜": "lì",
    "坝": "bà",
    "坞": "wù",
    "坟": "fén",
    "坠": "zhuì",
    "坡": "pō",
    "坢": "bàn,pǎn",
    "坣": "táng",
    "坤": "kūn",
    "坥": "qū",
    "坦": "tǎn",
    "坧": "zhǐ",
    "坨": "tuó",
    "坩": "gān",
    "坪": "píng",
    "坫": "diàn",
    "坬": "guà",
    "坭": "ní",
    "坮": "tái",
    "坯": "pī",
    "坰": "jiōng",
    "坱": "yǎng",
    "坲": "fó",
    "坳": "ào",
    "坴": "lù",
    "坵": "qiū",
    "坶": "mù,mǔ",
    "坷": "kě,kē",
    "坸": "gòu",
    "坹": "xuè",
    "坺": "fá",
    "坻": "dǐ,chí",
    "坼": "chè",
    "坽": "líng",
    "坾": "zhù",
    "坿": "fù",
    "垀": "hū",
    "垁": "zhì",
    "垂": "chuí",
    "垃": "lā",
    "垄": "lǒng",
    "垅": "lǒng",
    "垆": "lú",
    "垇": "ào",
    "垈": "dài",
    "垉": "páo",
    "垊": "mín",
    "型": "xíng",
    "垌": "dòng,tóng",
    "垍": "jì",
    "垎": "hè",
    "垏": "lǜ",
    "垐": "cí",
    "垑": "chǐ",
    "垒": "lěi",
    "垓": "gāi",
    "垔": "yīn",
    "垕": "hòu",
    "垖": "duī",
    "垗": "zhào",
    "垘": "fú",
    "垙": "guāng",
    "垚": "yáo",
    "垛": "duǒ,duò",
    "垜": "duǒ,duò",
    "垝": "guǐ",
    "垞": "chá",
    "垟": "yáng",
    "垠": "yín",
    "垡": "fá",
    "垢": "gòu",
    "垣": "yuán",
    "垤": "dié",
    "垥": "xié",
    "垦": "kěn",
    "垧": "shǎng",
    "垨": "shǒu",
    "垩": "è",
    "垪": "bìng",
    "垫": "diàn",
    "垬": "hóng",
    "垭": "yā",
    "垮": "kuǎ",
    "垯": "dá",
    "垰": "kǎ",
    "垱": "dàng",
    "垲": "kǎi",
    "垳": "háng",
    "垴": "nǎo",
    "垵": "ǎn",
    "垶": "xīng",
    "垷": "xiàn",
    "垸": "yuàn,huán",
    "垹": "bāng",
    "垺": "póu,fú",
    "垻": "bà",
    "垼": "yì",
    "垽": "yìn",
    "垾": "hàn",
    "垿": "xù",
    "埀": "chuí",
    "埁": "cén",
    "埂": "gěng",
    "埃": "āi",
    "埄": "běng,fēng",
    "埅": "dì,fáng",
    "埆": "què,jué",
    "埇": "yǒng",
    "埈": "jùn",
    "埉": "xiá,jiā",
    "埊": "dì",
    "埋": "mái,mán",
    "埌": "làng",
    "埍": "juǎn",
    "城": "chéng",
    "埏": "yán,shān",
    "埐": "qín,jīn",
    "埑": "zhé",
    "埒": "liè",
    "埓": "liè",
    "埔": "pǔ,bù",
    "埕": "chéng",
    "埖": "huā",
    "埗": "bù",
    "埘": "shí",
    "埙": "xūn",
    "埚": "guō",
    "埛": "jiōng",
    "埜": "yě",
    "埝": "niàn",
    "埞": "dī",
    "域": "yù",
    "埠": "bù",
    "埡": "yà",
    "埢": "quán",
    "埣": "suì,sù",
    "埤": "pí,pì",
    "埥": "qīng,zhēng",
    "埦": "wǎn,wān",
    "埧": "jù",
    "埨": "lǔn",
    "埩": "zhēng,chéng",
    "埪": "kōng",
    "埫": "chǒng,shǎng",
    "埬": "dōng",
    "埭": "dài",
    "埮": "tán,tàn",
    "埯": "ǎn",
    "埰": "cǎi,cài",
    "埱": "chù,tòu",
    "埲": "běng",
    "埳": "xiàn,kǎn",
    "埴": "zhí",
    "埵": "duǒ",
    "埶": "yì,shì",
    "執": "zhí",
    "埸": "yì",
    "培": "péi",
    "基": "jī",
    "埻": "zhǔn",
    "埼": "qí",
    "埽": "sào,sǎo",
    "埾": "jù",
    "埿": "ní",
    "堀": "kū",
    "堁": "kè",
    "堂": "táng",
    "堃": "kūn",
    "堄": "nì",
    "堅": "jiān",
    "堆": "duī",
    "堇": "jīn",
    "堈": "gāng",
    "堉": "yù",
    "堊": "è",
    "堋": "péng,bèng",
    "堌": "gù",
    "堍": "tù",
    "堎": "lèng",
    "堏": "fāng",
    "堐": "yá",
    "堑": "qiàn,jiàn",
    "堒": "kūn",
    "堓": "àn",
    "堔": "shēn",
    "堕": "duò,huī",
    "堖": "nǎo",
    "堗": "tū",
    "堘": "chéng",
    "堙": "yīn",
    "堚": "huán",
    "堛": "bì",
    "堜": "liàn",
    "堝": "guō",
    "堞": "dié",
    "堟": "zhuàn",
    "堠": "hòu",
    "堡": "bǎo,bǔ,pù",
    "堢": "bǎo",
    "堣": "yú",
    "堤": "dī",
    "堥": "máo,móu,wǔ",
    "堦": "jiē",
    "堧": "ruán",
    "堨": "è,ài,yè",
    "堩": "gèng",
    "堪": "kān",
    "堫": "zōng",
    "堬": "yú",
    "堭": "huáng",
    "堮": "è",
    "堯": "yáo",
    "堰": "yàn",
    "報": "bào",
    "堲": "jí",
    "堳": "méi",
    "場": "chǎng,cháng",
    "堵": "dǔ",
    "堶": "tuó",
    "堷": "yìn",
    "堸": "féng",
    "堹": "zhòng",
    "堺": "jiè",
    "堻": "jīn",
    "堼": "fēng",
    "堽": "gāng",
    "堾": "chuǎn",
    "堿": "jiǎn",
    "塀": "píng",
    "塁": "lěi",
    "塂": "jiǎng",
    "塃": "huāng",
    "塄": "léng",
    "塅": "duàn",
    "塆": "wān",
    "塇": "xuān",
    "塈": "jì",
    "塉": "jí",
    "塊": "kuài",
    "塋": "yíng",
    "塌": "tā",
    "塍": "chéng",
    "塎": "yǒng",
    "塏": "kǎi",
    "塐": "sù",
    "塑": "sù",
    "塒": "shí",
    "塓": "mì",
    "塔": "tǎ",
    "塕": "wěng",
    "塖": "chéng",
    "塗": "tú",
    "塘": "táng",
    "塙": "què",
    "塚": "zhǒng",
    "塛": "lì",
    "塜": "péng",
    "塝": "bàng",
    "塞": "sāi,sài,sè",
    "塟": "zàng",
    "塠": "duī",
    "塡": "tián",
    "塢": "wù",
    "塣": "zhèng",
    "塤": "xūn",
    "塥": "gé",
    "塦": "zhèn",
    "塧": "ài",
    "塨": "gōng",
    "塩": "yán",
    "塪": "xiàn",
    "填": "tián,zhèn",
    "塬": "yuán",
    "塭": "wēn",
    "塮": "xiè",
    "塯": "liù",
    "塰": "hǎi",
    "塱": "lǎng",
    "塲": "cháng,chǎng",
    "塳": "péng",
    "塴": "bèng",
    "塵": "chén",
    "塶": "lù",
    "塷": "lǔ",
    "塸": "ōu,qiū",
    "塹": "qiàn",
    "塺": "méi",
    "塻": "mò",
    "塼": "zhuān,tuán",
    "塽": "shuǎng",
    "塾": "shú",
    "塿": "lǒu",
    "墀": "chí",
    "墁": "màn",
    "墂": "biāo",
    "境": "jìng",
    "墄": "qī",
    "墅": "shù",
    "墆": "zhì,dì",
    "墇": "zhàng",
    "墈": "kàn",
    "墉": "yōng",
    "墊": "diàn",
    "墋": "chěn",
    "墌": "zhǐ,zhuó",
    "墍": "xì",
    "墎": "guō",
    "墏": "qiǎng",
    "墐": "jìn",
    "墑": "dì",
    "墒": "shāng",
    "墓": "mù",
    "墔": "cuī",
    "墕": "yàn",
    "墖": "tǎ",
    "増": "zēng",
    "墘": "qián",
    "墙": "qiáng",
    "墚": "liáng",
    "墛": "wèi",
    "墜": "zhuì",
    "墝": "qiāo",
    "增": "zēng",
    "墟": "xū",
    "墠": "shàn",
    "墡": "shàn",
    "墢": "fá",
    "墣": "pú",
    "墤": "kuài,tuí",
    "墥": "tuǎn,dǒng",
    "墦": "fán",
    "墧": "qiáo,què",
    "墨": "mò",
    "墩": "dūn",
    "墪": "dūn",
    "墫": "zūn,dūn",
    "墬": "dì",
    "墭": "shèng",
    "墮": "duò,huī",
    "墯": "duò",
    "墰": "tán",
    "墱": "dèng",
    "墲": "wú",
    "墳": "fén",
    "墴": "huáng",
    "墵": "tán",
    "墶": "dā",
    "墷": "yè",
    "墸": "zhù",
    "墹": "jiàn",
    "墺": "ào",
    "墻": "qiáng",
    "墼": "jī",
    "墽": "qiāo,áo",
    "墾": "kěn",
    "墿": "yì,tú",
    "壀": "pí",
    "壁": "bì",
    "壂": "diàn",
    "壃": "jiāng",
    "壄": "yě",
    "壅": "yōng",
    "壆": "xué,bó,jué",
    "壇": "tán",
    "壈": "lǎn",
    "壉": "jù",
    "壊": "huài",
    "壋": "dàng",
    "壌": "rǎng",
    "壍": "qiàn",
    "壎": "xūn",
    "壏": "xiàn,làn",
    "壐": "xǐ",
    "壑": "hè",
    "壒": "ài",
    "壓": "yā,yà",
    "壔": "dǎo",
    "壕": "háo",
    "壖": "ruán",
    "壗": "jìn",
    "壘": "lěi",
    "壙": "kuàng",
    "壚": "lú",
    "壛": "yán",
    "壜": "tán",
    "壝": "wéi",
    "壞": "huài",
    "壟": "lǒng",
    "壠": "lǒng",
    "壡": "ruǐ",
    "壢": "lì",
    "壣": "lín",
    "壤": "rǎng",
    "壥": "chán",
    "壦": "xūn",
    "壧": "yán",
    "壨": "lěi",
    "壩": "bà",
    "壪": "wān",
    "士": "shì",
    "壬": "rén",
    "壭": "san",
    "壮": "zhuàng",
    "壯": "zhuàng",
    "声": "shēng",
    "壱": "yī",
    "売": "mài",
    "壳": "ké,qiào",
    "壴": "zhù",
    "壵": "zhuàng",
    "壶": "hú",
    "壷": "hú",
    "壸": "kǔn",
    "壹": "yī",
    "壺": "hú",
    "壻": "xù",
    "壼": "kǔn",
    "壽": "shòu",
    "壾": "mǎng",
    "壿": "cún",
    "夀": "shòu",
    "夁": "yī",
    "夂": "zhǐ,zhōng",
    "夃": "gǔ,yíng",
    "处": "chù,chǔ",
    "夅": "jiàng,xiáng",
    "夆": "féng,fēng,páng",
    "备": "bèi",
    "夈": "zhāi",
    "変": "biàn",
    "夊": "suī",
    "夋": "qūn",
    "夌": "líng",
    "复": "fù",
    "夎": "cuò",
    "夏": "xià",
    "夐": "xiòng,xuàn",
    "夑": "xiè",
    "夒": "náo",
    "夓": "xià",
    "夔": "kuí",
    "夕": "xī",
    "外": "wài",
    "夗": "yuàn,wǎn,wān,yuān",
    "夘": "mǎo,wǎn",
    "夙": "sù",
    "多": "duō",
    "夛": "duō",
    "夜": "yè",
    "夝": "qíng",
    "夞": "null",
    "够": "gòu",
    "夠": "gòu",
    "夡": "qì",
    "夢": "mèng",
    "夣": "mèng",
    "夤": "yín",
    "夥": "huǒ",
    "夦": "chěn",
    "大": "dà,dài,tài",
    "夨": "cè",
    "天": "tiān",
    "太": "tài",
    "夫": "fū,fú",
    "夬": "guài",
    "夭": "yāo",
    "央": "yāng",
    "夯": "hāng,bèn",
    "夰": "gǎo",
    "失": "shī",
    "夲": "tāo,běn",
    "夳": "tài",
    "头": "tóu,tou",
    "夵": "yǎn,tāo",
    "夶": "bǐ",
    "夷": "yí",
    "夸": "kuā,kuà",
    "夹": "jiá,jiā,gā",
    "夺": "duó",
    "夻": "huà",
    "夼": "kuǎng",
    "夽": "yǔn",
    "夾": "jiá,jiā,gā",
    "夿": "bā",
    "奀": "ēn",
    "奁": "lián",
    "奂": "huàn",
    "奃": "dī,tì",
    "奄": "yǎn,yān",
    "奅": "pào",
    "奆": "juàn",
    "奇": "qí,jī",
    "奈": "nài",
    "奉": "fèng",
    "奊": "xié",
    "奋": "fèn",
    "奌": "diǎn",
    "奍": "quān,juàn",
    "奎": "kuí",
    "奏": "zòu",
    "奐": "huàn",
    "契": "qì,qiè,xiè",
    "奒": "kāi",
    "奓": "shē,chǐ,zhà",
    "奔": "bēn,bèn",
    "奕": "yì",
    "奖": "jiǎng",
    "套": "tào",
    "奘": "zàng,zhuǎng",
    "奙": "běn",
    "奚": "xī",
    "奛": "huǎng",
    "奜": "fěi",
    "奝": "diāo",
    "奞": "xùn,zhuì",
    "奟": "bēng",
    "奠": "diàn",
    "奡": "ào",
    "奢": "shē",
    "奣": "wěng",
    "奤": "pò,hǎ,tǎi",
    "奥": "ào,yù",
    "奦": "wù",
    "奧": "ào,yù",
    "奨": "jiǎng",
    "奩": "lián",
    "奪": "duó",
    "奫": "yūn",
    "奬": "jiǎng",
    "奭": "shì",
    "奮": "fèn",
    "奯": "huò",
    "奰": "bì",
    "奱": "luán",
    "奲": "duǒ,chě",
    "女": "nǚ,rǔ",
    "奴": "nú",
    "奵": "dǐng,dīng,tiǎn",
    "奶": "nǎi",
    "奷": "qiān",
    "奸": "jiān",
    "她": "tā,jiě",
    "奺": "jiǔ",
    "奻": "nuán",
    "奼": "chà",
    "好": "hǎo,hào",
    "奾": "xiān",
    "奿": "fàn",
    "妀": "jǐ",
    "妁": "shuò",
    "如": "rú",
    "妃": "fēi,pèi",
    "妄": "wàng",
    "妅": "hóng",
    "妆": "zhuāng",
    "妇": "fù",
    "妈": "mā",
    "妉": "dān",
    "妊": "rèn",
    "妋": "fū,yōu",
    "妌": "jìng",
    "妍": "yán",
    "妎": "hài,jiè",
    "妏": "wèn",
    "妐": "zhōng",
    "妑": "pā",
    "妒": "dù",
    "妓": "jì",
    "妔": "kēng,háng",
    "妕": "zhòng",
    "妖": "yāo",
    "妗": "jìn",
    "妘": "yún",
    "妙": "miào",
    "妚": "fǒu,pēi,pī",
    "妛": "chī",
    "妜": "yuè,jué",
    "妝": "zhuāng",
    "妞": "niū",
    "妟": "yàn",
    "妠": "nà,nàn",
    "妡": "xīn",
    "妢": "fén",
    "妣": "bǐ",
    "妤": "yú",
    "妥": "tuǒ",
    "妦": "fēng",
    "妧": "wàn,yuán",
    "妨": "fáng",
    "妩": "wǔ",
    "妪": "yù",
    "妫": "guī",
    "妬": "dù",
    "妭": "bá",
    "妮": "nī",
    "妯": "zhóu",
    "妰": "zhuó",
    "妱": "zhāo",
    "妲": "dá",
    "妳": "nǐ,nǎi",
    "妴": "yuàn",
    "妵": "tǒu",
    "妶": "xián,xuán,xù",
    "妷": "zhí,yì",
    "妸": "ē",
    "妹": "mèi",
    "妺": "mò",
    "妻": "qī,qì",
    "妼": "bì",
    "妽": "shēn",
    "妾": "qiè",
    "妿": "ē",
    "姀": "hé",
    "姁": "xǔ,xū",
    "姂": "fá",
    "姃": "zhēng",
    "姄": "mín",
    "姅": "bàn",
    "姆": "mǔ",
    "姇": "fū,fú",
    "姈": "líng",
    "姉": "zǐ",
    "姊": "zǐ",
    "始": "shǐ",
    "姌": "rǎn",
    "姍": "shān,shàn",
    "姎": "yāng",
    "姏": "mán",
    "姐": "jiě",
    "姑": "gū",
    "姒": "sì",
    "姓": "xìng",
    "委": "wěi,wēi",
    "姕": "zī",
    "姖": "jù",
    "姗": "shān,shàn",
    "姘": "pīn",
    "姙": "rèn",
    "姚": "yáo",
    "姛": "dòng",
    "姜": "jiāng",
    "姝": "shū",
    "姞": "jí",
    "姟": "gāi",
    "姠": "xiàng",
    "姡": "huá,huó",
    "姢": "juān",
    "姣": "jiāo,xiáo",
    "姤": "gòu,dù",
    "姥": "lǎo,mǔ",
    "姦": "jiān",
    "姧": "jiān",
    "姨": "yí",
    "姩": "nián,niàn",
    "姪": "zhí",
    "姫": "zhěn",
    "姬": "jī",
    "姭": "xiàn",
    "姮": "héng",
    "姯": "guāng",
    "姰": "xún,jūn",
    "姱": "kuā,hù",
    "姲": "yàn",
    "姳": "mǐng",
    "姴": "liè",
    "姵": "pèi",
    "姶": "è,yà",
    "姷": "yòu",
    "姸": "yán",
    "姹": "chà",
    "姺": "shēn,xiān",
    "姻": "yīn",
    "姼": "shí",
    "姽": "guǐ",
    "姾": "quán",
    "姿": "zī",
    "娀": "sōng",
    "威": "wēi",
    "娂": "hóng",
    "娃": "wá",
    "娄": "lóu",
    "娅": "yà",
    "娆": "ráo,rǎo",
    "娇": "jiāo",
    "娈": "luán",
    "娉": "pīng",
    "娊": "xiàn",
    "娋": "shào,shāo",
    "娌": "lǐ",
    "娍": "chéng,shèng",
    "娎": "xiē",
    "娏": "máng",
    "娐": "fū",
    "娑": "suō",
    "娒": "wǔ,mǔ",
    "娓": "wěi",
    "娔": "kè",
    "娕": "chuò,lài",
    "娖": "chuò",
    "娗": "tǐng",
    "娘": "niáng",
    "娙": "xíng",
    "娚": "nán",
    "娛": "yú",
    "娜": "nuó,nà",
    "娝": "pōu,bǐ",
    "娞": "něi,suī",
    "娟": "juān",
    "娠": "shēn",
    "娡": "zhì",
    "娢": "hán",
    "娣": "dì",
    "娤": "zhuāng",
    "娥": "é",
    "娦": "pín",
    "娧": "tuì",
    "娨": "mǎn",
    "娩": "miǎn",
    "娪": "wú,wù,yú",
    "娫": "yán",
    "娬": "wǔ",
    "娭": "xī,āi",
    "娮": "yán",
    "娯": "yú",
    "娰": "sì",
    "娱": "yú",
    "娲": "wā",
    "娳": "lì",
    "娴": "xián",
    "娵": "jū",
    "娶": "qǔ",
    "娷": "zhuì,shuì",
    "娸": "qī",
    "娹": "xián",
    "娺": "zhuó",
    "娻": "dōng,dòng",
    "娼": "chāng",
    "娽": "lù",
    "娾": "ǎi,ái,è",
    "娿": "ē,ě",
    "婀": "ē",
    "婁": "lóu",
    "婂": "mián",
    "婃": "cóng",
    "婄": "péi,pǒu,bù",
    "婅": "jú",
    "婆": "pó",
    "婇": "cǎi",
    "婈": "líng",
    "婉": "wǎn",
    "婊": "biǎo",
    "婋": "xiāo",
    "婌": "shū",
    "婍": "qǐ",
    "婎": "huī",
    "婏": "fù,fàn",
    "婐": "wǒ",
    "婑": "wǒ",
    "婒": "tán",
    "婓": "fēi",
    "婔": "fēi",
    "婕": "jié",
    "婖": "tiān",
    "婗": "ní,nǐ",
    "婘": "juàn,quán",
    "婙": "jìng",
    "婚": "hūn",
    "婛": "jīng",
    "婜": "qiān,jǐn",
    "婝": "diàn",
    "婞": "xìng",
    "婟": "hù",
    "婠": "wān,wà",
    "婡": "lái,lài",
    "婢": "bì",
    "婣": "yīn",
    "婤": "zhōu,chōu",
    "婥": "chuò,nào",
    "婦": "fù",
    "婧": "jìng",
    "婨": "lún",
    "婩": "nüè",
    "婪": "lán",
    "婫": "hùn,kūn",
    "婬": "yín",
    "婭": "yà",
    "婮": "jū",
    "婯": "lì",
    "婰": "diǎn",
    "婱": "xián",
    "婲": "huā",
    "婳": "huà",
    "婴": "yīng",
    "婵": "chán",
    "婶": "shěn",
    "婷": "tíng",
    "婸": "dàng,yáng",
    "婹": "yǎo",
    "婺": "wù",
    "婻": "nàn",
    "婼": "ruò,chuò",
    "婽": "jiǎ",
    "婾": "tōu,yú",
    "婿": "xù",
    "媀": "yú,yù",
    "媁": "wéi,wěi",
    "媂": "dì,tí",
    "媃": "róu",
    "媄": "měi",
    "媅": "dān",
    "媆": "ruǎn,nèn",
    "媇": "qīn",
    "媈": "huī",
    "媉": "wò",
    "媊": "qián",
    "媋": "chūn",
    "媌": "miáo",
    "媍": "fù",
    "媎": "jiě",
    "媏": "duān",
    "媐": "yí,pèi",
    "媑": "zhòng",
    "媒": "méi",
    "媓": "huáng",
    "媔": "mián,miǎn",
    "媕": "ān",
    "媖": "yīng",
    "媗": "xuān",
    "媘": "jiē",
    "媙": "wēi",
    "媚": "mèi",
    "媛": "yuàn,yuán",
    "媜": "zhēng",
    "媝": "qiū",
    "媞": "tí",
    "媟": "xiè",
    "媠": "tuó,duò",
    "媡": "liàn",
    "媢": "mào",
    "媣": "rǎn",
    "媤": "sī",
    "媥": "piān",
    "媦": "wèi",
    "媧": "wā",
    "媨": "cù",
    "媩": "hú",
    "媪": "ǎo",
    "媫": "jié",
    "媬": "bǎo",
    "媭": "xū",
    "媮": "tōu,yú",
    "媯": "guī",
    "媰": "chú,zòu",
    "媱": "yáo",
    "媲": "pì",
    "媳": "xí",
    "媴": "yuán",
    "媵": "yìng",
    "媶": "róng",
    "媷": "rù",
    "媸": "chī",
    "媹": "liú",
    "媺": "měi",
    "媻": "pán",
    "媼": "ǎo",
    "媽": "mā",
    "媾": "gòu",
    "媿": "kuì",
    "嫀": "qín,shēn",
    "嫁": "jià",
    "嫂": "sǎo",
    "嫃": "zhēn,zhěn",
    "嫄": "yuán",
    "嫅": "jiē,suǒ",
    "嫆": "róng",
    "嫇": "míng,mǐng",
    "嫈": "yīng",
    "嫉": "jí",
    "嫊": "sù",
    "嫋": "niǎo",
    "嫌": "xián",
    "嫍": "tāo",
    "嫎": "páng",
    "嫏": "láng",
    "嫐": "nǎo",
    "嫑": "biáo",
    "嫒": "ài",
    "嫓": "pì",
    "嫔": "pín",
    "嫕": "yì",
    "嫖": "piáo,piāo",
    "嫗": "yù",
    "嫘": "léi",
    "嫙": "xuán",
    "嫚": "màn",
    "嫛": "yī",
    "嫜": "zhāng",
    "嫝": "kāng",
    "嫞": "yōng",
    "嫟": "nì",
    "嫠": "lí",
    "嫡": "dí",
    "嫢": "guī",
    "嫣": "yān",
    "嫤": "jǐn,jìn",
    "嫥": "zhuān",
    "嫦": "cháng",
    "嫧": "zé",
    "嫨": "hān,nǎn",
    "嫩": "nèn",
    "嫪": "lào",
    "嫫": "mó",
    "嫬": "zhē",
    "嫭": "hù",
    "嫮": "hù",
    "嫯": "ào",
    "嫰": "nèn",
    "嫱": "qiáng",
    "嫲": "mā,má",
    "嫳": "piè",
    "嫴": "gū",
    "嫵": "wǔ",
    "嫶": "qiáo",
    "嫷": "tuǒ",
    "嫸": "zhǎn",
    "嫹": "miáo",
    "嫺": "xián",
    "嫻": "xián",
    "嫼": "mò",
    "嫽": "liáo",
    "嫾": "lián",
    "嫿": "huà",
    "嬀": "guī",
    "嬁": "dēng",
    "嬂": "zhí",
    "嬃": "xū",
    "嬄": "yī",
    "嬅": "huà",
    "嬆": "xī",
    "嬇": "kuì",
    "嬈": "ráo,rǎo",
    "嬉": "xī",
    "嬊": "yàn",
    "嬋": "chán",
    "嬌": "jiāo",
    "嬍": "měi",
    "嬎": "fàn",
    "嬏": "fān",
    "嬐": "xiān,yǎn,jìn",
    "嬑": "yì",
    "嬒": "huì",
    "嬓": "jiào",
    "嬔": "fù",
    "嬕": "shì",
    "嬖": "bì",
    "嬗": "shàn",
    "嬘": "suì",
    "嬙": "qiáng",
    "嬚": "liǎn",
    "嬛": "huán,xuān,qióng",
    "嬜": "xīn",
    "嬝": "niǎo",
    "嬞": "dǒng",
    "嬟": "yǐ",
    "嬠": "cān",
    "嬡": "ài",
    "嬢": "niáng",
    "嬣": "níng",
    "嬤": "mó",
    "嬥": "tiǎo",
    "嬦": "chóu",
    "嬧": "jìn",
    "嬨": "cí",
    "嬩": "yú",
    "嬪": "pín",
    "嬫": "róng",
    "嬬": "rú",
    "嬭": "nǎi",
    "嬮": "yān,yàn",
    "嬯": "tái",
    "嬰": "yīng",
    "嬱": "qiàn",
    "嬲": "niǎo",
    "嬳": "yuè",
    "嬴": "yíng",
    "嬵": "mián",
    "嬶": "bí",
    "嬷": "mó",
    "嬸": "shěn",
    "嬹": "xìng",
    "嬺": "nì",
    "嬻": "dú",
    "嬼": "liǔ",
    "嬽": "yuān",
    "嬾": "lǎn",
    "嬿": "yàn",
    "孀": "shuāng",
    "孁": "líng",
    "孂": "jiǎo",
    "孃": "niáng",
    "孄": "lǎn",
    "孅": "xiān,qiān",
    "孆": "yīng",
    "孇": "shuāng",
    "孈": "xié,huī",
    "孉": "huān,quán",
    "孊": "mǐ",
    "孋": "lì,lí",
    "孌": "luán",
    "孍": "yǎn",
    "孎": "zhú,chuò",
    "孏": "lǎn",
    "子": "zǐ",
    "孑": "jié",
    "孒": "jué",
    "孓": "jué",
    "孔": "kǒng",
    "孕": "yùn",
    "孖": "zī,mā",
    "字": "zì",
    "存": "cún",
    "孙": "sūn,xùn",
    "孚": "fú",
    "孛": "bèi",
    "孜": "zī",
    "孝": "xiào",
    "孞": "xìn",
    "孟": "mèng",
    "孠": "sì",
    "孡": "tāi",
    "孢": "bāo",
    "季": "jì",
    "孤": "gū",
    "孥": "nú",
    "学": "xué",
    "孧": "yòu,niū",
    "孨": "zhuǎn",
    "孩": "hái",
    "孪": "luán",
    "孫": "sūn,xùn",
    "孬": "nāo",
    "孭": "miē",
    "孮": "cóng",
    "孯": "qiān",
    "孰": "shú",
    "孱": "chán,càn",
    "孲": "yā",
    "孳": "zī",
    "孴": "nǐ",
    "孵": "fū",
    "孶": "zī",
    "孷": "lí",
    "學": "xué",
    "孹": "bò",
    "孺": "rú",
    "孻": "nái",
    "孼": "niè",
    "孽": "niè",
    "孾": "yīng",
    "孿": "luán",
    "宀": "mián",
    "宁": "níng,nìng,zhù",
    "宂": "rǒng",
    "它": "tā",
    "宄": "guǐ",
    "宅": "zhái",
    "宆": "qióng",
    "宇": "yǔ",
    "守": "shǒu",
    "安": "ān",
    "宊": "tū,jiā",
    "宋": "sòng",
    "完": "wán",
    "宍": "ròu",
    "宎": "yǎo",
    "宏": "hóng",
    "宐": "yí",
    "宑": "jǐng",
    "宒": "zhūn",
    "宓": "mì,fú",
    "宔": "zhǔ",
    "宕": "dàng",
    "宖": "hóng",
    "宗": "zōng",
    "官": "guān",
    "宙": "zhòu",
    "定": "dìng",
    "宛": "wǎn,yuān",
    "宜": "yí",
    "宝": "bǎo",
    "实": "shí",
    "実": "shí",
    "宠": "chǒng",
    "审": "shěn",
    "客": "kè",
    "宣": "xuān",
    "室": "shì",
    "宥": "yòu",
    "宦": "huàn",
    "宧": "yí",
    "宨": "tiǎo",
    "宩": "shǐ",
    "宪": "xiàn",
    "宫": "gōng",
    "宬": "chéng",
    "宭": "qún",
    "宮": "gōng",
    "宯": "xiāo",
    "宰": "zǎi",
    "宱": "zhà",
    "宲": "bǎo,shí",
    "害": "hài",
    "宴": "yàn",
    "宵": "xiāo",
    "家": "jiā,jia,jie",
    "宷": "shěn",
    "宸": "chén",
    "容": "róng",
    "宺": "huāng,huǎng",
    "宻": "mì",
    "宼": "kòu",
    "宽": "kuān",
    "宾": "bīn",
    "宿": "sù,xiǔ,xiù",
    "寀": "cǎi,cài",
    "寁": "zǎn",
    "寂": "jì",
    "寃": "yuān",
    "寄": "jì",
    "寅": "yín",
    "密": "mì",
    "寇": "kòu",
    "寈": "qīng",
    "寉": "hè",
    "寊": "zhēn",
    "寋": "jiàn",
    "富": "fù",
    "寍": "níng,nìng",
    "寎": "bǐng,bìng",
    "寏": "huán",
    "寐": "mèi",
    "寑": "qǐn",
    "寒": "hán",
    "寓": "yù",
    "寔": "shí",
    "寕": "níng,nìng",
    "寖": "qǐn,jìn",
    "寗": "níng,nìng",
    "寘": "zhì",
    "寙": "yǔ",
    "寚": "bǎo",
    "寛": "kuān",
    "寜": "níng,nìng",
    "寝": "qǐn",
    "寞": "mò",
    "察": "chá",
    "寠": "jù,lóu",
    "寡": "guǎ",
    "寢": "qǐn",
    "寣": "hū",
    "寤": "wù",
    "寥": "liáo",
    "實": "shí",
    "寧": "níng,nìng",
    "寨": "zhài",
    "審": "shěn",
    "寪": "wěi",
    "寫": "xiě,xiè",
    "寬": "kuān",
    "寭": "huì",
    "寮": "liáo",
    "寯": "jùn",
    "寰": "huán",
    "寱": "yì",
    "寲": "yí",
    "寳": "bǎo",
    "寴": "qīn,qìn",
    "寵": "chǒng",
    "寶": "bǎo",
    "寷": "fēng",
    "寸": "cùn",
    "对": "duì",
    "寺": "sì",
    "寻": "xún",
    "导": "dǎo",
    "寽": "lüè,luó",
    "対": "duì",
    "寿": "shòu",
    "尀": "pǒ",
    "封": "fēng",
    "専": "zhuān",
    "尃": "fū",
    "射": "shè,yè,yì",
    "尅": "kè,kēi",
    "将": "jiāng,jiàng",
    "將": "jiāng,jiàng",
    "專": "zhuān",
    "尉": "wèi,yù",
    "尊": "zūn",
    "尋": "xún",
    "尌": "shù,zhù",
    "對": "duì",
    "導": "dǎo",
    "小": "xiǎo",
    "尐": "jié,jí",
    "少": "shǎo,shào",
    "尒": "ěr",
    "尓": "ěr",
    "尔": "ěr",
    "尕": "gǎ",
    "尖": "jiān",
    "尗": "shú",
    "尘": "chén",
    "尙": "shàng",
    "尚": "shàng",
    "尛": "mó",
    "尜": "gá",
    "尝": "cháng",
    "尞": "liáo",
    "尟": "xiǎn",
    "尠": "xiǎn",
    "尡": "hùn",
    "尢": "yóu",
    "尣": "wāng",
    "尤": "yóu",
    "尥": "liào",
    "尦": "liào",
    "尧": "yáo",
    "尨": "lóng,máng,méng,páng",
    "尩": "wāng",
    "尪": "wāng",
    "尫": "wāng",
    "尬": "gà",
    "尭": "yáo",
    "尮": "duò",
    "尯": "kuì,kuǐ",
    "尰": "zhǒng",
    "就": "jiù",
    "尲": "gān",
    "尳": "gǔ",
    "尴": "gān",
    "尵": "tuí",
    "尶": "gān",
    "尷": "gān",
    "尸": "shī",
    "尹": "yǐn",
    "尺": "chǐ,chě",
    "尻": "kāo",
    "尼": "ní",
    "尽": "jìn,jǐn",
    "尾": "wěi,yǐ",
    "尿": "niào,suī",
    "局": "jú",
    "屁": "pì",
    "层": "céng",
    "屃": "xì",
    "屄": "bī",
    "居": "jū",
    "屆": "jiè",
    "屇": "tián",
    "屈": "qū",
    "屉": "tì",
    "届": "jiè",
    "屋": "wū",
    "屌": "diǎo",
    "屍": "shī",
    "屎": "shǐ",
    "屏": "píng,bǐng",
    "屐": "jī",
    "屑": "xiè",
    "屒": "zhěn",
    "屓": "xì",
    "屔": "ní",
    "展": "zhǎn",
    "屖": "xī",
    "屗": "wěi",
    "屘": "mǎn",
    "屙": "ē",
    "屚": "lòu",
    "屛": "pǐng,bǐng",
    "屜": "tì",
    "屝": "fèi",
    "属": "shǔ,zhǔ",
    "屟": "xiè,tì",
    "屠": "tú",
    "屡": "lǚ",
    "屢": "lǚ",
    "屣": "xǐ",
    "層": "céng",
    "履": "lǚ",
    "屦": "jù",
    "屧": "xiè",
    "屨": "jù",
    "屩": "juē",
    "屪": "liáo",
    "屫": "juē",
    "屬": "shǔ,zhǔ",
    "屭": "xì",
    "屮": "chè,cǎo",
    "屯": "tún,zhūn",
    "屰": "nì,jǐ",
    "山": "shān",
    "屲": "wā",
    "屳": "xiān",
    "屴": "lì",
    "屵": "àn",
    "屶": "huì",
    "屷": "huì",
    "屸": "hóng,lóng",
    "屹": "yì",
    "屺": "qǐ",
    "屻": "rèn",
    "屼": "wù",
    "屽": "hàn,àn",
    "屾": "shēn",
    "屿": "yǔ",
    "岀": "chū",
    "岁": "suì",
    "岂": "qǐ,kǎi",
    "岃": "rèn",
    "岄": "yuè",
    "岅": "bǎn",
    "岆": "yǎo",
    "岇": "áng",
    "岈": "yá",
    "岉": "wù",
    "岊": "jié",
    "岋": "è",
    "岌": "jí",
    "岍": "qiān",
    "岎": "fén",
    "岏": "wán",
    "岐": "qí",
    "岑": "cén",
    "岒": "qián",
    "岓": "qí",
    "岔": "chà",
    "岕": "jiè",
    "岖": "qū",
    "岗": "gǎng",
    "岘": "xiàn",
    "岙": "ào",
    "岚": "lán",
    "岛": "dǎo",
    "岜": "bā",
    "岝": "zuò",
    "岞": "zuò",
    "岟": "yǎng",
    "岠": "jù",
    "岡": "gāng",
    "岢": "kě",
    "岣": "gǒu",
    "岤": "xuè",
    "岥": "pō",
    "岦": "lì",
    "岧": "tiáo",
    "岨": "jū,jǔ",
    "岩": "yán",
    "岪": "fú",
    "岫": "xiù",
    "岬": "jiǎ",
    "岭": "lǐng,líng",
    "岮": "tuó",
    "岯": "pī",
    "岰": "ào",
    "岱": "dài",
    "岲": "kuàng",
    "岳": "yuè",
    "岴": "qū",
    "岵": "hù",
    "岶": "pò",
    "岷": "mín",
    "岸": "àn",
    "岹": "tiáo",
    "岺": "lǐng,líng",
    "岻": "dī",
    "岼": "píng",
    "岽": "dōng",
    "岾": "zhān",
    "岿": "kuī",
    "峀": "xiù",
    "峁": "mǎo",
    "峂": "tóng",
    "峃": "xué",
    "峄": "yì",
    "峅": "biàn",
    "峆": "hé",
    "峇": "kè,bā",
    "峈": "luò",
    "峉": "é",
    "峊": "fù,niè",
    "峋": "xún",
    "峌": "dié",
    "峍": "lù",
    "峎": "ěn",
    "峏": "ér",
    "峐": "gāi",
    "峑": "quán",
    "峒": "tóng,dòng",
    "峓": "yí",
    "峔": "mǔ",
    "峕": "shí",
    "峖": "ān",
    "峗": "wéi",
    "峘": "huán",
    "峙": "zhì,shì",
    "峚": "mì",
    "峛": "lǐ",
    "峜": "fǎ",
    "峝": "tóng",
    "峞": "wéi",
    "峟": "yòu",
    "峠": "qiǎ",
    "峡": "xiá",
    "峢": "lǐ",
    "峣": "yáo",
    "峤": "qiáo,jiào",
    "峥": "zhēng",
    "峦": "luán",
    "峧": "jiāo",
    "峨": "é",
    "峩": "é",
    "峪": "yù",
    "峫": "xié,yé",
    "峬": "bū",
    "峭": "qiào",
    "峮": "qún",
    "峯": "fēng",
    "峰": "fēng",
    "峱": "náo",
    "峲": "lǐ",
    "峳": "yōu",
    "峴": "xiàn",
    "峵": "róng",
    "島": "dǎo",
    "峷": "shēn",
    "峸": "chéng",
    "峹": "tú",
    "峺": "gěng",
    "峻": "jùn",
    "峼": "gào",
    "峽": "xiá",
    "峾": "yín",
    "峿": "wú",
    "崀": "lǎng",
    "崁": "kàn",
    "崂": "láo",
    "崃": "lái",
    "崄": "xiǎn",
    "崅": "què",
    "崆": "kōng",
    "崇": "chóng",
    "崈": "chóng",
    "崉": "tà",
    "崊": "lín",
    "崋": "huà",
    "崌": "jū",
    "崍": "lái",
    "崎": "qí",
    "崏": "mín",
    "崐": "kūn",
    "崑": "kūn",
    "崒": "zú,cuì",
    "崓": "gù",
    "崔": "cuī",
    "崕": "yá",
    "崖": "yá",
    "崗": "gǎng,gāng",
    "崘": "lún",
    "崙": "lún",
    "崚": "líng,léng",
    "崛": "jué",
    "崜": "duǒ",
    "崝": "zhēng",
    "崞": "guō",
    "崟": "yín",
    "崠": "dōng,dòng",
    "崡": "hán",
    "崢": "zhēng",
    "崣": "wěi",
    "崤": "xiáo",
    "崥": "pí,bǐ",
    "崦": "yān",
    "崧": "sōng",
    "崨": "jié",
    "崩": "bēng",
    "崪": "zú",
    "崫": "jué",
    "崬": "dōng",
    "崭": "zhǎn,chán",
    "崮": "gù",
    "崯": "yín",
    "崰": "zī",
    "崱": "zè",
    "崲": "huáng",
    "崳": "yú",
    "崴": "wēi,wǎi",
    "崵": "yáng,dàng",
    "崶": "fēng",
    "崷": "qiú",
    "崸": "yáng",
    "崹": "tí",
    "崺": "yǐ",
    "崻": "zhì,shì",
    "崼": "shì,dié",
    "崽": "zǎi",
    "崾": "yǎo",
    "崿": "è",
    "嵀": "zhù",
    "嵁": "kān,zhàn",
    "嵂": "lǜ",
    "嵃": "yǎn",
    "嵄": "měi",
    "嵅": "hán",
    "嵆": "jī",
    "嵇": "jī",
    "嵈": "huàn",
    "嵉": "tíng",
    "嵊": "shèng",
    "嵋": "méi",
    "嵌": "qiàn,kàn",
    "嵍": "wù,máo",
    "嵎": "yú",
    "嵏": "zōng",
    "嵐": "lán",
    "嵑": "kě,jié",
    "嵒": "yán",
    "嵓": "yán",
    "嵔": "wēi,wěi",
    "嵕": "zōng",
    "嵖": "chá",
    "嵗": "suì",
    "嵘": "róng",
    "嵙": "kē",
    "嵚": "qīn",
    "嵛": "yú",
    "嵜": "qí",
    "嵝": "lǒu",
    "嵞": "tú",
    "嵟": "cuī",
    "嵠": "xī",
    "嵡": "wěng",
    "嵢": "cāng",
    "嵣": "táng,dàng",
    "嵤": "róng,yíng",
    "嵥": "jié",
    "嵦": "kǎi,ái",
    "嵧": "liú",
    "嵨": "wù",
    "嵩": "sōng",
    "嵪": "kāo,qiāo",
    "嵫": "zī",
    "嵬": "wéi",
    "嵭": "bēng",
    "嵮": "diān",
    "嵯": "cuó",
    "嵰": "qīn,qiǎn",
    "嵱": "yǒng",
    "嵲": "niè",
    "嵳": "cuó",
    "嵴": "jǐ",
    "嵵": "shí",
    "嵶": "ruò",
    "嵷": "sǒng",
    "嵸": "zǒng",
    "嵹": "jiàng",
    "嵺": "liáo",
    "嵻": "kāng",
    "嵼": "chǎn",
    "嵽": "dié,dì",
    "嵾": "cēn",
    "嵿": "dǐng",
    "嶀": "tū",
    "嶁": "lǒu",
    "嶂": "zhàng",
    "嶃": "zhǎn,chán",
    "嶄": "zhǎn,chán",
    "嶅": "áo,ào",
    "嶆": "cáo",
    "嶇": "qū",
    "嶈": "qiāng",
    "嶉": "wěi",
    "嶊": "zuǐ",
    "嶋": "dǎo",
    "嶌": "dǎo",
    "嶍": "xí",
    "嶎": "yù",
    "嶏": "pǐ,pèi",
    "嶐": "lóng",
    "嶑": "xiàng",
    "嶒": "céng",
    "嶓": "bō",
    "嶔": "qīn",
    "嶕": "jiāo",
    "嶖": "yān",
    "嶗": "láo",
    "嶘": "zhàn",
    "嶙": "lín",
    "嶚": "liáo",
    "嶛": "liáo",
    "嶜": "qín",
    "嶝": "dèng",
    "嶞": "tuò",
    "嶟": "zūn",
    "嶠": "jiào,qiáo",
    "嶡": "jué,guì",
    "嶢": "yáo",
    "嶣": "jiāo",
    "嶤": "yáo",
    "嶥": "jué",
    "嶦": "zhān,shàn",
    "嶧": "yì",
    "嶨": "xué",
    "嶩": "náo",
    "嶪": "yè",
    "嶫": "yè",
    "嶬": "yí",
    "嶭": "niè",
    "嶮": "xiǎn",
    "嶯": "jí",
    "嶰": "xiè,jiè",
    "嶱": "kě,jié",
    "嶲": "guī,xī,juàn",
    "嶳": "dì",
    "嶴": "ào",
    "嶵": "zuì",
    "嶶": "wēi",
    "嶷": "yí",
    "嶸": "róng",
    "嶹": "dǎo",
    "嶺": "lǐng",
    "嶻": "jié",
    "嶼": "yǔ",
    "嶽": "yuè",
    "嶾": "yǐn",
    "嶿": "rū",
    "巀": "jié",
    "巁": "lì,liè",
    "巂": "guī,xī,juàn",
    "巃": "lóng",
    "巄": "lóng",
    "巅": "diān",
    "巆": "yíng,hōng",
    "巇": "xī",
    "巈": "jú",
    "巉": "chán",
    "巊": "yǐng",
    "巋": "kuī",
    "巌": "yán",
    "巍": "wēi",
    "巎": "náo",
    "巏": "quán",
    "巐": "chǎo",
    "巑": "cuán",
    "巒": "luán",
    "巓": "diān",
    "巔": "diān",
    "巕": "niè",
    "巖": "yán",
    "巗": "yán",
    "巘": "yǎn",
    "巙": "kuí",
    "巚": "yǎn",
    "巛": "chuān",
    "巜": "kuài",
    "川": "chuān",
    "州": "zhōu",
    "巟": "huāng",
    "巠": "jīng,xíng",
    "巡": "xún",
    "巢": "cháo",
    "巣": "cháo",
    "巤": "liè",
    "工": "gōng",
    "左": "zuǒ",
    "巧": "qiǎo",
    "巨": "jù",
    "巩": "gǒng",
    "巪": "jù",
    "巫": "wū",
    "巬": "gū",
    "巭": "gū",
    "差": "chà,chā,chāi,cī",
    "巯": "qiú",
    "巰": "qiú",
    "己": "jǐ",
    "已": "yǐ",
    "巳": "sì",
    "巴": "bā",
    "巵": "zhī",
    "巶": "zhāo",
    "巷": "xiàng,hàng",
    "巸": "yí",
    "巹": "jǐn",
    "巺": "xùn",
    "巻": "juǎn,juàn",
    "巼": "null",
    "巽": "xùn",
    "巾": "jīn",
    "巿": "fú",
    "帀": "zā",
    "币": "bì",
    "市": "shì",
    "布": "bù",
    "帄": "dīng",
    "帅": "shuài",
    "帆": "fān",
    "帇": "niè",
    "师": "shī",
    "帉": "fēn",
    "帊": "pà",
    "帋": "zhǐ",
    "希": "xī",
    "帍": "hù",
    "帎": "dàn",
    "帏": "wéi",
    "帐": "zhàng",
    "帑": "nú,tǎng",
    "帒": "dài",
    "帓": "mò,wà",
    "帔": "pèi",
    "帕": "pà",
    "帖": "tiě,tiè,tiē",
    "帗": "fú",
    "帘": "lián",
    "帙": "zhì",
    "帚": "zhǒu",
    "帛": "bó",
    "帜": "zhì",
    "帝": "dì",
    "帞": "mò",
    "帟": "yì",
    "帠": "yì",
    "帡": "píng",
    "帢": "qià",
    "帣": "juàn,juǎn",
    "帤": "rú",
    "帥": "shuài",
    "带": "dài",
    "帧": "zhēn",
    "帨": "shuì",
    "帩": "qiāo",
    "帪": "zhēn",
    "師": "shī",
    "帬": "qún",
    "席": "xí",
    "帮": "bāng",
    "帯": "dài",
    "帰": "guī",
    "帱": "chóu,dào",
    "帲": "píng",
    "帳": "zhàng",
    "帴": "jiǎn,jiān,sàn",
    "帵": "wān",
    "帶": "dài",
    "帷": "wéi",
    "常": "cháng",
    "帹": "shà,qiè",
    "帺": "qí,jì",
    "帻": "zé",
    "帼": "guó",
    "帽": "mào",
    "帾": "zhǔ",
    "帿": "hóu",
    "幀": "zhēn",
    "幁": "zhèng",
    "幂": "mì",
    "幃": "wéi",
    "幄": "wò",
    "幅": "fú",
    "幆": "yì",
    "幇": "bāng",
    "幈": "píng",
    "幉": "dié",
    "幊": "gōng",
    "幋": "pán",
    "幌": "huǎng",
    "幍": "tāo",
    "幎": "mì",
    "幏": "jià",
    "幐": "téng",
    "幑": "huī",
    "幒": "zhōng",
    "幓": "shān,qiāo,shēn",
    "幔": "màn",
    "幕": "mù",
    "幖": "biāo",
    "幗": "guó",
    "幘": "zé",
    "幙": "mù",
    "幚": "bāng",
    "幛": "zhàng",
    "幜": "jǐng",
    "幝": "chǎn,chàn",
    "幞": "fú",
    "幟": "zhì",
    "幠": "hū",
    "幡": "fān",
    "幢": "chuáng,zhuàng",
    "幣": "bì",
    "幤": "bì",
    "幥": "zhǎng",
    "幦": "mì",
    "幧": "qiāo",
    "幨": "chān,chàn",
    "幩": "fén",
    "幪": "méng",
    "幫": "bāng",
    "幬": "chóu,dào",
    "幭": "miè",
    "幮": "chú",
    "幯": "jié",
    "幰": "xiǎn",
    "幱": "lán",
    "干": "gān,gàn",
    "平": "píng",
    "年": "nián",
    "幵": "jiān",
    "并": "bìng,bīng",
    "幷": "bìng,bīng",
    "幸": "xìng",
    "幹": "gàn",
    "幺": "yāo",
    "幻": "huàn",
    "幼": "yòu",
    "幽": "yōu",
    "幾": "jǐ,jī",
    "广": "guǎng,ān",
    "庀": "pǐ",
    "庁": "tīng",
    "庂": "zè",
    "広": "guǎng",
    "庄": "zhuāng",
    "庅": "mó,mā,me",
    "庆": "qìng",
    "庇": "bì",
    "庈": "qín",
    "庉": "dùn,tún",
    "床": "chuáng",
    "庋": "guǐ",
    "庌": "yǎ",
    "庍": "bài,tīng",
    "庎": "jiè",
    "序": "xù",
    "庐": "lú",
    "庑": "wǔ",
    "庒": "zhuāng",
    "库": "kù",
    "应": "yīng,yìng",
    "底": "dǐ,de",
    "庖": "páo",
    "店": "diàn",
    "庘": "yā",
    "庙": "miào",
    "庚": "gēng",
    "庛": "cì",
    "府": "fǔ",
    "庝": "tóng",
    "庞": "páng",
    "废": "fèi",
    "庠": "xiáng",
    "庡": "yǐ",
    "庢": "zhì",
    "庣": "tiāo",
    "庤": "zhì",
    "庥": "xiū",
    "度": "dù,duó",
    "座": "zuò",
    "庨": "xiāo",
    "庩": "tú",
    "庪": "guǐ",
    "庫": "kù",
    "庬": "páng,máng,méng",
    "庭": "tíng",
    "庮": "yóu",
    "庯": "bū",
    "庰": "bìng,píng",
    "庱": "chěng",
    "庲": "lái",
    "庳": "bēi",
    "庴": "cuò,jī",
    "庵": "ān",
    "庶": "shù",
    "康": "kāng",
    "庸": "yōng",
    "庹": "tuǒ",
    "庺": "sōng",
    "庻": "shù",
    "庼": "qǐng",
    "庽": "yù",
    "庾": "yǔ",
    "庿": "miào",
    "廀": "sōu",
    "廁": "cè",
    "廂": "xiāng",
    "廃": "fèi",
    "廄": "jiù",
    "廅": "è",
    "廆": "guī,wěi,huì",
    "廇": "liù",
    "廈": "shà,xià",
    "廉": "lián",
    "廊": "láng",
    "廋": "sōu",
    "廌": "zhì",
    "廍": "bù",
    "廎": "qǐng",
    "廏": "jiù",
    "廐": "jiù",
    "廑": "jǐn,qín",
    "廒": "áo",
    "廓": "kuò",
    "廔": "lóu",
    "廕": "yìn",
    "廖": "liào",
    "廗": "dài",
    "廘": "lù",
    "廙": "yì",
    "廚": "chú",
    "廛": "chán",
    "廜": "tú",
    "廝": "sī",
    "廞": "xīn",
    "廟": "miào",
    "廠": "chǎng",
    "廡": "wǔ",
    "廢": "fèi",
    "廣": "guǎng",
    "廤": "kù",
    "廥": "kuài",
    "廦": "bì",
    "廧": "qiáng,sè",
    "廨": "xiè",
    "廩": "lǐn",
    "廪": "lǐn",
    "廫": "liáo",
    "廬": "lú",
    "廭": "jì",
    "廮": "yǐng",
    "廯": "xiān",
    "廰": "tīng",
    "廱": "yōng",
    "廲": "lí",
    "廳": "tīng",
    "廴": "yǐn,yìn",
    "廵": "xún",
    "延": "yán",
    "廷": "tíng",
    "廸": "dí",
    "廹": "pò,pǎi",
    "建": "jiàn",
    "廻": "huí",
    "廼": "nǎi",
    "廽": "huí",
    "廾": "gǒng",
    "廿": "niàn",
    "开": "kāi",
    "弁": "biàn",
    "异": "yì",
    "弃": "qì",
    "弄": "nòng,lòng",
    "弅": "fèn",
    "弆": "jǔ",
    "弇": "yǎn",
    "弈": "yì",
    "弉": "zàng",
    "弊": "bì",
    "弋": "yì",
    "弌": "yī",
    "弍": "èr",
    "弎": "sān",
    "式": "shì",
    "弐": "èr",
    "弑": "shì",
    "弒": "shì",
    "弓": "gōng",
    "弔": "diào",
    "引": "yǐn",
    "弖": "hù",
    "弗": "fú",
    "弘": "hóng",
    "弙": "wū",
    "弚": "tuí",
    "弛": "chí",
    "弜": "jiàng",
    "弝": "bà",
    "弞": "shěn",
    "弟": "dì,tì,tuí",
    "张": "zhāng",
    "弡": "jué,zhāng",
    "弢": "tāo",
    "弣": "fǔ",
    "弤": "dǐ",
    "弥": "mí,mǐ",
    "弦": "xián",
    "弧": "hú",
    "弨": "chāo",
    "弩": "nǔ",
    "弪": "jìng",
    "弫": "zhěn",
    "弬": "yi",
    "弭": "mǐ",
    "弮": "juàn,quān",
    "弯": "wān",
    "弰": "shāo",
    "弱": "ruò",
    "弲": "xuān,yuān",
    "弳": "jìng",
    "弴": "diāo",
    "張": "zhāng",
    "弶": "jiàng",
    "強": "qiáng,qiǎng,jiàng",
    "弸": "péng",
    "弹": "tán,dàn",
    "强": "qiáng,qiǎng,jiàng",
    "弻": "bì",
    "弼": "bì",
    "弽": "shè",
    "弾": "tán,dàn",
    "弿": "jiǎn",
    "彀": "gòu",
    "彁": "gē",
    "彂": "fā",
    "彃": "bì",
    "彄": "kōu",
    "彅": "jiǎn",
    "彆": "biè",
    "彇": "xiāo",
    "彈": "tán,dàn",
    "彉": "guō",
    "彊": "qiáng,qiǎng,jiàng",
    "彋": "hóng",
    "彌": "mí,mǐ",
    "彍": "guō",
    "彎": "wān",
    "彏": "jué",
    "彐": "jì,xuě",
    "彑": "jì",
    "归": "guī",
    "当": "dāng,dàng",
    "彔": "lù",
    "录": "lù",
    "彖": "tuàn",
    "彗": "huì",
    "彘": "zhì",
    "彙": "huì",
    "彚": "huì",
    "彛": "yí",
    "彜": "yí",
    "彝": "yí",
    "彞": "yí",
    "彟": "huò",
    "彠": "huò",
    "彡": "shān,xiǎn",
    "形": "xíng",
    "彣": "wén",
    "彤": "tóng",
    "彥": "yàn",
    "彦": "yàn",
    "彧": "yù",
    "彨": "chī",
    "彩": "cǎi",
    "彪": "biāo",
    "彫": "diāo",
    "彬": "bīn",
    "彭": "péng,bāng",
    "彮": "yǒng",
    "彯": "piāo,piào",
    "彰": "zhāng",
    "影": "yǐng",
    "彲": "chī",
    "彳": "chì",
    "彴": "zhuó,bó",
    "彵": "tuǒ,yí",
    "彶": "jí",
    "彷": "páng,fǎng",
    "彸": "zhōng",
    "役": "yì",
    "彺": "wǎng",
    "彻": "chè",
    "彼": "bǐ",
    "彽": "dī",
    "彾": "líng",
    "彿": "fù",
    "往": "wǎng",
    "征": "zhēng",
    "徂": "cú",
    "徃": "wǎng",
    "径": "jìng",
    "待": "dài,dāi",
    "徆": "xī",
    "徇": "xùn",
    "很": "hěn",
    "徉": "yáng",
    "徊": "huái",
    "律": "lǜ",
    "後": "hòu",
    "徍": "jiā,wàng,wā",
    "徎": "chěng,zhèng",
    "徏": "zhì",
    "徐": "xú",
    "徑": "jìng",
    "徒": "tú",
    "従": "cóng",
    "徔": "cóng",
    "徕": "lái,lài",
    "徖": "cóng",
    "得": "dé,děi,de",
    "徘": "pái",
    "徙": "xǐ",
    "徚": "dōng",
    "徛": "jì",
    "徜": "cháng",
    "徝": "zhì",
    "從": "cóng,zòng",
    "徟": "zhōu",
    "徠": "lái,lài",
    "御": "yù",
    "徢": "xiè",
    "徣": "jiè",
    "徤": "jiàn",
    "徥": "shì,tǐ",
    "徦": "jiǎ,xiá",
    "徧": "biàn",
    "徨": "huáng",
    "復": "fù",
    "循": "xún",
    "徫": "wěi",
    "徬": "páng",
    "徭": "yáo",
    "微": "wēi",
    "徯": "xī",
    "徰": "zhēng",
    "徱": "piào",
    "徲": "tí,chí",
    "徳": "dé",
    "徴": "zhēng,zhǐ",
    "徵": "zhēng,zhǐ",
    "徶": "bié",
    "德": "dé",
    "徸": "zhǒng,chōng",
    "徹": "chè",
    "徺": "jiǎo,yáo",
    "徻": "huì",
    "徼": "jiǎo,jiào",
    "徽": "huī",
    "徾": "méi",
    "徿": "lòng,lǒng",
    "忀": "xiāng",
    "忁": "bào",
    "忂": "qú,jù",
    "心": "xīn",
    "忄": "xīn",
    "必": "bì",
    "忆": "yì",
    "忇": "lè",
    "忈": "rén",
    "忉": "dāo",
    "忊": "dìng,tìng",
    "忋": "gǎi",
    "忌": "jì",
    "忍": "rěn",
    "忎": "rén",
    "忏": "chàn",
    "忐": "tǎn",
    "忑": "tè",
    "忒": "tè,tuī",
    "忓": "gān,hàn",
    "忔": "yì,qì",
    "忕": "shì,tài",
    "忖": "cǔn",
    "志": "zhì",
    "忘": "wàng",
    "忙": "máng",
    "忚": "xī,liě",
    "忛": "fān",
    "応": "yīng,yìng",
    "忝": "tiǎn",
    "忞": "mǐn,wěn,mín",
    "忟": "mǐn,wěn,mín",
    "忠": "zhōng",
    "忡": "chōng",
    "忢": "wù",
    "忣": "jí",
    "忤": "wǔ",
    "忥": "xì",
    "忦": "jiá",
    "忧": "yōu",
    "忨": "wán",
    "忩": "cōng",
    "忪": "sōng,zhōng",
    "快": "kuài",
    "忬": "yù,shū",
    "忭": "biàn",
    "忮": "zhì",
    "忯": "qí,shì",
    "忰": "cuì",
    "忱": "chén",
    "忲": "tài",
    "忳": "tún,zhūn,dùn",
    "忴": "qián,qín",
    "念": "niàn",
    "忶": "hún",
    "忷": "xiōng",
    "忸": "niǔ",
    "忹": "kuáng,wǎng",
    "忺": "xiān",
    "忻": "xīn",
    "忼": "kāng,hàng",
    "忽": "hū",
    "忾": "kài,xì",
    "忿": "fèn",
    "怀": "huái",
    "态": "tài",
    "怂": "sǒng",
    "怃": "wǔ",
    "怄": "òu",
    "怅": "chàng",
    "怆": "chuàng",
    "怇": "jù",
    "怈": "yì",
    "怉": "bǎo,bào",
    "怊": "chāo",
    "怋": "mín,mén",
    "怌": "pēi",
    "怍": "zuò,zhà",
    "怎": "zěn",
    "怏": "yàng",
    "怐": "kòu,jù",
    "怑": "bàn",
    "怒": "nù",
    "怓": "náo,niú",
    "怔": "zhēng",
    "怕": "pà",
    "怖": "bù",
    "怗": "tiē,zhān",
    "怘": "hù,gù",
    "怙": "hù",
    "怚": "cū,jù,zū",
    "怛": "dá",
    "怜": "lián",
    "思": "sī,sāi",
    "怞": "yóu,chóu",
    "怟": "dì",
    "怠": "dài",
    "怡": "yí",
    "怢": "tū,dié",
    "怣": "yóu",
    "怤": "fū",
    "急": "jí",
    "怦": "pēng",
    "性": "xìng",
    "怨": "yuàn",
    "怩": "ní",
    "怪": "guài",
    "怫": "fú",
    "怬": "xì",
    "怭": "bì",
    "怮": "yōu,yào",
    "怯": "qiè",
    "怰": "xuàn",
    "怱": "cōng",
    "怲": "bǐng",
    "怳": "huǎng",
    "怴": "xù,xuè",
    "怵": "chù",
    "怶": "bì,pī",
    "怷": "shù",
    "怸": "xī,shù",
    "怹": "tān",
    "怺": "yǒng",
    "总": "zǒng",
    "怼": "duì",
    "怽": "mì",
    "怾": "null",
    "怿": "yì",
    "恀": "shì",
    "恁": "nèn,nín",
    "恂": "xún",
    "恃": "shì",
    "恄": "xì",
    "恅": "lǎo",
    "恆": "héng",
    "恇": "kuāng",
    "恈": "móu",
    "恉": "zhǐ",
    "恊": "xié",
    "恋": "liàn",
    "恌": "tiāo,yáo",
    "恍": "huǎng",
    "恎": "dié",
    "恏": "hào",
    "恐": "kǒng",
    "恑": "guǐ",
    "恒": "héng",
    "恓": "xī,qī,xù",
    "恔": "xiào,jiǎo",
    "恕": "shù",
    "恖": "sī",
    "恗": "hū,kuā",
    "恘": "qiū",
    "恙": "yàng",
    "恚": "huì",
    "恛": "huí",
    "恜": "chì",
    "恝": "jiá",
    "恞": "yí",
    "恟": "xiōng",
    "恠": "guài",
    "恡": "lìn",
    "恢": "huī",
    "恣": "zì",
    "恤": "xù",
    "恥": "chǐ",
    "恦": "shàng",
    "恧": "nǜ",
    "恨": "hèn",
    "恩": "ēn",
    "恪": "kè",
    "恫": "dòng",
    "恬": "tián",
    "恭": "gōng",
    "恮": "quán,zhuān",
    "息": "xī",
    "恰": "qià",
    "恱": "yuè",
    "恲": "pēng",
    "恳": "kěn",
    "恴": "dé",
    "恵": "huì",
    "恶": "è,wù,ě,wū",
    "恷": "qiū",
    "恸": "tòng",
    "恹": "yān",
    "恺": "kǎi",
    "恻": "cè",
    "恼": "nǎo",
    "恽": "yùn",
    "恾": "máng",
    "恿": "yǒng",
    "悀": "yǒng",
    "悁": "yuān,juàn",
    "悂": "pī,pǐ",
    "悃": "kǔn",
    "悄": "qiāo,qiǎo",
    "悅": "yuè",
    "悆": "yù,shū",
    "悇": "tú",
    "悈": "jiè,kè",
    "悉": "xī",
    "悊": "zhé",
    "悋": "lìn",
    "悌": "tì",
    "悍": "hàn",
    "悎": "hào,jiào",
    "悏": "qiè",
    "悐": "tì",
    "悑": "bù",
    "悒": "yì",
    "悓": "qiàn",
    "悔": "huǐ",
    "悕": "xī",
    "悖": "bèi",
    "悗": "mán,mèn",
    "悘": "yī,yì",
    "悙": "hēng,hèng",
    "悚": "sǒng",
    "悛": "quān",
    "悜": "chěng",
    "悝": "kuī,lǐ",
    "悞": "wù",
    "悟": "wù",
    "悠": "yōu",
    "悡": "lí",
    "悢": "liàng",
    "患": "huàn",
    "悤": "cōng",
    "悥": "yì,niàn",
    "悦": "yuè",
    "悧": "lì",
    "您": "nín",
    "悩": "nǎo",
    "悪": "è",
    "悫": "què",
    "悬": "xuán",
    "悭": "qiān",
    "悮": "wù",
    "悯": "mǐn",
    "悰": "cóng",
    "悱": "fěi",
    "悲": "bēi",
    "悳": "dé",
    "悴": "cuì",
    "悵": "chàng",
    "悶": "mèn,mēn",
    "悷": "lì",
    "悸": "jì",
    "悹": "guàn",
    "悺": "guàn",
    "悻": "xìng",
    "悼": "dào",
    "悽": "qī",
    "悾": "kōng,kǒng",
    "悿": "tiǎn",
    "惀": "lǔn,lùn",
    "惁": "xī",
    "惂": "kǎn",
    "惃": "gǔn",
    "惄": "nì",
    "情": "qíng",
    "惆": "chóu",
    "惇": "dūn",
    "惈": "guǒ",
    "惉": "zhān",
    "惊": "jīng",
    "惋": "wǎn",
    "惌": "yuān,wǎn",
    "惍": "jīn",
    "惎": "jì",
    "惏": "lán,lín",
    "惐": "yù,xù",
    "惑": "huò",
    "惒": "hé,hè",
    "惓": "juàn,quán",
    "惔": "tán,dàn",
    "惕": "tì",
    "惖": "tì",
    "惗": "niàn",
    "惘": "wǎng",
    "惙": "chuò,chuì",
    "惚": "hū",
    "惛": "hūn,mèn",
    "惜": "xī",
    "惝": "chǎng",
    "惞": "xīn",
    "惟": "wéi",
    "惠": "huì",
    "惡": "è,wù,ě,wū",
    "惢": "ruǐ,suǒ",
    "惣": "zǒng",
    "惤": "jiān",
    "惥": "yǒng",
    "惦": "diàn",
    "惧": "jù",
    "惨": "cǎn",
    "惩": "chéng",
    "惪": "dé",
    "惫": "bèi",
    "惬": "qiè",
    "惭": "cán",
    "惮": "dàn,dá",
    "惯": "guàn",
    "惰": "duò",
    "惱": "nǎo",
    "惲": "yùn",
    "想": "xiǎng",
    "惴": "zhuì",
    "惵": "dié",
    "惶": "huáng",
    "惷": "chǔn",
    "惸": "qióng",
    "惹": "rě",
    "惺": "xīng",
    "惻": "cè",
    "惼": "biǎn",
    "惽": "mǐn",
    "惾": "zōng",
    "惿": "tí,shì",
    "愀": "qiǎo",
    "愁": "chóu",
    "愂": "bèi",
    "愃": "xuān",
    "愄": "wēi",
    "愅": "gé",
    "愆": "qiān",
    "愇": "wěi",
    "愈": "yù",
    "愉": "yú,tōu",
    "愊": "bì",
    "愋": "xuān",
    "愌": "huàn",
    "愍": "mǐn",
    "愎": "bì",
    "意": "yì",
    "愐": "miǎn",
    "愑": "yǒng",
    "愒": "qì,kài",
    "愓": "dàng,shāng,táng,yáng",
    "愔": "yīn",
    "愕": "è",
    "愖": "chén,xìn,dān",
    "愗": "mào",
    "愘": "kè,qià",
    "愙": "kè",
    "愚": "yú",
    "愛": "ài",
    "愜": "qiè",
    "愝": "yǎn",
    "愞": "nuò",
    "感": "gǎn",
    "愠": "yùn",
    "愡": "còng,sōng",
    "愢": "sāi,sī,sǐ",
    "愣": "lèng",
    "愤": "fèn",
    "愥": "yīng",
    "愦": "kuì",
    "愧": "kuì",
    "愨": "què",
    "愩": "gōng,gòng,hǒng",
    "愪": "yún",
    "愫": "sù",
    "愬": "sù,shuò",
    "愭": "qí",
    "愮": "yáo,yào",
    "愯": "sǒng",
    "愰": "huàng",
    "愱": "jí",
    "愲": "gǔ",
    "愳": "jù",
    "愴": "chuàng",
    "愵": "nì",
    "愶": "xié",
    "愷": "kǎi",
    "愸": "zhěng",
    "愹": "yǒng",
    "愺": "cǎo",
    "愻": "xùn",
    "愼": "shèn",
    "愽": "bó",
    "愾": "kài,xì",
    "愿": "yuàn",
    "慀": "xì,xié",
    "慁": "hùn",
    "慂": "yǒng",
    "慃": "yǎng",
    "慄": "lì",
    "慅": "sāo,cǎo",
    "慆": "tāo",
    "慇": "yīn",
    "慈": "cí",
    "慉": "xù,chù",
    "慊": "qiàn,qiè",
    "態": "tài",
    "慌": "huāng",
    "慍": "yùn",
    "慎": "shèn",
    "慏": "mǐng",
    "慐": "gōng,gòng,hǒng",
    "慑": "shè",
    "慒": "cáo,cóng",
    "慓": "piāo",
    "慔": "mù",
    "慕": "mù",
    "慖": "guó",
    "慗": "chì",
    "慘": "cǎn",
    "慙": "cán",
    "慚": "cán",
    "慛": "cuī",
    "慜": "mín",
    "慝": "tè",
    "慞": "zhāng",
    "慟": "tòng",
    "慠": "áo,ào",
    "慡": "shuǎng",
    "慢": "màn",
    "慣": "guàn",
    "慤": "què",
    "慥": "zào",
    "慦": "jiù",
    "慧": "huì",
    "慨": "kǎi",
    "慩": "lián,liǎn",
    "慪": "òu",
    "慫": "sǒng",
    "慬": "jǐn,qín,jìn",
    "慭": "yìn",
    "慮": "lǜ",
    "慯": "shāng",
    "慰": "wèi",
    "慱": "tuán",
    "慲": "mán",
    "慳": "qiān",
    "慴": "shè",
    "慵": "yōng",
    "慶": "qìng",
    "慷": "kāng",
    "慸": "dì,chì",
    "慹": "zhí,zhé",
    "慺": "lǚ,lóu",
    "慻": "juàn",
    "慼": "qī",
    "慽": "qī",
    "慾": "yù",
    "慿": "píng",
    "憀": "liáo",
    "憁": "còng",
    "憂": "yōu",
    "憃": "chōng",
    "憄": "zhī,zhì",
    "憅": "tòng",
    "憆": "chēng",
    "憇": "qì",
    "憈": "qū",
    "憉": "péng",
    "憊": "bèi",
    "憋": "biē",
    "憌": "qióng",
    "憍": "jiāo",
    "憎": "zēng",
    "憏": "chì",
    "憐": "lián",
    "憑": "píng",
    "憒": "kuì",
    "憓": "huì",
    "憔": "qiáo",
    "憕": "chéng,dèng,zhèng",
    "憖": "yìn",
    "憗": "yìn",
    "憘": "xǐ,xī",
    "憙": "xǐ",
    "憚": "dàn,dá",
    "憛": "tán",
    "憜": "duò",
    "憝": "duì",
    "憞": "duì,dùn,tūn",
    "憟": "sù",
    "憠": "jué",
    "憡": "cè",
    "憢": "xiāo,jiāo",
    "憣": "fān",
    "憤": "fèn",
    "憥": "láo",
    "憦": "lào,láo",
    "憧": "chōng",
    "憨": "hān",
    "憩": "qì",
    "憪": "xián,xiàn",
    "憫": "mǐn",
    "憬": "jǐng",
    "憭": "liǎo,liáo",
    "憮": "wǔ",
    "憯": "cǎn",
    "憰": "jué",
    "憱": "cù",
    "憲": "xiàn",
    "憳": "tǎn",
    "憴": "shéng",
    "憵": "pī",
    "憶": "yì",
    "憷": "chù",
    "憸": "xiān",
    "憹": "náo,nǎo,náng",
    "憺": "dàn",
    "憻": "tǎn",
    "憼": "jǐng,jìng",
    "憽": "sōng",
    "憾": "hàn",
    "憿": "jiǎo,jǐ",
    "懀": "wèi",
    "懁": "xuān,huān",
    "懂": "dǒng",
    "懃": "qín",
    "懄": "qín",
    "懅": "jù",
    "懆": "cǎo,sāo,sào",
    "懇": "kěn",
    "懈": "xiè",
    "應": "yīng,yìng",
    "懊": "ào",
    "懋": "mào",
    "懌": "yì",
    "懍": "lǐn",
    "懎": "sè",
    "懏": "jùn",
    "懐": "huái",
    "懑": "mèn",
    "懒": "lǎn",
    "懓": "ài",
    "懔": "lǐn",
    "懕": "yān",
    "懖": "guō",
    "懗": "xià",
    "懘": "chì",
    "懙": "yǔ,yú",
    "懚": "yìn",
    "懛": "dāi",
    "懜": "mèng,méng,měng",
    "懝": "ài,yì,nǐ",
    "懞": "méng,měng",
    "懟": "duì",
    "懠": "qí,jī,jì",
    "懡": "mǒ",
    "懢": "lán,xiàn",
    "懣": "mèn",
    "懤": "chóu",
    "懥": "zhì",
    "懦": "nuò",
    "懧": "nuò",
    "懨": "yān",
    "懩": "yǎng",
    "懪": "bó",
    "懫": "zhì",
    "懬": "kuàng",
    "懭": "kuǎng",
    "懮": "yōu,yǒu",
    "懯": "fū",
    "懰": "liú,liǔ",
    "懱": "miè",
    "懲": "chéng",
    "懳": "huì",
    "懴": "chàn",
    "懵": "měng",
    "懶": "lǎn",
    "懷": "huái",
    "懸": "xuán",
    "懹": "ràng",
    "懺": "chàn",
    "懻": "jì",
    "懼": "jù",
    "懽": "huān",
    "懾": "shè",
    "懿": "yì",
    "戀": "liàn",
    "戁": "nǎn",
    "戂": "mí,mó",
    "戃": "tǎng",
    "戄": "jué",
    "戅": "gàng,zhuàng",
    "戆": "gàng,zhuàng",
    "戇": "gàng,zhuàng",
    "戈": "gē",
    "戉": "yuè",
    "戊": "wù",
    "戋": "jiān",
    "戌": "xū",
    "戍": "shù",
    "戎": "róng",
    "戏": "xì,hū",
    "成": "chéng",
    "我": "wǒ",
    "戒": "jiè",
    "戓": "gē",
    "戔": "jiān",
    "戕": "qiāng",
    "或": "huò",
    "戗": "qiāng,qiàng",
    "战": "zhàn",
    "戙": "dòng",
    "戚": "qī",
    "戛": "jiá",
    "戜": "dié",
    "戝": "zéi",
    "戞": "jiá",
    "戟": "jǐ",
    "戠": "zhí",
    "戡": "kān",
    "戢": "jí",
    "戣": "kuí",
    "戤": "gài",
    "戥": "děng",
    "戦": "zhàn",
    "戧": "qiāng,qiàng",
    "戨": "gē",
    "戩": "jiǎn",
    "截": "jié",
    "戫": "yù",
    "戬": "jiǎn",
    "戭": "yǎn",
    "戮": "lù",
    "戯": "xì,hū",
    "戰": "zhàn",
    "戱": "xì,hū",
    "戲": "xì,hū",
    "戳": "chuō",
    "戴": "dài",
    "戵": "qú",
    "戶": "hù",
    "户": "hù",
    "戸": "hù",
    "戹": "è",
    "戺": "shì",
    "戻": "tì",
    "戼": "mǎo",
    "戽": "hù",
    "戾": "lì",
    "房": "fáng",
    "所": "suǒ",
    "扁": "biǎn,piān",
    "扂": "diàn",
    "扃": "jiōng",
    "扄": "shǎng,jiōng",
    "扅": "yí",
    "扆": "yǐ",
    "扇": "shàn,shān",
    "扈": "hù",
    "扉": "fēi",
    "扊": "yǎn",
    "手": "shǒu",
    "扌": "shǒu",
    "才": "cái",
    "扎": "zā,zhā,zhá",
    "扏": "qiú",
    "扐": "lè,lì,cái",
    "扑": "pū",
    "扒": "bā,pá",
    "打": "dǎ,dá",
    "扔": "rēng",
    "払": "fǎn,fú",
    "扖": "rù",
    "扗": "zài",
    "托": "tuō",
    "扙": "zhàng",
    "扚": "diǎo,dí,yuē,lì",
    "扛": "káng,gāng",
    "扜": "yū,wū",
    "扝": "yū,wū,kū",
    "扞": "hàn",
    "扟": "shēn",
    "扠": "chā",
    "扡": "tuō,chǐ,yǐ",
    "扢": "gǔ,xì,gē,jié",
    "扣": "kòu",
    "扤": "wù",
    "扥": "dèn",
    "扦": "qiān",
    "执": "zhí",
    "扨": "rèn",
    "扩": "kuò",
    "扪": "mén",
    "扫": "sǎo,sào",
    "扬": "yáng",
    "扭": "niǔ",
    "扮": "bàn",
    "扯": "chě",
    "扰": "rǎo",
    "扱": "xī,chā,qì",
    "扲": "qián,qín",
    "扳": "bān",
    "扴": "jiá",
    "扵": "yú",
    "扶": "fú",
    "扷": "bā,ào",
    "扸": "xī,zhé",
    "批": "pī",
    "扺": "zhǐ",
    "扻": "zhì,sǔn,kǎn",
    "扼": "è",
    "扽": "dèn",
    "找": "zhǎo",
    "承": "chéng",
    "技": "jì",
    "抁": "yǎn",
    "抂": "kuáng,wǎng,zài",
    "抃": "biàn",
    "抄": "chāo",
    "抅": "jū",
    "抆": "wěn",
    "抇": "hú,gǔ",
    "抈": "yuè",
    "抉": "jué",
    "把": "bǎ,bà",
    "抋": "qìn",
    "抌": "dǎn,shěn",
    "抍": "zhěng",
    "抎": "yǔn",
    "抏": "wán",
    "抐": "nè,nì,ruì,nà",
    "抑": "yì",
    "抒": "shū",
    "抓": "zhuā",
    "抔": "póu",
    "投": "tóu",
    "抖": "dǒu",
    "抗": "kàng",
    "折": "zhé,zhē,shé",
    "抙": "póu,pōu,fū",
    "抚": "fǔ",
    "抛": "pāo",
    "抜": "bá",
    "抝": "ǎo,ào,niù",
    "択": "zé",
    "抟": "tuán",
    "抠": "kōu",
    "抡": "lūn,lún",
    "抢": "qiǎng,qiāng,chēng",
    "抣": "yún",
    "护": "hù",
    "报": "bào",
    "抦": "bǐng",
    "抧": "zhǐ,zhǎi",
    "抨": "pēng",
    "抩": "nán",
    "抪": "bù,pū",
    "披": "pī",
    "抬": "tái",
    "抭": "yǎo,tāo",
    "抮": "zhěn",
    "抯": "zhā",
    "抰": "yāng",
    "抱": "bào",
    "抲": "hē,hè,qiā",
    "抳": "nǐ,ní",
    "抴": "yè",
    "抵": "dǐ",
    "抶": "chì",
    "抷": "pī,pēi",
    "抸": "jiā",
    "抹": "mǒ,mò,mā",
    "抺": "mèi",
    "抻": "chēn",
    "押": "yā",
    "抽": "chōu",
    "抾": "qū",
    "抿": "mǐn",
    "拀": "zhù",
    "拁": "jiā,yá",
    "拂": "fú,bì",
    "拃": "zhǎ",
    "拄": "zhǔ",
    "担": "dān,dàn,dǎn",
    "拆": "chāi,cā",
    "拇": "mǔ",
    "拈": "niān",
    "拉": "lā,lá",
    "拊": "fǔ",
    "拋": "pāo",
    "拌": "bàn,pàn",
    "拍": "pāi",
    "拎": "līn",
    "拏": "ná",
    "拐": "guǎi",
    "拑": "qián",
    "拒": "jù",
    "拓": "tuò,tà,zhí",
    "拔": "bá",
    "拕": "tuō",
    "拖": "tuō",
    "拗": "ào,niù,ǎo",
    "拘": "jū,gōu",
    "拙": "zhuō",
    "拚": "pīn,pàn,fān",
    "招": "zhāo",
    "拜": "bài",
    "拝": "bài",
    "拞": "dǐ",
    "拟": "nǐ",
    "拠": "jù",
    "拡": "kuò",
    "拢": "lǒng",
    "拣": "jiǎn",
    "拤": "qiǎ",
    "拥": "yōng",
    "拦": "lán",
    "拧": "nǐng,níng,nìng",
    "拨": "bō",
    "择": "zé,zhái",
    "拪": "qiān",
    "拫": "hén",
    "括": "kuò,guā",
    "拭": "shì",
    "拮": "jié,jiá",
    "拯": "zhěng",
    "拰": "nǐn",
    "拱": "gǒng",
    "拲": "gǒng",
    "拳": "quán",
    "拴": "shuān",
    "拵": "cún,zùn",
    "拶": "zā,zǎn",
    "拷": "kǎo",
    "拸": "yí,chǐ,hài",
    "拹": "xié",
    "拺": "cè,sè,chuò",
    "拻": "huī",
    "拼": "pīn",
    "拽": "zhuài,zhuāi,yè",
    "拾": "shí,shè",
    "拿": "ná",
    "挀": "bāi",
    "持": "chí",
    "挂": "guà",
    "挃": "zhì",
    "挄": "kuò,guāng",
    "挅": "duò",
    "挆": "duǒ,duò",
    "指": "zhǐ",
    "挈": "qiè",
    "按": "àn",
    "挊": "nòng",
    "挋": "zhèn",
    "挌": "gé",
    "挍": "jiào",
    "挎": "kuà,kū",
    "挏": "dòng",
    "挐": "rú,ná",
    "挑": "tiāo,tiǎo",
    "挒": "liè",
    "挓": "zhā",
    "挔": "lǚ",
    "挕": "dié,shè",
    "挖": "wā",
    "挗": "jué",
    "挘": "liě",
    "挙": "jǔ",
    "挚": "zhì",
    "挛": "luán",
    "挜": "yà,yǎ",
    "挝": "wō,zhuā",
    "挞": "tà",
    "挟": "xié,jiā",
    "挠": "náo",
    "挡": "dǎng,dàng",
    "挢": "jiǎo",
    "挣": "zhèng,zhēng",
    "挤": "jǐ",
    "挥": "huī",
    "挦": "xián",
    "挧": "yǔ",
    "挨": "āi,ái",
    "挩": "tuō,shuì",
    "挪": "nuó",
    "挫": "cuò",
    "挬": "bó",
    "挭": "gěng",
    "挮": "tǐ,tì",
    "振": "zhèn",
    "挰": "chéng",
    "挱": "suō,shā",
    "挲": "suō,shā",
    "挳": "kēng,qiān",
    "挴": "měi",
    "挵": "nòng",
    "挶": "jú",
    "挷": "bàng,péng",
    "挸": "jiǎn",
    "挹": "yì",
    "挺": "tǐng",
    "挻": "shān",
    "挼": "ruó",
    "挽": "wǎn",
    "挾": "xié,jiā",
    "挿": "chā",
    "捀": "péng",
    "捁": "jiǎo,kù",
    "捂": "wǔ",
    "捃": "jùn",
    "捄": "jiù",
    "捅": "tǒng",
    "捆": "kǔn",
    "捇": "huò,chì",
    "捈": "tú,shū,chá",
    "捉": "zhuō",
    "捊": "póu,pōu,fū",
    "捋": "luō,lǚ",
    "捌": "bā",
    "捍": "hàn",
    "捎": "shāo,shào",
    "捏": "niē",
    "捐": "juān",
    "捑": "zè",
    "捒": "shù,sǒng,sōu",
    "捓": "yé,yú",
    "捔": "jué,zhuó",
    "捕": "bǔ",
    "捖": "wán",
    "捗": "bù,pú,zhì",
    "捘": "zùn",
    "捙": "yè",
    "捚": "zhāi",
    "捛": "lǚ",
    "捜": "sōu",
    "捝": "tuō,shuì",
    "捞": "lāo",
    "损": "sǔn",
    "捠": "bāng",
    "捡": "jiǎn",
    "换": "huàn",
    "捣": "dǎo",
    "捤": "wěi",
    "捥": "wàn,wǎn,wān,yù",
    "捦": "qín",
    "捧": "pěng",
    "捨": "shě",
    "捩": "liè",
    "捪": "mín",
    "捫": "mén",
    "捬": "fǔ,fù,bǔ",
    "捭": "bǎi",
    "据": "jù,jū",
    "捯": "dáo",
    "捰": "wǒ,luò,luǒ",
    "捱": "ái",
    "捲": "juǎn,quán",
    "捳": "yuè",
    "捴": "zǒng",
    "捵": "chēn",
    "捶": "chuí",
    "捷": "jié",
    "捸": "tū",
    "捹": "bèn",
    "捺": "nà",
    "捻": "niǎn,niē",
    "捼": "ruó,wěi,ré",
    "捽": "zuó",
    "捾": "wò,xiá",
    "捿": "qī",
    "掀": "xiān",
    "掁": "chéng",
    "掂": "diān",
    "掃": "sǎo,sào",
    "掄": "lūn,lún",
    "掅": "qìng,qiàn",
    "掆": "gāng",
    "掇": "duō",
    "授": "shòu",
    "掉": "diào",
    "掊": "pǒu,póu",
    "掋": "dǐ",
    "掌": "zhǎng",
    "掍": "hùn",
    "掎": "jǐ",
    "掏": "tāo",
    "掐": "qiā",
    "掑": "qí",
    "排": "pái,pǎi",
    "掓": "shū",
    "掔": "qiān,wàn",
    "掕": "líng",
    "掖": "yè,yē",
    "掗": "yà,yǎ",
    "掘": "jué",
    "掙": "zhēng,zhèng",
    "掚": "liǎng",
    "掛": "guà",
    "掜": "nǐ,niè,yì",
    "掝": "huò,xù",
    "掞": "shàn,yàn,yǎn",
    "掟": "zhěng,dìng",
    "掠": "lüè",
    "採": "cǎi",
    "探": "tàn",
    "掣": "chè",
    "掤": "bīng",
    "接": "jiē",
    "掦": "tì",
    "控": "kòng",
    "推": "tuī",
    "掩": "yǎn",
    "措": "cuò",
    "掫": "zōu,zhōu,chōu",
    "掬": "jū",
    "掭": "tiàn",
    "掮": "qián",
    "掯": "kèn",
    "掰": "bāi",
    "掱": "pá",
    "掲": "jiē",
    "掳": "lǔ",
    "掴": "guó",
    "掵": "mìng",
    "掶": "jié",
    "掷": "zhì",
    "掸": "dǎn,shàn",
    "掹": "mēng",
    "掺": "chān,xiān,càn,shǎn",
    "掻": "sāo",
    "掼": "guàn",
    "掽": "pèng",
    "掾": "yuàn",
    "掿": "nuò",
    "揀": "jiǎn",
    "揁": "zhēng,kēng",
    "揂": "jiū,yóu",
    "揃": "jiǎn,jiān",
    "揄": "yú",
    "揅": "yán",
    "揆": "kuí",
    "揇": "nǎn",
    "揈": "hōng",
    "揉": "róu",
    "揊": "pì,chè",
    "揋": "wēi",
    "揌": "sāi",
    "揍": "zòu",
    "揎": "xuān",
    "描": "miáo",
    "提": "tí,dī,dǐ",
    "揑": "niē",
    "插": "chā",
    "揓": "shì",
    "揔": "zǒng,sōng",
    "揕": "zhèn,zhēn",
    "揖": "yī",
    "揗": "xún",
    "揘": "huáng,yóng",
    "揙": "biǎn",
    "揚": "yáng",
    "換": "huàn",
    "揜": "yǎn",
    "揝": "zǎn,zuàn",
    "揞": "ǎn",
    "揟": "xū,jū",
    "揠": "yà",
    "握": "wò",
    "揢": "ké,qiā",
    "揣": "chuài,chuǎi,chuāi,tuán,zhuī",
    "揤": "jí",
    "揥": "tì,dì",
    "揦": "là,lá",
    "揧": "là",
    "揨": "chéng",
    "揩": "kāi",
    "揪": "jiū",
    "揫": "jiū",
    "揬": "tú",
    "揭": "jiē,qì",
    "揮": "huī",
    "揯": "gèn",
    "揰": "chòng,dǒng",
    "揱": "xiāo",
    "揲": "shé,dié,yè",
    "揳": "xiē",
    "援": "yuán",
    "揵": "qián,jiàn,jiǎn",
    "揶": "yé",
    "揷": "chā",
    "揸": "zhā",
    "揹": "bēi",
    "揺": "yáo",
    "揻": "wēi",
    "揼": "bèng",
    "揽": "lǎn",
    "揾": "wèn",
    "揿": "qìn",
    "搀": "chān",
    "搁": "gē,gé",
    "搂": "lǒu,lōu",
    "搃": "zǒng",
    "搄": "gèn",
    "搅": "jiǎo",
    "搆": "gòu",
    "搇": "qìn",
    "搈": "róng",
    "搉": "què",
    "搊": "chōu,zǒu",
    "搋": "chuāi",
    "搌": "zhǎn",
    "損": "sǔn",
    "搎": "sūn",
    "搏": "bó",
    "搐": "chù",
    "搑": "róng,náng,nǎng",
    "搒": "bàng,péng",
    "搓": "cuō",
    "搔": "sāo",
    "搕": "kē,è",
    "搖": "yáo",
    "搗": "dǎo",
    "搘": "zhī",
    "搙": "nù,nuò,nòu",
    "搚": "lā,xié,xiàn",
    "搛": "jiān",
    "搜": "sōu",
    "搝": "qiǔ",
    "搞": "gǎo",
    "搟": "xiǎn,xiān",
    "搠": "shuò",
    "搡": "sǎng",
    "搢": "jìn",
    "搣": "miè",
    "搤": "è",
    "搥": "chuí",
    "搦": "nuò",
    "搧": "shān",
    "搨": "tà",
    "搩": "jié,zhé",
    "搪": "táng",
    "搫": "pán,bān,pó",
    "搬": "bān",
    "搭": "dā",
    "搮": "lì",
    "搯": "tāo",
    "搰": "hú",
    "搱": "zhì,nái",
    "搲": "wā,wǎ,wà",
    "搳": "huá",
    "搴": "qiān",
    "搵": "wèn",
    "搶": "qiāng,qiǎng,chēng",
    "搷": "tián,shēn",
    "搸": "zhēn",
    "搹": "è",
    "携": "xié",
    "搻": "ná,nuò",
    "搼": "quán",
    "搽": "chá",
    "搾": "zhà",
    "搿": "gé",
    "摀": "wǔ",
    "摁": "èn",
    "摂": "shè",
    "摃": "gāng",
    "摄": "shè,niè",
    "摅": "shū",
    "摆": "bǎi",
    "摇": "yáo",
    "摈": "bìn",
    "摉": "sōu",
    "摊": "tān",
    "摋": "sà,shā,shǎi",
    "摌": "chǎn,sùn",
    "摍": "suō",
    "摎": "jiū,liú,liáo,jiǎo,náo",
    "摏": "chōng",
    "摐": "chuāng",
    "摑": "guó",
    "摒": "bìng",
    "摓": "féng,pěng",
    "摔": "shuāi",
    "摕": "dì,tú,zhí",
    "摖": "qì,jì,chá",
    "摗": "sōu,sǒng",
    "摘": "zhāi",
    "摙": "liǎn,liàn",
    "摚": "chēng",
    "摛": "chī",
    "摜": "guàn",
    "摝": "lù",
    "摞": "luò",
    "摟": "lǒu,lōu",
    "摠": "zǒng",
    "摡": "gài,xì",
    "摢": "hù,chū",
    "摣": "zhā",
    "摤": "qiāng",
    "摥": "tàng",
    "摦": "huà",
    "摧": "cuī",
    "摨": "zhì,nái",
    "摩": "mó,mā",
    "摪": "jiāng,qiàng",
    "摫": "guī",
    "摬": "yǐng",
    "摭": "zhí",
    "摮": "áo,qiáo",
    "摯": "zhì",
    "摰": "niè,chè",
    "摱": "mán,màn",
    "摲": "chàn,cán",
    "摳": "kōu",
    "摴": "chū",
    "摵": "sè,mí,sù",
    "摶": "tuán",
    "摷": "jiǎo,chāo",
    "摸": "mō",
    "摹": "mó",
    "摺": "zhé",
    "摻": "chān,xiān,càn,shǎn",
    "摼": "kēng,qiān",
    "摽": "biào,biāo",
    "摾": "jiàng",
    "摿": "yáo",
    "撀": "gòu",
    "撁": "qiān",
    "撂": "liào",
    "撃": "jī",
    "撄": "yīng",
    "撅": "juē,jué",
    "撆": "piē",
    "撇": "piē,piě",
    "撈": "lāo",
    "撉": "dūn",
    "撊": "xiàn",
    "撋": "ruán",
    "撌": "guì",
    "撍": "zǎn,zān,zēn,qián",
    "撎": "yī",
    "撏": "xián",
    "撐": "chēng",
    "撑": "chēng",
    "撒": "sā,sǎ",
    "撓": "náo",
    "撔": "hòng",
    "撕": "sī",
    "撖": "hàn",
    "撗": "héng,guàng",
    "撘": "dā",
    "撙": "zǔn",
    "撚": "niǎn",
    "撛": "lǐn",
    "撜": "zhěng,chéng",
    "撝": "huī,wéi",
    "撞": "zhuàng",
    "撟": "jiǎo",
    "撠": "jǐ",
    "撡": "cāo",
    "撢": "dǎn",
    "撣": "dǎn,shàn",
    "撤": "chè",
    "撥": "bō",
    "撦": "chě",
    "撧": "juē",
    "撨": "xiāo,sōu",
    "撩": "liāo,liáo",
    "撪": "bèn",
    "撫": "fǔ",
    "撬": "qiào",
    "播": "bō",
    "撮": "cuō,zuǒ",
    "撯": "zhuó",
    "撰": "zhuàn",
    "撱": "wěi,tuǒ",
    "撲": "pū",
    "撳": "qìn",
    "撴": "dūn",
    "撵": "niǎn",
    "撶": "huá",
    "撷": "xié",
    "撸": "lū",
    "撹": "jiǎo",
    "撺": "cuān",
    "撻": "tà",
    "撼": "hàn",
    "撽": "qiào,yāo,jī",
    "撾": "zhuā,wō",
    "撿": "jiǎn",
    "擀": "gǎn",
    "擁": "yōng",
    "擂": "léi,lèi",
    "擃": "nǎng",
    "擄": "lǔ",
    "擅": "shàn",
    "擆": "zhuó",
    "擇": "zé,zhái",
    "擈": "pǔ",
    "擉": "chuò",
    "擊": "jī",
    "擋": "dǎng,dàng",
    "擌": "sè",
    "操": "cāo",
    "擎": "qíng",
    "擏": "qíng,jǐng",
    "擐": "huàn",
    "擑": "jiē",
    "擒": "qín",
    "擓": "kuǎi",
    "擔": "dān,dàn",
    "擕": "xié",
    "擖": "qiā,jiā,yè",
    "擗": "pǐ,bò",
    "擘": "bò,bāi",
    "擙": "ào",
    "據": "jù,jū",
    "擛": "yè",
    "擜": "è",
    "擝": "mēng",
    "擞": "sòu,sǒu",
    "擟": "mí",
    "擠": "jǐ",
    "擡": "tái",
    "擢": "zhuó",
    "擣": "dǎo",
    "擤": "xǐng",
    "擥": "lǎn",
    "擦": "cā",
    "擧": "jǔ",
    "擨": "yē",
    "擩": "rǔ",
    "擪": "yè",
    "擫": "yè",
    "擬": "nǐ",
    "擭": "huò",
    "擮": "jié",
    "擯": "bìn",
    "擰": "níng,nǐng,nìng",
    "擱": "gē,gé",
    "擲": "zhì",
    "擳": "zhì,jié",
    "擴": "kuò",
    "擵": "mó",
    "擶": "jiàn",
    "擷": "xié",
    "擸": "liè,là",
    "擹": "tān",
    "擺": "bǎi",
    "擻": "sǒu,sòu",
    "擼": "lū",
    "擽": "lì,luò,yuè",
    "擾": "rǎo",
    "擿": "tī,zhì,zhāi",
    "攀": "pān",
    "攁": "yǎng",
    "攂": "léi,lèi",
    "攃": "cā,sǎ",
    "攄": "shū",
    "攅": "zǎn",
    "攆": "niǎn",
    "攇": "xiǎn",
    "攈": "jùn,pèi",
    "攉": "huō",
    "攊": "lì,luò",
    "攋": "là,lài",
    "攌": "huàn",
    "攍": "yíng",
    "攎": "lú,luó",
    "攏": "lǒng",
    "攐": "qiān",
    "攑": "qiān",
    "攒": "zǎn,cuán",
    "攓": "qiān",
    "攔": "lán",
    "攕": "xiān,jiān",
    "攖": "yīng",
    "攗": "méi",
    "攘": "rǎng",
    "攙": "chān",
    "攚": "wěng",
    "攛": "cuān",
    "攜": "xié",
    "攝": "shè,niè",
    "攞": "luó",
    "攟": "jùn",
    "攠": "mí,mǐ,mó",
    "攡": "chī",
    "攢": "zǎn,cuán",
    "攣": "luán",
    "攤": "tān",
    "攥": "zuàn",
    "攦": "lì,shài",
    "攧": "diān",
    "攨": "wā",
    "攩": "dǎng",
    "攪": "jiǎo",
    "攫": "jué",
    "攬": "lǎn",
    "攭": "lì,luǒ",
    "攮": "nǎng",
    "支": "zhī",
    "攰": "guì",
    "攱": "guǐ,guì",
    "攲": "qī,yǐ,jī",
    "攳": "xún",
    "攴": "pū",
    "攵": "pū",
    "收": "shōu",
    "攷": "kǎo",
    "攸": "yōu",
    "改": "gǎi",
    "攺": "yǐ",
    "攻": "gōng",
    "攼": "gān,hàn",
    "攽": "bān",
    "放": "fàng",
    "政": "zhèng",
    "敀": "pò",
    "敁": "diān",
    "敂": "kòu",
    "敃": "mǐn",
    "敄": "wù,móu",
    "故": "gù",
    "敆": "hé",
    "敇": "cè",
    "效": "xiào",
    "敉": "mǐ",
    "敊": "chù,shōu",
    "敋": "gé,guó,è",
    "敌": "dí",
    "敍": "xù",
    "敎": "jiào,jiāo",
    "敏": "mǐn",
    "敐": "chén",
    "救": "jiù",
    "敒": "shēn",
    "敓": "duó,duì",
    "敔": "yǔ",
    "敕": "chì",
    "敖": "áo",
    "敗": "bài",
    "敘": "xù",
    "教": "jiào,jiāo",
    "敚": "duó,duì",
    "敛": "liǎn",
    "敜": "niè",
    "敝": "bì",
    "敞": "chǎng",
    "敟": "diǎn",
    "敠": "duō,què",
    "敡": "yì",
    "敢": "gǎn",
    "散": "sàn,sǎn",
    "敤": "kě",
    "敥": "yàn",
    "敦": "dūn,duì",
    "敧": "qī,yǐ,jī",
    "敨": "tǒu",
    "敩": "xiào,xué",
    "敪": "duō,què",
    "敫": "jiǎo",
    "敬": "jìng",
    "敭": "yáng",
    "敮": "xiá",
    "敯": "mǐn",
    "数": "shǔ,shù,shuò",
    "敱": "ái,zhú",
    "敲": "qiāo",
    "敳": "ái",
    "整": "zhěng",
    "敵": "dí",
    "敶": "chén",
    "敷": "fū",
    "數": "shǔ,shù,shuò",
    "敹": "liáo",
    "敺": "qū",
    "敻": "xiòng,xuàn",
    "敼": "yǐ",
    "敽": "jiǎo",
    "敾": "shàn",
    "敿": "jiǎo",
    "斀": "zhuó,zhú",
    "斁": "yì,dù",
    "斂": "liǎn",
    "斃": "bì",
    "斄": "lí,tái",
    "斅": "xiào",
    "斆": "xiào",
    "文": "wén",
    "斈": "xué",
    "斉": "qí",
    "斊": "qí",
    "斋": "zhāi",
    "斌": "bīn",
    "斍": "jué,jiào",
    "斎": "zhāi",
    "斏": "láng",
    "斐": "fěi,fēi",
    "斑": "bān",
    "斒": "bān",
    "斓": "lán",
    "斔": "yǔ,zhōng",
    "斕": "lán",
    "斖": "wěi,mén",
    "斗": "dòu,dǒu",
    "斘": "shēng",
    "料": "liào",
    "斚": "jiǎ",
    "斛": "hú",
    "斜": "xié",
    "斝": "jiǎ",
    "斞": "yǔ",
    "斟": "zhēn",
    "斠": "jiào",
    "斡": "wò,guǎn",
    "斢": "tǒu,tiǎo",
    "斣": "dòu",
    "斤": "jīn",
    "斥": "chì",
    "斦": "yín,zhì",
    "斧": "fǔ",
    "斨": "qiāng",
    "斩": "zhǎn",
    "斪": "qú",
    "斫": "zhuó",
    "斬": "zhǎn",
    "断": "duàn",
    "斮": "zhuó",
    "斯": "sī",
    "新": "xīn",
    "斱": "zhuó",
    "斲": "zhuó",
    "斳": "qín",
    "斴": "lín",
    "斵": "zhuó",
    "斶": "chù",
    "斷": "duàn",
    "斸": "zhú",
    "方": "fāng",
    "斺": "chǎn,jiè",
    "斻": "háng",
    "於": "yú,wū",
    "施": "shī",
    "斾": "pèi",
    "斿": "liú,yóu",
    "旀": "mèi",
    "旁": "páng,bàng",
    "旂": "qí",
    "旃": "zhān",
    "旄": "máo,mào",
    "旅": "lǚ",
    "旆": "pèi",
    "旇": "pī,bì",
    "旈": "liú",
    "旉": "fū",
    "旊": "fǎng",
    "旋": "xuán,xuàn",
    "旌": "jīng",
    "旍": "jīng",
    "旎": "nǐ",
    "族": "zú",
    "旐": "zhào",
    "旑": "yǐ",
    "旒": "liú",
    "旓": "shāo",
    "旔": "jiàn",
    "旕": "null",
    "旖": "yǐ",
    "旗": "qí",
    "旘": "zhì",
    "旙": "fān",
    "旚": "piāo",
    "旛": "fān",
    "旜": "zhān",
    "旝": "kuài",
    "旞": "suì",
    "旟": "yú",
    "无": "wú",
    "旡": "jì",
    "既": "jì",
    "旣": "jì",
    "旤": "huò",
    "日": "rì",
    "旦": "dàn",
    "旧": "jiù",
    "旨": "zhǐ",
    "早": "zǎo",
    "旪": "xié",
    "旫": "tiāo",
    "旬": "xún",
    "旭": "xù",
    "旮": "gā",
    "旯": "lá",
    "旰": "gàn,hàn",
    "旱": "hàn",
    "旲": "tái,yīng",
    "旳": "dì,dí,de",
    "旴": "xū,xù",
    "旵": "chǎn",
    "时": "shí",
    "旷": "kuàng",
    "旸": "yáng",
    "旹": "shí",
    "旺": "wàng",
    "旻": "mín",
    "旼": "mín",
    "旽": "tūn,zhùn",
    "旾": "chūn",
    "旿": "wù,wǔ",
    "昀": "yún",
    "昁": "bèi",
    "昂": "áng",
    "昃": "zè",
    "昄": "bǎn",
    "昅": "jié",
    "昆": "kūn",
    "昇": "shēng",
    "昈": "hù",
    "昉": "fǎng",
    "昊": "hào",
    "昋": "guì",
    "昌": "chāng",
    "昍": "xuān",
    "明": "míng",
    "昏": "hūn",
    "昐": "fēn",
    "昑": "qǐn",
    "昒": "hū",
    "易": "yì",
    "昔": "xī",
    "昕": "xīn",
    "昖": "yán",
    "昗": "zè",
    "昘": "fǎng",
    "昙": "tán",
    "昚": "shèn",
    "昛": "jù",
    "昜": "yáng",
    "昝": "zǎn",
    "昞": "bǐng",
    "星": "xīng",
    "映": "yìng",
    "昡": "xuàn",
    "昢": "pò",
    "昣": "zhěn",
    "昤": "líng",
    "春": "chūn",
    "昦": "hào",
    "昧": "mèi",
    "昨": "zuó",
    "昩": "mò",
    "昪": "biàn",
    "昫": "xù",
    "昬": "hūn",
    "昭": "zhāo",
    "昮": "zòng",
    "是": "shì",
    "昰": "shì",
    "昱": "yù",
    "昲": "fèi",
    "昳": "dié,yì",
    "昴": "mǎo",
    "昵": "nì",
    "昶": "chǎng",
    "昷": "wēn",
    "昸": "dōng",
    "昹": "ǎi",
    "昺": "bǐng",
    "昻": "áng",
    "昼": "zhòu",
    "昽": "lóng",
    "显": "xiǎn",
    "昿": "kuàng",
    "晀": "tiǎo",
    "晁": "cháo",
    "時": "shí",
    "晃": "huǎng,huàng",
    "晄": "huǎng",
    "晅": "xuān",
    "晆": "kuí",
    "晇": "xù,kuā",
    "晈": "jiǎo",
    "晉": "jìn",
    "晊": "zhì",
    "晋": "jìn",
    "晌": "shǎng",
    "晍": "tóng",
    "晎": "hǒng",
    "晏": "yàn",
    "晐": "gāi",
    "晑": "xiǎng",
    "晒": "shài",
    "晓": "xiǎo",
    "晔": "yè",
    "晕": "yūn,yùn",
    "晖": "huī",
    "晗": "hán",
    "晘": "hàn",
    "晙": "jùn",
    "晚": "wǎn",
    "晛": "xiàn",
    "晜": "kūn",
    "晝": "zhòu",
    "晞": "xī",
    "晟": "shèng,chéng",
    "晠": "shèng",
    "晡": "bū",
    "晢": "zhé",
    "晣": "zhé",
    "晤": "wù",
    "晥": "wǎn",
    "晦": "huì",
    "晧": "hào",
    "晨": "chén",
    "晩": "wǎn",
    "晪": "tiǎn",
    "晫": "zhuó",
    "晬": "zuì",
    "晭": "zhǒu",
    "普": "pǔ",
    "景": "jǐng,yǐng",
    "晰": "xī",
    "晱": "shǎn",
    "晲": "nǐ",
    "晳": "xī",
    "晴": "qíng",
    "晵": "qǐ,dù",
    "晶": "jīng",
    "晷": "guǐ",
    "晸": "zhěng",
    "晹": "yì",
    "智": "zhì",
    "晻": "àn,ǎn,yǎn",
    "晼": "wǎn",
    "晽": "lín",
    "晾": "liàng",
    "晿": "chēng",
    "暀": "wǎng,wàng",
    "暁": "xiǎo",
    "暂": "zàn",
    "暃": "fēi",
    "暄": "xuān",
    "暅": "xuǎn",
    "暆": "yí",
    "暇": "xiá",
    "暈": "yūn,yùn",
    "暉": "huī",
    "暊": "xǔ",
    "暋": "mǐn,mín",
    "暌": "kuí",
    "暍": "yē",
    "暎": "yìng",
    "暏": "shǔ,dǔ",
    "暐": "wěi",
    "暑": "shǔ",
    "暒": "qíng",
    "暓": "mào",
    "暔": "nán",
    "暕": "jiǎn,lán",
    "暖": "nuǎn",
    "暗": "àn",
    "暘": "yáng",
    "暙": "chūn",
    "暚": "yáo",
    "暛": "suǒ",
    "暜": "pǔ",
    "暝": "míng",
    "暞": "jiǎo",
    "暟": "kǎi",
    "暠": "hào",
    "暡": "wěng",
    "暢": "chàng",
    "暣": "qì",
    "暤": "hào",
    "暥": "yàn",
    "暦": "lì",
    "暧": "ài",
    "暨": "jì",
    "暩": "jì",
    "暪": "mèn",
    "暫": "zàn",
    "暬": "xiè",
    "暭": "hào",
    "暮": "mù",
    "暯": "mù",
    "暰": "cōng",
    "暱": "nì",
    "暲": "zhāng",
    "暳": "huì",
    "暴": "bào,pù",
    "暵": "hàn",
    "暶": "xuán",
    "暷": "chuán",
    "暸": "liáo",
    "暹": "xiān",
    "暺": "tǎn",
    "暻": "jǐng",
    "暼": "piē",
    "暽": "lín",
    "暾": "tūn",
    "暿": "xī,xǐ",
    "曀": "yì",
    "曁": "jì",
    "曂": "huàng",
    "曃": "dài",
    "曄": "yè",
    "曅": "yè",
    "曆": "lì",
    "曇": "tán",
    "曈": "tóng",
    "曉": "xiǎo",
    "曊": "fèi",
    "曋": "shěn",
    "曌": "zhào",
    "曍": "hào",
    "曎": "yì",
    "曏": "xiàng",
    "曐": "xīng",
    "曑": "shēn",
    "曒": "jiǎo",
    "曓": "bào",
    "曔": "jìng",
    "曕": "yàn",
    "曖": "ài",
    "曗": "yè",
    "曘": "rú",
    "曙": "shǔ",
    "曚": "méng",
    "曛": "xūn",
    "曜": "yào",
    "曝": "pù,bào",
    "曞": "lì",
    "曟": "chén",
    "曠": "kuàng",
    "曡": "dié",
    "曢": "liǎo",
    "曣": "yàn",
    "曤": "huò",
    "曥": "lú",
    "曦": "xī",
    "曧": "róng",
    "曨": "lóng",
    "曩": "nǎng",
    "曪": "luǒ",
    "曫": "luán",
    "曬": "shài",
    "曭": "tǎng",
    "曮": "yǎn",
    "曯": "zhú",
    "曰": "yuē",
    "曱": "yuē",
    "曲": "qǔ,qū",
    "曳": "yè",
    "更": "gèng,gēng",
    "曵": "yè",
    "曶": "hū,hù",
    "曷": "hé",
    "書": "shū",
    "曹": "cáo",
    "曺": "cáo",
    "曻": "shēng",
    "曼": "màn",
    "曽": "céng,zēng",
    "曾": "céng,zēng",
    "替": "tì",
    "最": "zuì",
    "朁": "cǎn,qián,jiàn",
    "朂": "xù",
    "會": "huì,kuài",
    "朄": "yǐn",
    "朅": "hé,qiè",
    "朆": "fēn",
    "朇": "bì,pí",
    "月": "yuè",
    "有": "yǒu,yòu",
    "朊": "ruǎn",
    "朋": "péng",
    "朌": "fén,bān",
    "服": "fú,fù",
    "朎": "líng",
    "朏": "fěi,kū",
    "朐": "qú,xù,chǔn",
    "朑": "tì",
    "朒": "nǜ,gǎ",
    "朓": "tiǎo",
    "朔": "shuò",
    "朕": "zhèn",
    "朖": "lǎng",
    "朗": "lǎng",
    "朘": "juān,zuī",
    "朙": "míng",
    "朚": "huāng,máng,wáng",
    "望": "wàng",
    "朜": "tūn",
    "朝": "cháo,zhāo",
    "朞": "jī",
    "期": "qī,jī",
    "朠": "yīng",
    "朡": "zōng",
    "朢": "wàng",
    "朣": "tóng,chuáng",
    "朤": "lǎng",
    "朥": "láo",
    "朦": "méng",
    "朧": "lóng",
    "木": "mù",
    "朩": "null",
    "未": "wèi",
    "末": "mò",
    "本": "běn",
    "札": "zhá",
    "朮": "shù,shú,zhú",
    "术": "shù,shú,zhú",
    "朰": "null",
    "朱": "zhū,shú",
    "朲": "rén",
    "朳": "bā",
    "朴": "pǔ,pò,pō,piáo",
    "朵": "duǒ",
    "朶": "duǒ",
    "朷": "dāo,tiáo,mù",
    "朸": "lì",
    "朹": "qiú,guǐ",
    "机": "jī",
    "朻": "jiū",
    "朼": "bǐ",
    "朽": "xiǔ",
    "朾": "chéng,chēng",
    "朿": "cì",
    "杀": "shā",
    "杁": "rù",
    "杂": "zá",
    "权": "quán",
    "杄": "qiān",
    "杅": "yú,wū",
    "杆": "gān,gǎn",
    "杇": "wū",
    "杈": "chā,chà",
    "杉": "shān,shā",
    "杊": "xún",
    "杋": "fán",
    "杌": "wù",
    "杍": "zǐ",
    "李": "lǐ",
    "杏": "xìng",
    "材": "cái",
    "村": "cūn",
    "杒": "rèn,ér",
    "杓": "sháo,biāo",
    "杔": "tuō,zhé",
    "杕": "dì,duò",
    "杖": "zhàng",
    "杗": "máng",
    "杘": "chì",
    "杙": "yì",
    "杚": "gū,gài",
    "杛": "gōng",
    "杜": "dù",
    "杝": "yí,lì,lí,duò,tuò",
    "杞": "qǐ",
    "束": "shù",
    "杠": "gàng,gāng",
    "条": "tiáo,tiāo",
    "杢": "jié",
    "杣": "mián",
    "杤": "wàn",
    "来": "lái",
    "杦": "jiǔ",
    "杧": "máng",
    "杨": "yáng",
    "杩": "mǎ,mà",
    "杪": "miǎo",
    "杫": "sì,zhǐ,xǐ",
    "杬": "yuán,wán",
    "杭": "háng",
    "杮": "fèi,bèi",
    "杯": "bēi",
    "杰": "jié",
    "東": "dōng",
    "杲": "gǎo",
    "杳": "yǎo",
    "杴": "xiān",
    "杵": "chǔ",
    "杶": "chūn",
    "杷": "pá",
    "杸": "shū,duì",
    "杹": "huà",
    "杺": "xīn",
    "杻": "niǔ,chǒu",
    "杼": "zhù",
    "杽": "chǒu",
    "松": "sōng",
    "板": "bǎn",
    "枀": "sōng",
    "极": "jí",
    "枂": "wò,yuè",
    "枃": "jìn",
    "构": "gòu",
    "枅": "jī",
    "枆": "máo",
    "枇": "pí",
    "枈": "pī,mì",
    "枉": "wǎng",
    "枊": "àng",
    "枋": "fāng,bìng",
    "枌": "fén",
    "枍": "yì",
    "枎": "fú,fū",
    "枏": "nán",
    "析": "xī",
    "枑": "hù,dǐ",
    "枒": "yā",
    "枓": "dōu",
    "枔": "xín",
    "枕": "zhěn",
    "枖": "yǎo,yāo",
    "林": "lín",
    "枘": "ruì",
    "枙": "ě,è",
    "枚": "méi",
    "枛": "zhào",
    "果": "guǒ",
    "枝": "zhī,qí",
    "枞": "cōng,zōng",
    "枟": "yùn",
    "枠": "huà",
    "枡": "shēng",
    "枢": "shū",
    "枣": "zǎo",
    "枤": "dì,duò",
    "枥": "lì",
    "枦": "lú",
    "枧": "jiǎn",
    "枨": "chéng",
    "枩": "sōng",
    "枪": "qiāng",
    "枫": "fēng",
    "枬": "zhān",
    "枭": "xiāo",
    "枮": "xiān,zhēn",
    "枯": "kū",
    "枰": "píng",
    "枱": "sì,tái",
    "枲": "xǐ",
    "枳": "zhǐ",
    "枴": "guǎi",
    "枵": "xiāo",
    "架": "jià",
    "枷": "jiā",
    "枸": "gǒu,jǔ",
    "枹": "bāo,fú",
    "枺": "mò",
    "枻": "yì,xiè",
    "枼": "yè",
    "枽": "yè",
    "枾": "shì",
    "枿": "niè",
    "柀": "bǐ",
    "柁": "tuó,duò",
    "柂": "yí,duò,lí",
    "柃": "líng",
    "柄": "bǐng",
    "柅": "nǐ,chì",
    "柆": "lā",
    "柇": "hé",
    "柈": "pán,bàn",
    "柉": "fán",
    "柊": "zhōng",
    "柋": "dài",
    "柌": "cí",
    "柍": "yǎng,yàng,yāng,yīng",
    "柎": "fū,fǔ,fù",
    "柏": "bǎi,bó,bò",
    "某": "mǒu",
    "柑": "gān",
    "柒": "qī",
    "染": "rǎn",
    "柔": "róu",
    "柕": "mào",
    "柖": "sháo,shào",
    "柗": "sōng",
    "柘": "zhè",
    "柙": "xiá",
    "柚": "yòu,yóu",
    "柛": "shēn",
    "柜": "guì,jǔ",
    "柝": "tuò",
    "柞": "zuò,zhà",
    "柟": "nán",
    "柠": "níng",
    "柡": "yǒng",
    "柢": "dǐ,chí",
    "柣": "zhì,dié",
    "柤": "zhā,zǔ,zū",
    "查": "chá,zhā",
    "柦": "dàn",
    "柧": "gū",
    "柨": "bù,pū",
    "柩": "jiù",
    "柪": "āo,ào",
    "柫": "fú",
    "柬": "jiǎn",
    "柭": "bā,fú,pèi,bó,biē",
    "柮": "duò,zuó,wù",
    "柯": "kē",
    "柰": "nài",
    "柱": "zhù",
    "柲": "bì,bié",
    "柳": "liǔ",
    "柴": "chái",
    "柵": "shān",
    "柶": "sì",
    "柷": "zhù",
    "柸": "bēi,pēi",
    "柹": "shì,fèi",
    "柺": "guǎi",
    "査": "chá,zhā",
    "柼": "yǎo",
    "柽": "chēng",
    "柾": "jiù",
    "柿": "shì",
    "栀": "zhī",
    "栁": "liǔ",
    "栂": "méi",
    "栃": "lì",
    "栄": "róng",
    "栅": "zhà,shān,shi,cè",
    "栆": "zǎo",
    "标": "biāo",
    "栈": "zhàn",
    "栉": "zhì",
    "栊": "lóng",
    "栋": "dòng",
    "栌": "lú",
    "栍": "null",
    "栎": "lì,yuè",
    "栏": "lán",
    "栐": "yǒng",
    "树": "shù",
    "栒": "xún",
    "栓": "shuān",
    "栔": "qì,qiè",
    "栕": "chén",
    "栖": "qī,xī",
    "栗": "lì",
    "栘": "yí",
    "栙": "xiáng",
    "栚": "zhèn",
    "栛": "lì",
    "栜": "sè",
    "栝": "guā,tiǎn",
    "栞": "kān",
    "栟": "bēn,bīng",
    "栠": "rěn",
    "校": "xiào,jiào",
    "栢": "bǎi",
    "栣": "rěn",
    "栤": "bìng",
    "栥": "zī",
    "栦": "chóu",
    "栧": "yì,xiè",
    "栨": "cì",
    "栩": "xǔ",
    "株": "zhū",
    "栫": "jiàn,zùn",
    "栬": "zuì",
    "栭": "ér",
    "栮": "ěr",
    "栯": "yǒu,yù",
    "栰": "fá",
    "栱": "gǒng",
    "栲": "kǎo",
    "栳": "lǎo",
    "栴": "zhān",
    "栵": "liè",
    "栶": "yīn",
    "样": "yàng",
    "核": "hé,hú",
    "根": "gēn",
    "栺": "zhī,yì",
    "栻": "shì",
    "格": "gé",
    "栽": "zāi",
    "栾": "luán",
    "栿": "fú",
    "桀": "jié",
    "桁": "héng,háng",
    "桂": "guì",
    "桃": "táo",
    "桄": "guāng,guàng",
    "桅": "wéi",
    "框": "kuàng",
    "桇": "rú",
    "案": "àn",
    "桉": "ān",
    "桊": "juàn",
    "桋": "yí,tí",
    "桌": "zhuō",
    "桍": "kū",
    "桎": "zhì",
    "桏": "qióng",
    "桐": "tóng",
    "桑": "sāng",
    "桒": "sāng",
    "桓": "huán",
    "桔": "jié,jú",
    "桕": "jiù",
    "桖": "xuè",
    "桗": "duò",
    "桘": "chuí",
    "桙": "yú,móu",
    "桚": "zā,zǎn",
    "桛": "null",
    "桜": "yīng",
    "桝": "jié",
    "桞": "liǔ",
    "桟": "zhàn",
    "桠": "yā",
    "桡": "ráo,náo",
    "桢": "zhēn",
    "档": "dàng",
    "桤": "qī",
    "桥": "qiáo",
    "桦": "huà",
    "桧": "guì,huì",
    "桨": "jiǎng",
    "桩": "zhuāng",
    "桪": "xún",
    "桫": "suō",
    "桬": "shā",
    "桭": "chén,zhèn",
    "桮": "bēi",
    "桯": "tīng,yíng",
    "桰": "guā",
    "桱": "jìng",
    "桲": "bó",
    "桳": "bèn,fàn",
    "桴": "fú",
    "桵": "ruí",
    "桶": "tǒng",
    "桷": "jué",
    "桸": "xī",
    "桹": "láng",
    "桺": "liǔ",
    "桻": "fēng,fèng",
    "桼": "qī",
    "桽": "wěn",
    "桾": "jūn",
    "桿": "gǎn",
    "梀": "sù,yìn",
    "梁": "liáng",
    "梂": "qiú",
    "梃": "tǐng,tìng",
    "梄": "yǒu",
    "梅": "méi",
    "梆": "bāng",
    "梇": "lòng",
    "梈": "pēng",
    "梉": "zhuāng",
    "梊": "dì",
    "梋": "xuān,juān,xié",
    "梌": "tú,chá",
    "梍": "zào",
    "梎": "āo,yòu",
    "梏": "gù",
    "梐": "bì",
    "梑": "dí",
    "梒": "hán",
    "梓": "zǐ",
    "梔": "zhī",
    "梕": "rèn,ér",
    "梖": "bèi",
    "梗": "gěng",
    "梘": "jiǎn",
    "梙": "huàn",
    "梚": "wǎn",
    "梛": "nuó",
    "梜": "jiā",
    "條": "tiáo,tiāo",
    "梞": "jì",
    "梟": "xiāo",
    "梠": "lǚ",
    "梡": "kuǎn",
    "梢": "shāo,sào",
    "梣": "chén",
    "梤": "fēn",
    "梥": "sōng",
    "梦": "mèng",
    "梧": "wú",
    "梨": "lí",
    "梩": "sì,qǐ",
    "梪": "dòu",
    "梫": "qǐn",
    "梬": "yǐng",
    "梭": "suō",
    "梮": "jū",
    "梯": "tī",
    "械": "xiè",
    "梱": "kǔn",
    "梲": "zhuō",
    "梳": "shū",
    "梴": "chān,yán",
    "梵": "fàn",
    "梶": "wěi",
    "梷": "jìng",
    "梸": "lí",
    "梹": "bīn,bīng",
    "梺": "xià",
    "梻": "fó",
    "梼": "chóu,táo,dào",
    "梽": "zhì",
    "梾": "lái",
    "梿": "lián,liǎn",
    "检": "jiǎn",
    "棁": "zhuō",
    "棂": "líng",
    "棃": "lí",
    "棄": "qì",
    "棅": "bǐng",
    "棆": "lún",
    "棇": "cōng,sōng",
    "棈": "qiàn",
    "棉": "mián",
    "棊": "qí",
    "棋": "qí",
    "棌": "cǎi",
    "棍": "gùn,hùn",
    "棎": "chán",
    "棏": "dé,zhé",
    "棐": "fěi",
    "棑": "pái,bèi,pèi",
    "棒": "bàng",
    "棓": "bàng,pǒu,bèi,bēi",
    "棔": "hūn",
    "棕": "zōng",
    "棖": "chéng",
    "棗": "zǎo",
    "棘": "jí",
    "棙": "lì,liè",
    "棚": "péng",
    "棛": "yù",
    "棜": "yù",
    "棝": "gù",
    "棞": "jùn",
    "棟": "dòng",
    "棠": "táng",
    "棡": "gāng",
    "棢": "wǎng",
    "棣": "dì,dài,tì",
    "棤": "què",
    "棥": "fán",
    "棦": "chēng",
    "棧": "zhàn",
    "棨": "qǐ",
    "棩": "yuān",
    "棪": "yǎn,yàn",
    "棫": "yù",
    "棬": "quān,juàn",
    "棭": "yì",
    "森": "sēn",
    "棯": "rěn,shěn",
    "棰": "chuí",
    "棱": "léng,lēng,líng",
    "棲": "qī",
    "棳": "zhuō",
    "棴": "fú,sù",
    "棵": "kē",
    "棶": "lái",
    "棷": "zōu,sǒu",
    "棸": "zōu",
    "棹": "zhào,zhuō",
    "棺": "guān",
    "棻": "fēn",
    "棼": "fén",
    "棽": "chēn,shēn",
    "棾": "qíng",
    "棿": "ní,nǐ",
    "椀": "wǎn",
    "椁": "guǒ",
    "椂": "lù",
    "椃": "háo",
    "椄": "jiē,qiè",
    "椅": "yǐ,yī",
    "椆": "chóu,zhòu,diāo",
    "椇": "jǔ",
    "椈": "jú",
    "椉": "chéng,shèng",
    "椊": "zú,cuì",
    "椋": "liáng",
    "椌": "qiāng,kōng",
    "植": "zhí",
    "椎": "zhuī,chuí",
    "椏": "yā",
    "椐": "jū",
    "椑": "bēi",
    "椒": "jiāo",
    "椓": "zhuó",
    "椔": "zī",
    "椕": "bīn",
    "椖": "péng",
    "椗": "dìng",
    "椘": "chǔ",
    "椙": "chāng",
    "椚": "mēn",
    "椛": "huā",
    "検": "jiǎn",
    "椝": "guī",
    "椞": "xì",
    "椟": "dú",
    "椠": "qiàn",
    "椡": "dào",
    "椢": "guì",
    "椣": "diǎn",
    "椤": "luó",
    "椥": "zhī",
    "椦": "quān,juàn,quán",
    "椧": "null",
    "椨": "fǔ",
    "椩": "gēng",
    "椪": "pèng",
    "椫": "shàn",
    "椬": "yí",
    "椭": "tuǒ",
    "椮": "sēn",
    "椯": "duǒ,chuán",
    "椰": "yē",
    "椱": "fù",
    "椲": "wěi,huī",
    "椳": "wēi",
    "椴": "duàn",
    "椵": "jiǎ,jiā",
    "椶": "zōng",
    "椷": "jiān,hán",
    "椸": "yí",
    "椹": "zhēn,shèn",
    "椺": "xí",
    "椻": "yàn,yà",
    "椼": "yǎn",
    "椽": "chuán",
    "椾": "jiān",
    "椿": "chūn",
    "楀": "yǔ",
    "楁": "hé",
    "楂": "zhā,chá",
    "楃": "wò",
    "楄": "piān",
    "楅": "bī",
    "楆": "yāo",
    "楇": "guō,kuǎ",
    "楈": "xū",
    "楉": "ruò",
    "楊": "yáng",
    "楋": "là",
    "楌": "yán",
    "楍": "běn",
    "楎": "huī",
    "楏": "kuí",
    "楐": "jiè",
    "楑": "kuí",
    "楒": "sī",
    "楓": "fēng",
    "楔": "xiē",
    "楕": "tuǒ",
    "楖": "jí,zhì",
    "楗": "jiàn",
    "楘": "mù",
    "楙": "máo",
    "楚": "chǔ",
    "楛": "kǔ,hù",
    "楜": "hú",
    "楝": "liàn",
    "楞": "léng",
    "楟": "tíng",
    "楠": "nán",
    "楡": "yú",
    "楢": "yóu,yǒu",
    "楣": "méi",
    "楤": "sǒng,cōng",
    "楥": "xuàn,yuán",
    "楦": "xuàn",
    "楧": "yǎng,yàng,yīng",
    "楨": "zhēn",
    "楩": "pián",
    "楪": "dié,yè",
    "楫": "jí",
    "楬": "jiē",
    "業": "yè",
    "楮": "chǔ",
    "楯": "shǔn,dùn",
    "楰": "yú",
    "楱": "còu,zòu",
    "楲": "wēi",
    "楳": "méi",
    "楴": "dì,dǐ,shì",
    "極": "jí",
    "楶": "jié",
    "楷": "kǎi,jiē",
    "楸": "qiū",
    "楹": "yíng",
    "楺": "róu,ròu",
    "楻": "huáng",
    "楼": "lóu",
    "楽": "lè,yuè",
    "楾": "quán",
    "楿": "xiāng",
    "榀": "pǐn",
    "榁": "shǐ",
    "概": "gài",
    "榃": "tán",
    "榄": "lǎn",
    "榅": "wēn,yùn",
    "榆": "yú",
    "榇": "chèn",
    "榈": "lǘ",
    "榉": "jǔ",
    "榊": "shén",
    "榋": "chū",
    "榌": "bī,pi",
    "榍": "xiè",
    "榎": "jiǎ",
    "榏": "yì",
    "榐": "zhǎn,niǎn,zhèn",
    "榑": "fú,fù,bó",
    "榒": "nuò",
    "榓": "mì",
    "榔": "láng",
    "榕": "róng",
    "榖": "gǔ",
    "榗": "jiàn,jìn",
    "榘": "jǔ",
    "榙": "tā",
    "榚": "yǎo",
    "榛": "zhēn",
    "榜": "bǎng,bàng",
    "榝": "shā,xiè",
    "榞": "yuán",
    "榟": "zǐ",
    "榠": "míng",
    "榡": "sù",
    "榢": "jià",
    "榣": "yáo",
    "榤": "jié",
    "榥": "huàng",
    "榦": "gàn",
    "榧": "fěi",
    "榨": "zhà",
    "榩": "qián",
    "榪": "mà,mā",
    "榫": "sǔn",
    "榬": "yuán",
    "榭": "xiè",
    "榮": "róng",
    "榯": "shí",
    "榰": "zhī",
    "榱": "cuī",
    "榲": "wēn",
    "榳": "tíng",
    "榴": "liú",
    "榵": "róng",
    "榶": "táng",
    "榷": "què",
    "榸": "zhāi",
    "榹": "sì",
    "榺": "shèng",
    "榻": "tà",
    "榼": "kē",
    "榽": "xī",
    "榾": "gù",
    "榿": "qī",
    "槀": "gǎo",
    "槁": "gǎo",
    "槂": "sūn",
    "槃": "pán",
    "槄": "tāo",
    "槅": "gé",
    "槆": "chūn",
    "槇": "diān",
    "槈": "nòu",
    "槉": "jí",
    "槊": "shuò",
    "構": "gòu",
    "槌": "chuí",
    "槍": "qiāng",
    "槎": "chá",
    "槏": "qiǎn,lián,xiàn",
    "槐": "huái",
    "槑": "méi",
    "槒": "xù",
    "槓": "gàng",
    "槔": "gāo",
    "槕": "zhuō",
    "槖": "tuó",
    "槗": "qiáo",
    "様": "yàng",
    "槙": "diān,zhěn,zhēn",
    "槚": "jiǎ",
    "槛": "jiàn,kǎn",
    "槜": "zuì",
    "槝": "dǎo",
    "槞": "lóng",
    "槟": "bīn,bīng",
    "槠": "zhū",
    "槡": "sāng",
    "槢": "xí,dié",
    "槣": "jī,guī",
    "槤": "lián,liǎn",
    "槥": "huì",
    "槦": "róng,yōng",
    "槧": "qiàn",
    "槨": "guǒ",
    "槩": "gài",
    "槪": "gài",
    "槫": "tuán,shuàn,quán",
    "槬": "huà",
    "槭": "qì,sè",
    "槮": "sēn",
    "槯": "cuī,zhǐ",
    "槰": "pèng",
    "槱": "yǒu,chǎo",
    "槲": "hú",
    "槳": "jiǎng",
    "槴": "hù",
    "槵": "huàn",
    "槶": "guì",
    "槷": "niè",
    "槸": "yì",
    "槹": "gāo",
    "槺": "kāng",
    "槻": "guī",
    "槼": "guī",
    "槽": "cáo",
    "槾": "màn,wàn",
    "槿": "jǐn",
    "樀": "dī",
    "樁": "zhuāng",
    "樂": "lè,yuè,yào,lào",
    "樃": "láng",
    "樄": "chén",
    "樅": "cōng,zōng",
    "樆": "lí,chī",
    "樇": "xiū",
    "樈": "qíng",
    "樉": "shǎng",
    "樊": "fán",
    "樋": "tōng",
    "樌": "guàn",
    "樍": "zé",
    "樎": "sù",
    "樏": "léi,lěi",
    "樐": "lǔ",
    "樑": "liáng",
    "樒": "mì",
    "樓": "lóu",
    "樔": "cháo,jiǎo,chāo",
    "樕": "sù",
    "樖": "kē",
    "樗": "chū",
    "樘": "táng",
    "標": "biāo",
    "樚": "lù",
    "樛": "jiū,liáo",
    "樜": "zhè",
    "樝": "zhā",
    "樞": "shū",
    "樟": "zhāng",
    "樠": "mán",
    "模": "mó,mú",
    "樢": "niǎo,mù",
    "樣": "yàng",
    "樤": "tiáo",
    "樥": "péng",
    "樦": "zhù",
    "樧": "shā,xiè",
    "樨": "xī",
    "権": "quán",
    "横": "héng,hèng",
    "樫": "jiān",
    "樬": "cōng",
    "樭": "jī",
    "樮": "yān",
    "樯": "qiáng",
    "樰": "xuě",
    "樱": "yīng",
    "樲": "èr",
    "樳": "xún",
    "樴": "zhí",
    "樵": "qiáo",
    "樶": "zuī",
    "樷": "cóng",
    "樸": "pǔ",
    "樹": "shù",
    "樺": "huà",
    "樻": "guì",
    "樼": "zhēn",
    "樽": "zūn",
    "樾": "yuè",
    "樿": "shàn",
    "橀": "xī",
    "橁": "chūn",
    "橂": "diàn",
    "橃": "fá,fèi",
    "橄": "gǎn",
    "橅": "mó",
    "橆": "wú",
    "橇": "qiāo",
    "橈": "ráo,náo",
    "橉": "lìn",
    "橊": "liú",
    "橋": "qiáo",
    "橌": "xiàn",
    "橍": "rùn",
    "橎": "fǎn",
    "橏": "zhǎn,jiǎn",
    "橐": "tuó",
    "橑": "liáo",
    "橒": "yún",
    "橓": "shùn",
    "橔": "tuí,dūn",
    "橕": "chēng",
    "橖": "táng,chēng",
    "橗": "méng",
    "橘": "jú",
    "橙": "chéng",
    "橚": "sù,qiū",
    "橛": "jué",
    "橜": "jué",
    "橝": "tán,diàn",
    "橞": "huì",
    "機": "jī",
    "橠": "nuó",
    "橡": "xiàng",
    "橢": "tuǒ",
    "橣": "níng",
    "橤": "ruǐ",
    "橥": "zhū",
    "橦": "tóng,chuáng",
    "橧": "zēng,céng",
    "橨": "fén,fèn,fèi",
    "橩": "qióng",
    "橪": "rǎn,yān",
    "橫": "héng,hèng",
    "橬": "qián",
    "橭": "gū",
    "橮": "liǔ",
    "橯": "lào",
    "橰": "gāo",
    "橱": "chú",
    "橲": "xǐ",
    "橳": "shèng",
    "橴": "zǐ",
    "橵": "zān",
    "橶": "jǐ",
    "橷": "dōu",
    "橸": "jīng",
    "橹": "lǔ",
    "橺": "xiàn",
    "橻": "cū,chu",
    "橼": "yuán",
    "橽": "tà",
    "橾": "shū,qiāo",
    "橿": "jiāng",
    "檀": "tán",
    "檁": "lǐn",
    "檂": "nóng",
    "檃": "yǐn",
    "檄": "xí",
    "檅": "huì",
    "檆": "shān",
    "檇": "zuì",
    "檈": "xuán",
    "檉": "chēng",
    "檊": "gàn",
    "檋": "jū",
    "檌": "zuì",
    "檍": "yì",
    "檎": "qín",
    "檏": "pǔ",
    "檐": "yán",
    "檑": "léi",
    "檒": "fēng",
    "檓": "huǐ",
    "檔": "dàng",
    "檕": "jì",
    "檖": "suì",
    "檗": "bò",
    "檘": "píng,bò",
    "檙": "chéng",
    "檚": "chǔ",
    "檛": "zhuā",
    "檜": "guì,huì",
    "檝": "jí",
    "檞": "jiě",
    "檟": "jiǎ",
    "檠": "qíng",
    "檡": "zhái,shì,tú",
    "檢": "jiǎn",
    "檣": "qiáng",
    "檤": "dào",
    "檥": "yǐ",
    "檦": "biāo,biǎo",
    "檧": "sōng",
    "檨": "shē",
    "檩": "lǐn",
    "檪": "lì",
    "檫": "chá",
    "檬": "méng",
    "檭": "yín",
    "檮": "chóu,táo,dǎo",
    "檯": "tái",
    "檰": "mián",
    "檱": "qí",
    "檲": "tuán",
    "檳": "bīn,bīng",
    "檴": "huò",
    "檵": "jì",
    "檶": "qiān,lián",
    "檷": "nǐ,mí",
    "檸": "níng",
    "檹": "yī",
    "檺": "gǎo",
    "檻": "jiàn,kǎn",
    "檼": "yǐn",
    "檽": "nòu,ruǎn,rú",
    "檾": "qǐng",
    "檿": "yǎn",
    "櫀": "qí",
    "櫁": "mì",
    "櫂": "zhào",
    "櫃": "guì",
    "櫄": "chūn",
    "櫅": "jī,jì",
    "櫆": "kuí",
    "櫇": "pó",
    "櫈": "dèng",
    "櫉": "chú",
    "櫊": "gé",
    "櫋": "mián",
    "櫌": "yōu",
    "櫍": "zhì",
    "櫎": "huǎng,guǒ,gǔ",
    "櫏": "qiān",
    "櫐": "lěi",
    "櫑": "léi,lěi",
    "櫒": "sà",
    "櫓": "lǔ",
    "櫔": "lì",
    "櫕": "cuán",
    "櫖": "lǜ,chū",
    "櫗": "miè,mèi",
    "櫘": "huì",
    "櫙": "ōu",
    "櫚": "lǘ",
    "櫛": "zhì",
    "櫜": "gāo",
    "櫝": "dú",
    "櫞": "yuán",
    "櫟": "lì,yuè",
    "櫠": "fèi",
    "櫡": "zhuó,zhù",
    "櫢": "sǒu",
    "櫣": "lián,liǎn",
    "櫤": "jiàng",
    "櫥": "chú",
    "櫦": "qìng",
    "櫧": "zhū",
    "櫨": "lú",
    "櫩": "yán",
    "櫪": "lì",
    "櫫": "zhū",
    "櫬": "chèn",
    "櫭": "jué,jì",
    "櫮": "è",
    "櫯": "sū",
    "櫰": "huái,guī",
    "櫱": "niè",
    "櫲": "yù",
    "櫳": "lóng",
    "櫴": "là,lài",
    "櫵": "qiáo",
    "櫶": "xiǎn",
    "櫷": "guī",
    "櫸": "jǔ",
    "櫹": "xiāo",
    "櫺": "líng",
    "櫻": "yīng",
    "櫼": "jiān",
    "櫽": "yǐn",
    "櫾": "yòu,yóu",
    "櫿": "yíng",
    "欀": "xiāng",
    "欁": "nóng",
    "欂": "bó",
    "欃": "chán,zhàn",
    "欄": "lán",
    "欅": "jǔ",
    "欆": "shuāng",
    "欇": "shè",
    "欈": "wéi,zuì",
    "欉": "cóng",
    "權": "quán",
    "欋": "qú",
    "欌": "cáng",
    "欍": "jiù",
    "欎": "yù",
    "欏": "luó",
    "欐": "lì",
    "欑": "cuán",
    "欒": "luán",
    "欓": "dǎng",
    "欔": "qú",
    "欕": "yán",
    "欖": "lǎn",
    "欗": "lán",
    "欘": "zhú",
    "欙": "léi",
    "欚": "lǐ",
    "欛": "bà",
    "欜": "náng",
    "欝": "yù",
    "欞": "líng",
    "欟": "guàn",
    "欠": "qiàn",
    "次": "cì",
    "欢": "huān",
    "欣": "xīn",
    "欤": "yú",
    "欥": "yù,yì",
    "欦": "qiān,xiān",
    "欧": "ōu",
    "欨": "xū",
    "欩": "chāo",
    "欪": "chù,qù,xì",
    "欫": "qì",
    "欬": "kài,ài",
    "欭": "yì,yīn",
    "欮": "jué",
    "欯": "xì,kài",
    "欰": "xù",
    "欱": "hē",
    "欲": "yù",
    "欳": "kuài",
    "欴": "láng",
    "欵": "kuǎn",
    "欶": "shuò,sòu",
    "欷": "xī",
    "欸": "èi,ěi,ǎi",
    "欹": "qī",
    "欺": "qī",
    "欻": "xū,chuā",
    "欼": "chǐ,chuài",
    "欽": "qīn",
    "款": "kuǎn",
    "欿": "kǎn,qiàn",
    "歀": "kuǎn",
    "歁": "kǎn,kè",
    "歂": "chuǎn,chuán",
    "歃": "shà",
    "歄": "guā",
    "歅": "yān,yīn",
    "歆": "xīn",
    "歇": "xiē",
    "歈": "yú",
    "歉": "qiàn",
    "歊": "xiāo",
    "歋": "yē",
    "歌": "gē",
    "歍": "wū",
    "歎": "tàn",
    "歏": "jìn,qūn",
    "歐": "ōu",
    "歑": "hū",
    "歒": "tì",
    "歓": "huān",
    "歔": "xū",
    "歕": "pēn",
    "歖": "xǐ",
    "歗": "xiào",
    "歘": "xū",
    "歙": "xī,shè",
    "歚": "shàn",
    "歛": "liǎn,hān",
    "歜": "chù",
    "歝": "yì",
    "歞": "è",
    "歟": "yú",
    "歠": "chuò",
    "歡": "huān",
    "止": "zhǐ",
    "正": "zhèng,zhēng",
    "此": "cǐ",
    "步": "bù",
    "武": "wǔ",
    "歧": "qí",
    "歨": "bù",
    "歩": "bù",
    "歪": "wāi",
    "歫": "jù",
    "歬": "qián",
    "歭": "zhì,chí",
    "歮": "sè",
    "歯": "chǐ",
    "歰": "sè,shà",
    "歱": "zhǒng",
    "歲": "suì",
    "歳": "suì",
    "歴": "lì",
    "歵": "zé",
    "歶": "yú",
    "歷": "lì",
    "歸": "guī",
    "歹": "dǎi",
    "歺": "è",
    "死": "sǐ",
    "歼": "jiān",
    "歽": "zhé",
    "歾": "mò,wěn",
    "歿": "mò",
    "殀": "yāo",
    "殁": "mò",
    "殂": "cú",
    "殃": "yāng",
    "殄": "tiǎn",
    "殅": "shēng",
    "殆": "dài",
    "殇": "shāng",
    "殈": "xù",
    "殉": "xùn",
    "殊": "shū",
    "残": "cán",
    "殌": "jǐng",
    "殍": "piǎo",
    "殎": "qià",
    "殏": "qiú",
    "殐": "sù",
    "殑": "qíng,jìng",
    "殒": "yǔn",
    "殓": "liàn",
    "殔": "yì",
    "殕": "fǒu,bó",
    "殖": "zhí,shi",
    "殗": "yè,yān,yàn",
    "殘": "cán",
    "殙": "hūn,mèi",
    "殚": "dān",
    "殛": "jí",
    "殜": "dié",
    "殝": "zhēn",
    "殞": "yǔn",
    "殟": "wēn",
    "殠": "chòu",
    "殡": "bìn",
    "殢": "tì",
    "殣": "jìn",
    "殤": "shāng",
    "殥": "yín",
    "殦": "chī",
    "殧": "jiù",
    "殨": "kuì,huì",
    "殩": "cuàn",
    "殪": "yì",
    "殫": "dān",
    "殬": "dù",
    "殭": "jiāng",
    "殮": "liàn",
    "殯": "bìn",
    "殰": "dú",
    "殱": "jiān",
    "殲": "jiān",
    "殳": "shū",
    "殴": "ōu",
    "段": "duàn",
    "殶": "zhù",
    "殷": "yīn,yān,yǐn",
    "殸": "qìng,kēng,shēng",
    "殹": "yì",
    "殺": "shā",
    "殻": "ké,qiào",
    "殼": "ké,qiào",
    "殽": "xiáo,yáo,xiào",
    "殾": "xùn",
    "殿": "diàn",
    "毀": "huǐ",
    "毁": "huǐ",
    "毂": "gǔ",
    "毃": "qiāo",
    "毄": "jī",
    "毅": "yì",
    "毆": "ōu",
    "毇": "huǐ",
    "毈": "duàn",
    "毉": "yī",
    "毊": "xiāo",
    "毋": "wú",
    "毌": "guàn,wān",
    "母": "mǔ",
    "毎": "měi",
    "每": "měi",
    "毐": "ǎi",
    "毑": "jiě",
    "毒": "dú,dài",
    "毓": "yù",
    "比": "bǐ",
    "毕": "bì",
    "毖": "bì",
    "毗": "pí",
    "毘": "pí",
    "毙": "bì",
    "毚": "chán",
    "毛": "máo",
    "毜": "háo",
    "毝": "cǎi",
    "毞": "bǐ",
    "毟": "liě",
    "毠": "jiā",
    "毡": "zhān",
    "毢": "sāi",
    "毣": "mù",
    "毤": "tuò",
    "毥": "xún,xùn",
    "毦": "ěr",
    "毧": "róng",
    "毨": "xiǎn",
    "毩": "jū",
    "毪": "mú",
    "毫": "háo",
    "毬": "qiú",
    "毭": "dòu,nuò",
    "毮": "shā",
    "毯": "tǎn",
    "毰": "péi",
    "毱": "jū",
    "毲": "duō",
    "毳": "cuì",
    "毴": "bī",
    "毵": "sān",
    "毶": "sān",
    "毷": "mào",
    "毸": "sāi,suī",
    "毹": "shū",
    "毺": "shū",
    "毻": "tuò",
    "毼": "hé",
    "毽": "jiàn",
    "毾": "tà",
    "毿": "sān",
    "氀": "lǘ",
    "氁": "mú",
    "氂": "máo",
    "氃": "tóng",
    "氄": "rǒng",
    "氅": "chǎng",
    "氆": "pǔ",
    "氇": "lǔ",
    "氈": "zhān",
    "氉": "sào",
    "氊": "zhān",
    "氋": "méng",
    "氌": "lǔ",
    "氍": "qú",
    "氎": "dié",
    "氏": "shì,zhī",
    "氐": "dī,dǐ",
    "民": "mín",
    "氒": "jué",
    "氓": "méng,máng",
    "气": "qì",
    "氕": "piē",
    "氖": "nǎi",
    "気": "qì",
    "氘": "dāo",
    "氙": "xiān",
    "氚": "chuān",
    "氛": "fēn",
    "氜": "yáng,rì",
    "氝": "nèi",
    "氞": "nèi",
    "氟": "fú",
    "氠": "shēn",
    "氡": "dōng",
    "氢": "qīng",
    "氣": "qì",
    "氤": "yīn",
    "氥": "xī",
    "氦": "hài",
    "氧": "yǎng",
    "氨": "ān",
    "氩": "yà",
    "氪": "kè",
    "氫": "qīng",
    "氬": "yà",
    "氭": "dōng",
    "氮": "dàn",
    "氯": "lǜ",
    "氰": "qíng",
    "氱": "yǎng",
    "氲": "yūn",
    "氳": "yūn",
    "水": "shuǐ",
    "氵": "shuǐ",
    "氶": "zhěng,chéng,zhèng",
    "氷": "bīng",
    "永": "yǒng",
    "氹": "dàng",
    "氺": "shuǐ",
    "氻": "lè",
    "氼": "nì",
    "氽": "tǔn",
    "氾": "fàn",
    "氿": "guǐ,jiǔ",
    "汀": "tīng",
    "汁": "zhī",
    "求": "qiú",
    "汃": "bīn,pà,pā",
    "汄": "zè",
    "汅": "miǎn",
    "汆": "cuān",
    "汇": "huì",
    "汈": "diāo",
    "汉": "hàn",
    "汊": "chà",
    "汋": "zhuó,què",
    "汌": "chuàn",
    "汍": "wán",
    "汎": "fàn",
    "汏": "tài,dà",
    "汐": "xī",
    "汑": "tuō",
    "汒": "máng",
    "汓": "qiú",
    "汔": "qì",
    "汕": "shàn",
    "汖": "pìn",
    "汗": "hàn,hán",
    "汘": "qiān",
    "汙": "wū",
    "汚": "wū",
    "汛": "xùn",
    "汜": "sì",
    "汝": "rǔ",
    "汞": "gǒng",
    "江": "jiāng",
    "池": "chí",
    "污": "wū",
    "汢": "tu",
    "汣": "jiǔ",
    "汤": "tāng,shāng",
    "汥": "zhī,jì",
    "汦": "zhǐ",
    "汧": "qiān",
    "汨": "mì",
    "汩": "gǔ,yù",
    "汪": "wāng",
    "汫": "jǐng",
    "汬": "jǐng",
    "汭": "ruì",
    "汮": "jūn",
    "汯": "hóng",
    "汰": "tài",
    "汱": "tài",
    "汲": "jí",
    "汳": "biàn",
    "汴": "biàn",
    "汵": "gàn,hán,cén",
    "汶": "wèn,mén",
    "汷": "zhōng",
    "汸": "fāng,pāng",
    "汹": "xiōng",
    "決": "jué",
    "汻": "hǔ,huǎng",
    "汼": "niú,yóu",
    "汽": "qì",
    "汾": "fén",
    "汿": "xù",
    "沀": "xù",
    "沁": "qìn",
    "沂": "yí",
    "沃": "wò",
    "沄": "yún",
    "沅": "yuán",
    "沆": "hàng",
    "沇": "yǎn",
    "沈": "shěn,chén",
    "沉": "chén",
    "沊": "dàn",
    "沋": "yóu",
    "沌": "dùn",
    "沍": "hù",
    "沎": "huò",
    "沏": "qī",
    "沐": "mù",
    "沑": "nǜ,niǔ",
    "沒": "méi,mò",
    "沓": "tà,dá",
    "沔": "miǎn",
    "沕": "mì,wù",
    "沖": "chōng",
    "沗": "hóng,pāng",
    "沘": "bǐ",
    "沙": "shā,shà",
    "沚": "zhǐ",
    "沛": "pèi",
    "沜": "pàn",
    "沝": "zhuǐ,zǐ",
    "沞": "zā",
    "沟": "gōu",
    "沠": "pài",
    "没": "méi,mò",
    "沢": "zé",
    "沣": "fēng",
    "沤": "òu,ōu",
    "沥": "lì",
    "沦": "lún",
    "沧": "cāng",
    "沨": "fēng",
    "沩": "wéi",
    "沪": "hù",
    "沫": "mò",
    "沬": "mèi",
    "沭": "shù",
    "沮": "jǔ,jù",
    "沯": "zá",
    "沰": "tuō,duó",
    "沱": "tuó",
    "沲": "tuó,duò",
    "河": "hé",
    "沴": "lì",
    "沵": "mǐ,lì",
    "沶": "yí,chí",
    "沷": "fā",
    "沸": "fèi",
    "油": "yóu",
    "沺": "tián",
    "治": "zhì",
    "沼": "zhǎo",
    "沽": "gū",
    "沾": "zhān",
    "沿": "yán",
    "泀": "sī",
    "況": "kuàng",
    "泂": "jiǒng",
    "泃": "jū",
    "泄": "xiè,yì",
    "泅": "qiú",
    "泆": "yì,dié",
    "泇": "jiā",
    "泈": "zhōng",
    "泉": "quán",
    "泊": "bó,pō",
    "泋": "huì",
    "泌": "mì,bì",
    "泍": "bēn,bèn",
    "泎": "zé",
    "泏": "chù,shè",
    "泐": "lè",
    "泑": "yōu,yòu,āo",
    "泒": "gū",
    "泓": "hóng",
    "泔": "gān",
    "法": "fǎ",
    "泖": "mǎo",
    "泗": "sì",
    "泘": "hū",
    "泙": "pēng,píng",
    "泚": "cǐ",
    "泛": "fàn",
    "泜": "zhī",
    "泝": "sù",
    "泞": "nìng",
    "泟": "chēng",
    "泠": "líng",
    "泡": "pào,pāo",
    "波": "bō",
    "泣": "qì",
    "泤": "sì",
    "泥": "ní,nì",
    "泦": "jú",
    "泧": "yuè,sà",
    "注": "zhù",
    "泩": "shēng",
    "泪": "lèi",
    "泫": "xuàn",
    "泬": "jué,xuè",
    "泭": "fú",
    "泮": "pàn",
    "泯": "mǐn",
    "泰": "tài",
    "泱": "yāng",
    "泲": "jǐ",
    "泳": "yǒng",
    "泴": "guàn",
    "泵": "bèng",
    "泶": "xué",
    "泷": "lóng,shuāng",
    "泸": "lú",
    "泹": "dàn",
    "泺": "luò,pō",
    "泻": "xiè",
    "泼": "pō",
    "泽": "zé,shì",
    "泾": "jīng",
    "泿": "yín",
    "洀": "pán",
    "洁": "jié",
    "洂": "yè",
    "洃": "huī",
    "洄": "huí",
    "洅": "zài",
    "洆": "chéng",
    "洇": "yīn",
    "洈": "wéi",
    "洉": "hòu",
    "洊": "jiàn",
    "洋": "yáng",
    "洌": "liè",
    "洍": "sì",
    "洎": "jì",
    "洏": "ér",
    "洐": "xíng",
    "洑": "fú,fù",
    "洒": "sǎ,xǐ",
    "洓": "sè,qì,zì",
    "洔": "zhǐ",
    "洕": "yìn",
    "洖": "wú",
    "洗": "xǐ,xiǎn",
    "洘": "kǎo,kào",
    "洙": "zhū",
    "洚": "jiàng",
    "洛": "luò",
    "洜": "luò",
    "洝": "àn,yàn,è",
    "洞": "dòng",
    "洟": "yí",
    "洠": "sì",
    "洡": "lěi,lèi",
    "洢": "yī",
    "洣": "mǐ",
    "洤": "quán",
    "津": "jīn",
    "洦": "pò",
    "洧": "wěi",
    "洨": "xiáo",
    "洩": "xiè",
    "洪": "hóng",
    "洫": "xù",
    "洬": "sù,shuò",
    "洭": "kuāng",
    "洮": "táo",
    "洯": "qiè,jié",
    "洰": "jù",
    "洱": "ěr",
    "洲": "zhōu",
    "洳": "rù",
    "洴": "píng",
    "洵": "xún",
    "洶": "xiōng",
    "洷": "zhì",
    "洸": "guāng",
    "洹": "huán",
    "洺": "míng",
    "活": "huó",
    "洼": "wā",
    "洽": "qià",
    "派": "pài",
    "洿": "wū",
    "浀": "qū",
    "流": "liú",
    "浂": "yì",
    "浃": "jiā",
    "浄": "jìng",
    "浅": "qiǎn,jiān",
    "浆": "jiāng,jiàng",
    "浇": "jiāo",
    "浈": "zhēn",
    "浉": "shī",
    "浊": "zhuó",
    "测": "cè",
    "浌": "fá",
    "浍": "kuài,huì",
    "济": "jì,jǐ",
    "浏": "liú",
    "浐": "chǎn",
    "浑": "hún",
    "浒": "hǔ,xǔ",
    "浓": "nóng",
    "浔": "xún",
    "浕": "jìn",
    "浖": "liè",
    "浗": "qiú",
    "浘": "wěi",
    "浙": "zhè",
    "浚": "jùn,xùn",
    "浛": "hán",
    "浜": "bāng",
    "浝": "máng",
    "浞": "zhuó",
    "浟": "yōu,dí",
    "浠": "xī",
    "浡": "bó",
    "浢": "dòu",
    "浣": "huàn",
    "浤": "hóng",
    "浥": "yì",
    "浦": "pǔ",
    "浧": "yǐng,chéng,yíng",
    "浨": "lǎn",
    "浩": "hào",
    "浪": "làng",
    "浫": "hǎn",
    "浬": "lǐ",
    "浭": "gēng",
    "浮": "fú",
    "浯": "wú",
    "浰": "lì",
    "浱": "chún",
    "浲": "féng,hóng",
    "浳": "yì",
    "浴": "yù",
    "浵": "tóng",
    "浶": "láo",
    "海": "hǎi",
    "浸": "jìn",
    "浹": "jiā",
    "浺": "chōng",
    "浻": "jiǒng,jiōng",
    "浼": "měi",
    "浽": "suī,něi",
    "浾": "chēng",
    "浿": "pèi",
    "涀": "xiàn",
    "涁": "shèn",
    "涂": "tú",
    "涃": "kùn",
    "涄": "pīng",
    "涅": "niè",
    "涆": "hàn",
    "涇": "jīng",
    "消": "xiāo",
    "涉": "shè",
    "涊": "niǎn",
    "涋": "tū",
    "涌": "yǒng,chōng",
    "涍": "xiào",
    "涎": "xián",
    "涏": "tǐng",
    "涐": "é",
    "涑": "sù",
    "涒": "tūn,yūn",
    "涓": "juān",
    "涔": "cén",
    "涕": "tì",
    "涖": "lì",
    "涗": "shuì",
    "涘": "sì",
    "涙": "lèi",
    "涚": "shuì",
    "涛": "tāo",
    "涜": "dú",
    "涝": "lào",
    "涞": "lái",
    "涟": "lián",
    "涠": "wéi",
    "涡": "wō,guō",
    "涢": "yún",
    "涣": "huàn",
    "涤": "dí",
    "涥": "hēng",
    "润": "rùn",
    "涧": "jiàn",
    "涨": "zhǎng,zhàng",
    "涩": "sè",
    "涪": "fú",
    "涫": "guān",
    "涬": "xìng",
    "涭": "shòu,tāo",
    "涮": "shuàn",
    "涯": "yá",
    "涰": "chuò",
    "涱": "zhàng",
    "液": "yè",
    "涳": "kōng,náng",
    "涴": "wǎn,wò,yuān",
    "涵": "hán",
    "涶": "tuō,tuò",
    "涷": "dōng",
    "涸": "hé",
    "涹": "wō",
    "涺": "jū",
    "涻": "shè",
    "涼": "liáng,liàng",
    "涽": "hūn",
    "涾": "tà",
    "涿": "zhuō",
    "淀": "diàn",
    "淁": "qiè,jí",
    "淂": "dé",
    "淃": "juàn",
    "淄": "zī",
    "淅": "xī",
    "淆": "xiáo",
    "淇": "qí",
    "淈": "gǔ",
    "淉": "guǒ,guàn",
    "淊": "yān",
    "淋": "lín,lìn",
    "淌": "tǎng,chǎng",
    "淍": "zhōu",
    "淎": "pěng",
    "淏": "hào",
    "淐": "chāng",
    "淑": "shū",
    "淒": "qī",
    "淓": "fāng",
    "淔": "zhí",
    "淕": "lù",
    "淖": "nào,chuò,zhuō",
    "淗": "jú",
    "淘": "táo",
    "淙": "cóng",
    "淚": "lèi",
    "淛": "zhè",
    "淜": "píng,péng",
    "淝": "féi",
    "淞": "sōng",
    "淟": "tiǎn",
    "淠": "pì,pèi",
    "淡": "dàn",
    "淢": "yù,xù",
    "淣": "ní",
    "淤": "yū",
    "淥": "lù",
    "淦": "gàn",
    "淧": "mì",
    "淨": "jìng,chēng",
    "淩": "líng",
    "淪": "lún",
    "淫": "yín",
    "淬": "cuì",
    "淭": "qú",
    "淮": "huái",
    "淯": "yù",
    "淰": "niǎn,shěn",
    "深": "shēn",
    "淲": "biāo,hǔ",
    "淳": "chún,zhūn",
    "淴": "hū",
    "淵": "yuān",
    "淶": "lái",
    "混": "hùn,hún",
    "淸": "qīng",
    "淹": "yān",
    "淺": "qiǎn",
    "添": "tiān",
    "淼": "miǎo",
    "淽": "zhǐ",
    "淾": "yǐn",
    "淿": "bó",
    "渀": "bèn",
    "渁": "yuān",
    "渂": "wèn,mín",
    "渃": "ruò,rè,luò",
    "渄": "fēi",
    "清": "qīng",
    "渆": "yuān",
    "渇": "kě",
    "済": "jì,jǐ",
    "渉": "shè",
    "渊": "yuān",
    "渋": "sè",
    "渌": "lù",
    "渍": "zì",
    "渎": "dú,dòu",
    "渏": "yī",
    "渐": "jiàn,jiān",
    "渑": "miǎn,shéng",
    "渒": "pài",
    "渓": "xī",
    "渔": "yú",
    "渕": "yuān",
    "渖": "shěn",
    "渗": "shèn",
    "渘": "róu",
    "渙": "huàn",
    "渚": "zhǔ",
    "減": "jiǎn",
    "渜": "nuǎn,nuán",
    "渝": "yú",
    "渞": "qiú,wù",
    "渟": "tíng,tīng",
    "渠": "qú,jù",
    "渡": "dù",
    "渢": "fēng",
    "渣": "zhā",
    "渤": "bó",
    "渥": "wò",
    "渦": "wō,guō",
    "渧": "tí,dī,dì",
    "渨": "wěi",
    "温": "wēn",
    "渪": "rú",
    "渫": "xiè",
    "測": "cè",
    "渭": "wèi",
    "渮": "hé",
    "港": "gǎng,jiǎng",
    "渰": "yān,yǎn",
    "渱": "hóng",
    "渲": "xuàn",
    "渳": "mǐ",
    "渴": "kě",
    "渵": "máo",
    "渶": "yīng",
    "渷": "yǎn",
    "游": "yóu",
    "渹": "hōng,qìng",
    "渺": "miǎo",
    "渻": "shěng",
    "渼": "měi",
    "渽": "zāi",
    "渾": "hún",
    "渿": "nài",
    "湀": "guǐ",
    "湁": "chì",
    "湂": "è",
    "湃": "pài",
    "湄": "méi",
    "湅": "liàn",
    "湆": "qì",
    "湇": "qì",
    "湈": "méi",
    "湉": "tián",
    "湊": "còu",
    "湋": "wéi",
    "湌": "cān",
    "湍": "tuān",
    "湎": "miǎn",
    "湏": "huì,mǐn,xū",
    "湐": "pò",
    "湑": "xǔ,xū",
    "湒": "jí",
    "湓": "pén",
    "湔": "jiān",
    "湕": "jiǎn",
    "湖": "hú",
    "湗": "fèng",
    "湘": "xiāng",
    "湙": "yì",
    "湚": "yìn",
    "湛": "zhàn",
    "湜": "shí",
    "湝": "jiē",
    "湞": "zhēn",
    "湟": "huáng",
    "湠": "tàn",
    "湡": "yú",
    "湢": "bì",
    "湣": "mǐn,hūn",
    "湤": "shī",
    "湥": "tū",
    "湦": "shēng",
    "湧": "yǒng",
    "湨": "jú",
    "湩": "dòng",
    "湪": "tuàn,nuǎn",
    "湫": "qiū,jiǎo",
    "湬": "qiū,jiǎo",
    "湭": "qiú",
    "湮": "yān,yīn",
    "湯": "tāng,shāng",
    "湰": "lóng",
    "湱": "huò",
    "湲": "yuán",
    "湳": "nǎn",
    "湴": "bàn,pán",
    "湵": "yǒu",
    "湶": "quán",
    "湷": "zhuāng,hún",
    "湸": "liàng",
    "湹": "chán",
    "湺": "xián",
    "湻": "chún",
    "湼": "niè",
    "湽": "zī",
    "湾": "wān",
    "湿": "shī",
    "満": "mǎn",
    "溁": "yíng",
    "溂": "là",
    "溃": "kuì,huì",
    "溄": "féng,hóng",
    "溅": "jiàn,jiān",
    "溆": "xù",
    "溇": "lóu",
    "溈": "wéi",
    "溉": "gài",
    "溊": "bō",
    "溋": "yíng",
    "溌": "pō",
    "溍": "jìn",
    "溎": "yàn,guì",
    "溏": "táng",
    "源": "yuán",
    "溑": "suǒ",
    "溒": "yuán",
    "溓": "lián,liǎn,nián,xián,xiàn",
    "溔": "yǎo",
    "溕": "méng",
    "準": "zhǔn",
    "溗": "chéng",
    "溘": "kè",
    "溙": "tài",
    "溚": "dá,tǎ",
    "溛": "wā",
    "溜": "liū,liù",
    "溝": "gōu",
    "溞": "sāo",
    "溟": "míng",
    "溠": "zhà",
    "溡": "shí",
    "溢": "yì",
    "溣": "lùn",
    "溤": "mǎ",
    "溥": "pǔ",
    "溦": "wēi",
    "溧": "lì",
    "溨": "zāi",
    "溩": "wù",
    "溪": "xī",
    "溫": "wēn",
    "溬": "qiāng",
    "溭": "zé",
    "溮": "shī",
    "溯": "sù",
    "溰": "ái",
    "溱": "zhēn,qín",
    "溲": "sōu",
    "溳": "yún",
    "溴": "xiù",
    "溵": "yīn",
    "溶": "róng",
    "溷": "hùn",
    "溸": "sù",
    "溹": "suò",
    "溺": "nì,niào",
    "溻": "tā",
    "溼": "shī",
    "溽": "rù",
    "溾": "āi",
    "溿": "pàn",
    "滀": "chù,xù",
    "滁": "chú",
    "滂": "pāng",
    "滃": "wěng,wēng",
    "滄": "cāng",
    "滅": "miè",
    "滆": "gé",
    "滇": "diān",
    "滈": "hào,xuè",
    "滉": "huàng",
    "滊": "qì,xì,xiē",
    "滋": "zī",
    "滌": "dí",
    "滍": "zhì",
    "滎": "xíng,yíng",
    "滏": "fǔ",
    "滐": "jié",
    "滑": "huá",
    "滒": "gē",
    "滓": "zǐ",
    "滔": "tāo",
    "滕": "téng",
    "滖": "suī",
    "滗": "bì",
    "滘": "jiào",
    "滙": "huì",
    "滚": "gǔn",
    "滛": "yín",
    "滜": "zé,hào",
    "滝": "lóng",
    "滞": "zhì",
    "滟": "yàn",
    "滠": "shè",
    "满": "mǎn",
    "滢": "yíng",
    "滣": "chún",
    "滤": "lǜ",
    "滥": "làn",
    "滦": "luán",
    "滧": "yáo",
    "滨": "bīn",
    "滩": "tān",
    "滪": "yù",
    "滫": "xiǔ",
    "滬": "hù",
    "滭": "bì",
    "滮": "biāo",
    "滯": "zhì",
    "滰": "jiàng",
    "滱": "kòu",
    "滲": "shèn",
    "滳": "shāng",
    "滴": "dī",
    "滵": "mì",
    "滶": "áo",
    "滷": "lǔ",
    "滸": "hǔ,xǔ",
    "滹": "hū",
    "滺": "yōu",
    "滻": "chǎn",
    "滼": "fàn",
    "滽": "yōng",
    "滾": "gǔn",
    "滿": "mǎn",
    "漀": "qǐng",
    "漁": "yú",
    "漂": "piāo,piǎo,piào",
    "漃": "jì",
    "漄": "yá",
    "漅": "cháo",
    "漆": "qī",
    "漇": "xǐ",
    "漈": "jì",
    "漉": "lù",
    "漊": "lóu",
    "漋": "lóng",
    "漌": "jǐn",
    "漍": "guó",
    "漎": "cóng,sǒng",
    "漏": "lòu",
    "漐": "zhí",
    "漑": "gài",
    "漒": "qiáng",
    "漓": "lí",
    "演": "yǎn",
    "漕": "cáo",
    "漖": "jiào",
    "漗": "cōng",
    "漘": "chún",
    "漙": "tuán,zhuān",
    "漚": "òu,ōu",
    "漛": "téng",
    "漜": "yě",
    "漝": "xí",
    "漞": "mì",
    "漟": "táng",
    "漠": "mò",
    "漡": "shāng",
    "漢": "hàn",
    "漣": "lián",
    "漤": "lǎn",
    "漥": "wā",
    "漦": "chí",
    "漧": "gān",
    "漨": "féng,péng",
    "漩": "xuán",
    "漪": "yī",
    "漫": "màn",
    "漬": "zì",
    "漭": "mǎng",
    "漮": "kāng",
    "漯": "luò,tà",
    "漰": "bēn,pēng",
    "漱": "shù",
    "漲": "zhǎng,zhàng",
    "漳": "zhāng",
    "漴": "chóng,zhuàng",
    "漵": "xù",
    "漶": "huàn",
    "漷": "huǒ,huò,kuò",
    "漸": "jiàn,jiān",
    "漹": "yān",
    "漺": "shuǎng",
    "漻": "liáo,liú",
    "漼": "cuǐ,cuī",
    "漽": "tí",
    "漾": "yàng",
    "漿": "jiāng,jiàng",
    "潀": "cóng,zǒng",
    "潁": "yǐng",
    "潂": "hóng",
    "潃": "xiǔ",
    "潄": "shù",
    "潅": "guàn",
    "潆": "yíng",
    "潇": "xiāo",
    "潈": "cóng,zōng",
    "潉": "kūn",
    "潊": "xù",
    "潋": "liàn",
    "潌": "zhì",
    "潍": "wéi",
    "潎": "pì,piē",
    "潏": "yù",
    "潐": "jiào,qiáo",
    "潑": "pō",
    "潒": "dàng,xiàng",
    "潓": "huì",
    "潔": "jié",
    "潕": "wǔ",
    "潖": "pá",
    "潗": "jí",
    "潘": "pān",
    "潙": "wéi",
    "潚": "sù",
    "潛": "qián",
    "潜": "qián",
    "潝": "xī,yà",
    "潞": "lù",
    "潟": "xì",
    "潠": "xùn",
    "潡": "dùn",
    "潢": "huáng,guāng",
    "潣": "mǐn",
    "潤": "rùn",
    "潥": "sù",
    "潦": "lǎo,lào,liáo",
    "潧": "zhēn",
    "潨": "cōng,zòng",
    "潩": "yì",
    "潪": "zhí,zhì",
    "潫": "wān",
    "潬": "tān,shàn",
    "潭": "tán",
    "潮": "cháo",
    "潯": "xún",
    "潰": "kuì,huì",
    "潱": "yē",
    "潲": "shào",
    "潳": "tú,zhā",
    "潴": "zhū",
    "潵": "sàn,sǎ",
    "潶": "hēi",
    "潷": "bì",
    "潸": "shān",
    "潹": "chán",
    "潺": "chán",
    "潻": "shǔ",
    "潼": "tóng",
    "潽": "pū",
    "潾": "lín",
    "潿": "wéi",
    "澀": "sè",
    "澁": "sè",
    "澂": "chéng",
    "澃": "jiǒng",
    "澄": "chéng,dèng",
    "澅": "huà",
    "澆": "jiāo",
    "澇": "lào",
    "澈": "chè",
    "澉": "gǎn",
    "澊": "cūn,cún",
    "澋": "jǐng",
    "澌": "sī",
    "澍": "shù,zhù",
    "澎": "péng",
    "澏": "hán",
    "澐": "yún",
    "澑": "liū,liù",
    "澒": "hòng,gǒng",
    "澓": "fú",
    "澔": "hào",
    "澕": "hé",
    "澖": "xián",
    "澗": "jiàn",
    "澘": "shān",
    "澙": "xì",
    "澚": "ào,yù",
    "澛": "lǔ",
    "澜": "lán",
    "澝": "nìng",
    "澞": "yú",
    "澟": "lǐn",
    "澠": "miǎn,shéng",
    "澡": "zǎo",
    "澢": "dāng",
    "澣": "huàn",
    "澤": "zé,shì",
    "澥": "xiè",
    "澦": "yù",
    "澧": "lǐ",
    "澨": "shì",
    "澩": "xué",
    "澪": "líng",
    "澫": "wàn,màn",
    "澬": "zī",
    "澭": "yōng,yǒng",
    "澮": "kuài,huì",
    "澯": "càn",
    "澰": "liàn",
    "澱": "diàn",
    "澲": "yè",
    "澳": "ào",
    "澴": "huán",
    "澵": "zhēn",
    "澶": "chán",
    "澷": "màn",
    "澸": "gǎn",
    "澹": "dàn,tán",
    "澺": "yì",
    "澻": "suì",
    "澼": "pì",
    "澽": "jù",
    "澾": "tà",
    "澿": "qín",
    "激": "jī",
    "濁": "zhuó",
    "濂": "lián",
    "濃": "nóng",
    "濄": "guō,wō",
    "濅": "jìn",
    "濆": "fén,pēn",
    "濇": "sè",
    "濈": "jí,shà",
    "濉": "suī",
    "濊": "huì,huò",
    "濋": "chǔ",
    "濌": "tà",
    "濍": "sōng",
    "濎": "dǐng,tìng",
    "濏": "sè",
    "濐": "zhǔ",
    "濑": "lài",
    "濒": "bīn",
    "濓": "lián",
    "濔": "mǐ,nǐ",
    "濕": "shī",
    "濖": "shù",
    "濗": "mì",
    "濘": "nìng",
    "濙": "yíng",
    "濚": "yíng",
    "濛": "méng",
    "濜": "jìn",
    "濝": "qí",
    "濞": "bì,pì",
    "濟": "jì,jǐ",
    "濠": "háo",
    "濡": "rú",
    "濢": "cuì,zuǐ",
    "濣": "wò",
    "濤": "tāo",
    "濥": "yǐn",
    "濦": "yīn",
    "濧": "duì",
    "濨": "cí",
    "濩": "huò,hù",
    "濪": "qìng",
    "濫": "làn",
    "濬": "jùn,xùn",
    "濭": "ǎi,kài,kè",
    "濮": "pú",
    "濯": "zhuó,zhào",
    "濰": "wéi",
    "濱": "bīn",
    "濲": "gǔ",
    "濳": "qián",
    "濴": "yíng",
    "濵": "bīn",
    "濶": "kuò",
    "濷": "fèi",
    "濸": "cāng",
    "濹": "mè",
    "濺": "jiàn,jiān",
    "濻": "wěi,duì",
    "濼": "luò,pō",
    "濽": "zàn,cuán",
    "濾": "lǜ",
    "濿": "lì",
    "瀀": "yōu",
    "瀁": "yǎng,yàng",
    "瀂": "lǔ",
    "瀃": "sì",
    "瀄": "zhì",
    "瀅": "yíng",
    "瀆": "dú,dòu",
    "瀇": "wǎng,wāng",
    "瀈": "huī",
    "瀉": "xiè",
    "瀊": "pán",
    "瀋": "shěn",
    "瀌": "biāo",
    "瀍": "chán",
    "瀎": "miè,mò",
    "瀏": "liú",
    "瀐": "jiān",
    "瀑": "pù,bào",
    "瀒": "sè",
    "瀓": "chéng,dèng",
    "瀔": "gǔ",
    "瀕": "bīn",
    "瀖": "huò",
    "瀗": "xiàn",
    "瀘": "lú",
    "瀙": "qìn",
    "瀚": "hàn",
    "瀛": "yíng",
    "瀜": "róng",
    "瀝": "lì",
    "瀞": "jìng",
    "瀟": "xiāo",
    "瀠": "yíng",
    "瀡": "suǐ",
    "瀢": "wěi,duì",
    "瀣": "xiè",
    "瀤": "huái,wāi",
    "瀥": "xuè",
    "瀦": "zhū",
    "瀧": "lóng,shuāng",
    "瀨": "lài",
    "瀩": "duì",
    "瀪": "fàn",
    "瀫": "hú",
    "瀬": "lài",
    "瀭": "shū",
    "瀮": "lián",
    "瀯": "yíng",
    "瀰": "mí",
    "瀱": "jì",
    "瀲": "liàn",
    "瀳": "jiàn,zùn",
    "瀴": "yīng,yǐng,yìng",
    "瀵": "fèn",
    "瀶": "lín",
    "瀷": "yì",
    "瀸": "jiān",
    "瀹": "yuè",
    "瀺": "chán",
    "瀻": "dài",
    "瀼": "ráng,nǎng",
    "瀽": "jiǎn",
    "瀾": "lán",
    "瀿": "fán",
    "灀": "shuàng",
    "灁": "yuān",
    "灂": "zhuó,jiào,zé",
    "灃": "fēng",
    "灄": "shè",
    "灅": "lěi",
    "灆": "lán",
    "灇": "cóng",
    "灈": "qú",
    "灉": "yōng",
    "灊": "qián",
    "灋": "fǎ",
    "灌": "guàn",
    "灍": "jué",
    "灎": "yàn",
    "灏": "hào",
    "灐": "yíng",
    "灑": "sǎ",
    "灒": "zàn,cuán",
    "灓": "luán,luàn",
    "灔": "yàn",
    "灕": "lí",
    "灖": "mǐ",
    "灗": "shàn",
    "灘": "tān",
    "灙": "dǎng,tǎng",
    "灚": "jiǎo",
    "灛": "chǎn",
    "灜": "yíng",
    "灝": "hào",
    "灞": "bà",
    "灟": "zhú",
    "灠": "lǎn",
    "灡": "lán",
    "灢": "nǎng",
    "灣": "wān",
    "灤": "luán",
    "灥": "xún,quán,quàn",
    "灦": "xiǎn",
    "灧": "yàn",
    "灨": "gàn",
    "灩": "yàn",
    "灪": "yù",
    "火": "huǒ",
    "灬": "huǒ,biāo",
    "灭": "miè",
    "灮": "guāng",
    "灯": "dēng",
    "灰": "huī",
    "灱": "xiāo",
    "灲": "xiāo",
    "灳": "huī",
    "灴": "hōng",
    "灵": "líng",
    "灶": "zào",
    "灷": "zhuàn",
    "灸": "jiǔ",
    "灹": "zhà,yù",
    "灺": "xiè",
    "灻": "chì",
    "灼": "zhuó",
    "災": "zāi",
    "灾": "zāi",
    "灿": "càn",
    "炀": "yáng",
    "炁": "qì",
    "炂": "zhōng",
    "炃": "fén,bèn",
    "炄": "niǔ",
    "炅": "jiǒng,guì",
    "炆": "wén",
    "炇": "pū",
    "炈": "yì",
    "炉": "lú",
    "炊": "chuī",
    "炋": "pī",
    "炌": "kài",
    "炍": "pàn",
    "炎": "yán",
    "炏": "yán",
    "炐": "pàng,fēng",
    "炑": "mù",
    "炒": "chǎo",
    "炓": "liào",
    "炔": "quē",
    "炕": "kàng",
    "炖": "dùn",
    "炗": "guāng",
    "炘": "xìn",
    "炙": "zhì",
    "炚": "guāng",
    "炛": "guāng",
    "炜": "wěi",
    "炝": "qiàng",
    "炞": "biān",
    "炟": "dá",
    "炠": "xiá",
    "炡": "zhēng",
    "炢": "zhú",
    "炣": "kě",
    "炤": "zhào,zhāo",
    "炥": "fú",
    "炦": "bá",
    "炧": "xiè",
    "炨": "xiè",
    "炩": "lìng",
    "炪": "zhuō,chù",
    "炫": "xuàn",
    "炬": "jù",
    "炭": "tàn",
    "炮": "pào,páo,bāo",
    "炯": "jiǒng",
    "炰": "páo,fǒu",
    "炱": "tái",
    "炲": "tái",
    "炳": "bǐng",
    "炴": "yǎng",
    "炵": "tōng",
    "炶": "shǎn,qián,shān",
    "炷": "zhù",
    "炸": "zhà,zhá",
    "点": "diǎn",
    "為": "wéi,wèi",
    "炻": "shí",
    "炼": "liàn",
    "炽": "chì",
    "炾": "huǎng",
    "炿": "zhōu",
    "烀": "hū",
    "烁": "shuò",
    "烂": "làn",
    "烃": "tīng",
    "烄": "jiǎo,yào",
    "烅": "xù",
    "烆": "héng",
    "烇": "quǎn",
    "烈": "liè",
    "烉": "huàn",
    "烊": "yáng,yàng",
    "烋": "xiāo",
    "烌": "xiū",
    "烍": "xiǎn",
    "烎": "yín",
    "烏": "wū",
    "烐": "zhōu",
    "烑": "yáo",
    "烒": "shì",
    "烓": "wēi",
    "烔": "tóng,dòng",
    "烕": "miè",
    "烖": "zāi",
    "烗": "kài",
    "烘": "hōng",
    "烙": "lào,luò",
    "烚": "xiá",
    "烛": "zhú",
    "烜": "xuǎn",
    "烝": "zhēng",
    "烞": "pò",
    "烟": "yān",
    "烠": "huí,huǐ",
    "烡": "guāng",
    "烢": "chè",
    "烣": "huī",
    "烤": "kǎo",
    "烥": "jù",
    "烦": "fán",
    "烧": "shāo",
    "烨": "yè",
    "烩": "huì",
    "烪": "null",
    "烫": "tàng",
    "烬": "jìn",
    "热": "rè",
    "烮": "liè",
    "烯": "xī",
    "烰": "fú,páo",
    "烱": "jiǒng",
    "烲": "xiè,chè",
    "烳": "pǔ",
    "烴": "tīng",
    "烵": "zhuó",
    "烶": "tǐng",
    "烷": "wán",
    "烸": "hǎi",
    "烹": "pēng",
    "烺": "lǎng",
    "烻": "yàn",
    "烼": "xù",
    "烽": "fēng",
    "烾": "chì",
    "烿": "róng",
    "焀": "hú",
    "焁": "xī",
    "焂": "shū",
    "焃": "hè",
    "焄": "xūn,hūn",
    "焅": "kù",
    "焆": "juān,yè",
    "焇": "xiāo",
    "焈": "xī",
    "焉": "yān",
    "焊": "hàn",
    "焋": "zhuàng",
    "焌": "qū,jùn",
    "焍": "dì",
    "焎": "xiè,chè",
    "焏": "jí,qì",
    "焐": "wù",
    "焑": "yān",
    "焒": "lǚ",
    "焓": "hán",
    "焔": "yàn",
    "焕": "huàn",
    "焖": "mèn",
    "焗": "jú",
    "焘": "dào",
    "焙": "bèi",
    "焚": "fén",
    "焛": "lìn",
    "焜": "kūn",
    "焝": "hùn",
    "焞": "tūn",
    "焟": "xī",
    "焠": "cuì",
    "無": "wú",
    "焢": "hōng",
    "焣": "chǎo,jù",
    "焤": "fǔ",
    "焥": "wò,ài",
    "焦": "jiāo",
    "焧": "zǒng,cōng",
    "焨": "fèng",
    "焩": "píng",
    "焪": "qióng",
    "焫": "ruò",
    "焬": "xī,yì",
    "焭": "qióng",
    "焮": "xìn",
    "焯": "zhuō,chāo",
    "焰": "yàn",
    "焱": "yàn",
    "焲": "yì",
    "焳": "jué",
    "焴": "yù",
    "焵": "gàng",
    "然": "rán",
    "焷": "pí",
    "焸": "xiǒng,yīng",
    "焹": "gàng",
    "焺": "shēng",
    "焻": "chàng",
    "焼": "shāo",
    "焽": "xiǒng,yīng",
    "焾": "niǎn",
    "焿": "gēng",
    "煀": "qū",
    "煁": "chén",
    "煂": "hè",
    "煃": "kuǐ",
    "煄": "zhǒng",
    "煅": "duàn",
    "煆": "xiā",
    "煇": "huī,yùn,xūn",
    "煈": "fèng",
    "煉": "liàn",
    "煊": "xuān",
    "煋": "xīng",
    "煌": "huáng",
    "煍": "jiǎo,qiāo",
    "煎": "jiān",
    "煏": "bì",
    "煐": "yīng",
    "煑": "zhǔ",
    "煒": "wěi",
    "煓": "tuān",
    "煔": "shǎn,qián,shān",
    "煕": "xī,yí",
    "煖": "nuǎn",
    "煗": "nuǎn",
    "煘": "chán",
    "煙": "yān",
    "煚": "jiǒng",
    "煛": "jiǒng",
    "煜": "yù",
    "煝": "mèi",
    "煞": "shā,shà",
    "煟": "wèi",
    "煠": "yè,zhá",
    "煡": "jìn",
    "煢": "qióng",
    "煣": "róu",
    "煤": "méi",
    "煥": "huàn",
    "煦": "xù",
    "照": "zhào",
    "煨": "wēi",
    "煩": "fán",
    "煪": "qiú",
    "煫": "suì",
    "煬": "yáng,yàng",
    "煭": "liè",
    "煮": "zhǔ",
    "煯": "jiē",
    "煰": "zào",
    "煱": "guā",
    "煲": "bāo",
    "煳": "hú",
    "煴": "yūn,yǔn",
    "煵": "nǎn",
    "煶": "shì",
    "煷": "huǒ",
    "煸": "biān",
    "煹": "gòu",
    "煺": "tuì",
    "煻": "táng",
    "煼": "chǎo",
    "煽": "shān",
    "煾": "ēn,yūn",
    "煿": "bó",
    "熀": "huǎng",
    "熁": "xié",
    "熂": "xì",
    "熃": "wù",
    "熄": "xī",
    "熅": "yūn,yǔn",
    "熆": "hé",
    "熇": "hè,xiāo",
    "熈": "xī",
    "熉": "yún",
    "熊": "xióng",
    "熋": "xióng",
    "熌": "shǎn",
    "熍": "qióng",
    "熎": "yào",
    "熏": "xūn,xùn",
    "熐": "mì",
    "熑": "lián",
    "熒": "yíng",
    "熓": "wǔ",
    "熔": "róng",
    "熕": "gòng",
    "熖": "yàn",
    "熗": "qiàng",
    "熘": "liū",
    "熙": "xī",
    "熚": "bì",
    "熛": "biāo",
    "熜": "cōng,zǒng",
    "熝": "lù,āo",
    "熞": "jiān",
    "熟": "shú",
    "熠": "yì",
    "熡": "lóu",
    "熢": "péng,fēng",
    "熣": "suī,cuǐ",
    "熤": "yì",
    "熥": "tēng",
    "熦": "jué",
    "熧": "zōng",
    "熨": "yùn,yù",
    "熩": "hù",
    "熪": "yí",
    "熫": "zhì",
    "熬": "āo,áo",
    "熭": "wèi",
    "熮": "liǔ",
    "熯": "hàn,rǎn",
    "熰": "ōu,ǒu",
    "熱": "rè",
    "熲": "jiǒng",
    "熳": "màn",
    "熴": "kūn",
    "熵": "shāng",
    "熶": "cuàn",
    "熷": "zèng",
    "熸": "jiān",
    "熹": "xī",
    "熺": "xī",
    "熻": "xī",
    "熼": "yì",
    "熽": "xiào",
    "熾": "chì",
    "熿": "huáng,huǎng",
    "燀": "chǎn,dǎn,chàn",
    "燁": "yè",
    "燂": "tán",
    "燃": "rán",
    "燄": "yàn",
    "燅": "xún",
    "燆": "qiāo",
    "燇": "jùn",
    "燈": "dēng",
    "燉": "dùn",
    "燊": "shēn",
    "燋": "jiāo,qiáo,jué,zhuó",
    "燌": "fén",
    "燍": "sī",
    "燎": "liáo,liǎo",
    "燏": "yù",
    "燐": "lín",
    "燑": "tóng,dòng",
    "燒": "shāo",
    "燓": "fén",
    "燔": "fán",
    "燕": "yàn,yān",
    "燖": "xún",
    "燗": "làn",
    "燘": "měi",
    "燙": "tàng",
    "燚": "yì",
    "燛": "jiǒng",
    "燜": "mèn",
    "燝": "zhǔ",
    "燞": "jiǎo",
    "營": "yíng",
    "燠": "yù",
    "燡": "yì",
    "燢": "xué",
    "燣": "lán",
    "燤": "tài,liè",
    "燥": "zào",
    "燦": "càn",
    "燧": "suì",
    "燨": "xī",
    "燩": "què",
    "燪": "zǒng",
    "燫": "lián",
    "燬": "huǐ",
    "燭": "zhú",
    "燮": "xiè",
    "燯": "líng",
    "燰": "wēi",
    "燱": "yì",
    "燲": "xié",
    "燳": "zhào",
    "燴": "huì",
    "燵": "dá",
    "燶": "nóng",
    "燷": "lán",
    "燸": "xū",
    "燹": "xiǎn",
    "燺": "hè",
    "燻": "xūn",
    "燼": "jìn",
    "燽": "chóu",
    "燾": "dào",
    "燿": "yào",
    "爀": "hè",
    "爁": "làn",
    "爂": "biāo",
    "爃": "róng,yíng",
    "爄": "lì,liè",
    "爅": "mò",
    "爆": "bào",
    "爇": "ruò",
    "爈": "lǜ",
    "爉": "là,liè",
    "爊": "āo",
    "爋": "xūn,xùn",
    "爌": "kuàng,huǎng",
    "爍": "shuò",
    "爎": "liáo,liǎo",
    "爏": "lì",
    "爐": "lú",
    "爑": "jué",
    "爒": "liáo,liǎo",
    "爓": "yàn,xún",
    "爔": "xī",
    "爕": "xiè",
    "爖": "lóng",
    "爗": "yè",
    "爘": "cān",
    "爙": "rǎng",
    "爚": "yuè",
    "爛": "làn",
    "爜": "cóng",
    "爝": "jué",
    "爞": "chóng",
    "爟": "guàn",
    "爠": "qú",
    "爡": "chè",
    "爢": "mí",
    "爣": "tǎng",
    "爤": "làn",
    "爥": "zhú",
    "爦": "lǎn,làn",
    "爧": "líng",
    "爨": "cuàn",
    "爩": "yù",
    "爪": "zhǎo,zhuǎ",
    "爫": "zhǎo,zhuǎ",
    "爬": "pá",
    "爭": "zhēng",
    "爮": "páo",
    "爯": "chēng,chèn",
    "爰": "yuán",
    "爱": "ài",
    "爲": "wéi,wèi",
    "爳": "han",
    "爴": "jué",
    "爵": "jué",
    "父": "fù,fǔ",
    "爷": "yé",
    "爸": "bà",
    "爹": "diē",
    "爺": "yé",
    "爻": "yáo",
    "爼": "zǔ",
    "爽": "shuǎng",
    "爾": "ěr",
    "爿": "pán",
    "牀": "chuáng",
    "牁": "kē",
    "牂": "zāng",
    "牃": "dié",
    "牄": "qiāng",
    "牅": "yōng",
    "牆": "qiáng",
    "片": "piàn,piān",
    "版": "bǎn",
    "牉": "pàn",
    "牊": "cháo",
    "牋": "jiān",
    "牌": "pái",
    "牍": "dú",
    "牎": "chuāng",
    "牏": "yú",
    "牐": "zhá",
    "牑": "biān,miàn",
    "牒": "dié",
    "牓": "bǎng",
    "牔": "bó",
    "牕": "chuāng",
    "牖": "yǒu",
    "牗": "yǒu,yōng",
    "牘": "dú",
    "牙": "yá",
    "牚": "chēng,chèng",
    "牛": "niú",
    "牜": "niú",
    "牝": "pìn",
    "牞": "jiū,lè",
    "牟": "móu,mù",
    "牠": "tā",
    "牡": "mǔ",
    "牢": "láo",
    "牣": "rèn",
    "牤": "māng",
    "牥": "fāng",
    "牦": "máo",
    "牧": "mù",
    "牨": "gāng",
    "物": "wù",
    "牪": "yàn",
    "牫": "gē,qiú",
    "牬": "bèi",
    "牭": "sì",
    "牮": "jiàn",
    "牯": "gǔ",
    "牰": "yòu,chōu",
    "牱": "kē",
    "牲": "shēng",
    "牳": "mǔ",
    "牴": "dǐ",
    "牵": "qiān",
    "牶": "quàn",
    "牷": "quán",
    "牸": "zì",
    "特": "tè",
    "牺": "xī",
    "牻": "máng",
    "牼": "kēng",
    "牽": "qiān",
    "牾": "wǔ",
    "牿": "gù",
    "犀": "xī",
    "犁": "lí",
    "犂": "lí",
    "犃": "pǒu",
    "犄": "jī",
    "犅": "gāng",
    "犆": "zhí,tè",
    "犇": "bēn",
    "犈": "quán",
    "犉": "chún",
    "犊": "dú",
    "犋": "jù",
    "犌": "jiā",
    "犍": "jiān,qián",
    "犎": "fēng",
    "犏": "piān",
    "犐": "kē",
    "犑": "jú",
    "犒": "kào",
    "犓": "chú",
    "犔": "xì",
    "犕": "bèi",
    "犖": "luò",
    "犗": "jiè",
    "犘": "má",
    "犙": "sān",
    "犚": "wèi",
    "犛": "máo,lí",
    "犜": "dūn",
    "犝": "tóng",
    "犞": "qiáo",
    "犟": "jiàng",
    "犠": "xī",
    "犡": "lì",
    "犢": "dú",
    "犣": "liè",
    "犤": "pái",
    "犥": "piāo",
    "犦": "bào",
    "犧": "xī",
    "犨": "chōu",
    "犩": "wéi",
    "犪": "kuí",
    "犫": "chōu",
    "犬": "quǎn",
    "犭": "quǎn",
    "犮": "quǎn,bá",
    "犯": "fàn",
    "犰": "qiú",
    "犱": "jǐ",
    "犲": "chái",
    "犳": "zhuó,bào",
    "犴": "hān,àn",
    "犵": "gē",
    "状": "zhuàng",
    "犷": "guǎng",
    "犸": "mǎ",
    "犹": "yóu",
    "犺": "kàng,gǎng",
    "犻": "pèi,fèi",
    "犼": "hǒu",
    "犽": "yà",
    "犾": "yín",
    "犿": "huān,fān",
    "狀": "zhuàng",
    "狁": "yǔn",
    "狂": "kuáng",
    "狃": "niǔ",
    "狄": "dí",
    "狅": "kuáng",
    "狆": "zhòng",
    "狇": "mù",
    "狈": "bèi",
    "狉": "pī",
    "狊": "jú",
    "狋": "yí,quán,chí",
    "狌": "shēng,xīng",
    "狍": "páo",
    "狎": "xiá",
    "狏": "tuó,yí",
    "狐": "hú",
    "狑": "líng",
    "狒": "fèi",
    "狓": "pī",
    "狔": "nǐ",
    "狕": "yǎo",
    "狖": "yòu",
    "狗": "gǒu",
    "狘": "xuè",
    "狙": "jū",
    "狚": "dàn",
    "狛": "bó",
    "狜": "kǔ",
    "狝": "xiǎn",
    "狞": "níng",
    "狟": "huán,huān",
    "狠": "hěn",
    "狡": "jiǎo",
    "狢": "hé,mò",
    "狣": "zhào",
    "狤": "jié",
    "狥": "xùn",
    "狦": "shān",
    "狧": "tà,shì",
    "狨": "róng",
    "狩": "shòu",
    "狪": "tóng,dòng",
    "狫": "lǎo",
    "独": "dú",
    "狭": "xiá",
    "狮": "shī",
    "狯": "kuài",
    "狰": "zhēng",
    "狱": "yù",
    "狲": "sūn",
    "狳": "yú",
    "狴": "bì",
    "狵": "máng,dòu",
    "狶": "xī,shǐ",
    "狷": "juàn",
    "狸": "lí",
    "狹": "xiá",
    "狺": "yín",
    "狻": "suān",
    "狼": "láng",
    "狽": "bèi",
    "狾": "zhì",
    "狿": "yán",
    "猀": "shā",
    "猁": "lì",
    "猂": "hàn",
    "猃": "xiǎn",
    "猄": "jīng",
    "猅": "pái",
    "猆": "fēi",
    "猇": "xiāo",
    "猈": "bài,pí",
    "猉": "qí",
    "猊": "ní",
    "猋": "biāo",
    "猌": "yìn",
    "猍": "lái",
    "猎": "liè",
    "猏": "jiān,yàn",
    "猐": "qiāng",
    "猑": "kūn",
    "猒": "yàn",
    "猓": "guō",
    "猔": "zòng",
    "猕": "mí",
    "猖": "chāng",
    "猗": "yī,yǐ",
    "猘": "zhì",
    "猙": "zhēng",
    "猚": "yá,wèi",
    "猛": "měng",
    "猜": "cāi",
    "猝": "cù",
    "猞": "shē",
    "猟": "liè",
    "猠": "null",
    "猡": "luó",
    "猢": "hú",
    "猣": "zōng",
    "猤": "guì",
    "猥": "wěi",
    "猦": "fēng",
    "猧": "wō",
    "猨": "yuán",
    "猩": "xīng",
    "猪": "zhū",
    "猫": "māo,máo",
    "猬": "wèi",
    "猭": "chuàn,chuān",
    "献": "xiàn",
    "猯": "tuān,tuàn",
    "猰": "yà,jiá,qiè",
    "猱": "náo",
    "猲": "xiē,hè,gé,hài",
    "猳": "jiā",
    "猴": "hóu",
    "猵": "biān,piàn",
    "猶": "yóu",
    "猷": "yóu",
    "猸": "méi",
    "猹": "chá",
    "猺": "yáo",
    "猻": "sūn",
    "猼": "bó,pò",
    "猽": "míng",
    "猾": "huá",
    "猿": "yuán",
    "獀": "sōu",
    "獁": "mǎ",
    "獂": "huán",
    "獃": "dāi",
    "獄": "yù",
    "獅": "shī",
    "獆": "háo",
    "獇": "qiāng",
    "獈": "yì",
    "獉": "zhēn",
    "獊": "cāng",
    "獋": "háo,gāo",
    "獌": "màn",
    "獍": "jìng",
    "獎": "jiǎng",
    "獏": "mò",
    "獐": "zhāng",
    "獑": "chán",
    "獒": "áo",
    "獓": "áo",
    "獔": "háo",
    "獕": "suǒ",
    "獖": "fén,fèn",
    "獗": "jué",
    "獘": "bì",
    "獙": "bì",
    "獚": "huáng",
    "獛": "pú",
    "獜": "lín,lìn",
    "獝": "xù",
    "獞": "tóng",
    "獟": "yào,xiāo",
    "獠": "liáo",
    "獡": "shuò,xī",
    "獢": "xiāo",
    "獣": "shòu",
    "獤": "dūn",
    "獥": "jiào",
    "獦": "gé,liè,xiē",
    "獧": "juàn",
    "獨": "dú",
    "獩": "huì",
    "獪": "kuài",
    "獫": "xiǎn",
    "獬": "xiè",
    "獭": "tǎ",
    "獮": "xiǎn",
    "獯": "xūn",
    "獰": "níng",
    "獱": "biān,piàn",
    "獲": "huò",
    "獳": "nòu,rú",
    "獴": "méng",
    "獵": "liè",
    "獶": "náo,nǎo,yōu",
    "獷": "guǎng",
    "獸": "shòu",
    "獹": "lú",
    "獺": "tǎ",
    "獻": "xiàn",
    "獼": "mí",
    "獽": "ráng",
    "獾": "huān",
    "獿": "náo,yōu",
    "玀": "luó",
    "玁": "xiǎn",
    "玂": "qí",
    "玃": "jué",
    "玄": "xuán",
    "玅": "miào",
    "玆": "zī",
    "率": "lǜ,shuài",
    "玈": "lú",
    "玉": "yù",
    "玊": "sù",
    "王": "wáng,wàng",
    "玌": "qiú",
    "玍": "gǎ",
    "玎": "dīng",
    "玏": "lè",
    "玐": "bā",
    "玑": "jī",
    "玒": "hóng",
    "玓": "dì",
    "玔": "chuàn",
    "玕": "gān",
    "玖": "jiǔ",
    "玗": "yú",
    "玘": "qǐ",
    "玙": "yú",
    "玚": "chàng,yáng",
    "玛": "mǎ",
    "玜": "hóng",
    "玝": "wǔ",
    "玞": "fū",
    "玟": "mín,wén",
    "玠": "jiè",
    "玡": "yà",
    "玢": "bīn,fēn",
    "玣": "biàn",
    "玤": "bàng",
    "玥": "yuè",
    "玦": "jué",
    "玧": "mén,yǔn",
    "玨": "jué",
    "玩": "wán",
    "玪": "jiān,qián",
    "玫": "méi",
    "玬": "dǎn",
    "玭": "pín",
    "玮": "wěi",
    "环": "huán",
    "现": "xiàn",
    "玱": "qiāng,cāng",
    "玲": "líng",
    "玳": "dài",
    "玴": "yì",
    "玵": "án,gān",
    "玶": "píng",
    "玷": "diàn",
    "玸": "fú",
    "玹": "xuán,xián",
    "玺": "xǐ",
    "玻": "bō",
    "玼": "cī,cǐ",
    "玽": "gǒu",
    "玾": "jiǎ",
    "玿": "sháo",
    "珀": "pò",
    "珁": "cí",
    "珂": "kē",
    "珃": "rǎn",
    "珄": "shēng",
    "珅": "shēn",
    "珆": "yí,tāi",
    "珇": "zǔ,jù",
    "珈": "jiā",
    "珉": "mín",
    "珊": "shān",
    "珋": "liǔ",
    "珌": "bì",
    "珍": "zhēn",
    "珎": "zhēn",
    "珏": "jué",
    "珐": "fà",
    "珑": "lóng",
    "珒": "jīn",
    "珓": "jiào",
    "珔": "jiàn",
    "珕": "lì",
    "珖": "guāng",
    "珗": "xiān",
    "珘": "zhōu",
    "珙": "gǒng",
    "珚": "yān",
    "珛": "xiù",
    "珜": "yáng",
    "珝": "xǔ",
    "珞": "luò",
    "珟": "sù",
    "珠": "zhū",
    "珡": "qín",
    "珢": "yín,kèn",
    "珣": "xún",
    "珤": "bǎo",
    "珥": "ěr",
    "珦": "xiàng",
    "珧": "yáo",
    "珨": "xiá",
    "珩": "héng",
    "珪": "guī",
    "珫": "chōng",
    "珬": "xù",
    "班": "bān",
    "珮": "pèi",
    "珯": "lǎo",
    "珰": "dāng",
    "珱": "yīng",
    "珲": "hún,huī",
    "珳": "wén",
    "珴": "é",
    "珵": "chéng",
    "珶": "dì,tí",
    "珷": "wǔ",
    "珸": "wú",
    "珹": "chéng",
    "珺": "jùn",
    "珻": "méi",
    "珼": "bèi",
    "珽": "tǐng",
    "現": "xiàn",
    "珿": "chù",
    "琀": "hán",
    "琁": "xuán,qióng",
    "琂": "yán",
    "球": "qiú",
    "琄": "xuàn",
    "琅": "láng",
    "理": "lǐ",
    "琇": "xiù",
    "琈": "fú,fū",
    "琉": "liú",
    "琊": "yá",
    "琋": "xī",
    "琌": "líng",
    "琍": "lí",
    "琎": "jīn",
    "琏": "liǎn",
    "琐": "suǒ",
    "琑": "suǒ",
    "琒": "fēng",
    "琓": "wán",
    "琔": "diàn",
    "琕": "pín,bǐng",
    "琖": "zhǎn",
    "琗": "cuì,sè",
    "琘": "mín",
    "琙": "yù",
    "琚": "jū",
    "琛": "chēn",
    "琜": "lái",
    "琝": "mín",
    "琞": "shèng",
    "琟": "wéi,yù",
    "琠": "tiǎn,tiàn",
    "琡": "shū",
    "琢": "zhuó,zuó",
    "琣": "běng,pěi",
    "琤": "chēng",
    "琥": "hǔ",
    "琦": "qí",
    "琧": "è",
    "琨": "kūn",
    "琩": "chāng",
    "琪": "qí",
    "琫": "běng",
    "琬": "wǎn",
    "琭": "lù",
    "琮": "cóng",
    "琯": "guǎn",
    "琰": "yǎn",
    "琱": "diāo",
    "琲": "bèi",
    "琳": "lín",
    "琴": "qín",
    "琵": "pí",
    "琶": "pá",
    "琷": "què",
    "琸": "zhuó",
    "琹": "qín",
    "琺": "fà",
    "琻": "jīn",
    "琼": "qióng",
    "琽": "dǔ",
    "琾": "jiè",
    "琿": "hún,huī",
    "瑀": "yǔ",
    "瑁": "mào",
    "瑂": "méi",
    "瑃": "chūn",
    "瑄": "xuān",
    "瑅": "tí",
    "瑆": "xīng",
    "瑇": "dài",
    "瑈": "róu",
    "瑉": "mín",
    "瑊": "jiān",
    "瑋": "wěi",
    "瑌": "ruǎn",
    "瑍": "huàn",
    "瑎": "xié,jiē",
    "瑏": "chuān",
    "瑐": "jiǎn",
    "瑑": "zhuàn",
    "瑒": "chàng,yáng",
    "瑓": "liàn",
    "瑔": "quán",
    "瑕": "xiá",
    "瑖": "duàn",
    "瑗": "yuàn",
    "瑘": "yé",
    "瑙": "nǎo",
    "瑚": "hú",
    "瑛": "yīng",
    "瑜": "yú",
    "瑝": "huáng",
    "瑞": "ruì",
    "瑟": "sè",
    "瑠": "liú",
    "瑡": "shī",
    "瑢": "róng",
    "瑣": "suǒ",
    "瑤": "yáo",
    "瑥": "wēn",
    "瑦": "wǔ",
    "瑧": "zhēn",
    "瑨": "jìn",
    "瑩": "yíng",
    "瑪": "mǎ",
    "瑫": "tāo",
    "瑬": "liú",
    "瑭": "táng",
    "瑮": "lì",
    "瑯": "láng",
    "瑰": "guī",
    "瑱": "tiàn,tián,zhèn",
    "瑲": "qiāng,cāng",
    "瑳": "cuō",
    "瑴": "jué",
    "瑵": "zhǎo",
    "瑶": "yáo",
    "瑷": "ài",
    "瑸": "bīn,pián",
    "瑹": "tú,shū",
    "瑺": "cháng",
    "瑻": "kūn",
    "瑼": "zhuān",
    "瑽": "cōng",
    "瑾": "jǐn",
    "瑿": "yī",
    "璀": "cuǐ",
    "璁": "cōng",
    "璂": "qí",
    "璃": "lí",
    "璄": "jǐng",
    "璅": "zǎo,suǒ",
    "璆": "qiú",
    "璇": "xuán",
    "璈": "áo",
    "璉": "liǎn",
    "璊": "mén",
    "璋": "zhāng",
    "璌": "yín",
    "璍": "yè",
    "璎": "yīng",
    "璏": "zhì",
    "璐": "lù",
    "璑": "wú",
    "璒": "dēng",
    "璓": "xiù",
    "璔": "zēng",
    "璕": "xún",
    "璖": "qú",
    "璗": "dàng",
    "璘": "lín",
    "璙": "liáo",
    "璚": "qióng,jué",
    "璛": "sù",
    "璜": "huáng",
    "璝": "guī",
    "璞": "pú",
    "璟": "jǐng",
    "璠": "fán",
    "璡": "jīn",
    "璢": "liú",
    "璣": "jī",
    "璤": "huì",
    "璥": "jǐng",
    "璦": "ài",
    "璧": "bì",
    "璨": "càn",
    "璩": "qú",
    "璪": "zǎo",
    "璫": "dāng",
    "璬": "jiǎo",
    "璭": "guǎn",
    "璮": "tǎn",
    "璯": "huì,kuài",
    "環": "huán",
    "璱": "sè",
    "璲": "suì",
    "璳": "tián",
    "璴": "chǔ",
    "璵": "yú",
    "璶": "jìn",
    "璷": "lú,fū",
    "璸": "bīn,pián",
    "璹": "shú",
    "璺": "wèn",
    "璻": "zuǐ",
    "璼": "lán",
    "璽": "xǐ",
    "璾": "jì,zī",
    "璿": "xuán",
    "瓀": "ruǎn",
    "瓁": "wò",
    "瓂": "gài",
    "瓃": "léi",
    "瓄": "dú",
    "瓅": "lì",
    "瓆": "zhì",
    "瓇": "róu",
    "瓈": "lí",
    "瓉": "zàn",
    "瓊": "qióng",
    "瓋": "tì",
    "瓌": "guī",
    "瓍": "suí",
    "瓎": "là",
    "瓏": "lóng",
    "瓐": "lú",
    "瓑": "lì",
    "瓒": "zàn",
    "瓓": "làn",
    "瓔": "yīng",
    "瓕": "mí,xǐ",
    "瓖": "xiāng",
    "瓗": "qióng,wěi,wèi",
    "瓘": "guàn",
    "瓙": "dào",
    "瓚": "zàn",
    "瓛": "huán,yè,yà",
    "瓜": "guā",
    "瓝": "bó",
    "瓞": "dié",
    "瓟": "bó,páo",
    "瓠": "hù",
    "瓡": "zhí,hú",
    "瓢": "piáo",
    "瓣": "bàn",
    "瓤": "ráng",
    "瓥": "lì",
    "瓦": "wǎ,wà",
    "瓧": "null",
    "瓨": "xiáng,hóng",
    "瓩": "null",
    "瓪": "bǎn",
    "瓫": "pén",
    "瓬": "fǎng",
    "瓭": "dǎn",
    "瓮": "wèng",
    "瓯": "ōu",
    "瓰": "null",
    "瓱": "null",
    "瓲": "null",
    "瓳": "hú",
    "瓴": "líng",
    "瓵": "yí",
    "瓶": "píng",
    "瓷": "cí",
    "瓸": "bǎi,wǎ",
    "瓹": "juàn,juān",
    "瓺": "cháng",
    "瓻": "chī",
    "瓼": "null",
    "瓽": "dàng",
    "瓾": "wā",
    "瓿": "bù",
    "甀": "zhuì",
    "甁": "píng",
    "甂": "biān",
    "甃": "zhòu",
    "甄": "zhēn",
    "甅": "null",
    "甆": "cí",
    "甇": "yīng",
    "甈": "qì",
    "甉": "xián",
    "甊": "lǒu",
    "甋": "dì",
    "甌": "ōu",
    "甍": "méng",
    "甎": "zhuān",
    "甏": "bèng",
    "甐": "lìn",
    "甑": "zèng",
    "甒": "wǔ",
    "甓": "pì",
    "甔": "dān",
    "甕": "wèng",
    "甖": "yīng",
    "甗": "yǎn",
    "甘": "gān",
    "甙": "dài",
    "甚": "shèn,shén",
    "甛": "tián",
    "甜": "tián",
    "甝": "hán",
    "甞": "cháng",
    "生": "shēng",
    "甠": "qíng",
    "甡": "shēn",
    "產": "chǎn",
    "産": "chǎn",
    "甤": "ruí",
    "甥": "shēng",
    "甦": "sū",
    "甧": "shēn",
    "用": "yòng",
    "甩": "shuǎi",
    "甪": "lù",
    "甫": "fǔ",
    "甬": "yǒng",
    "甭": "béng",
    "甮": "béng",
    "甯": "níng,nìng",
    "田": "tián",
    "由": "yóu",
    "甲": "jiǎ",
    "申": "shēn",
    "甴": "yóu,zhá",
    "电": "diàn",
    "甶": "fú",
    "男": "nán",
    "甸": "diàn,tián,shèng",
    "甹": "pīng",
    "町": "tǐng,dīng",
    "画": "huà",
    "甼": "tǐng,dīng",
    "甽": "zhèn",
    "甾": "zāi,zī",
    "甿": "méng",
    "畀": "bì",
    "畁": "bì,qí",
    "畂": "mǔ",
    "畃": "xún",
    "畄": "liú",
    "畅": "chàng",
    "畆": "mǔ",
    "畇": "yún",
    "畈": "fàn",
    "畉": "fú",
    "畊": "gēng",
    "畋": "tián",
    "界": "jiè",
    "畍": "jiè",
    "畎": "quǎn",
    "畏": "wèi",
    "畐": "fú,bì",
    "畑": "tián",
    "畒": "mǔ",
    "畓": "duō",
    "畔": "pàn",
    "畕": "jiāng",
    "畖": "wā",
    "畗": "dá,fú",
    "畘": "nán",
    "留": "liú",
    "畚": "běn",
    "畛": "zhěn",
    "畜": "chù,xù",
    "畝": "mǔ",
    "畞": "mǔ",
    "畟": "cè,jì",
    "畠": "zāi,zī",
    "畡": "gāi",
    "畢": "bì",
    "畣": "dá",
    "畤": "zhì,chóu,shì",
    "略": "lüè",
    "畦": "qí",
    "畧": "lüè",
    "畨": "fān,pān",
    "畩": "yī",
    "番": "fān,pān",
    "畫": "huà",
    "畬": "shē,yú",
    "畭": "shē",
    "畮": "mǔ",
    "畯": "jùn",
    "異": "yì",
    "畱": "liú",
    "畲": "shē",
    "畳": "dié",
    "畴": "chóu",
    "畵": "huà",
    "當": "dāng,dàng,dǎng",
    "畷": "zhuì",
    "畸": "jī",
    "畹": "wǎn",
    "畺": "jiāng,jiàng",
    "畻": "chéng",
    "畼": "chàng",
    "畽": "tuǎn",
    "畾": "léi",
    "畿": "jī",
    "疀": "chā",
    "疁": "liú",
    "疂": "dié",
    "疃": "tuǎn",
    "疄": "lín,lìn",
    "疅": "jiāng",
    "疆": "jiāng,qiáng",
    "疇": "chóu",
    "疈": "pì",
    "疉": "dié",
    "疊": "dié",
    "疋": "pǐ,yǎ,shū",
    "疌": "jié,qiè",
    "疍": "dàn",
    "疎": "shū",
    "疏": "shū",
    "疐": "zhì,dì",
    "疑": "yí,nǐ",
    "疒": "nè",
    "疓": "nǎi",
    "疔": "dīng",
    "疕": "bǐ",
    "疖": "jiē",
    "疗": "liáo",
    "疘": "gāng",
    "疙": "gē,yì",
    "疚": "jiù",
    "疛": "zhǒu",
    "疜": "xià",
    "疝": "shàn",
    "疞": "xū",
    "疟": "nüè,yào",
    "疠": "lì,lài",
    "疡": "yáng",
    "疢": "chèn",
    "疣": "yóu",
    "疤": "bā",
    "疥": "jiè",
    "疦": "jué,xuè",
    "疧": "qí",
    "疨": "yǎ,xiā",
    "疩": "cuì",
    "疪": "bì",
    "疫": "yì",
    "疬": "lì",
    "疭": "zòng",
    "疮": "chuāng",
    "疯": "fēng",
    "疰": "zhù",
    "疱": "pào",
    "疲": "pí",
    "疳": "gān",
    "疴": "kē",
    "疵": "cī",
    "疶": "xuē",
    "疷": "zhī",
    "疸": "dǎn",
    "疹": "zhěn",
    "疺": "fá,biǎn",
    "疻": "zhǐ",
    "疼": "téng",
    "疽": "jū",
    "疾": "jí",
    "疿": "fèi,féi",
    "痀": "gōu",
    "痁": "shān,diàn",
    "痂": "jiā",
    "痃": "xuán",
    "痄": "zhà",
    "病": "bìng",
    "痆": "niè",
    "症": "zhèng,zhēng",
    "痈": "yōng",
    "痉": "jìng",
    "痊": "quán",
    "痋": "téng,chóng",
    "痌": "tōng,tóng",
    "痍": "yí",
    "痎": "jiē",
    "痏": "wěi,yòu,yù",
    "痐": "huí",
    "痑": "tān,shǐ",
    "痒": "yǎng",
    "痓": "zhì",
    "痔": "zhì",
    "痕": "hén",
    "痖": "yǎ",
    "痗": "mèi",
    "痘": "dòu",
    "痙": "jìng",
    "痚": "xiāo",
    "痛": "tòng",
    "痜": "tū",
    "痝": "máng",
    "痞": "pǐ",
    "痟": "xiāo",
    "痠": "suān",
    "痡": "pū,pù",
    "痢": "lì",
    "痣": "zhì",
    "痤": "cuó",
    "痥": "duó",
    "痦": "wù",
    "痧": "shā",
    "痨": "láo",
    "痩": "shòu",
    "痪": "huàn",
    "痫": "xián",
    "痬": "yì",
    "痭": "bēng,péng",
    "痮": "zhàng",
    "痯": "guǎn",
    "痰": "tán",
    "痱": "fèi,féi",
    "痲": "má",
    "痳": "má,lìn",
    "痴": "chī",
    "痵": "jì",
    "痶": "tiǎn,diàn",
    "痷": "ān,yè,è",
    "痸": "chì",
    "痹": "bì",
    "痺": "bì",
    "痻": "mín",
    "痼": "gù",
    "痽": "duī",
    "痾": "kē,ē",
    "痿": "wěi",
    "瘀": "yū",
    "瘁": "cuì",
    "瘂": "yǎ",
    "瘃": "zhú",
    "瘄": "cù",
    "瘅": "dàn,dān",
    "瘆": "shèn",
    "瘇": "zhǒng",
    "瘈": "zhì,chì",
    "瘉": "yù",
    "瘊": "hóu",
    "瘋": "fēng",
    "瘌": "là",
    "瘍": "yáng",
    "瘎": "chén",
    "瘏": "tú",
    "瘐": "yǔ",
    "瘑": "guō",
    "瘒": "wén",
    "瘓": "huàn",
    "瘔": "kù",
    "瘕": "jiǎ,xiá,xiā",
    "瘖": "yīn",
    "瘗": "yì",
    "瘘": "lòu",
    "瘙": "sào",
    "瘚": "jué",
    "瘛": "chì",
    "瘜": "xī",
    "瘝": "guān",
    "瘞": "yì",
    "瘟": "wēn",
    "瘠": "jí",
    "瘡": "chuāng",
    "瘢": "bān",
    "瘣": "huì,lěi",
    "瘤": "liú",
    "瘥": "chài,cuó",
    "瘦": "shòu",
    "瘧": "nüè,yào",
    "瘨": "diān,chēn",
    "瘩": "dá,da",
    "瘪": "biē,biě",
    "瘫": "tān",
    "瘬": "zhàng",
    "瘭": "biāo",
    "瘮": "shèn",
    "瘯": "cù",
    "瘰": "luǒ",
    "瘱": "yì",
    "瘲": "zòng",
    "瘳": "chōu",
    "瘴": "zhàng",
    "瘵": "zhài",
    "瘶": "sòu",
    "瘷": "sè",
    "瘸": "qué",
    "瘹": "diào",
    "瘺": "lòu",
    "瘻": "lòu",
    "瘼": "mò",
    "瘽": "qín",
    "瘾": "yǐn",
    "瘿": "yǐng",
    "癀": "huáng",
    "癁": "fú",
    "療": "liáo",
    "癃": "lóng",
    "癄": "qiáo,jiào",
    "癅": "liú",
    "癆": "láo",
    "癇": "xián",
    "癈": "fèi",
    "癉": "dàn,dān",
    "癊": "yìn",
    "癋": "hè",
    "癌": "ái",
    "癍": "bān",
    "癎": "xián",
    "癏": "guān",
    "癐": "guì,wēi",
    "癑": "nòng,nóng",
    "癒": "yù",
    "癓": "wēi",
    "癔": "yì",
    "癕": "yōng",
    "癖": "pǐ",
    "癗": "lěi",
    "癘": "lì,lài",
    "癙": "shǔ",
    "癚": "dàn",
    "癛": "lǐn",
    "癜": "diàn",
    "癝": "lǐn",
    "癞": "lài",
    "癟": "biē,biě",
    "癠": "jì",
    "癡": "chī",
    "癢": "yǎng",
    "癣": "xuǎn",
    "癤": "jiē",
    "癥": "zhēng",
    "癦": "mèng",
    "癧": "lì",
    "癨": "huò",
    "癩": "lài",
    "癪": "jī",
    "癫": "diān",
    "癬": "xuǎn",
    "癭": "yǐng",
    "癮": "yǐn",
    "癯": "qú",
    "癰": "yōng",
    "癱": "tān",
    "癲": "diān",
    "癳": "luǒ",
    "癴": "luán",
    "癵": "luán",
    "癶": "bō",
    "癷": "bō,bǒ",
    "癸": "guǐ",
    "癹": "bá",
    "発": "fā",
    "登": "dēng",
    "發": "fā",
    "白": "bái",
    "百": "bǎi",
    "癿": "qié",
    "皀": "jí,bī",
    "皁": "zào",
    "皂": "zào",
    "皃": "mào",
    "的": "de,dí,dì",
    "皅": "pā,bà",
    "皆": "jiē",
    "皇": "huáng",
    "皈": "guī",
    "皉": "cǐ",
    "皊": "líng",
    "皋": "gāo,háo",
    "皌": "mò",
    "皍": "jí",
    "皎": "jiǎo",
    "皏": "pěng",
    "皐": "gāo,yáo",
    "皑": "ái",
    "皒": "é",
    "皓": "hào",
    "皔": "hàn",
    "皕": "bì",
    "皖": "wǎn",
    "皗": "chóu",
    "皘": "qiàn",
    "皙": "xī",
    "皚": "ái",
    "皛": "xiǎo",
    "皜": "hào",
    "皝": "huàng",
    "皞": "hào",
    "皟": "zé",
    "皠": "cuǐ",
    "皡": "hào",
    "皢": "xiǎo",
    "皣": "yè",
    "皤": "pó",
    "皥": "hào",
    "皦": "jiǎo",
    "皧": "ài",
    "皨": "xīng",
    "皩": "huàng",
    "皪": "lì,luò,bō",
    "皫": "piǎo",
    "皬": "hé",
    "皭": "jiào",
    "皮": "pí",
    "皯": "gǎn",
    "皰": "pào",
    "皱": "zhòu",
    "皲": "jūn",
    "皳": "qiú",
    "皴": "cūn",
    "皵": "què",
    "皶": "zhā",
    "皷": "gǔ",
    "皸": "jūn",
    "皹": "jūn",
    "皺": "zhòu",
    "皻": "zhā,cǔ",
    "皼": "gǔ",
    "皽": "zhāo,zhǎn,dǎn",
    "皾": "dú",
    "皿": "mǐn",
    "盀": "qǐ",
    "盁": "yíng",
    "盂": "yú",
    "盃": "bēi",
    "盄": "diào",
    "盅": "zhōng",
    "盆": "pén",
    "盇": "hé",
    "盈": "yíng",
    "盉": "hé",
    "益": "yì",
    "盋": "bō",
    "盌": "wǎn",
    "盍": "hé",
    "盎": "àng",
    "盏": "zhǎn",
    "盐": "yán",
    "监": "jiān,jiàn",
    "盒": "hé",
    "盓": "yū",
    "盔": "kuī",
    "盕": "fàn",
    "盖": "gài,gě,hé",
    "盗": "dào",
    "盘": "pán",
    "盙": "fǔ",
    "盚": "qiú",
    "盛": "shèng,chéng",
    "盜": "dào",
    "盝": "lù",
    "盞": "zhǎn",
    "盟": "méng",
    "盠": "lí",
    "盡": "jìn",
    "盢": "xù",
    "監": "jiān,jiàn",
    "盤": "pán",
    "盥": "guàn",
    "盦": "ān",
    "盧": "lú",
    "盨": "xǔ",
    "盩": "zhōu,chóu",
    "盪": "dàng",
    "盫": "ān",
    "盬": "gǔ",
    "盭": "lì",
    "目": "mù",
    "盯": "dīng",
    "盰": "gàn",
    "盱": "xū",
    "盲": "máng",
    "盳": "máng,wàng",
    "直": "zhí",
    "盵": "qì",
    "盶": "yuǎn",
    "盷": "xián,tián",
    "相": "xiāng,xiàng",
    "盹": "dǔn",
    "盺": "xīn",
    "盻": "xì,pǎn",
    "盼": "pàn",
    "盽": "fēng",
    "盾": "dùn",
    "盿": "mín",
    "眀": "míng",
    "省": "shěng,xǐng",
    "眂": "shì",
    "眃": "yún,hùn",
    "眄": "miǎn",
    "眅": "pān",
    "眆": "fǎng",
    "眇": "miǎo",
    "眈": "dān",
    "眉": "méi",
    "眊": "mào",
    "看": "kàn,kān",
    "県": "xiàn",
    "眍": "kōu",
    "眎": "shì",
    "眏": "yāng,yǎng,yìng",
    "眐": "zhēng",
    "眑": "yǎo,āo,ǎo",
    "眒": "shēn",
    "眓": "huò",
    "眔": "dà",
    "眕": "zhěn",
    "眖": "kuàng",
    "眗": "jū,xū,kōu",
    "眘": "shèn",
    "眙": "yí,chì",
    "眚": "shěng",
    "眛": "mèi",
    "眜": "mò,miè",
    "眝": "zhù",
    "眞": "zhēn",
    "真": "zhēn",
    "眠": "mián",
    "眡": "shì",
    "眢": "yuān",
    "眣": "dié,tì",
    "眤": "nì",
    "眥": "zì",
    "眦": "zì",
    "眧": "chǎo",
    "眨": "zhǎ",
    "眩": "xuàn",
    "眪": "bǐng,fǎng",
    "眫": "pàng,pán",
    "眬": "lóng",
    "眭": "guì,suī",
    "眮": "tóng",
    "眯": "mī,mí",
    "眰": "dié,zhì",
    "眱": "dì",
    "眲": "nè",
    "眳": "míng",
    "眴": "xuàn,shùn,xún",
    "眵": "chī",
    "眶": "kuàng",
    "眷": "juàn",
    "眸": "móu",
    "眹": "zhèn",
    "眺": "tiào",
    "眻": "yáng",
    "眼": "yǎn",
    "眽": "mò",
    "眾": "zhòng",
    "眿": "mò",
    "着": "zhuó,zháo,zhāo,zhe",
    "睁": "zhēng",
    "睂": "méi",
    "睃": "suō",
    "睄": "qiáo,shào,xiāo",
    "睅": "hàn",
    "睆": "huǎn",
    "睇": "dì",
    "睈": "chěng",
    "睉": "cuó,zhuài",
    "睊": "juàn",
    "睋": "é",
    "睌": "miǎn",
    "睍": "xiàn",
    "睎": "xī",
    "睏": "kùn",
    "睐": "lài",
    "睑": "jiǎn",
    "睒": "shǎn",
    "睓": "tiǎn",
    "睔": "gùn",
    "睕": "wān",
    "睖": "lèng",
    "睗": "shì",
    "睘": "qióng",
    "睙": "lì",
    "睚": "yá",
    "睛": "jīng",
    "睜": "zhēng",
    "睝": "lí",
    "睞": "lài",
    "睟": "suì,zuì",
    "睠": "juàn",
    "睡": "shuì",
    "睢": "huī,suī",
    "督": "dū",
    "睤": "bì",
    "睥": "bì,pì",
    "睦": "mù",
    "睧": "hūn",
    "睨": "nì",
    "睩": "lù",
    "睪": "yì,zé,gāo",
    "睫": "jié",
    "睬": "cǎi",
    "睭": "zhǒu",
    "睮": "yú",
    "睯": "hūn",
    "睰": "mà",
    "睱": "xià",
    "睲": "xǐng,xìng",
    "睳": "huī",
    "睴": "hùn",
    "睵": "zāi",
    "睶": "chǔn",
    "睷": "jiān",
    "睸": "mèi",
    "睹": "dǔ",
    "睺": "hóu",
    "睻": "xuān",
    "睼": "tí",
    "睽": "kuí",
    "睾": "gāo",
    "睿": "ruì",
    "瞀": "mào",
    "瞁": "xù",
    "瞂": "fá",
    "瞃": "wò",
    "瞄": "miáo",
    "瞅": "chǒu",
    "瞆": "guì,wèi,kuì",
    "瞇": "mī,mí",
    "瞈": "wěng",
    "瞉": "kòu,jì",
    "瞊": "dàng",
    "瞋": "chēn",
    "瞌": "kē",
    "瞍": "sǒu",
    "瞎": "xiā",
    "瞏": "qióng,huán",
    "瞐": "mò",
    "瞑": "míng",
    "瞒": "mán,mén",
    "瞓": "fèn",
    "瞔": "zé",
    "瞕": "zhàng",
    "瞖": "yì",
    "瞗": "diāo,dōu",
    "瞘": "kōu",
    "瞙": "mò",
    "瞚": "shùn",
    "瞛": "cōng",
    "瞜": "lóu,lǘ,lou",
    "瞝": "chī",
    "瞞": "mán,mén",
    "瞟": "piǎo",
    "瞠": "chēng",
    "瞡": "guī",
    "瞢": "méng,měng",
    "瞣": "wàn",
    "瞤": "rún,shùn",
    "瞥": "piē",
    "瞦": "xī",
    "瞧": "qiáo",
    "瞨": "pú",
    "瞩": "zhǔ",
    "瞪": "dèng",
    "瞫": "shěn",
    "瞬": "shùn",
    "瞭": "liǎo,liào",
    "瞮": "chè",
    "瞯": "xián,jiàn",
    "瞰": "kàn",
    "瞱": "yè",
    "瞲": "xuè",
    "瞳": "tóng",
    "瞴": "wǔ,mí",
    "瞵": "lín",
    "瞶": "guì,kuì",
    "瞷": "jiàn",
    "瞸": "yè",
    "瞹": "ài",
    "瞺": "huì",
    "瞻": "zhān",
    "瞼": "jiǎn",
    "瞽": "gǔ",
    "瞾": "zhào",
    "瞿": "qú,jù",
    "矀": "wéi",
    "矁": "chǒu",
    "矂": "sào",
    "矃": "nǐng,chēng",
    "矄": "xūn",
    "矅": "yào",
    "矆": "huò,yuè",
    "矇": "mēng",
    "矈": "mián",
    "矉": "pín",
    "矊": "mián",
    "矋": "lěi",
    "矌": "kuàng,guō",
    "矍": "jué",
    "矎": "xuān",
    "矏": "mián",
    "矐": "huò",
    "矑": "lú",
    "矒": "méng,měng",
    "矓": "lóng",
    "矔": "guàn,quán",
    "矕": "mǎn,mán",
    "矖": "xǐ",
    "矗": "chù",
    "矘": "tǎng",
    "矙": "kàn",
    "矚": "zhǔ",
    "矛": "máo",
    "矜": "jīn,qín,guān",
    "矝": "jīn,qín,guān",
    "矞": "yù,xù,jué",
    "矟": "shuò",
    "矠": "zé",
    "矡": "jué",
    "矢": "shǐ",
    "矣": "yǐ",
    "矤": "shěn",
    "知": "zhī,zhì",
    "矦": "hóu,hòu",
    "矧": "shěn",
    "矨": "yǐng",
    "矩": "jǔ",
    "矪": "zhōu",
    "矫": "jiǎo,jiáo",
    "矬": "cuó",
    "短": "duǎn",
    "矮": "ǎi",
    "矯": "jiǎo,jiáo",
    "矰": "zēng",
    "矱": "yuē",
    "矲": "bà",
    "石": "shí,dàn",
    "矴": "dìng",
    "矵": "qì",
    "矶": "jī",
    "矷": "zǐ",
    "矸": "gān",
    "矹": "wù",
    "矺": "zhé",
    "矻": "kū",
    "矼": "gāng,qiāng,kòng",
    "矽": "xī",
    "矾": "fán",
    "矿": "kuàng",
    "砀": "dàng",
    "码": "mǎ",
    "砂": "shā",
    "砃": "dān",
    "砄": "jué",
    "砅": "lì",
    "砆": "fū",
    "砇": "mín",
    "砈": "è",
    "砉": "xū,huā",
    "砊": "kāng",
    "砋": "zhǐ",
    "砌": "qì,qiè",
    "砍": "kǎn",
    "砎": "jiè",
    "砏": "pīn,bīn,fēn",
    "砐": "è",
    "砑": "yà",
    "砒": "pī",
    "砓": "zhé",
    "研": "yán,yàn",
    "砕": "suì",
    "砖": "zhuān",
    "砗": "chē",
    "砘": "dùn",
    "砙": "wǎ",
    "砚": "yàn",
    "砛": "jīn",
    "砜": "fēng",
    "砝": "fǎ",
    "砞": "mò",
    "砟": "zhǎ",
    "砠": "jū",
    "砡": "yù",
    "砢": "kē,luǒ",
    "砣": "tuó",
    "砤": "tuó",
    "砥": "dǐ",
    "砦": "zhài",
    "砧": "zhēn",
    "砨": "ě",
    "砩": "fú,fèi",
    "砪": "mǔ",
    "砫": "zhù,zhǔ",
    "砬": "lì,lā,lá",
    "砭": "biān",
    "砮": "nǔ",
    "砯": "pīng",
    "砰": "pēng",
    "砱": "líng",
    "砲": "pào",
    "砳": "lè",
    "破": "pò",
    "砵": "bō",
    "砶": "pò",
    "砷": "shēn",
    "砸": "zá",
    "砹": "ài",
    "砺": "lì",
    "砻": "lóng",
    "砼": "tóng",
    "砽": "yòng",
    "砾": "lì",
    "砿": "kuàng",
    "础": "chǔ",
    "硁": "kēng",
    "硂": "quán",
    "硃": "zhū",
    "硄": "kuāng,guāng",
    "硅": "guī",
    "硆": "è",
    "硇": "náo",
    "硈": "qià",
    "硉": "lù",
    "硊": "wěi,guì",
    "硋": "ài",
    "硌": "luò,gè",
    "硍": "kèn,xiàn,gǔn,yǐn",
    "硎": "xíng",
    "硏": "yán,yàn",
    "硐": "dòng",
    "硑": "pēng,píng",
    "硒": "xī",
    "硓": "lǎo",
    "硔": "hóng",
    "硕": "shuò,shí",
    "硖": "xiá",
    "硗": "qiāo",
    "硘": "qíng",
    "硙": "wéi,wèi",
    "硚": "qiáo",
    "硛": "null",
    "硜": "kēng",
    "硝": "xiāo",
    "硞": "què,kè,kù",
    "硟": "chàn",
    "硠": "láng",
    "硡": "hōng",
    "硢": "yù",
    "硣": "xiāo",
    "硤": "xiá",
    "硥": "mǎng,bàng",
    "硦": "luò,lòng",
    "硧": "yǒng,tóng",
    "硨": "chē",
    "硩": "chè",
    "硪": "wò",
    "硫": "liú",
    "硬": "yìng",
    "硭": "máng",
    "确": "què",
    "硯": "yàn",
    "硰": "shā",
    "硱": "kǔn",
    "硲": "yù",
    "硳": "null",
    "硴": "huā",
    "硵": "lǔ",
    "硶": "chěn",
    "硷": "jiǎn",
    "硸": "nüè",
    "硹": "sōng",
    "硺": "zhuó",
    "硻": "kēng,kěng",
    "硼": "péng",
    "硽": "yān,yǎn",
    "硾": "zhuì,chuí,duǒ",
    "硿": "kōng",
    "碀": "chēng",
    "碁": "qí",
    "碂": "zòng,cóng",
    "碃": "qìng",
    "碄": "lín",
    "碅": "jūn",
    "碆": "bō",
    "碇": "dìng",
    "碈": "mín",
    "碉": "diāo",
    "碊": "jiān,zhàn",
    "碋": "hè",
    "碌": "lù,liù",
    "碍": "ài",
    "碎": "suì",
    "碏": "què,xī",
    "碐": "léng",
    "碑": "bēi",
    "碒": "yín",
    "碓": "duì",
    "碔": "wǔ",
    "碕": "qí",
    "碖": "lún,lǔn,lùn",
    "碗": "wǎn",
    "碘": "diǎn",
    "碙": "náo,gāng",
    "碚": "bèi",
    "碛": "qì",
    "碜": "chěn",
    "碝": "ruǎn",
    "碞": "yán",
    "碟": "dié",
    "碠": "dìng",
    "碡": "zhóu",
    "碢": "tuó",
    "碣": "jié,yà",
    "碤": "yīng",
    "碥": "biǎn",
    "碦": "kè",
    "碧": "bì",
    "碨": "wěi,wèi",
    "碩": "shuò,shí",
    "碪": "zhēn",
    "碫": "duàn",
    "碬": "xiá",
    "碭": "dàng",
    "碮": "tí,dī",
    "碯": "nǎo",
    "碰": "pèng",
    "碱": "jiǎn",
    "碲": "dì",
    "碳": "tàn",
    "碴": "chá,chā",
    "碵": "tián",
    "碶": "qì",
    "碷": "dùn",
    "碸": "fēng",
    "碹": "xuàn",
    "確": "què",
    "碻": "què,qiāo",
    "碼": "mǎ",
    "碽": "gōng",
    "碾": "niǎn",
    "碿": "sù,xiè",
    "磀": "é",
    "磁": "cí",
    "磂": "liú,liù",
    "磃": "sī,tí",
    "磄": "táng",
    "磅": "bàng,páng",
    "磆": "huá,kě,gū",
    "磇": "pī",
    "磈": "kuǐ,wěi",
    "磉": "sǎng",
    "磊": "lěi",
    "磋": "cuō",
    "磌": "tián",
    "磍": "xiá,qià,yà",
    "磎": "xī",
    "磏": "lián,qiān",
    "磐": "pán",
    "磑": "ái,wèi",
    "磒": "yǔn",
    "磓": "duī",
    "磔": "zhé",
    "磕": "kē",
    "磖": "lá,lā",
    "磗": "zhuān",
    "磘": "yáo",
    "磙": "gǔn",
    "磚": "zhuān",
    "磛": "chán",
    "磜": "qì",
    "磝": "áo,qiāo",
    "磞": "pēng,pèng",
    "磟": "liù",
    "磠": "lǔ",
    "磡": "kàn",
    "磢": "chuǎng",
    "磣": "chěn",
    "磤": "yīn,yǐn",
    "磥": "lěi,léi",
    "磦": "biāo",
    "磧": "qì",
    "磨": "mó,mò",
    "磩": "qì,zhú",
    "磪": "cuī",
    "磫": "zōng",
    "磬": "qìng",
    "磭": "chuò",
    "磮": "lún",
    "磯": "jī",
    "磰": "shàn",
    "磱": "láo,luò",
    "磲": "qú",
    "磳": "zēng",
    "磴": "dèng",
    "磵": "jiàn",
    "磶": "xì",
    "磷": "lín",
    "磸": "dìng",
    "磹": "diàn",
    "磺": "huáng",
    "磻": "pán,bō",
    "磼": "jí,shé",
    "磽": "qiāo",
    "磾": "dī",
    "磿": "lì",
    "礀": "jiàn",
    "礁": "jiāo",
    "礂": "xī",
    "礃": "zhǎng",
    "礄": "qiáo",
    "礅": "dūn",
    "礆": "jiǎn",
    "礇": "yù",
    "礈": "zhuì",
    "礉": "hé,qiāo,qiào",
    "礊": "kè,huò",
    "礋": "zé",
    "礌": "léi,lěi",
    "礍": "jié",
    "礎": "chǔ",
    "礏": "yè",
    "礐": "què,hú",
    "礑": "dàng",
    "礒": "yǐ",
    "礓": "jiāng",
    "礔": "pī",
    "礕": "pī",
    "礖": "yù",
    "礗": "pīn",
    "礘": "è,qì",
    "礙": "ài",
    "礚": "kē",
    "礛": "jiān",
    "礜": "yù",
    "礝": "ruǎn",
    "礞": "méng",
    "礟": "pào",
    "礠": "cí",
    "礡": "bō",
    "礢": "yǎng",
    "礣": "miè",
    "礤": "cǎ",
    "礥": "xián,xín",
    "礦": "kuàng",
    "礧": "léi,lěi,lèi",
    "礨": "lěi",
    "礩": "zhì",
    "礪": "lì",
    "礫": "lì",
    "礬": "fán",
    "礭": "què",
    "礮": "pào",
    "礯": "yīng",
    "礰": "lì",
    "礱": "lóng",
    "礲": "lóng",
    "礳": "mò",
    "礴": "bó",
    "礵": "shuāng",
    "礶": "guàn",
    "礷": "jiān",
    "礸": "cǎ",
    "礹": "yán,yǎn",
    "示": "shì",
    "礻": "shì",
    "礼": "lǐ",
    "礽": "réng",
    "社": "shè",
    "礿": "yuè",
    "祀": "sì",
    "祁": "qí",
    "祂": "tā",
    "祃": "mà",
    "祄": "xiè",
    "祅": "yāo",
    "祆": "xiān",
    "祇": "zhǐ,qí",
    "祈": "qí",
    "祉": "zhǐ",
    "祊": "bēng,fāng",
    "祋": "duì",
    "祌": "zhòng",
    "祍": "rèn",
    "祎": "yī",
    "祏": "shí",
    "祐": "yòu",
    "祑": "zhì",
    "祒": "tiáo",
    "祓": "fú",
    "祔": "fù",
    "祕": "mì,bì",
    "祖": "zǔ",
    "祗": "zhī",
    "祘": "suàn",
    "祙": "mèi",
    "祚": "zuò",
    "祛": "qū",
    "祜": "hù",
    "祝": "zhù",
    "神": "shén",
    "祟": "suì",
    "祠": "cí",
    "祡": "chái",
    "祢": "mí",
    "祣": "lǚ",
    "祤": "yǔ",
    "祥": "xiáng",
    "祦": "wú",
    "祧": "tiāo",
    "票": "piào,piāo",
    "祩": "zhù",
    "祪": "guǐ",
    "祫": "xiá",
    "祬": "zhī",
    "祭": "jì,zhài",
    "祮": "gào",
    "祯": "zhēn",
    "祰": "gào",
    "祱": "shuì,lèi",
    "祲": "jìn",
    "祳": "shèn",
    "祴": "gāi",
    "祵": "kǔn",
    "祶": "dì",
    "祷": "dǎo",
    "祸": "huò",
    "祹": "táo",
    "祺": "qí",
    "祻": "gù",
    "祼": "guàn",
    "祽": "zuì",
    "祾": "líng",
    "祿": "lù",
    "禀": "bǐng",
    "禁": "jīn,jìn",
    "禂": "dǎo",
    "禃": "zhí",
    "禄": "lù",
    "禅": "chán,shàn",
    "禆": "bì,pí",
    "禇": "chǔ",
    "禈": "huī",
    "禉": "yǒu",
    "禊": "xì",
    "禋": "yīn",
    "禌": "zī",
    "禍": "huò",
    "禎": "zhēn",
    "福": "fú",
    "禐": "yuàn",
    "禑": "xú",
    "禒": "xiǎn",
    "禓": "shāng,yáng",
    "禔": "tí,zhǐ",
    "禕": "yī",
    "禖": "méi",
    "禗": "sī",
    "禘": "dì",
    "禙": "bèi",
    "禚": "zhuó",
    "禛": "zhēn",
    "禜": "yíng",
    "禝": "jì",
    "禞": "gào",
    "禟": "táng",
    "禠": "sī",
    "禡": "mà",
    "禢": "tà",
    "禣": "fù",
    "禤": "xuān",
    "禥": "qí",
    "禦": "yù",
    "禧": "xǐ",
    "禨": "jī,jì",
    "禩": "sì",
    "禪": "shàn,chán",
    "禫": "dàn",
    "禬": "guì",
    "禭": "suì",
    "禮": "lǐ",
    "禯": "nóng",
    "禰": "mí",
    "禱": "dǎo",
    "禲": "lì",
    "禳": "ráng",
    "禴": "yuè",
    "禵": "tí",
    "禶": "zàn",
    "禷": "lèi",
    "禸": "róu",
    "禹": "yǔ",
    "禺": "yú,yù,ǒu",
    "离": "lí",
    "禼": "xiè",
    "禽": "qín",
    "禾": "hé",
    "禿": "tū",
    "秀": "xiù",
    "私": "sī",
    "秂": "rén",
    "秃": "tū",
    "秄": "zǐ,zì",
    "秅": "chá,ná",
    "秆": "gǎn",
    "秇": "yì,zhí",
    "秈": "xiān",
    "秉": "bǐng",
    "秊": "nián",
    "秋": "qiū",
    "秌": "qiū",
    "种": "zhǒng,zhòng,chóng",
    "秎": "fèn",
    "秏": "hào,mào",
    "秐": "yún",
    "科": "kē",
    "秒": "miǎo",
    "秓": "zhī",
    "秔": "jīng",
    "秕": "bǐ",
    "秖": "zhǐ",
    "秗": "yù",
    "秘": "mì,bì",
    "秙": "kù,kū",
    "秚": "bàn",
    "秛": "pī",
    "秜": "ní,nì",
    "秝": "lì",
    "秞": "yóu",
    "租": "zū",
    "秠": "pī",
    "秡": "bó",
    "秢": "líng",
    "秣": "mò",
    "秤": "chèng",
    "秥": "nián",
    "秦": "qín",
    "秧": "yāng",
    "秨": "zuó",
    "秩": "zhì",
    "秪": "dī",
    "秫": "shú",
    "秬": "jù",
    "秭": "zǐ",
    "秮": "huó,kuò",
    "积": "jī",
    "称": "chēng,chèn,chèng",
    "秱": "tóng",
    "秲": "shì,zhì",
    "秳": "huó,kuò",
    "秴": "huō",
    "秵": "yīn",
    "秶": "zī",
    "秷": "zhì",
    "秸": "jiē",
    "秹": "rěn",
    "秺": "dù",
    "移": "yí",
    "秼": "zhū",
    "秽": "huì",
    "秾": "nóng",
    "秿": "fù,pū",
    "稀": "xī",
    "稁": "gǎo",
    "稂": "láng",
    "稃": "fū",
    "稄": "xùn,zè",
    "稅": "shuì",
    "稆": "lǚ",
    "稇": "kǔn",
    "稈": "gǎn",
    "稉": "jīng",
    "稊": "tí",
    "程": "chéng",
    "稌": "tú,shǔ",
    "稍": "shāo,shào",
    "税": "shuì",
    "稏": "yà",
    "稐": "lǔn",
    "稑": "lù",
    "稒": "gū",
    "稓": "zuó",
    "稔": "rěn",
    "稕": "zhùn,zhǔn",
    "稖": "bàng",
    "稗": "bài",
    "稘": "jī,qí",
    "稙": "zhī",
    "稚": "zhì",
    "稛": "kǔn",
    "稜": "léng,lēng,líng",
    "稝": "péng",
    "稞": "kē",
    "稟": "bǐng",
    "稠": "chóu",
    "稡": "zuì,zú,sū",
    "稢": "yù",
    "稣": "sū",
    "稤": "lüè",
    "稥": "xiāng",
    "稦": "yī",
    "稧": "xì,qiè",
    "稨": "biǎn",
    "稩": "jì",
    "稪": "fú",
    "稫": "pì,bì",
    "稬": "nuò",
    "稭": "jiē",
    "種": "zhǒng,zhòng",
    "稯": "zōng,zǒng",
    "稰": "xǔ,xū",
    "稱": "chēng,chèn,chèng",
    "稲": "dào",
    "稳": "wěn",
    "稴": "xián,jiān,liàn",
    "稵": "zī,jiū",
    "稶": "yù",
    "稷": "jì",
    "稸": "xù",
    "稹": "zhěn",
    "稺": "zhì",
    "稻": "dào",
    "稼": "jià",
    "稽": "jī,qǐ",
    "稾": "gǎo",
    "稿": "gǎo",
    "穀": "gǔ",
    "穁": "róng",
    "穂": "suì",
    "穃": "ròng",
    "穄": "jì",
    "穅": "kāng",
    "穆": "mù",
    "穇": "cǎn,shān,cēn",
    "穈": "mén,méi",
    "穉": "zhì",
    "穊": "jì",
    "穋": "lù",
    "穌": "sū",
    "積": "jī",
    "穎": "yǐng",
    "穏": "wěn",
    "穐": "qiū",
    "穑": "sè",
    "穒": "null",
    "穓": "yì",
    "穔": "huáng",
    "穕": "qiè",
    "穖": "jǐ,jì",
    "穗": "suì",
    "穘": "xiāo,rào",
    "穙": "pú",
    "穚": "jiāo",
    "穛": "zhuō,bó",
    "穜": "tóng,zhǒng",
    "穝": "zuō",
    "穞": "lǔ",
    "穟": "suì",
    "穠": "nóng",
    "穡": "sè",
    "穢": "huì",
    "穣": "ráng",
    "穤": "nuò",
    "穥": "yǔ",
    "穦": "pīn",
    "穧": "jì",
    "穨": "tuí",
    "穩": "wěn",
    "穪": "chēng,chèn,chèng",
    "穫": "huò",
    "穬": "kuàng",
    "穭": "lǚ",
    "穮": "biāo,pāo",
    "穯": "sè",
    "穰": "ráng",
    "穱": "zhuō,jué",
    "穲": "lí",
    "穳": "cuán,zàn",
    "穴": "xué",
    "穵": "wā",
    "究": "jiū",
    "穷": "qióng",
    "穸": "xī",
    "穹": "qióng",
    "空": "kōng,kòng,kǒng",
    "穻": "yū,yǔ",
    "穼": "shēn",
    "穽": "jǐng",
    "穾": "yào",
    "穿": "chuān",
    "窀": "zhūn",
    "突": "tū",
    "窂": "láo",
    "窃": "qiè",
    "窄": "zhǎi",
    "窅": "yǎo",
    "窆": "biǎn",
    "窇": "báo",
    "窈": "yǎo",
    "窉": "bìng",
    "窊": "wā",
    "窋": "zhú,kū",
    "窌": "jiào,liáo,liù",
    "窍": "qiào",
    "窎": "diào",
    "窏": "wū",
    "窐": "wā,guī",
    "窑": "yáo",
    "窒": "zhì",
    "窓": "chuāng",
    "窔": "yào",
    "窕": "tiǎo,yáo",
    "窖": "jiào",
    "窗": "chuāng",
    "窘": "jiǒng",
    "窙": "xiāo",
    "窚": "chéng",
    "窛": "kòu",
    "窜": "cuàn",
    "窝": "wō",
    "窞": "dàn",
    "窟": "kū",
    "窠": "kē",
    "窡": "zhuó",
    "窢": "huò",
    "窣": "sū",
    "窤": "guān",
    "窥": "kuī",
    "窦": "dòu",
    "窧": "zhuō",
    "窨": "yìn,xūn",
    "窩": "wō",
    "窪": "wā",
    "窫": "yà,yē",
    "窬": "yú",
    "窭": "jù",
    "窮": "qióng",
    "窯": "yáo",
    "窰": "yáo",
    "窱": "tiǎo",
    "窲": "cháo",
    "窳": "yǔ",
    "窴": "tián,diān,yǎn",
    "窵": "diào",
    "窶": "jù",
    "窷": "liào",
    "窸": "xī",
    "窹": "wù",
    "窺": "kuī",
    "窻": "chuāng",
    "窼": "chāo,kē",
    "窽": "kuǎn,cuàn",
    "窾": "kuǎn,cuàn",
    "窿": "lóng",
    "竀": "chēng,chèng",
    "竁": "cuì",
    "竂": "liáo",
    "竃": "zào",
    "竄": "cuàn",
    "竅": "qiào",
    "竆": "qióng",
    "竇": "dòu",
    "竈": "zào",
    "竉": "lǒng",
    "竊": "qiè",
    "立": "lì",
    "竌": "chù",
    "竍": "shí",
    "竎": "fù",
    "竏": "qiān",
    "竐": "chù,qì",
    "竑": "hóng",
    "竒": "qí",
    "竓": "háo",
    "竔": "shēng",
    "竕": "fēn",
    "竖": "shù",
    "竗": "miào",
    "竘": "qǔ,kǒu",
    "站": "zhàn",
    "竚": "zhù",
    "竛": "líng",
    "竜": "lóng",
    "竝": "bìng",
    "竞": "jìng",
    "竟": "jìng",
    "章": "zhāng",
    "竡": "bǎi",
    "竢": "sì",
    "竣": "jùn",
    "竤": "hóng",
    "童": "tóng",
    "竦": "sǒng",
    "竧": "jìng,zhěn",
    "竨": "diào",
    "竩": "yì",
    "竪": "shù",
    "竫": "jìng",
    "竬": "qǔ",
    "竭": "jié",
    "竮": "píng",
    "端": "duān",
    "竰": "lí",
    "竱": "zhuǎn",
    "竲": "céng,zēng",
    "竳": "dēng",
    "竴": "cūn",
    "竵": "wāi",
    "競": "jìng",
    "竷": "kǎn,kàn",
    "竸": "jìng",
    "竹": "zhú",
    "竺": "zhú,dǔ",
    "竻": "lè,jīn",
    "竼": "péng",
    "竽": "yú",
    "竾": "chí",
    "竿": "gān",
    "笀": "máng",
    "笁": "zhú",
    "笂": "wán",
    "笃": "dǔ",
    "笄": "jī",
    "笅": "jiǎo,jiào",
    "笆": "bā",
    "笇": "suàn",
    "笈": "jí",
    "笉": "qǐn",
    "笊": "zhào",
    "笋": "sǔn",
    "笌": "yá",
    "笍": "zhuì,ruì",
    "笎": "yuán",
    "笏": "hù",
    "笐": "háng,hàng",
    "笑": "xiào",
    "笒": "cén,jìn,hán",
    "笓": "pí,bì",
    "笔": "bǐ",
    "笕": "jiǎn",
    "笖": "yǐ",
    "笗": "dōng",
    "笘": "shān",
    "笙": "shēng",
    "笚": "dā,xiá,nà",
    "笛": "dí",
    "笜": "zhú",
    "笝": "nà",
    "笞": "chī",
    "笟": "gū",
    "笠": "lì",
    "笡": "qiè",
    "笢": "mǐn",
    "笣": "bāo",
    "笤": "tiáo",
    "笥": "sì",
    "符": "fú",
    "笧": "cè",
    "笨": "bèn",
    "笩": "fá",
    "笪": "dá",
    "笫": "zǐ",
    "第": "dì",
    "笭": "líng",
    "笮": "zuó,zé",
    "笯": "nú",
    "笰": "fú,fèi",
    "笱": "gǒu",
    "笲": "fán",
    "笳": "jiā",
    "笴": "gě",
    "笵": "fàn",
    "笶": "shǐ",
    "笷": "mǎo",
    "笸": "pǒ",
    "笹": "tì",
    "笺": "jiān",
    "笻": "qióng",
    "笼": "lóng,lǒng",
    "笽": "mǐn",
    "笾": "biān",
    "笿": "luò",
    "筀": "guì",
    "筁": "qū",
    "筂": "chí",
    "筃": "yīn",
    "筄": "yào",
    "筅": "xiǎn",
    "筆": "bǐ",
    "筇": "qióng",
    "筈": "kuò",
    "等": "děng",
    "筊": "jiǎo,jiào",
    "筋": "jīn",
    "筌": "quán",
    "筍": "sǔn",
    "筎": "rú",
    "筏": "fá",
    "筐": "kuāng",
    "筑": "zhù,zhú",
    "筒": "tǒng",
    "筓": "jī",
    "答": "dá,dā",
    "筕": "háng",
    "策": "cè",
    "筗": "zhòng",
    "筘": "kòu",
    "筙": "lái",
    "筚": "bì",
    "筛": "shāi",
    "筜": "dāng",
    "筝": "zhēng",
    "筞": "cè",
    "筟": "fū",
    "筠": "yún,jūn",
    "筡": "tú",
    "筢": "pá",
    "筣": "lí",
    "筤": "láng,làng",
    "筥": "jǔ",
    "筦": "guǎn",
    "筧": "jiǎn",
    "筨": "hán",
    "筩": "tǒng",
    "筪": "xiá",
    "筫": "zhì,zhǐ",
    "筬": "chéng",
    "筭": "suàn",
    "筮": "shì",
    "筯": "zhù",
    "筰": "zuó",
    "筱": "xiǎo",
    "筲": "shāo",
    "筳": "tíng",
    "筴": "cè",
    "筵": "yán",
    "筶": "gào",
    "筷": "kuài",
    "筸": "gān",
    "筹": "chóu",
    "筺": "kuāng",
    "筻": "gàng",
    "筼": "yún",
    "筽": "o",
    "签": "qiān",
    "筿": "xiǎo",
    "简": "jiǎn",
    "箁": "póu,bù,fú,pú",
    "箂": "lái",
    "箃": "zōu",
    "箄": "pái,bēi",
    "箅": "bì",
    "箆": "bì",
    "箇": "gè",
    "箈": "tái,chí",
    "箉": "guǎi,dài",
    "箊": "yū",
    "箋": "jiān",
    "箌": "zhào,dào",
    "箍": "gū",
    "箎": "chí",
    "箏": "zhēng",
    "箐": "qìng,jīng",
    "箑": "shà",
    "箒": "zhǒu",
    "箓": "lù",
    "箔": "bó",
    "箕": "jī",
    "箖": "lín,lǐn",
    "算": "suàn",
    "箘": "jùn,qūn",
    "箙": "fú",
    "箚": "zhá",
    "箛": "gū",
    "箜": "kōng",
    "箝": "qián",
    "箞": "quān",
    "箟": "jùn",
    "箠": "chuí",
    "管": "guǎn",
    "箢": "wǎn,yuān",
    "箣": "cè",
    "箤": "zú",
    "箥": "pǒ",
    "箦": "zé",
    "箧": "qiè",
    "箨": "tuò",
    "箩": "luó",
    "箪": "dān",
    "箫": "xiāo",
    "箬": "ruò",
    "箭": "jiàn",
    "箮": "xuān",
    "箯": "biān",
    "箰": "sǔn",
    "箱": "xiāng",
    "箲": "xiǎn",
    "箳": "píng",
    "箴": "zhēn",
    "箵": "xīng",
    "箶": "hú",
    "箷": "shī,yí",
    "箸": "zhù",
    "箹": "yuē,yào,chuò",
    "箺": "chūn",
    "箻": "lǜ",
    "箼": "wū",
    "箽": "dǒng",
    "箾": "shuò,xiāo,qiào",
    "箿": "jí",
    "節": "jié",
    "篁": "huáng",
    "篂": "xīng",
    "篃": "mèi",
    "範": "fàn",
    "篅": "chuán",
    "篆": "zhuàn",
    "篇": "piān",
    "篈": "fēng",
    "築": "zhù,zhú",
    "篊": "hóng",
    "篋": "qiè",
    "篌": "hóu",
    "篍": "qiū",
    "篎": "miǎo",
    "篏": "qiàn",
    "篐": "gū",
    "篑": "kuì",
    "篒": "yì",
    "篓": "lǒu",
    "篔": "yún",
    "篕": "hé",
    "篖": "táng",
    "篗": "yuè",
    "篘": "chōu",
    "篙": "gāo",
    "篚": "fěi",
    "篛": "ruò",
    "篜": "zhēng",
    "篝": "gōu",
    "篞": "niè",
    "篟": "qiàn",
    "篠": "xiǎo",
    "篡": "cuàn",
    "篢": "gōng,gǎn,lǒng",
    "篣": "péng,páng",
    "篤": "dǔ",
    "篥": "lì",
    "篦": "bì",
    "篧": "zhuó,huò",
    "篨": "chú",
    "篩": "shāi",
    "篪": "chí",
    "篫": "zhù",
    "篬": "qiāng,cāng",
    "篭": "lóng,lǒng",
    "篮": "lán",
    "篯": "jiǎn,jiān",
    "篰": "bù",
    "篱": "lí",
    "篲": "huì",
    "篳": "bì",
    "篴": "zhú,dí",
    "篵": "cōng",
    "篶": "yān",
    "篷": "péng",
    "篸": "cēn,zān,cǎn",
    "篹": "zhuàn,zuàn,suǎn",
    "篺": "pí",
    "篻": "piǎo,biāo",
    "篼": "dōu",
    "篽": "yù",
    "篾": "miè",
    "篿": "tuán,zhuān",
    "簀": "zé",
    "簁": "shāi",
    "簂": "guó,guì",
    "簃": "yí",
    "簄": "hù",
    "簅": "chǎn",
    "簆": "kòu",
    "簇": "cù",
    "簈": "píng",
    "簉": "zào",
    "簊": "jī",
    "簋": "guǐ",
    "簌": "sù",
    "簍": "lǒu",
    "簎": "cè,jí",
    "簏": "lù",
    "簐": "niǎn",
    "簑": "suō",
    "簒": "cuàn",
    "簓": "diāo",
    "簔": "suō",
    "簕": "lè",
    "簖": "duàn",
    "簗": "zhù",
    "簘": "xiāo",
    "簙": "bó",
    "簚": "mì,miè",
    "簛": "shāi",
    "簜": "dàng",
    "簝": "liáo",
    "簞": "dān",
    "簟": "diàn",
    "簠": "fǔ",
    "簡": "jiǎn",
    "簢": "mǐn",
    "簣": "kuì",
    "簤": "dài",
    "簥": "jiāo",
    "簦": "dēng",
    "簧": "huáng",
    "簨": "sǔn,zhuàn",
    "簩": "láo",
    "簪": "zān",
    "簫": "xiāo",
    "簬": "lù",
    "簭": "shì",
    "簮": "zān",
    "簯": "qí",
    "簰": "pái",
    "簱": "qí",
    "簲": "pái",
    "簳": "gǎn,gàn",
    "簴": "jù",
    "簵": "lù",
    "簶": "lù",
    "簷": "yán",
    "簸": "bò,bǒ",
    "簹": "dāng",
    "簺": "sài",
    "簻": "zhuā",
    "簼": "gōu",
    "簽": "qiān",
    "簾": "lián",
    "簿": "bù,bó",
    "籀": "zhòu",
    "籁": "lài",
    "籂": "shi",
    "籃": "lán",
    "籄": "kuì",
    "籅": "yú",
    "籆": "yuè",
    "籇": "háo",
    "籈": "zhēn,jiān",
    "籉": "tái",
    "籊": "tì",
    "籋": "niè",
    "籌": "chóu",
    "籍": "jí",
    "籎": "yí",
    "籏": "qí",
    "籐": "téng",
    "籑": "zhuàn",
    "籒": "zhòu",
    "籓": "fān,pān,biān",
    "籔": "sǒu,shǔ",
    "籕": "zhòu",
    "籖": "qiān",
    "籗": "zhuó",
    "籘": "téng",
    "籙": "lù",
    "籚": "lú",
    "籛": "jiǎn,jiān",
    "籜": "tuò",
    "籝": "yíng",
    "籞": "yù",
    "籟": "lài",
    "籠": "lóng,lǒng",
    "籡": "qiè",
    "籢": "lián",
    "籣": "lán",
    "籤": "qiān",
    "籥": "yuè",
    "籦": "zhōng",
    "籧": "qú",
    "籨": "lián",
    "籩": "biān",
    "籪": "duàn",
    "籫": "zuǎn",
    "籬": "lí",
    "籭": "shāi",
    "籮": "luó",
    "籯": "yíng",
    "籰": "yuè",
    "籱": "zhuó",
    "籲": "yù",
    "米": "mǐ",
    "籴": "dí",
    "籵": "fán",
    "籶": "shēn",
    "籷": "zhé",
    "籸": "shēn",
    "籹": "nǚ",
    "籺": "hé",
    "类": "lèi",
    "籼": "xiān",
    "籽": "zǐ",
    "籾": "ní",
    "籿": "cùn",
    "粀": "zhàng",
    "粁": "qiān",
    "粂": "zhāi",
    "粃": "bǐ",
    "粄": "bǎn",
    "粅": "wù",
    "粆": "shā,chǎo",
    "粇": "kāng,jīng",
    "粈": "róu",
    "粉": "fěn",
    "粊": "bì",
    "粋": "cuì",
    "粌": "yǐn",
    "粍": "zhé",
    "粎": "mǐ",
    "粏": "tà",
    "粐": "hù",
    "粑": "bā",
    "粒": "lì",
    "粓": "gān",
    "粔": "jù",
    "粕": "pò",
    "粖": "yù",
    "粗": "cū",
    "粘": "nián,zhān",
    "粙": "zhòu",
    "粚": "chī",
    "粛": "sù",
    "粜": "tiào",
    "粝": "lì",
    "粞": "xī",
    "粟": "sù",
    "粠": "hóng",
    "粡": "tóng",
    "粢": "zī,cí",
    "粣": "cè,sè",
    "粤": "yuè",
    "粥": "zhōu,yù",
    "粦": "lín",
    "粧": "zhuāng",
    "粨": "bǎi",
    "粩": "lāo",
    "粪": "fèn",
    "粫": "ér",
    "粬": "qū",
    "粭": "hé",
    "粮": "liáng",
    "粯": "xiàn",
    "粰": "fū,fú",
    "粱": "liáng",
    "粲": "càn",
    "粳": "jīng",
    "粴": "lǐ",
    "粵": "yuè",
    "粶": "lù",
    "粷": "jú",
    "粸": "qí",
    "粹": "cuì",
    "粺": "bài",
    "粻": "zhāng",
    "粼": "lín",
    "粽": "zòng",
    "精": "jīng",
    "粿": "guǒ",
    "糀": "huā",
    "糁": "sǎn,shēn",
    "糂": "shēn",
    "糃": "táng",
    "糄": "biān,biǎn",
    "糅": "róu",
    "糆": "miàn",
    "糇": "hóu",
    "糈": "xǔ",
    "糉": "zòng",
    "糊": "hū,hú,hù",
    "糋": "jiàn",
    "糌": "zān",
    "糍": "cí",
    "糎": "lí",
    "糏": "xiè",
    "糐": "fū",
    "糑": "nuò",
    "糒": "bèi",
    "糓": "gǔ,gòu",
    "糔": "xiǔ",
    "糕": "gāo",
    "糖": "táng",
    "糗": "qiǔ",
    "糘": "jiā",
    "糙": "cāo",
    "糚": "zhuāng",
    "糛": "táng",
    "糜": "mí,méi",
    "糝": "sǎn,shēn",
    "糞": "fèn",
    "糟": "zāo",
    "糠": "kāng",
    "糡": "jiàng",
    "糢": "mó",
    "糣": "sǎn,shēn",
    "糤": "sǎn",
    "糥": "nuò",
    "糦": "xī",
    "糧": "liáng",
    "糨": "jiàng",
    "糩": "kuài",
    "糪": "bó",
    "糫": "huán",
    "糬": "shǔ",
    "糭": "zòng",
    "糮": "xiàn",
    "糯": "nuò",
    "糰": "tuán",
    "糱": "niè",
    "糲": "lì",
    "糳": "zuò",
    "糴": "dí",
    "糵": "niè",
    "糶": "tiào",
    "糷": "làn",
    "糸": "mì,sī",
    "糹": "sī",
    "糺": "jiū,jiǔ",
    "系": "xì,jì",
    "糼": "gōng",
    "糽": "zhēng,zhěng",
    "糾": "jiū",
    "糿": "gōng",
    "紀": "jì",
    "紁": "chà,chǎ",
    "紂": "zhòu",
    "紃": "xún",
    "約": "yuē,yāo",
    "紅": "hóng,gōng",
    "紆": "yū",
    "紇": "hé,gē",
    "紈": "wán",
    "紉": "rèn",
    "紊": "wěn",
    "紋": "wén,wèn",
    "紌": "qiú",
    "納": "nà",
    "紎": "zī",
    "紏": "tǒu",
    "紐": "niǔ",
    "紑": "fóu",
    "紒": "jì,jié,jiè",
    "紓": "shū",
    "純": "chún",
    "紕": "pī,pí,bǐ",
    "紖": "zhèn",
    "紗": "shā",
    "紘": "hóng",
    "紙": "zhǐ",
    "級": "jí",
    "紛": "fēn",
    "紜": "yún",
    "紝": "rèn",
    "紞": "dǎn",
    "紟": "jīn,jìn",
    "素": "sù",
    "紡": "fǎng",
    "索": "suǒ",
    "紣": "cuì",
    "紤": "jiǔ",
    "紥": "zhā,zā",
    "紦": "hā",
    "紧": "jǐn",
    "紨": "fū,fù",
    "紩": "zhì",
    "紪": "qī",
    "紫": "zǐ",
    "紬": "chōu,chóu",
    "紭": "hóng",
    "紮": "zhā,zā",
    "累": "léi,lěi,lèi",
    "細": "xì",
    "紱": "fú",
    "紲": "xiè",
    "紳": "shēn",
    "紴": "bō,bì",
    "紵": "zhù",
    "紶": "qū,qǔ",
    "紷": "líng",
    "紸": "zhù",
    "紹": "shào",
    "紺": "gàn",
    "紻": "yǎng",
    "紼": "fú",
    "紽": "tuó",
    "紾": "zhěn,tiǎn",
    "紿": "dài",
    "絀": "chù",
    "絁": "shī",
    "終": "zhōng",
    "絃": "xián",
    "組": "zǔ",
    "絅": "jiōng,jiǒng",
    "絆": "bàn",
    "絇": "qú",
    "絈": "mò",
    "絉": "shù",
    "絊": "zuì",
    "絋": "kuàng",
    "経": "jīng",
    "絍": "rèn",
    "絎": "háng",
    "絏": "xiè",
    "結": "jié,jiē",
    "絑": "zhū",
    "絒": "chóu",
    "絓": "guà,kuā",
    "絔": "bǎi,mò",
    "絕": "jué",
    "絖": "kuàng",
    "絗": "hú",
    "絘": "cì",
    "絙": "huán,gēng",
    "絚": "gēng",
    "絛": "tāo",
    "絜": "xié,jié",
    "絝": "kù",
    "絞": "jiǎo",
    "絟": "quán,shuān",
    "絠": "gǎi,ǎi",
    "絡": "luò,lào",
    "絢": "xuàn",
    "絣": "bēng,bīng,pēng",
    "絤": "xiàn",
    "絥": "fú",
    "給": "gěi,jǐ",
    "絧": "tōng,tóng,dòng",
    "絨": "róng",
    "絩": "tiào,diào,dào",
    "絪": "yīn",
    "絫": "lěi,lèi,léi",
    "絬": "xiè",
    "絭": "juàn",
    "絮": "xù",
    "絯": "gāi,hài",
    "絰": "dié",
    "統": "tǒng",
    "絲": "sī",
    "絳": "jiàng",
    "絴": "xiáng",
    "絵": "huì",
    "絶": "jué",
    "絷": "zhí",
    "絸": "jiǎn",
    "絹": "juàn",
    "絺": "chī,zhǐ",
    "絻": "miǎn,wèn,mán,wàn",
    "絼": "zhèn",
    "絽": "lǚ",
    "絾": "chéng",
    "絿": "qiú",
    "綀": "shū",
    "綁": "bǎng",
    "綂": "tǒng",
    "綃": "xiāo",
    "綄": "huán,huàn,wàn",
    "綅": "qīn,xiān",
    "綆": "gěng",
    "綇": "xū",
    "綈": "tí,tì",
    "綉": "xiù",
    "綊": "xié",
    "綋": "hóng",
    "綌": "xì",
    "綍": "fú",
    "綎": "tīng",
    "綏": "suí",
    "綐": "duì",
    "綑": "kǔn",
    "綒": "fū",
    "經": "jīng",
    "綔": "hù",
    "綕": "zhī",
    "綖": "yán,xiàn",
    "綗": "jiǒng",
    "綘": "féng",
    "継": "jì",
    "続": "xù",
    "綛": "rěn",
    "綜": "zōng,zèng",
    "綝": "lín,chēn",
    "綞": "duǒ",
    "綟": "lì,liè",
    "綠": "lǜ",
    "綡": "jīng",
    "綢": "chóu",
    "綣": "quǎn",
    "綤": "shào",
    "綥": "qí",
    "綦": "qí",
    "綧": "zhǔn,zhùn",
    "綨": "jī,qí",
    "綩": "wǎn",
    "綪": "qiàn,qīng,zhēng",
    "綫": "xiàn",
    "綬": "shòu",
    "維": "wéi",
    "綮": "qìng,qǐ",
    "綯": "táo",
    "綰": "wǎn",
    "綱": "gāng",
    "網": "wǎng",
    "綳": "bēng,běng,bèng",
    "綴": "zhuì",
    "綵": "cǎi",
    "綶": "guǒ",
    "綷": "cuì",
    "綸": "lún,guān",
    "綹": "liǔ",
    "綺": "qǐ",
    "綻": "zhàn",
    "綼": "bì",
    "綽": "chuò,chāo",
    "綾": "líng",
    "綿": "mián",
    "緀": "qī",
    "緁": "jī",
    "緂": "tián,tǎn,chān",
    "緃": "zōng",
    "緄": "gǔn",
    "緅": "zōu",
    "緆": "xī",
    "緇": "zī",
    "緈": "xìng",
    "緉": "liǎng",
    "緊": "jǐn",
    "緋": "fēi",
    "緌": "ruí",
    "緍": "mín",
    "緎": "yù",
    "総": "zǒng",
    "緐": "fán",
    "緑": "lǜ,lù",
    "緒": "xù",
    "緓": "yīng",
    "緔": "shàng",
    "緕": "zī",
    "緖": "xù",
    "緗": "xiāng",
    "緘": "jiān",
    "緙": "kè",
    "線": "xiàn",
    "緛": "ruǎn,ruàn",
    "緜": "mián",
    "緝": "jī,qī",
    "緞": "duàn",
    "緟": "chóng,zhòng",
    "締": "dì",
    "緡": "mín",
    "緢": "miáo,máo",
    "緣": "yuán",
    "緤": "xiè,yè",
    "緥": "bǎo",
    "緦": "sī",
    "緧": "qiū",
    "編": "biān",
    "緩": "huǎn",
    "緪": "gēng,gèng",
    "緫": "zǒng",
    "緬": "miǎn",
    "緭": "wèi",
    "緮": "fù",
    "緯": "wěi",
    "緰": "tōu,xū,shū",
    "緱": "gōu",
    "緲": "miǎo",
    "緳": "xié",
    "練": "liàn",
    "緵": "zōng,zòng",
    "緶": "biàn,pián",
    "緷": "gǔn,yùn",
    "緸": "yīn",
    "緹": "tí",
    "緺": "guā,wō",
    "緻": "zhì",
    "緼": "yùn,yūn,wēn",
    "緽": "chēng",
    "緾": "chán",
    "緿": "dài",
    "縀": "xié",
    "縁": "yuán",
    "縂": "zǒng",
    "縃": "xū",
    "縄": "shéng",
    "縅": "wēi",
    "縆": "gēng,gèng",
    "縇": "null",
    "縈": "yíng",
    "縉": "jìn",
    "縊": "yì",
    "縋": "zhuì",
    "縌": "nì",
    "縍": "bāng,bàng",
    "縎": "gǔ,hú",
    "縏": "pán",
    "縐": "zhòu",
    "縑": "jiān",
    "縒": "cī,cuò,suǒ",
    "縓": "quán",
    "縔": "shuǎng",
    "縕": "yùn,yūn,wēn",
    "縖": "xiá",
    "縗": "cuī,suī,shuāi",
    "縘": "xì",
    "縙": "róng,rǒng,ròng",
    "縚": "tāo",
    "縛": "fù",
    "縜": "yún",
    "縝": "zhěn",
    "縞": "gǎo",
    "縟": "rù",
    "縠": "hú",
    "縡": "zài,zēng",
    "縢": "téng",
    "縣": "xiàn,xuán",
    "縤": "sù",
    "縥": "zhěn",
    "縦": "zòng",
    "縧": "tāo",
    "縨": "huǎng",
    "縩": "cài",
    "縪": "bì",
    "縫": "féng,fèng",
    "縬": "cù",
    "縭": "lí",
    "縮": "suō,sù",
    "縯": "yǎn,yǐn",
    "縰": "xǐ",
    "縱": "zòng,zǒng",
    "縲": "léi",
    "縳": "zhuàn,juàn",
    "縴": "qiàn",
    "縵": "màn",
    "縶": "zhí",
    "縷": "lǚ",
    "縸": "mù,mò",
    "縹": "piǎo,piāo",
    "縺": "lián",
    "縻": "mí",
    "縼": "xuàn",
    "總": "zǒng",
    "績": "jì",
    "縿": "shān",
    "繀": "suì",
    "繁": "fán,pó",
    "繂": "lǜ",
    "繃": "bēng,běng,bèng",
    "繄": "yī",
    "繅": "sāo",
    "繆": "móu,miù,miào,mù,liǎo",
    "繇": "yáo,yóu,zhòu",
    "繈": "qiǎng",
    "繉": "shéng",
    "繊": "xiān",
    "繋": "jì",
    "繌": "zōng,zòng",
    "繍": "xiù",
    "繎": "rán",
    "繏": "xuàn",
    "繐": "suì",
    "繑": "qiāo",
    "繒": "zēng,zèng",
    "繓": "zuǒ",
    "織": "zhī,zhì",
    "繕": "shàn",
    "繖": "sǎn",
    "繗": "lín",
    "繘": "jú,jué",
    "繙": "fān",
    "繚": "liáo",
    "繛": "chuō,chuò",
    "繜": "zūn,zǔn",
    "繝": "jiàn",
    "繞": "rào",
    "繟": "chǎn,chán",
    "繠": "ruǐ",
    "繡": "xiù",
    "繢": "huì,huí",
    "繣": "huà",
    "繤": "zuǎn",
    "繥": "xī",
    "繦": "qiǎng",
    "繧": "wén",
    "繨": "da",
    "繩": "shéng",
    "繪": "huì",
    "繫": "xì,jì",
    "繬": "sè",
    "繭": "jiǎn",
    "繮": "jiāng",
    "繯": "huán",
    "繰": "qiāo,sāo",
    "繱": "cōng",
    "繲": "xiè",
    "繳": "jiǎo,zhuó",
    "繴": "bì",
    "繵": "dàn,tán,chán",
    "繶": "yì",
    "繷": "nǒng",
    "繸": "suì",
    "繹": "yì",
    "繺": "shā",
    "繻": "rú",
    "繼": "jì",
    "繽": "bīn",
    "繾": "qiǎn",
    "繿": "lán",
    "纀": "pú,fú",
    "纁": "xūn",
    "纂": "zuǎn",
    "纃": "zī",
    "纄": "péng",
    "纅": "yào,lì",
    "纆": "mò",
    "纇": "lèi",
    "纈": "xiè",
    "纉": "zuǎn",
    "纊": "kuàng",
    "纋": "yōu",
    "續": "xù",
    "纍": "léi",
    "纎": "xiān",
    "纏": "chán",
    "纐": "jiǎo",
    "纑": "lú",
    "纒": "chán",
    "纓": "yīng",
    "纔": "cái",
    "纕": "xiāng,rǎng",
    "纖": "xiān",
    "纗": "zuī",
    "纘": "zuǎn",
    "纙": "luò",
    "纚": "lí,xǐ,lǐ,sǎ",
    "纛": "dào",
    "纜": "lǎn",
    "纝": "léi",
    "纞": "liàn",
    "纟": "sī",
    "纠": "jiū",
    "纡": "yū",
    "红": "hóng,gōng",
    "纣": "zhòu",
    "纤": "xiān,qiàn",
    "纥": "hé,gē",
    "约": "yuē,yāo",
    "级": "jí",
    "纨": "wán",
    "纩": "kuàng",
    "纪": "jì,jǐ",
    "纫": "rèn",
    "纬": "wěi",
    "纭": "yún",
    "纮": "hóng",
    "纯": "chún",
    "纰": "pī,pí,bǐ",
    "纱": "shā",
    "纲": "gāng",
    "纳": "nà",
    "纴": "rèn",
    "纵": "zòng,zǒng",
    "纶": "lún,guān",
    "纷": "fēn",
    "纸": "zhǐ",
    "纹": "wén,wèn",
    "纺": "fǎng",
    "纻": "zhù",
    "纼": "zhèn",
    "纽": "niǔ",
    "纾": "shū",
    "线": "xiàn",
    "绀": "gàn",
    "绁": "xiè",
    "绂": "fú",
    "练": "liàn",
    "组": "zǔ",
    "绅": "shēn",
    "细": "xì",
    "织": "zhī,zhì",
    "终": "zhōng",
    "绉": "zhòu",
    "绊": "bàn",
    "绋": "fú",
    "绌": "chù",
    "绍": "shào",
    "绎": "yì",
    "经": "jīng",
    "绐": "dài",
    "绑": "bǎng",
    "绒": "róng",
    "结": "jié,jiē",
    "绔": "kù",
    "绕": "rào",
    "绖": "dié",
    "绗": "háng",
    "绘": "huì",
    "给": "gěi,jǐ",
    "绚": "xuàn",
    "绛": "jiàng",
    "络": "luò,lào",
    "绝": "jué",
    "绞": "jiǎo",
    "统": "tǒng",
    "绠": "gěng",
    "绡": "xiāo",
    "绢": "juàn",
    "绣": "xiù",
    "绤": "xì",
    "绥": "suí",
    "绦": "tāo",
    "继": "jì",
    "绨": "tí,tì",
    "绩": "jì",
    "绪": "xù",
    "绫": "líng",
    "绬": "yīng",
    "续": "xù",
    "绮": "qǐ",
    "绯": "fēi",
    "绰": "chuò,chāo",
    "绱": "shàng",
    "绲": "gǔn",
    "绳": "shéng",
    "维": "wéi",
    "绵": "mián",
    "绶": "shòu",
    "绷": "bēng,běng,bèng",
    "绸": "chóu",
    "绹": "táo",
    "绺": "liǔ",
    "绻": "quǎn",
    "综": "zōng,zèng",
    "绽": "zhàn",
    "绾": "wǎn",
    "绿": "lǜ,lù",
    "缀": "zhuì",
    "缁": "zī",
    "缂": "kè",
    "缃": "xiāng",
    "缄": "jiān",
    "缅": "miǎn",
    "缆": "lǎn",
    "缇": "tí",
    "缈": "miǎo",
    "缉": "jī,qī",
    "缊": "yùn,yūn,wēn",
    "缋": "huì,huí",
    "缌": "sī",
    "缍": "duǒ",
    "缎": "duàn",
    "缏": "biàn,pián",
    "缐": "xiàn",
    "缑": "gōu",
    "缒": "zhuì",
    "缓": "huǎn",
    "缔": "dì",
    "缕": "lǚ",
    "编": "biān",
    "缗": "mín",
    "缘": "yuán",
    "缙": "jìn",
    "缚": "fù",
    "缛": "rù",
    "缜": "zhěn",
    "缝": "féng,fèng",
    "缞": "cuī,suī,shuāi",
    "缟": "gǎo",
    "缠": "chán",
    "缡": "lí",
    "缢": "yì",
    "缣": "jiān",
    "缤": "bīn",
    "缥": "piǎo,piāo",
    "缦": "màn",
    "缧": "léi",
    "缨": "yīng",
    "缩": "suō,sù",
    "缪": "móu,miù,miào,mù,liǎo",
    "缫": "sāo",
    "缬": "xié",
    "缭": "liáo",
    "缮": "shàn",
    "缯": "zēng,zèng",
    "缰": "jiāng",
    "缱": "qiǎn",
    "缲": "qiāo,sāo",
    "缳": "huán",
    "缴": "jiǎo,zhuó",
    "缵": "zuǎn",
    "缶": "fǒu",
    "缷": "xiè",
    "缸": "gāng",
    "缹": "fǒu",
    "缺": "quē",
    "缻": "fǒu",
    "缼": "quē",
    "缽": "bō",
    "缾": "píng",
    "缿": "xiàng",
    "罀": "zhào",
    "罁": "gāng",
    "罂": "yīng",
    "罃": "yīng",
    "罄": "qìng",
    "罅": "xià",
    "罆": "guàn",
    "罇": "zūn",
    "罈": "tán",
    "罉": "chēng",
    "罊": "qì",
    "罋": "wèng",
    "罌": "yīng",
    "罍": "léi",
    "罎": "tán",
    "罏": "lú",
    "罐": "guàn",
    "网": "wǎng",
    "罒": "wǎng",
    "罓": "wǎng",
    "罔": "wǎng",
    "罕": "hǎn",
    "罖": "wǎng",
    "罗": "luó",
    "罘": "fú",
    "罙": "shēn",
    "罚": "fá",
    "罛": "gū",
    "罜": "zhǔ",
    "罝": "jū",
    "罞": "máo",
    "罟": "gǔ",
    "罠": "mín",
    "罡": "gāng",
    "罢": "bà,ba,pí",
    "罣": "guà",
    "罤": "tí",
    "罥": "juàn",
    "罦": "fú",
    "罧": "shēn",
    "罨": "yǎn",
    "罩": "zhào",
    "罪": "zuì",
    "罫": "guǎi,guà",
    "罬": "zhuó",
    "罭": "yù",
    "置": "zhì",
    "罯": "ǎn",
    "罰": "fá",
    "罱": "lǎn",
    "署": "shǔ",
    "罳": "sī",
    "罴": "pí",
    "罵": "mà",
    "罶": "liǔ",
    "罷": "bà,ba,pí",
    "罸": "fá",
    "罹": "lí",
    "罺": "cháo",
    "罻": "wèi",
    "罼": "bì",
    "罽": "jì",
    "罾": "zēng",
    "罿": "chōng",
    "羀": "liǔ",
    "羁": "jī",
    "羂": "juàn",
    "羃": "mì",
    "羄": "zhào",
    "羅": "luó",
    "羆": "pí",
    "羇": "jī",
    "羈": "jī",
    "羉": "luán",
    "羊": "yáng,xiáng",
    "羋": "mǐ",
    "羌": "qiāng",
    "羍": "dá",
    "美": "měi",
    "羏": "yáng,xiáng",
    "羐": "líng",
    "羑": "yǒu",
    "羒": "fén",
    "羓": "bā",
    "羔": "gāo",
    "羕": "yàng",
    "羖": "gǔ",
    "羗": "qiāng",
    "羘": "zāng",
    "羙": "měi,gāo",
    "羚": "líng",
    "羛": "yì,xī",
    "羜": "zhù",
    "羝": "dī",
    "羞": "xiū",
    "羟": "qiǎng",
    "羠": "yí",
    "羡": "xiàn",
    "羢": "róng",
    "羣": "qún",
    "群": "qún",
    "羥": "qiǎng",
    "羦": "huán",
    "羧": "suō",
    "羨": "xiàn",
    "義": "yì",
    "羪": "yōu",
    "羫": "qiāng,kòng",
    "羬": "qián,xián,yán",
    "羭": "yú",
    "羮": "gēng",
    "羯": "jié",
    "羰": "tāng",
    "羱": "yuán",
    "羲": "xī",
    "羳": "fán",
    "羴": "shān",
    "羵": "fén",
    "羶": "shān",
    "羷": "liǎn",
    "羸": "léi",
    "羹": "gēng",
    "羺": "nóu",
    "羻": "qiàng",
    "羼": "chàn",
    "羽": "yǔ",
    "羾": "hóng,gòng",
    "羿": "yì",
    "翀": "chōng",
    "翁": "wēng",
    "翂": "fēn",
    "翃": "hóng",
    "翄": "chì",
    "翅": "chì",
    "翆": "cuì",
    "翇": "fú",
    "翈": "xiá",
    "翉": "běn",
    "翊": "yì",
    "翋": "là",
    "翌": "yì",
    "翍": "pī,bì,pō",
    "翎": "líng",
    "翏": "liù",
    "翐": "zhì",
    "翑": "qú,yù",
    "習": "xí",
    "翓": "xié",
    "翔": "xiáng",
    "翕": "xī",
    "翖": "xī",
    "翗": "ké",
    "翘": "qiáo,qiào",
    "翙": "huì",
    "翚": "huī",
    "翛": "xiāo",
    "翜": "shà",
    "翝": "hóng",
    "翞": "jiāng",
    "翟": "dí,zhái",
    "翠": "cuì",
    "翡": "fěi",
    "翢": "dào,zhōu",
    "翣": "shà",
    "翤": "chì",
    "翥": "zhù",
    "翦": "jiǎn",
    "翧": "xuān",
    "翨": "chì",
    "翩": "piān",
    "翪": "zōng",
    "翫": "wán",
    "翬": "huī",
    "翭": "hóu",
    "翮": "hé",
    "翯": "hè",
    "翰": "hàn",
    "翱": "áo",
    "翲": "piāo",
    "翳": "yì",
    "翴": "lián",
    "翵": "hóu,qú",
    "翶": "áo",
    "翷": "lín",
    "翸": "pěn",
    "翹": "qiáo,qiào",
    "翺": "áo",
    "翻": "fān",
    "翼": "yì",
    "翽": "huì",
    "翾": "xuān",
    "翿": "dào",
    "耀": "yào",
    "老": "lǎo",
    "耂": "lǎo",
    "考": "kǎo",
    "耄": "mào",
    "者": "zhě",
    "耆": "qí,shì",
    "耇": "gǒu",
    "耈": "gǒu",
    "耉": "gǒu",
    "耊": "dié",
    "耋": "dié",
    "而": "ér",
    "耍": "shuǎ",
    "耎": "ruǎn,nuò",
    "耏": "ér,nài",
    "耐": "nài",
    "耑": "duān,zhuān",
    "耒": "lěi",
    "耓": "tīng",
    "耔": "zǐ",
    "耕": "gēng",
    "耖": "chào",
    "耗": "hào",
    "耘": "yún",
    "耙": "bà,pá",
    "耚": "pī",
    "耛": "sì,chí",
    "耜": "sì",
    "耝": "qù,chú",
    "耞": "jiā",
    "耟": "jù",
    "耠": "huō",
    "耡": "chú",
    "耢": "lào",
    "耣": "lún,lǔn",
    "耤": "jí,jiè",
    "耥": "tǎng",
    "耦": "ǒu",
    "耧": "lóu",
    "耨": "nòu",
    "耩": "jiǎng",
    "耪": "pǎng",
    "耫": "zhá,zé",
    "耬": "lóu",
    "耭": "jī",
    "耮": "lào",
    "耯": "huò",
    "耰": "yōu",
    "耱": "mò",
    "耲": "huái",
    "耳": "ěr",
    "耴": "yì",
    "耵": "dīng",
    "耶": "yé,yē",
    "耷": "dā",
    "耸": "sǒng",
    "耹": "qín",
    "耺": "yún,yíng",
    "耻": "chǐ",
    "耼": "dān",
    "耽": "dān",
    "耾": "hóng",
    "耿": "gěng",
    "聀": "zhí",
    "聁": "pàn",
    "聂": "niè",
    "聃": "dān",
    "聄": "zhěn",
    "聅": "chè",
    "聆": "líng",
    "聇": "zhēng",
    "聈": "yǒu",
    "聉": "wà,tuǐ,zhuó",
    "聊": "liáo",
    "聋": "lóng",
    "职": "zhí",
    "聍": "níng",
    "聎": "tiāo",
    "聏": "ér,nǜ",
    "聐": "yà",
    "聑": "tiē,zhé",
    "聒": "guō",
    "聓": "xù",
    "联": "lián",
    "聕": "hào",
    "聖": "shèng",
    "聗": "liè",
    "聘": "pìn",
    "聙": "jīng",
    "聚": "jù",
    "聛": "bǐ",
    "聜": "dǐ,zhì",
    "聝": "guó",
    "聞": "wén",
    "聟": "xù",
    "聠": "pīng",
    "聡": "cōng",
    "聢": "dìng",
    "聣": "ní",
    "聤": "tíng",
    "聥": "jǔ",
    "聦": "cōng",
    "聧": "kuī",
    "聨": "lián",
    "聩": "kuì",
    "聪": "cōng",
    "聫": "lián",
    "聬": "wēng",
    "聭": "kuì",
    "聮": "lián",
    "聯": "lián",
    "聰": "cōng",
    "聱": "áo",
    "聲": "shēng",
    "聳": "sǒng",
    "聴": "tīng",
    "聵": "kuì",
    "聶": "niè",
    "職": "zhí",
    "聸": "dān",
    "聹": "níng",
    "聺": "qié",
    "聻": "nǐ,jiàn",
    "聼": "tīng",
    "聽": "tīng",
    "聾": "lóng",
    "聿": "yù",
    "肀": "yù",
    "肁": "zhào",
    "肂": "sì",
    "肃": "sù",
    "肄": "yì",
    "肅": "sù",
    "肆": "sì",
    "肇": "zhào",
    "肈": "zhào",
    "肉": "ròu",
    "肊": "yì",
    "肋": "lèi,lē",
    "肌": "jī",
    "肍": "qiú",
    "肎": "kěn",
    "肏": "cào",
    "肐": "gē",
    "肑": "bó,dí",
    "肒": "huàn",
    "肓": "huāng",
    "肔": "chǐ",
    "肕": "rèn",
    "肖": "xiāo,xiào",
    "肗": "rǔ",
    "肘": "zhǒu",
    "肙": "yuān",
    "肚": "dù,dǔ",
    "肛": "gāng",
    "肜": "róng,chēn",
    "肝": "gān",
    "肞": "chāi",
    "肟": "wò",
    "肠": "cháng",
    "股": "gǔ",
    "肢": "zhī",
    "肣": "qín,hán,hàn",
    "肤": "fū",
    "肥": "féi",
    "肦": "bān",
    "肧": "pēi",
    "肨": "pàng,pán,pàn",
    "肩": "jiān",
    "肪": "fáng",
    "肫": "zhūn,chún",
    "肬": "yóu",
    "肭": "nà",
    "肮": "āng",
    "肯": "kěn",
    "肰": "rán",
    "肱": "gōng",
    "育": "yù",
    "肳": "wěn",
    "肴": "yáo",
    "肵": "qí",
    "肶": "pí,bǐ,bì",
    "肷": "qiǎn",
    "肸": "xī",
    "肹": "xī",
    "肺": "fèi",
    "肻": "kěn",
    "肼": "jǐng",
    "肽": "tài",
    "肾": "shèn",
    "肿": "zhǒng",
    "胀": "zhàng",
    "胁": "xié",
    "胂": "shèn",
    "胃": "wèi",
    "胄": "zhòu",
    "胅": "dié",
    "胆": "dǎn",
    "胇": "fèi,bì",
    "胈": "bá",
    "胉": "bó",
    "胊": "qú",
    "胋": "tián",
    "背": "bēi,bèi",
    "胍": "guā",
    "胎": "tāi",
    "胏": "zǐ,fèi",
    "胐": "fěi,kū",
    "胑": "zhī",
    "胒": "nì",
    "胓": "píng,pēng",
    "胔": "zì",
    "胕": "fū,fú,zhǒu",
    "胖": "pàng,pán,pàn",
    "胗": "zhēn",
    "胘": "xián",
    "胙": "zuò",
    "胚": "pēi",
    "胛": "jiǎ",
    "胜": "shèng",
    "胝": "zhī",
    "胞": "bāo",
    "胟": "mǔ",
    "胠": "qū",
    "胡": "hú",
    "胢": "qià",
    "胣": "chǐ",
    "胤": "yìn",
    "胥": "xū",
    "胦": "yāng",
    "胧": "lóng",
    "胨": "dòng",
    "胩": "kǎ",
    "胪": "lú",
    "胫": "jìng",
    "胬": "nǔ",
    "胭": "yān",
    "胮": "pāng",
    "胯": "kuà",
    "胰": "yí",
    "胱": "guāng",
    "胲": "hǎi",
    "胳": "gē,gé",
    "胴": "dòng",
    "胵": "chī",
    "胶": "jiāo",
    "胷": "xiōng",
    "胸": "xiōng",
    "胹": "ér",
    "胺": "àn",
    "胻": "héng",
    "胼": "pián",
    "能": "néng,nài",
    "胾": "zì",
    "胿": "guī,kuì",
    "脀": "zhēng",
    "脁": "tiǎo",
    "脂": "zhī",
    "脃": "cuì",
    "脄": "méi",
    "脅": "xié",
    "脆": "cuì",
    "脇": "xié",
    "脈": "mài",
    "脉": "mài,mò",
    "脊": "jǐ",
    "脋": "xié",
    "脌": "nín",
    "脍": "kuài",
    "脎": "sà",
    "脏": "zàng",
    "脐": "qí",
    "脑": "nǎo",
    "脒": "mǐ",
    "脓": "nóng",
    "脔": "luán",
    "脕": "wàn",
    "脖": "bó",
    "脗": "wěn",
    "脘": "wǎn",
    "脙": "xiū",
    "脚": "jiǎo",
    "脛": "jìng",
    "脜": "róu",
    "脝": "hēng",
    "脞": "cuǒ",
    "脟": "liè",
    "脠": "shān",
    "脡": "tǐng",
    "脢": "méi",
    "脣": "chún",
    "脤": "shèn",
    "脥": "jiá",
    "脦": "tè",
    "脧": "juān",
    "脨": "cù",
    "脩": "xiū",
    "脪": "xìn",
    "脫": "tuō",
    "脬": "pāo",
    "脭": "chéng",
    "脮": "něi",
    "脯": "fǔ,pú",
    "脰": "dòu",
    "脱": "tuō",
    "脲": "niào",
    "脳": "nǎo",
    "脴": "pǐ",
    "脵": "gǔ",
    "脶": "luó",
    "脷": "lì",
    "脸": "liǎn",
    "脹": "zhàng",
    "脺": "cuī",
    "脻": "jiē",
    "脼": "liǎng",
    "脽": "shuí",
    "脾": "pí",
    "脿": "biāo",
    "腀": "lún",
    "腁": "pián",
    "腂": "guò",
    "腃": "juàn",
    "腄": "chuí",
    "腅": "dàn",
    "腆": "tiǎn",
    "腇": "něi",
    "腈": "jīng",
    "腉": "nái",
    "腊": "là,xī",
    "腋": "yè",
    "腌": "ā,yān",
    "腍": "rèn",
    "腎": "shèn",
    "腏": "zhuì",
    "腐": "fǔ",
    "腑": "fǔ",
    "腒": "jū",
    "腓": "féi",
    "腔": "qiāng",
    "腕": "wàn",
    "腖": "dòng",
    "腗": "pí",
    "腘": "guó",
    "腙": "zōng",
    "腚": "dìng",
    "腛": "wò",
    "腜": "méi",
    "腝": "ruǎn",
    "腞": "zhuàn",
    "腟": "chì",
    "腠": "còu",
    "腡": "luó",
    "腢": "ǒu",
    "腣": "dì",
    "腤": "ān",
    "腥": "xīng",
    "腦": "nǎo",
    "腧": "shù",
    "腨": "shuàn",
    "腩": "nǎn",
    "腪": "yùn",
    "腫": "zhǒng",
    "腬": "róu",
    "腭": "è",
    "腮": "sāi",
    "腯": "tú",
    "腰": "yāo",
    "腱": "jiàn",
    "腲": "wěi",
    "腳": "jiǎo",
    "腴": "yú",
    "腵": "jiā",
    "腶": "duàn",
    "腷": "bì",
    "腸": "cháng",
    "腹": "fù",
    "腺": "xiàn",
    "腻": "nì",
    "腼": "miǎn",
    "腽": "wà",
    "腾": "téng",
    "腿": "tuǐ",
    "膀": "bǎng",
    "膁": "qiǎn",
    "膂": "lǚ",
    "膃": "wà",
    "膄": "shòu",
    "膅": "táng",
    "膆": "sù",
    "膇": "zhuì",
    "膈": "gé",
    "膉": "yì",
    "膊": "bó",
    "膋": "liáo",
    "膌": "jí",
    "膍": "pí",
    "膎": "xié",
    "膏": "gāo,gào",
    "膐": "lǚ",
    "膑": "bìn",
    "膒": "ōu",
    "膓": "cháng",
    "膔": "lù,biāo",
    "膕": "guó",
    "膖": "pāng",
    "膗": "chuái",
    "膘": "biāo",
    "膙": "jiǎng",
    "膚": "fū",
    "膛": "táng",
    "膜": "mó",
    "膝": "xī",
    "膞": "zhuān,chuán,chún,zhuǎn",
    "膟": "lǜ",
    "膠": "jiāo",
    "膡": "yìng",
    "膢": "lǘ",
    "膣": "zhì",
    "膤": "xuě",
    "膥": "cūn",
    "膦": "lìn",
    "膧": "tóng",
    "膨": "péng",
    "膩": "nì",
    "膪": "chuài",
    "膫": "liáo",
    "膬": "cuì",
    "膭": "kuì",
    "膮": "xiāo",
    "膯": "tēng",
    "膰": "fán,pán",
    "膱": "zhí",
    "膲": "jiāo",
    "膳": "shàn",
    "膴": "hū,wǔ",
    "膵": "cuì",
    "膶": "rùn",
    "膷": "xiāng",
    "膸": "suǐ",
    "膹": "fèn",
    "膺": "yīng",
    "膻": "shān,dàn",
    "膼": "zhuā",
    "膽": "dǎn",
    "膾": "kuài",
    "膿": "nóng",
    "臀": "tún",
    "臁": "lián",
    "臂": "bì,bei",
    "臃": "yōng",
    "臄": "jué",
    "臅": "chù",
    "臆": "yì",
    "臇": "juǎn",
    "臈": "là,gé",
    "臉": "liǎn",
    "臊": "sāo,sào",
    "臋": "tún",
    "臌": "gǔ",
    "臍": "qí",
    "臎": "cuì",
    "臏": "bìn",
    "臐": "xūn",
    "臑": "nào",
    "臒": "wò,yuè",
    "臓": "zàng",
    "臔": "xiàn",
    "臕": "biāo",
    "臖": "xìng",
    "臗": "kuān",
    "臘": "là",
    "臙": "yān",
    "臚": "lú",
    "臛": "huò",
    "臜": "zā",
    "臝": "luǒ",
    "臞": "qú",
    "臟": "zàng",
    "臠": "luán",
    "臡": "ní,luán",
    "臢": "zā",
    "臣": "chén",
    "臤": "qiān,xián",
    "臥": "wò",
    "臦": "guàng,jiǒng",
    "臧": "zāng,zàng,cáng",
    "臨": "lín",
    "臩": "guǎng,jiǒng",
    "自": "zì",
    "臫": "jiǎo",
    "臬": "niè",
    "臭": "chòu,xiù",
    "臮": "jì",
    "臯": "gāo",
    "臰": "chòu",
    "臱": "mián,biān",
    "臲": "niè",
    "至": "zhì",
    "致": "zhì",
    "臵": "gé",
    "臶": "jiàn",
    "臷": "dié,zhí",
    "臸": "zhī,jìn",
    "臹": "xiū",
    "臺": "tái",
    "臻": "zhēn",
    "臼": "jiù",
    "臽": "xiàn",
    "臾": "yú",
    "臿": "chā",
    "舀": "yǎo",
    "舁": "yú",
    "舂": "chōng",
    "舃": "xì",
    "舄": "xì",
    "舅": "jiù",
    "舆": "yú",
    "與": "yǔ",
    "興": "xīng",
    "舉": "jǔ",
    "舊": "jiù",
    "舋": "xìn",
    "舌": "shé",
    "舍": "shě,shè",
    "舎": "shè",
    "舏": "jiǔ",
    "舐": "shì",
    "舑": "tān",
    "舒": "shū",
    "舓": "shì",
    "舔": "tiǎn",
    "舕": "tàn",
    "舖": "pù",
    "舗": "pù",
    "舘": "guǎn",
    "舙": "huà",
    "舚": "tiàn",
    "舛": "chuǎn",
    "舜": "shùn",
    "舝": "xiá",
    "舞": "wǔ",
    "舟": "zhōu",
    "舠": "dāo",
    "舡": "chuán",
    "舢": "shān",
    "舣": "yǐ",
    "舤": "fán",
    "舥": "pā",
    "舦": "tài",
    "舧": "fán",
    "舨": "bǎn",
    "舩": "chuán",
    "航": "háng",
    "舫": "fǎng",
    "般": "bān",
    "舭": "bǐ",
    "舮": "lú",
    "舯": "zhōng",
    "舰": "jiàn",
    "舱": "cāng",
    "舲": "líng",
    "舳": "zhú",
    "舴": "zé",
    "舵": "duò",
    "舶": "bó",
    "舷": "xián",
    "舸": "gě",
    "船": "chuán",
    "舺": "xiá",
    "舻": "lú",
    "舼": "qióng",
    "舽": "páng",
    "舾": "xī",
    "舿": "kuā",
    "艀": "fú",
    "艁": "zào",
    "艂": "féng",
    "艃": "lí",
    "艄": "shāo",
    "艅": "yú",
    "艆": "láng",
    "艇": "tǐng",
    "艈": "yù",
    "艉": "wěi",
    "艊": "bó",
    "艋": "měng",
    "艌": "niàn",
    "艍": "jū",
    "艎": "huáng",
    "艏": "shǒu",
    "艐": "kè",
    "艑": "biàn",
    "艒": "mù",
    "艓": "dié",
    "艔": "dào",
    "艕": "bàng",
    "艖": "chā",
    "艗": "yì",
    "艘": "sōu",
    "艙": "cāng",
    "艚": "cáo",
    "艛": "lóu",
    "艜": "dài",
    "艝": "xuě",
    "艞": "yào",
    "艟": "chōng",
    "艠": "dēng",
    "艡": "dāng",
    "艢": "qiáng",
    "艣": "lǔ",
    "艤": "yǐ",
    "艥": "jí",
    "艦": "jiàn",
    "艧": "huò",
    "艨": "méng",
    "艩": "qí",
    "艪": "lǔ",
    "艫": "lú",
    "艬": "chán",
    "艭": "shuāng",
    "艮": "gèn",
    "良": "liáng",
    "艰": "jiān",
    "艱": "jiān",
    "色": "sè",
    "艳": "yàn",
    "艴": "fú",
    "艵": "pīng",
    "艶": "yàn",
    "艷": "yàn",
    "艸": "cǎo",
    "艹": "ǎo",
    "艺": "yì",
    "艻": "lè",
    "艼": "dǐng",
    "艽": "jiāo,qiú",
    "艾": "ài,yì",
    "艿": "nǎi",
    "芀": "tiáo",
    "芁": "qiú",
    "节": "jié,jiē",
    "芃": "péng",
    "芄": "wán",
    "芅": "yì",
    "芆": "chāi,chā",
    "芇": "mián",
    "芈": "mǐ",
    "芉": "gǎn",
    "芊": "qiān",
    "芋": "yù",
    "芌": "yù",
    "芍": "sháo",
    "芎": "xiōng",
    "芏": "dù",
    "芐": "hù,xià",
    "芑": "qǐ",
    "芒": "máng",
    "芓": "zì,zǐ",
    "芔": "huì,hū",
    "芕": "suī",
    "芖": "zhì",
    "芗": "xiāng",
    "芘": "bì,pí",
    "芙": "fú",
    "芚": "tún,chūn",
    "芛": "wěi",
    "芜": "wú",
    "芝": "zhī",
    "芞": "qì",
    "芟": "shān",
    "芠": "wén",
    "芡": "qiàn",
    "芢": "rén",
    "芣": "fú",
    "芤": "kōu",
    "芥": "jiè,gài",
    "芦": "lú",
    "芧": "xù,zhù",
    "芨": "jī",
    "芩": "qín",
    "芪": "qí",
    "芫": "yuán,yán",
    "芬": "fēn",
    "芭": "bā",
    "芮": "ruì",
    "芯": "xīn,xìn",
    "芰": "jì",
    "花": "huā",
    "芲": "lún,huā",
    "芳": "fāng",
    "芴": "wù,hū",
    "芵": "jué",
    "芶": "gōu,gǒu",
    "芷": "zhǐ",
    "芸": "yún",
    "芹": "qín",
    "芺": "ǎo",
    "芻": "chú",
    "芼": "máo,mào",
    "芽": "yá",
    "芾": "fèi,fú",
    "芿": "réng",
    "苀": "háng",
    "苁": "cōng",
    "苂": "chán,yín",
    "苃": "yǒu",
    "苄": "biàn",
    "苅": "yì",
    "苆": "qiē",
    "苇": "wěi",
    "苈": "lì",
    "苉": "pǐ",
    "苊": "è",
    "苋": "xiàn",
    "苌": "cháng",
    "苍": "cāng",
    "苎": "zhù",
    "苏": "sū,sù",
    "苐": "dì,tí",
    "苑": "yuàn",
    "苒": "rǎn",
    "苓": "líng",
    "苔": "tái,tāi",
    "苕": "tiáo,sháo",
    "苖": "dí",
    "苗": "miáo",
    "苘": "qǐng",
    "苙": "lì,jī",
    "苚": "yòng",
    "苛": "kē,hē",
    "苜": "mù",
    "苝": "bèi",
    "苞": "bāo",
    "苟": "gǒu",
    "苠": "mín",
    "苡": "yǐ",
    "苢": "yǐ",
    "苣": "jù,qǔ",
    "苤": "piě",
    "若": "ruò,rě",
    "苦": "kǔ",
    "苧": "zhù,níng",
    "苨": "nǐ",
    "苩": "pā,bó",
    "苪": "bǐng",
    "苫": "shān,shàn",
    "苬": "xiú",
    "苭": "yǎo",
    "苮": "xiān",
    "苯": "běn",
    "苰": "hóng",
    "英": "yīng",
    "苲": "zuó,zhǎ",
    "苳": "dōng",
    "苴": "jū,chá",
    "苵": "dié",
    "苶": "nié",
    "苷": "gān",
    "苸": "hū",
    "苹": "píng,pēng",
    "苺": "méi",
    "苻": "fú",
    "苼": "shēng,ruí",
    "苽": "gū",
    "苾": "bì",
    "苿": "wèi",
    "茀": "fú",
    "茁": "zhuó",
    "茂": "mào",
    "范": "fàn",
    "茄": "qié",
    "茅": "máo",
    "茆": "máo",
    "茇": "bá",
    "茈": "zǐ",
    "茉": "mò",
    "茊": "zī",
    "茋": "zhǐ",
    "茌": "chí",
    "茍": "jì",
    "茎": "jīng",
    "茏": "lóng",
    "茐": "cōng",
    "茑": "niǎo",
    "茒": "yuán",
    "茓": "xué",
    "茔": "yíng",
    "茕": "qióng",
    "茖": "gè",
    "茗": "míng",
    "茘": "lì",
    "茙": "róng",
    "茚": "yìn",
    "茛": "gèn",
    "茜": "qiàn",
    "茝": "chǎi",
    "茞": "chén",
    "茟": "yù",
    "茠": "hāo",
    "茡": "zì",
    "茢": "liè",
    "茣": "wú",
    "茤": "jì",
    "茥": "guī",
    "茦": "cì",
    "茧": "jiǎn",
    "茨": "cí",
    "茩": "hòu",
    "茪": "guāng",
    "茫": "máng",
    "茬": "chá",
    "茭": "jiāo",
    "茮": "jiāo",
    "茯": "fú",
    "茰": "yú",
    "茱": "zhū",
    "茲": "zī",
    "茳": "jiāng",
    "茴": "huí",
    "茵": "yīn",
    "茶": "chá",
    "茷": "fá",
    "茸": "róng",
    "茹": "rú",
    "茺": "chōng",
    "茻": "mǎng",
    "茼": "tóng",
    "茽": "zhòng",
    "茾": "qiān",
    "茿": "zhú",
    "荀": "xún",
    "荁": "huán",
    "荂": "fū",
    "荃": "quán",
    "荄": "gāi",
    "荅": "dá",
    "荆": "jīng",
    "荇": "xìng",
    "荈": "chuǎn",
    "草": "cǎo",
    "荊": "jīng",
    "荋": "ér",
    "荌": "àn",
    "荍": "qiáo",
    "荎": "chí",
    "荏": "rěn",
    "荐": "jiàn",
    "荑": "yí,tí",
    "荒": "huāng",
    "荓": "píng",
    "荔": "lì",
    "荕": "jīn",
    "荖": "lǎo",
    "荗": "shù",
    "荘": "zhuāng",
    "荙": "dá",
    "荚": "jiá",
    "荛": "ráo",
    "荜": "bì",
    "荝": "cè",
    "荞": "qiáo",
    "荟": "huì",
    "荠": "jì,qí",
    "荡": "dàng",
    "荢": "zì",
    "荣": "róng",
    "荤": "hūn",
    "荥": "xíng,yīng",
    "荦": "luò",
    "荧": "yíng",
    "荨": "qián,xún",
    "荩": "jìn",
    "荪": "sūn",
    "荫": "yīn,yìn",
    "荬": "mǎi",
    "荭": "hóng",
    "荮": "zhòu",
    "药": "yào",
    "荰": "dù",
    "荱": "wěi",
    "荲": "lí",
    "荳": "dòu",
    "荴": "fū",
    "荵": "rěn",
    "荶": "yín",
    "荷": "hé,hè",
    "荸": "bí",
    "荹": "bù",
    "荺": "yǔn",
    "荻": "dí",
    "荼": "tú",
    "荽": "suī",
    "荾": "suī",
    "荿": "chéng",
    "莀": "chén",
    "莁": "wú",
    "莂": "bié",
    "莃": "xī",
    "莄": "gěng",
    "莅": "lì",
    "莆": "pú",
    "莇": "zhù",
    "莈": "mò",
    "莉": "lì",
    "莊": "zhuāng",
    "莋": "zuó",
    "莌": "tuō",
    "莍": "qiú",
    "莎": "suō,shā",
    "莏": "suō",
    "莐": "chén",
    "莑": "péng,fēng",
    "莒": "jǔ",
    "莓": "méi",
    "莔": "méng",
    "莕": "xìng",
    "莖": "jìng",
    "莗": "chē",
    "莘": "shēn,xīn",
    "莙": "jūn",
    "莚": "yán",
    "莛": "tíng",
    "莜": "yóu",
    "莝": "cuò",
    "莞": "wǎn,guǎn,guān",
    "莟": "hàn",
    "莠": "yǒu",
    "莡": "cuò",
    "莢": "jiá",
    "莣": "wáng",
    "莤": "sù,yóu",
    "莥": "niǔ",
    "莦": "shāo,xiāo",
    "莧": "xiàn",
    "莨": "làng,liáng",
    "莩": "fú,piǎo",
    "莪": "é",
    "莫": "mò,mù",
    "莬": "wèn,wǎn,miǎn",
    "莭": "jié",
    "莮": "nán",
    "莯": "mù",
    "莰": "kǎn",
    "莱": "lái",
    "莲": "lián",
    "莳": "shì,shí",
    "莴": "wō",
    "莵": "tù,tú",
    "莶": "xiān,liǎn",
    "获": "huò",
    "莸": "yóu",
    "莹": "yíng",
    "莺": "yīng",
    "莻": "null",
    "莼": "chún",
    "莽": "mǎng",
    "莾": "mǎng",
    "莿": "cì",
    "菀": "wǎn,yùn",
    "菁": "jīng",
    "菂": "dì",
    "菃": "qú",
    "菄": "dōng",
    "菅": "jiān",
    "菆": "zōu,chù",
    "菇": "gū",
    "菈": "lā",
    "菉": "lù",
    "菊": "jú",
    "菋": "wèi",
    "菌": "jūn,jùn",
    "菍": "niè,rěn",
    "菎": "kūn",
    "菏": "hé",
    "菐": "pú",
    "菑": "zī,zì,zāi",
    "菒": "gǎo",
    "菓": "guǒ",
    "菔": "fú",
    "菕": "lún",
    "菖": "chāng",
    "菗": "chóu",
    "菘": "sōng",
    "菙": "chuí",
    "菚": "zhàn",
    "菛": "mén",
    "菜": "cài",
    "菝": "bá",
    "菞": "lí",
    "菟": "tù,tú",
    "菠": "bō",
    "菡": "hàn",
    "菢": "bào",
    "菣": "qìn",
    "菤": "juǎn",
    "菥": "xī",
    "菦": "qín",
    "菧": "dǐ",
    "菨": "jiē,shà",
    "菩": "pú",
    "菪": "dàng",
    "菫": "jǐn",
    "菬": "qiáo,zhǎo",
    "菭": "tái,zhī,chí",
    "菮": "gēng",
    "華": "huá,huà,huā",
    "菰": "gū",
    "菱": "líng",
    "菲": "fēi,fěi",
    "菳": "qín,qīn,jīn",
    "菴": "ān",
    "菵": "wǎng",
    "菶": "běng",
    "菷": "zhǒu",
    "菸": "yān",
    "菹": "zū",
    "菺": "jiān",
    "菻": "lǐn,má",
    "菼": "tǎn",
    "菽": "shū",
    "菾": "tián,tiàn",
    "菿": "dào",
    "萀": "hǔ",
    "萁": "qí",
    "萂": "hé",
    "萃": "cuì",
    "萄": "táo",
    "萅": "chūn",
    "萆": "bì",
    "萇": "cháng",
    "萈": "huán",
    "萉": "fèi",
    "萊": "lái",
    "萋": "qī",
    "萌": "méng",
    "萍": "píng",
    "萎": "wěi",
    "萏": "dàn",
    "萐": "shà",
    "萑": "huán",
    "萒": "yǎn",
    "萓": "yí",
    "萔": "tiáo",
    "萕": "qí",
    "萖": "wǎn",
    "萗": "cè",
    "萘": "nài",
    "萙": "zhěn",
    "萚": "tuò",
    "萛": "jiū",
    "萜": "tiē",
    "萝": "luó",
    "萞": "bì",
    "萟": "yì",
    "萠": "pān",
    "萡": "bó",
    "萢": "pāo",
    "萣": "dìng",
    "萤": "yíng",
    "营": "yíng",
    "萦": "yíng",
    "萧": "xiāo",
    "萨": "sà",
    "萩": "qiū",
    "萪": "kē",
    "萫": "xiāng",
    "萬": "wàn",
    "萭": "yǔ",
    "萮": "yú",
    "萯": "fù",
    "萰": "liàn",
    "萱": "xuān",
    "萲": "xuān",
    "萳": "nǎn",
    "萴": "cè",
    "萵": "wō",
    "萶": "chǔn",
    "萷": "shāo",
    "萸": "yú",
    "萹": "biān",
    "萺": "mào",
    "萻": "ān",
    "萼": "è",
    "落": "luò,là,lào",
    "萾": "yíng",
    "萿": "kuò",
    "葀": "kuò",
    "葁": "jiāng",
    "葂": "miǎn",
    "葃": "zuò",
    "葄": "zuò",
    "葅": "zū",
    "葆": "bǎo",
    "葇": "róu",
    "葈": "xǐ",
    "葉": "yè",
    "葊": "ān",
    "葋": "qú",
    "葌": "jiān",
    "葍": "fú",
    "葎": "lǜ",
    "葏": "jīng",
    "葐": "pén",
    "葑": "fēng",
    "葒": "hóng",
    "葓": "hóng",
    "葔": "hóu",
    "葕": "xìng",
    "葖": "tū",
    "著": "zhù,zhuó,zhe",
    "葘": "zī",
    "葙": "xiāng",
    "葚": "shèn",
    "葛": "gé,gě",
    "葜": "qiā",
    "葝": "qíng",
    "葞": "mǐ",
    "葟": "huáng",
    "葠": "shēn",
    "葡": "pú",
    "葢": "gài",
    "董": "dǒng",
    "葤": "zhòu",
    "葥": "qián",
    "葦": "wěi",
    "葧": "bó",
    "葨": "wēi",
    "葩": "pā",
    "葪": "jì",
    "葫": "hú",
    "葬": "zàng",
    "葭": "jiā",
    "葮": "duàn",
    "葯": "yào",
    "葰": "jùn",
    "葱": "cōng",
    "葲": "quán",
    "葳": "wēi",
    "葴": "zhēn",
    "葵": "kuí",
    "葶": "tíng",
    "葷": "hūn",
    "葸": "xǐ",
    "葹": "shī",
    "葺": "qì",
    "葻": "lán",
    "葼": "zōng",
    "葽": "yāo",
    "葾": "yuān",
    "葿": "méi",
    "蒀": "yūn",
    "蒁": "shù",
    "蒂": "dì",
    "蒃": "zhuàn",
    "蒄": "guān",
    "蒅": "rǎn",
    "蒆": "xuē",
    "蒇": "chǎn",
    "蒈": "kǎi",
    "蒉": "kuì,kuài",
    "蒊": "huā",
    "蒋": "jiǎng",
    "蒌": "lóu",
    "蒍": "wěi",
    "蒎": "pài",
    "蒏": "yòng",
    "蒐": "sōu",
    "蒑": "yīn",
    "蒒": "shī",
    "蒓": "chún",
    "蒔": "shì,shí",
    "蒕": "yūn",
    "蒖": "zhēn",
    "蒗": "làng",
    "蒘": "rú,ná",
    "蒙": "mēng,méng,měng",
    "蒚": "lì",
    "蒛": "quē",
    "蒜": "suàn",
    "蒝": "yuán,huán",
    "蒞": "lì",
    "蒟": "jǔ",
    "蒠": "xī",
    "蒡": "bàng",
    "蒢": "chú",
    "蒣": "xú,shú",
    "蒤": "tú",
    "蒥": "liú",
    "蒦": "huò",
    "蒧": "diǎn",
    "蒨": "qiàn",
    "蒩": "zū,jù",
    "蒪": "pò",
    "蒫": "cuó",
    "蒬": "yuān",
    "蒭": "chú",
    "蒮": "yù",
    "蒯": "kuǎi",
    "蒰": "pán",
    "蒱": "pú",
    "蒲": "pú",
    "蒳": "nà",
    "蒴": "shuò",
    "蒵": "xí,xì",
    "蒶": "fén",
    "蒷": "yún",
    "蒸": "zhēng",
    "蒹": "jiān",
    "蒺": "jí",
    "蒻": "ruò",
    "蒼": "cāng",
    "蒽": "ēn",
    "蒾": "mí",
    "蒿": "hāo",
    "蓀": "sūn",
    "蓁": "zhēn",
    "蓂": "míng",
    "蓃": "sōu,sǒu",
    "蓄": "xù",
    "蓅": "liú",
    "蓆": "xí",
    "蓇": "gū",
    "蓈": "láng",
    "蓉": "róng",
    "蓊": "wěng",
    "蓋": "gài,gě,hé",
    "蓌": "cuò",
    "蓍": "shī",
    "蓎": "táng",
    "蓏": "luǒ",
    "蓐": "rù",
    "蓑": "suō",
    "蓒": "xuān",
    "蓓": "bèi",
    "蓔": "yǎo,zhuó",
    "蓕": "guì",
    "蓖": "bì",
    "蓗": "zǒng",
    "蓘": "gǔn",
    "蓙": "zuò",
    "蓚": "tiáo",
    "蓛": "cè",
    "蓜": "pèi",
    "蓝": "lán",
    "蓞": "dàn",
    "蓟": "jì",
    "蓠": "lí",
    "蓡": "shēn",
    "蓢": "lǎng",
    "蓣": "yù",
    "蓤": "líng",
    "蓥": "yíng",
    "蓦": "mò",
    "蓧": "diào,tiáo,dí",
    "蓨": "tiáo",
    "蓩": "mǎo",
    "蓪": "tōng",
    "蓫": "zhú",
    "蓬": "péng",
    "蓭": "ān",
    "蓮": "lián",
    "蓯": "cōng",
    "蓰": "xǐ",
    "蓱": "píng",
    "蓲": "qiū,xū,fū",
    "蓳": "jǐn",
    "蓴": "chún",
    "蓵": "jié",
    "蓶": "wéi",
    "蓷": "tuī",
    "蓸": "cáo",
    "蓹": "yù",
    "蓺": "yì",
    "蓻": "zí,jú",
    "蓼": "liǎo,lù",
    "蓽": "bì",
    "蓾": "lǔ",
    "蓿": "xù",
    "蔀": "bù",
    "蔁": "zhāng",
    "蔂": "léi",
    "蔃": "qiáng",
    "蔄": "màn",
    "蔅": "yán",
    "蔆": "líng",
    "蔇": "jì",
    "蔈": "biāo",
    "蔉": "gǔn",
    "蔊": "hàn",
    "蔋": "dí",
    "蔌": "sù",
    "蔍": "lù",
    "蔎": "shè",
    "蔏": "shāng",
    "蔐": "dí",
    "蔑": "miè",
    "蔒": "hūn",
    "蔓": "màn,wàn",
    "蔔": "bo",
    "蔕": "dì",
    "蔖": "cuó",
    "蔗": "zhè",
    "蔘": "shēn",
    "蔙": "xuàn",
    "蔚": "wèi",
    "蔛": "hú",
    "蔜": "áo",
    "蔝": "mǐ",
    "蔞": "lóu",
    "蔟": "cù",
    "蔠": "zhōng",
    "蔡": "cài",
    "蔢": "pó",
    "蔣": "jiǎng",
    "蔤": "mì",
    "蔥": "cōng",
    "蔦": "niǎo",
    "蔧": "huì",
    "蔨": "juàn",
    "蔩": "yín",
    "蔪": "jiān",
    "蔫": "niān",
    "蔬": "shū",
    "蔭": "yīn",
    "蔮": "guó",
    "蔯": "chén",
    "蔰": "hù",
    "蔱": "shā",
    "蔲": "kòu",
    "蔳": "qiàn",
    "蔴": "má",
    "蔵": "zàng",
    "蔶": "zé",
    "蔷": "qiáng",
    "蔸": "dōu",
    "蔹": "liǎn",
    "蔺": "lìn",
    "蔻": "kòu",
    "蔼": "ǎi",
    "蔽": "bì",
    "蔾": "lí",
    "蔿": "wěi",
    "蕀": "jí",
    "蕁": "qián,xún",
    "蕂": "shèng",
    "蕃": "fán",
    "蕄": "méng",
    "蕅": "ǒu",
    "蕆": "chǎn",
    "蕇": "diǎn",
    "蕈": "xùn",
    "蕉": "jiāo",
    "蕊": "ruǐ",
    "蕋": "ruǐ",
    "蕌": "lěi",
    "蕍": "yú",
    "蕎": "qiáo",
    "蕏": "zhū",
    "蕐": "huá",
    "蕑": "jiān",
    "蕒": "mǎi",
    "蕓": "yún",
    "蕔": "bāo",
    "蕕": "yóu",
    "蕖": "qú",
    "蕗": "lù",
    "蕘": "ráo",
    "蕙": "huì",
    "蕚": "è",
    "蕛": "tí",
    "蕜": "fěi",
    "蕝": "jué",
    "蕞": "zuì",
    "蕟": "fà",
    "蕠": "rú",
    "蕡": "fén",
    "蕢": "kuì",
    "蕣": "shùn",
    "蕤": "ruí",
    "蕥": "yǎ",
    "蕦": "xū",
    "蕧": "fù",
    "蕨": "jué",
    "蕩": "dàng",
    "蕪": "wú",
    "蕫": "dǒng",
    "蕬": "sī",
    "蕭": "xiāo",
    "蕮": "xì",
    "蕯": "sà",
    "蕰": "yùn",
    "蕱": "shāo",
    "蕲": "qí",
    "蕳": "jiān",
    "蕴": "yùn",
    "蕵": "sūn",
    "蕶": "líng",
    "蕷": "yù",
    "蕸": "xiá",
    "蕹": "wèng",
    "蕺": "jí",
    "蕻": "hòng",
    "蕼": "sì",
    "蕽": "nóng",
    "蕾": "lěi",
    "蕿": "xuān",
    "薀": "yùn",
    "薁": "yù",
    "薂": "xí,xiào",
    "薃": "hào",
    "薄": "báo,bó,bò",
    "薅": "hāo",
    "薆": "ài",
    "薇": "wēi",
    "薈": "huì",
    "薉": "huì",
    "薊": "jì",
    "薋": "cí,zī",
    "薌": "xiāng",
    "薍": "wàn,luàn",
    "薎": "miè",
    "薏": "yì",
    "薐": "léng",
    "薑": "jiāng",
    "薒": "càn",
    "薓": "shēn",
    "薔": "qiáng,sè",
    "薕": "lián",
    "薖": "kē",
    "薗": "yuán",
    "薘": "dá",
    "薙": "tì",
    "薚": "tāng",
    "薛": "xuē",
    "薜": "bì",
    "薝": "zhān",
    "薞": "sūn",
    "薟": "xiān,liǎn",
    "薠": "fán",
    "薡": "dǐng",
    "薢": "xiè",
    "薣": "gǔ",
    "薤": "xiè",
    "薥": "shǔ",
    "薦": "jiàn",
    "薧": "hāo,kǎo",
    "薨": "hōng",
    "薩": "sà",
    "薪": "xīn",
    "薫": "xūn",
    "薬": "yào",
    "薭": "bài",
    "薮": "sǒu",
    "薯": "shǔ",
    "薰": "xūn",
    "薱": "duì",
    "薲": "pín",
    "薳": "yuǎn,wěi",
    "薴": "níng",
    "薵": "chóu,zhòu",
    "薶": "mái,wō",
    "薷": "rú",
    "薸": "piáo",
    "薹": "tái",
    "薺": "jì,qí",
    "薻": "zǎo",
    "薼": "chén",
    "薽": "zhēn",
    "薾": "ěr",
    "薿": "nǐ",
    "藀": "yíng",
    "藁": "gǎo",
    "藂": "cóng",
    "藃": "xiāo,hào",
    "藄": "qí",
    "藅": "fá",
    "藆": "jiǎn",
    "藇": "xù,yù,xū",
    "藈": "kuí",
    "藉": "jiè,jí",
    "藊": "biǎn",
    "藋": "diào,zhuó",
    "藌": "mí",
    "藍": "lán",
    "藎": "jìn",
    "藏": "cáng,zàng",
    "藐": "miǎo",
    "藑": "qióng",
    "藒": "qì",
    "藓": "xiǎn",
    "藔": "liáo",
    "藕": "ǒu",
    "藖": "xián",
    "藗": "sù",
    "藘": "lǘ",
    "藙": "yì",
    "藚": "xù",
    "藛": "xiě",
    "藜": "lí",
    "藝": "yì",
    "藞": "lǎ",
    "藟": "lěi",
    "藠": "jiào",
    "藡": "dí",
    "藢": "zhǐ",
    "藣": "bēi",
    "藤": "téng",
    "藥": "yào",
    "藦": "mò",
    "藧": "huàn",
    "藨": "biāo,pāo",
    "藩": "fān",
    "藪": "sǒu",
    "藫": "tán",
    "藬": "tuī",
    "藭": "qióng",
    "藮": "qiáo",
    "藯": "wèi",
    "藰": "liú,liǔ",
    "藱": "huì,huí",
    "藲": "ōu",
    "藳": "gǎo",
    "藴": "yùn",
    "藵": "bǎo",
    "藶": "lì",
    "藷": "shǔ",
    "藸": "zhū,chú",
    "藹": "ǎi",
    "藺": "lìn",
    "藻": "zǎo",
    "藼": "xuān",
    "藽": "qìn",
    "藾": "lài",
    "藿": "huò",
    "蘀": "tuò",
    "蘁": "wù",
    "蘂": "ruǐ",
    "蘃": "ruǐ",
    "蘄": "qí",
    "蘅": "héng",
    "蘆": "lú",
    "蘇": "sū",
    "蘈": "tuí",
    "蘉": "máng",
    "蘊": "yùn",
    "蘋": "pín,píng",
    "蘌": "yù",
    "蘍": "xūn",
    "蘎": "jì",
    "蘏": "jiōng",
    "蘐": "xuān",
    "蘑": "mó",
    "蘒": "qiū",
    "蘓": "sū",
    "蘔": "jiōng",
    "蘕": "péng",
    "蘖": "niè",
    "蘗": "bò",
    "蘘": "ráng",
    "蘙": "yì",
    "蘚": "xiǎn",
    "蘛": "yú",
    "蘜": "jú",
    "蘝": "liǎn",
    "蘞": "liǎn",
    "蘟": "yǐn",
    "蘠": "qiáng",
    "蘡": "yīng",
    "蘢": "lóng",
    "蘣": "tǒu",
    "蘤": "huā",
    "蘥": "yuè",
    "蘦": "lìng",
    "蘧": "qú",
    "蘨": "yáo",
    "蘩": "fán",
    "蘪": "mí",
    "蘫": "lán",
    "蘬": "guī",
    "蘭": "lán",
    "蘮": "jì",
    "蘯": "dàng",
    "蘰": "màn",
    "蘱": "lèi",
    "蘲": "léi",
    "蘳": "huī",
    "蘴": "fēng",
    "蘵": "zhī",
    "蘶": "wèi",
    "蘷": "kuí",
    "蘸": "zhàn",
    "蘹": "huái",
    "蘺": "lí",
    "蘻": "jì",
    "蘼": "mí",
    "蘽": "lěi",
    "蘾": "huài",
    "蘿": "luó",
    "虀": "jī",
    "虁": "kuí",
    "虂": "lù",
    "虃": "jiān",
    "虄": "null",
    "虅": "téng",
    "虆": "léi",
    "虇": "quǎn",
    "虈": "xiāo",
    "虉": "yì",
    "虊": "luán",
    "虋": "mén",
    "虌": "biē",
    "虍": "hū",
    "虎": "hǔ",
    "虏": "lǔ",
    "虐": "nüè",
    "虑": "lǜ",
    "虒": "sī",
    "虓": "xiāo",
    "虔": "qián",
    "處": "chǔ",
    "虖": "hū",
    "虗": "xū",
    "虘": "cuó",
    "虙": "fú",
    "虚": "xū",
    "虛": "xū",
    "虜": "lǔ",
    "虝": "hǔ",
    "虞": "yú",
    "號": "hào,háo",
    "虠": "jiāo",
    "虡": "jù",
    "虢": "guó",
    "虣": "bào",
    "虤": "yán",
    "虥": "zhàn",
    "虦": "zhàn",
    "虧": "kuī",
    "虨": "bīn",
    "虩": "xì",
    "虪": "shù",
    "虫": "chóng",
    "虬": "qiú",
    "虭": "diāo",
    "虮": "jǐ",
    "虯": "qiú",
    "虰": "dīng",
    "虱": "shī",
    "虲": "xiā",
    "虳": "jué",
    "虴": "zhé",
    "虵": "shé",
    "虶": "yú",
    "虷": "hán",
    "虸": "zǐ",
    "虹": "hóng",
    "虺": "huǐ,huī",
    "虻": "méng",
    "虼": "gè",
    "虽": "suī",
    "虾": "xiā,hā",
    "虿": "chài",
    "蚀": "shí",
    "蚁": "yǐ",
    "蚂": "mǎ,mā,mà",
    "蚃": "xiǎng",
    "蚄": "fāng,bàng",
    "蚅": "è",
    "蚆": "bā",
    "蚇": "chǐ",
    "蚈": "qiān",
    "蚉": "wén",
    "蚊": "wén",
    "蚋": "ruì",
    "蚌": "bàng,bèng",
    "蚍": "pí",
    "蚎": "yuè",
    "蚏": "yuè",
    "蚐": "jūn",
    "蚑": "qí",
    "蚒": "tóng",
    "蚓": "yǐn",
    "蚔": "qí,zhǐ",
    "蚕": "cán",
    "蚖": "yuán,wán",
    "蚗": "jué,quē",
    "蚘": "huí",
    "蚙": "qín,qián",
    "蚚": "qí",
    "蚛": "zhòng",
    "蚜": "yá",
    "蚝": "háo",
    "蚞": "mù",
    "蚟": "wáng",
    "蚠": "fén",
    "蚡": "fén",
    "蚢": "háng",
    "蚣": "gōng,zhōng",
    "蚤": "zǎo",
    "蚥": "fù,fǔ",
    "蚦": "rán",
    "蚧": "jiè",
    "蚨": "fú",
    "蚩": "chī",
    "蚪": "dǒu",
    "蚫": "bào",
    "蚬": "xiǎn",
    "蚭": "ní",
    "蚮": "dài,dé",
    "蚯": "qiū",
    "蚰": "yóu",
    "蚱": "zhà",
    "蚲": "píng",
    "蚳": "chí",
    "蚴": "yòu",
    "蚵": "kē",
    "蚶": "hān",
    "蚷": "jù",
    "蚸": "lì",
    "蚹": "fù",
    "蚺": "rán",
    "蚻": "zhá",
    "蚼": "gǒu,qú,xù",
    "蚽": "pí",
    "蚾": "pí,bǒ",
    "蚿": "xián",
    "蛀": "zhù",
    "蛁": "diāo",
    "蛂": "bié",
    "蛃": "bīng",
    "蛄": "gū",
    "蛅": "zhān",
    "蛆": "qū",
    "蛇": "shé,yí",
    "蛈": "tiě",
    "蛉": "líng",
    "蛊": "gǔ",
    "蛋": "dàn",
    "蛌": "tún",
    "蛍": "yíng",
    "蛎": "lì",
    "蛏": "chēng",
    "蛐": "qū",
    "蛑": "móu",
    "蛒": "gé,luò",
    "蛓": "cì",
    "蛔": "huí",
    "蛕": "huí",
    "蛖": "máng,bàng",
    "蛗": "fù",
    "蛘": "yáng",
    "蛙": "wā",
    "蛚": "liè",
    "蛛": "zhū",
    "蛜": "yī",
    "蛝": "xián",
    "蛞": "kuò",
    "蛟": "jiāo",
    "蛠": "lì",
    "蛡": "yì,xǔ",
    "蛢": "píng",
    "蛣": "jié",
    "蛤": "gé,há",
    "蛥": "shé",
    "蛦": "yí",
    "蛧": "wǎng",
    "蛨": "mò",
    "蛩": "qióng",
    "蛪": "qiè,ní",
    "蛫": "guǐ",
    "蛬": "qióng",
    "蛭": "zhì",
    "蛮": "mán",
    "蛯": "lǎo",
    "蛰": "zhé",
    "蛱": "jiá",
    "蛲": "náo",
    "蛳": "sī",
    "蛴": "qí",
    "蛵": "xíng",
    "蛶": "jiè",
    "蛷": "qiú",
    "蛸": "xiāo",
    "蛹": "yǒng",
    "蛺": "jiá",
    "蛻": "tuì",
    "蛼": "chē",
    "蛽": "bèi",
    "蛾": "é,yǐ",
    "蛿": "hàn",
    "蜀": "shǔ",
    "蜁": "xuán",
    "蜂": "fēng",
    "蜃": "shèn",
    "蜄": "shèn",
    "蜅": "fǔ",
    "蜆": "xiǎn",
    "蜇": "zhé",
    "蜈": "wú",
    "蜉": "fú",
    "蜊": "lì",
    "蜋": "láng",
    "蜌": "bì",
    "蜍": "chú",
    "蜎": "yuān",
    "蜏": "yǒu",
    "蜐": "jié",
    "蜑": "dàn",
    "蜒": "yán",
    "蜓": "tíng",
    "蜔": "diàn",
    "蜕": "tuì",
    "蜖": "huí",
    "蜗": "wō",
    "蜘": "zhī",
    "蜙": "zhōng",
    "蜚": "fēi",
    "蜛": "jū",
    "蜜": "mì",
    "蜝": "qí",
    "蜞": "qí",
    "蜟": "yù",
    "蜠": "jùn",
    "蜡": "là",
    "蜢": "měng",
    "蜣": "qiāng",
    "蜤": "sī",
    "蜥": "xī",
    "蜦": "lún",
    "蜧": "lì",
    "蜨": "dié",
    "蜩": "tiáo",
    "蜪": "táo",
    "蜫": "kūn",
    "蜬": "hán",
    "蜭": "hàn",
    "蜮": "yù",
    "蜯": "bàng",
    "蜰": "féi",
    "蜱": "pí",
    "蜲": "wēi",
    "蜳": "dūn",
    "蜴": "yì",
    "蜵": "yuān",
    "蜶": "suò",
    "蜷": "quán",
    "蜸": "qiǎn",
    "蜹": "ruì",
    "蜺": "ní",
    "蜻": "qīng",
    "蜼": "wèi",
    "蜽": "liǎng",
    "蜾": "guǒ",
    "蜿": "wān",
    "蝀": "dōng",
    "蝁": "è",
    "蝂": "bǎn",
    "蝃": "dì",
    "蝄": "wǎng",
    "蝅": "cán",
    "蝆": "yǎng",
    "蝇": "yíng",
    "蝈": "guō",
    "蝉": "chán",
    "蝊": "dìng",
    "蝋": "là",
    "蝌": "kē",
    "蝍": "jí",
    "蝎": "xiē",
    "蝏": "tíng",
    "蝐": "mào",
    "蝑": "xū",
    "蝒": "mián",
    "蝓": "yú",
    "蝔": "jiē",
    "蝕": "shí",
    "蝖": "xuān",
    "蝗": "huáng",
    "蝘": "yǎn",
    "蝙": "biān",
    "蝚": "róu",
    "蝛": "wēi",
    "蝜": "fù",
    "蝝": "yuán",
    "蝞": "mèi",
    "蝟": "wèi",
    "蝠": "fú",
    "蝡": "rú",
    "蝢": "xié",
    "蝣": "yóu",
    "蝤": "qiú",
    "蝥": "máo",
    "蝦": "xiā,hā",
    "蝧": "yīng",
    "蝨": "shī",
    "蝩": "chóng",
    "蝪": "tāng",
    "蝫": "zhū",
    "蝬": "zōng",
    "蝭": "dì",
    "蝮": "fù",
    "蝯": "yuán",
    "蝰": "kuí",
    "蝱": "méng",
    "蝲": "là",
    "蝳": "dài",
    "蝴": "hú",
    "蝵": "qiū",
    "蝶": "dié",
    "蝷": "lì",
    "蝸": "wō",
    "蝹": "yūn",
    "蝺": "qǔ",
    "蝻": "nǎn",
    "蝼": "lóu",
    "蝽": "chūn",
    "蝾": "róng",
    "蝿": "yíng",
    "螀": "jiāng",
    "螁": "tuì",
    "螂": "láng",
    "螃": "páng",
    "螄": "sī",
    "螅": "xī",
    "螆": "cì",
    "螇": "xī,qī",
    "螈": "yuán",
    "螉": "wēng",
    "螊": "lián",
    "螋": "sōu",
    "螌": "bān",
    "融": "róng",
    "螎": "róng",
    "螏": "jí",
    "螐": "wū",
    "螑": "xiù",
    "螒": "hàn",
    "螓": "qín",
    "螔": "yí",
    "螕": "bī,pí",
    "螖": "huá",
    "螗": "táng",
    "螘": "yǐ",
    "螙": "dù",
    "螚": "nài,něng",
    "螛": "hé,xiá",
    "螜": "hú",
    "螝": "guì,huǐ",
    "螞": "mǎ,mā,mà",
    "螟": "míng",
    "螠": "yì",
    "螡": "wén",
    "螢": "yíng",
    "螣": "téng",
    "螤": "zhōng",
    "螥": "cāng",
    "螦": "sāo",
    "螧": "qí",
    "螨": "mǎn",
    "螩": "dāo",
    "螪": "shāng",
    "螫": "shì,zhē",
    "螬": "cáo",
    "螭": "chī",
    "螮": "dì",
    "螯": "áo",
    "螰": "lù",
    "螱": "wèi",
    "螲": "dié,zhì",
    "螳": "táng",
    "螴": "chén",
    "螵": "piāo",
    "螶": "qú,jù",
    "螷": "pí",
    "螸": "yú",
    "螹": "chán,jiàn",
    "螺": "luó",
    "螻": "lóu",
    "螼": "qǐn",
    "螽": "zhōng",
    "螾": "yǐn",
    "螿": "jiāng",
    "蟀": "shuài",
    "蟁": "wén",
    "蟂": "xiāo",
    "蟃": "wàn",
    "蟄": "zhé",
    "蟅": "zhè",
    "蟆": "má,mò",
    "蟇": "má",
    "蟈": "guō",
    "蟉": "liú",
    "蟊": "máo",
    "蟋": "xī",
    "蟌": "cōng",
    "蟍": "lí",
    "蟎": "mǎn",
    "蟏": "xiāo",
    "蟐": "chán",
    "蟑": "zhāng",
    "蟒": "mǎng,měng",
    "蟓": "xiàng",
    "蟔": "mò",
    "蟕": "zuī",
    "蟖": "sī",
    "蟗": "qiū",
    "蟘": "tè",
    "蟙": "zhí",
    "蟚": "péng",
    "蟛": "péng",
    "蟜": "jiǎo",
    "蟝": "qú",
    "蟞": "biē,bié",
    "蟟": "liáo",
    "蟠": "pán",
    "蟡": "guǐ",
    "蟢": "xǐ",
    "蟣": "jǐ",
    "蟤": "zhuān",
    "蟥": "huáng",
    "蟦": "fèi,bēn",
    "蟧": "láo,liáo",
    "蟨": "jué",
    "蟩": "jué",
    "蟪": "huì",
    "蟫": "yín,xún",
    "蟬": "chán",
    "蟭": "jiāo",
    "蟮": "shàn",
    "蟯": "náo",
    "蟰": "xiāo",
    "蟱": "wú",
    "蟲": "chóng",
    "蟳": "xún",
    "蟴": "sī",
    "蟵": "chú",
    "蟶": "chēng",
    "蟷": "dāng",
    "蟸": "lí",
    "蟹": "xiè",
    "蟺": "shàn",
    "蟻": "yǐ",
    "蟼": "jǐng",
    "蟽": "dá",
    "蟾": "chán",
    "蟿": "qì",
    "蠀": "cī",
    "蠁": "xiǎng",
    "蠂": "shè",
    "蠃": "luǒ",
    "蠄": "qín",
    "蠅": "yíng",
    "蠆": "chài",
    "蠇": "lì",
    "蠈": "zéi",
    "蠉": "xuān",
    "蠊": "lián",
    "蠋": "zhú",
    "蠌": "zé",
    "蠍": "xiē",
    "蠎": "mǎng",
    "蠏": "xiè",
    "蠐": "qí",
    "蠑": "róng",
    "蠒": "jiǎn",
    "蠓": "měng",
    "蠔": "háo",
    "蠕": "rú",
    "蠖": "huò",
    "蠗": "zhuó",
    "蠘": "jié",
    "蠙": "pín",
    "蠚": "hē",
    "蠛": "miè",
    "蠜": "fán",
    "蠝": "lěi",
    "蠞": "jié",
    "蠟": "là",
    "蠠": "mǐn",
    "蠡": "lǐ",
    "蠢": "chǔn",
    "蠣": "lì",
    "蠤": "qiū",
    "蠥": "niè",
    "蠦": "lú",
    "蠧": "dù",
    "蠨": "xiāo",
    "蠩": "zhū",
    "蠪": "lóng",
    "蠫": "lí",
    "蠬": "lóng",
    "蠭": "fēng",
    "蠮": "yē",
    "蠯": "pí",
    "蠰": "náng",
    "蠱": "gǔ",
    "蠲": "juān",
    "蠳": "yīng",
    "蠴": "shǔ",
    "蠵": "xī",
    "蠶": "cán",
    "蠷": "qú",
    "蠸": "quán",
    "蠹": "dù",
    "蠺": "cán",
    "蠻": "mán",
    "蠼": "qú",
    "蠽": "jié",
    "蠾": "zhú",
    "蠿": "zhuó",
    "血": "xiě,xuè",
    "衁": "huāng",
    "衂": "nǜ",
    "衃": "pēi",
    "衄": "nǜ",
    "衅": "xìn",
    "衆": "zhòng",
    "衇": "mài",
    "衈": "ěr",
    "衉": "kè",
    "衊": "miè",
    "衋": "xì",
    "行": "xíng,háng",
    "衍": "yǎn",
    "衎": "kàn",
    "衏": "yuàn",
    "衐": "qú",
    "衑": "líng",
    "衒": "xuàn",
    "術": "shù",
    "衔": "xián",
    "衕": "tòng",
    "衖": "xiàng",
    "街": "jiē",
    "衘": "xián",
    "衙": "yá",
    "衚": "hú",
    "衛": "wèi",
    "衜": "dào",
    "衝": "chōng",
    "衞": "wèi",
    "衟": "dào",
    "衠": "zhūn",
    "衡": "héng",
    "衢": "qú",
    "衣": "yī",
    "衤": "yī",
    "补": "bǔ",
    "衦": "gǎn",
    "衧": "yú",
    "表": "biǎo",
    "衩": "chà",
    "衪": "yì",
    "衫": "shān",
    "衬": "chèn",
    "衭": "fū",
    "衮": "gǔn",
    "衯": "fēn",
    "衰": "shuāi,cuī",
    "衱": "jié",
    "衲": "nà",
    "衳": "zhōng",
    "衴": "dǎn",
    "衵": "rì",
    "衶": "zhòng",
    "衷": "zhōng",
    "衸": "jiè",
    "衹": "zhǐ",
    "衺": "xié",
    "衻": "rán",
    "衼": "zhī",
    "衽": "rèn",
    "衾": "qīn",
    "衿": "jīn",
    "袀": "jūn",
    "袁": "yuán",
    "袂": "mèi",
    "袃": "chài",
    "袄": "ǎo",
    "袅": "niǎo",
    "袆": "huī",
    "袇": "rán",
    "袈": "jiā",
    "袉": "tuó,tuō",
    "袊": "lǐng,líng",
    "袋": "dài",
    "袌": "bào,páo,pào",
    "袍": "páo",
    "袎": "yào",
    "袏": "zuò",
    "袐": "bì",
    "袑": "shào",
    "袒": "tǎn",
    "袓": "jù,jiē",
    "袔": "hè,kè",
    "袕": "xué",
    "袖": "xiù",
    "袗": "zhěn",
    "袘": "yí,yì",
    "袙": "pà",
    "袚": "fú",
    "袛": "dī",
    "袜": "wà",
    "袝": "fù",
    "袞": "gǔn",
    "袟": "zhì",
    "袠": "zhì",
    "袡": "rán",
    "袢": "pàn",
    "袣": "yì",
    "袤": "mào",
    "袥": "tuō",
    "袦": "nà,jué",
    "袧": "gōu",
    "袨": "xuàn",
    "袩": "zhé",
    "袪": "qū",
    "被": "bèi,pī",
    "袬": "yù",
    "袭": "xí",
    "袮": "mí",
    "袯": "bó",
    "袰": "bō",
    "袱": "fú",
    "袲": "chǐ,nuǒ",
    "袳": "chǐ,qǐ,duǒ,nuǒ",
    "袴": "kù",
    "袵": "rèn",
    "袶": "péng",
    "袷": "jiá,jié,qiā",
    "袸": "jiàn,zùn",
    "袹": "bó,mò",
    "袺": "jié",
    "袻": "ér",
    "袼": "gē",
    "袽": "rú",
    "袾": "zhū",
    "袿": "guī,guà",
    "裀": "yīn",
    "裁": "cái",
    "裂": "liè,liě",
    "裃": "kǎ",
    "裄": "háng",
    "装": "zhuāng",
    "裆": "dāng",
    "裇": "xū",
    "裈": "kūn",
    "裉": "kèn",
    "裊": "niǎo",
    "裋": "shù",
    "裌": "jiá",
    "裍": "kǔn",
    "裎": "chéng,chěng",
    "裏": "lǐ",
    "裐": "juān",
    "裑": "shēn",
    "裒": "póu",
    "裓": "gé,jiē",
    "裔": "yì",
    "裕": "yù",
    "裖": "zhěn",
    "裗": "liú",
    "裘": "qiú",
    "裙": "qún",
    "裚": "jì",
    "裛": "yì",
    "補": "bǔ",
    "裝": "zhuāng",
    "裞": "shuì",
    "裟": "shā",
    "裠": "qún",
    "裡": "lǐ",
    "裢": "lián",
    "裣": "liǎn",
    "裤": "kù",
    "裥": "jiǎn",
    "裦": "bāo",
    "裧": "chān",
    "裨": "pí,bì",
    "裩": "kūn",
    "裪": "táo",
    "裫": "yuàn",
    "裬": "líng",
    "裭": "chǐ",
    "裮": "chāng",
    "裯": "chóu,dāo",
    "裰": "duō",
    "裱": "biǎo",
    "裲": "liǎng",
    "裳": "cháng,shang",
    "裴": "péi",
    "裵": "péi",
    "裶": "fēi",
    "裷": "yuān,gǔn",
    "裸": "luǒ",
    "裹": "guǒ",
    "裺": "yǎn,ān",
    "裻": "dú",
    "裼": "xī,tì",
    "製": "zhì",
    "裾": "jū",
    "裿": "yǐ",
    "褀": "qí",
    "褁": "guǒ",
    "褂": "guà",
    "褃": "kèn",
    "褄": "qī",
    "褅": "tì",
    "褆": "tí",
    "複": "fù",
    "褈": "chóng",
    "褉": "xiè",
    "褊": "biǎn",
    "褋": "dié",
    "褌": "kūn",
    "褍": "duān",
    "褎": "xiù",
    "褏": "xiù",
    "褐": "hè",
    "褑": "yuàn",
    "褒": "bāo",
    "褓": "bǎo",
    "褔": "fù,fú",
    "褕": "yú",
    "褖": "tuàn",
    "褗": "yǎn",
    "褘": "huī",
    "褙": "bèi",
    "褚": "zhǔ,chǔ",
    "褛": "lǚ",
    "褜": "páo",
    "褝": "dān",
    "褞": "yùn",
    "褟": "tā",
    "褠": "gōu",
    "褡": "dā",
    "褢": "huái",
    "褣": "róng",
    "褤": "yuán",
    "褥": "rù",
    "褦": "nài",
    "褧": "jiǒng",
    "褨": "suǒ",
    "褩": "bān",
    "褪": "tuì,tùn",
    "褫": "chǐ",
    "褬": "sǎng",
    "褭": "niǎo",
    "褮": "yīng",
    "褯": "jiè",
    "褰": "qiān",
    "褱": "huái",
    "褲": "kù",
    "褳": "lián",
    "褴": "lán",
    "褵": "lí",
    "褶": "zhě",
    "褷": "shī",
    "褸": "lǚ",
    "褹": "yì",
    "褺": "diē",
    "褻": "xiè",
    "褼": "xiān",
    "褽": "wèi",
    "褾": "biǎo",
    "褿": "cáo",
    "襀": "jì",
    "襁": "qiǎng",
    "襂": "sēn",
    "襃": "bāo",
    "襄": "xiāng",
    "襅": "bì",
    "襆": "fú",
    "襇": "jiǎn",
    "襈": "zhuàn",
    "襉": "jiǎn",
    "襊": "cuì",
    "襋": "jí",
    "襌": "dān",
    "襍": "zá",
    "襎": "fán",
    "襏": "bó",
    "襐": "xiàng",
    "襑": "xín",
    "襒": "bié",
    "襓": "ráo",
    "襔": "mǎn",
    "襕": "lán",
    "襖": "ǎo",
    "襗": "zé",
    "襘": "guì",
    "襙": "cào",
    "襚": "suì",
    "襛": "nóng",
    "襜": "chān",
    "襝": "liǎn",
    "襞": "bì",
    "襟": "jīn",
    "襠": "dāng",
    "襡": "shǔ",
    "襢": "tǎn",
    "襣": "bì",
    "襤": "lán",
    "襥": "fú",
    "襦": "rú",
    "襧": "zhǐ",
    "襨": "null",
    "襩": "shǔ",
    "襪": "wà",
    "襫": "shì",
    "襬": "bǎi",
    "襭": "xié",
    "襮": "bó",
    "襯": "chèn",
    "襰": "lǎi",
    "襱": "lóng",
    "襲": "xí",
    "襳": "xiān",
    "襴": "lán",
    "襵": "zhě",
    "襶": "dài",
    "襷": "jǔ",
    "襸": "zàn",
    "襹": "shī",
    "襺": "jiǎn",
    "襻": "pàn",
    "襼": "yì",
    "襽": "lán",
    "襾": "yà",
    "西": "xī",
    "覀": "yà",
    "要": "yào,yāo",
    "覂": "fěng",
    "覃": "tán,qín",
    "覄": "fù",
    "覅": "fiào",
    "覆": "fù",
    "覇": "bà",
    "覈": "hé",
    "覉": "jī",
    "覊": "jī",
    "見": "jiàn,xiàn",
    "覌": "guān,guàn",
    "覍": "biàn",
    "覎": "yàn",
    "規": "guī",
    "覐": "jué,jiào",
    "覑": "piǎn",
    "覒": "mào",
    "覓": "mì",
    "覔": "mì",
    "覕": "piē,miè",
    "視": "shì",
    "覗": "sì",
    "覘": "chān",
    "覙": "zhěn",
    "覚": "jué,jiào",
    "覛": "mì",
    "覜": "tiào",
    "覝": "lián",
    "覞": "yào",
    "覟": "zhì",
    "覠": "jūn",
    "覡": "xī",
    "覢": "shǎn",
    "覣": "wēi",
    "覤": "xì",
    "覥": "tiǎn",
    "覦": "yú",
    "覧": "lǎn",
    "覨": "è",
    "覩": "dǔ",
    "親": "qīn,qìng",
    "覫": "pǎng",
    "覬": "jì",
    "覭": "míng",
    "覮": "yíng,yǐng",
    "覯": "gòu",
    "覰": "qū,qù",
    "覱": "zhàn,zhān",
    "覲": "jìn",
    "観": "guān,guàn",
    "覴": "dèng",
    "覵": "jiàn,biǎn",
    "覶": "luó,luǎn",
    "覷": "qù,qū",
    "覸": "jiàn",
    "覹": "wéi",
    "覺": "jué,jiào",
    "覻": "qù,qū",
    "覼": "luó",
    "覽": "lǎn",
    "覾": "shěn",
    "覿": "dí",
    "觀": "guān,guàn",
    "见": "jiàn,xiàn",
    "观": "guān,guàn",
    "觃": "yàn",
    "规": "guī",
    "觅": "mì",
    "视": "shì",
    "觇": "chān",
    "览": "lǎn",
    "觉": "jué,jiào",
    "觊": "jì",
    "觋": "xí",
    "觌": "dí",
    "觍": "tiǎn",
    "觎": "yú",
    "觏": "gòu",
    "觐": "jìn",
    "觑": "qù,qū",
    "角": "jiǎo,jué",
    "觓": "qiú",
    "觔": "jīn",
    "觕": "cū",
    "觖": "jué",
    "觗": "zhì",
    "觘": "chào",
    "觙": "jí",
    "觚": "gū",
    "觛": "dàn",
    "觜": "zī,zuǐ",
    "觝": "dǐ",
    "觞": "shāng",
    "觟": "huà,xiè",
    "觠": "quán",
    "觡": "gé",
    "觢": "shì",
    "解": "jiě,jiè,xiè",
    "觤": "guǐ",
    "觥": "gōng",
    "触": "chù",
    "觧": "jiě,jiè,xiè",
    "觨": "hùn",
    "觩": "qiú",
    "觪": "xīng",
    "觫": "sù",
    "觬": "ní",
    "觭": "jī,qí",
    "觮": "jué",
    "觯": "zhì",
    "觰": "zhā",
    "觱": "bì",
    "觲": "xīng",
    "觳": "hú",
    "觴": "shāng",
    "觵": "gōng",
    "觶": "zhì",
    "觷": "xué,hù",
    "觸": "chù",
    "觹": "xī",
    "觺": "yí",
    "觻": "lì,lù",
    "觼": "jué",
    "觽": "xī",
    "觾": "yàn",
    "觿": "xī",
    "言": "yán",
    "訁": "yán",
    "訂": "dìng",
    "訃": "fù",
    "訄": "qiú",
    "訅": "qiú",
    "訆": "jiào",
    "訇": "hōng",
    "計": "jì",
    "訉": "fàn",
    "訊": "xùn",
    "訋": "diào",
    "訌": "hòng",
    "訍": "chài",
    "討": "tǎo",
    "訏": "xū",
    "訐": "jié",
    "訑": "dàn",
    "訒": "rèn",
    "訓": "xùn",
    "訔": "yín",
    "訕": "shàn",
    "訖": "qì",
    "託": "tuō",
    "記": "jì",
    "訙": "xùn",
    "訚": "yín",
    "訛": "é",
    "訜": "fēn",
    "訝": "yà",
    "訞": "yāo",
    "訟": "sòng",
    "訠": "shěn",
    "訡": "yín",
    "訢": "xīn",
    "訣": "jué",
    "訤": "xiáo",
    "訥": "nè",
    "訦": "chén",
    "訧": "yóu",
    "訨": "zhǐ",
    "訩": "xiōng",
    "訪": "fǎng",
    "訫": "xìn",
    "訬": "chāo",
    "設": "shè",
    "訮": "yán",
    "訯": "sǎ",
    "訰": "zhùn",
    "許": "xū",
    "訲": "yì",
    "訳": "yì",
    "訴": "sù",
    "訵": "chī",
    "訶": "hē",
    "訷": "shēn",
    "訸": "hé",
    "訹": "xù",
    "診": "zhěn",
    "註": "zhù",
    "証": "zhèng",
    "訽": "gòu",
    "訾": "zī",
    "訿": "zǐ",
    "詀": "zhān",
    "詁": "gǔ",
    "詂": "fù",
    "詃": "jiǎn",
    "詄": "dié",
    "詅": "líng",
    "詆": "dǐ",
    "詇": "yàng",
    "詈": "lì",
    "詉": "náo",
    "詊": "pàn",
    "詋": "zhòu",
    "詌": "gàn",
    "詍": "yì",
    "詎": "jù",
    "詏": "yào",
    "詐": "zhà",
    "詑": "tuó",
    "詒": "yí,dài",
    "詓": "qǔ",
    "詔": "zhào",
    "評": "píng",
    "詖": "bì",
    "詗": "xiòng",
    "詘": "qū",
    "詙": "bá",
    "詚": "dá",
    "詛": "zǔ",
    "詜": "tāo",
    "詝": "zhǔ",
    "詞": "cí",
    "詟": "zhé",
    "詠": "yǒng",
    "詡": "xǔ",
    "詢": "xún",
    "詣": "yì",
    "詤": "huǎng",
    "詥": "hé",
    "試": "shì",
    "詧": "chá",
    "詨": "xiào",
    "詩": "shī",
    "詪": "hěn",
    "詫": "chà",
    "詬": "gòu",
    "詭": "guǐ",
    "詮": "quán",
    "詯": "huì",
    "詰": "jié",
    "話": "huà",
    "該": "gāi",
    "詳": "xiáng",
    "詴": "wēi",
    "詵": "shēn",
    "詶": "chóu",
    "詷": "tóng",
    "詸": "mí",
    "詹": "zhān",
    "詺": "míng",
    "詻": "luò",
    "詼": "huī",
    "詽": "yán",
    "詾": "xiōng",
    "詿": "guà",
    "誀": "èr",
    "誁": "bìng",
    "誂": "tiǎo,diào",
    "誃": "yí,chǐ,chì",
    "誄": "lěi",
    "誅": "zhū",
    "誆": "kuāng",
    "誇": "kuā,kuà",
    "誈": "wū",
    "誉": "yù",
    "誊": "téng",
    "誋": "jì",
    "誌": "zhì",
    "認": "rèn",
    "誎": "cù",
    "誏": "lǎng,làng",
    "誐": "é",
    "誑": "kuáng",
    "誒": "ēi,éi,ěi,èi,xī",
    "誓": "shì",
    "誔": "tǐng",
    "誕": "dàn",
    "誖": "bèi,bó",
    "誗": "chán",
    "誘": "yòu",
    "誙": "kēng",
    "誚": "qiào",
    "誛": "qīn",
    "誜": "shuà",
    "誝": "ān",
    "語": "yǔ,yù",
    "誟": "xiào",
    "誠": "chéng",
    "誡": "jiè",
    "誢": "xiàn",
    "誣": "wū",
    "誤": "wù",
    "誥": "gào",
    "誦": "sòng",
    "誧": "bū",
    "誨": "huì",
    "誩": "jìng",
    "說": "shuō,shuì,yuè",
    "誫": "zhèn",
    "説": "shuō,shuì,yuè",
    "読": "dú",
    "誮": "huā",
    "誯": "chàng",
    "誰": "shuí,shéi",
    "誱": "jié",
    "課": "kè",
    "誳": "qū,juè",
    "誴": "cóng",
    "誵": "xiáo",
    "誶": "suì",
    "誷": "wǎng",
    "誸": "xián",
    "誹": "fěi",
    "誺": "chī,lài",
    "誻": "tà",
    "誼": "yì",
    "誽": "nì,ná",
    "誾": "yín",
    "調": "diào,tiáo",
    "諀": "pǐ,bēi",
    "諁": "zhuó",
    "諂": "chǎn",
    "諃": "chēn",
    "諄": "zhūn",
    "諅": "jì,jī",
    "諆": "qī",
    "談": "tán",
    "諈": "zhuì",
    "諉": "wěi",
    "諊": "jū",
    "請": "qǐng",
    "諌": "dǒng",
    "諍": "zhèng",
    "諎": "zé,zuò,zhǎ,cuò",
    "諏": "zōu",
    "諐": "qiān",
    "諑": "zhuó",
    "諒": "liàng",
    "諓": "jiàn",
    "諔": "chù,jí",
    "諕": "xià,háo",
    "論": "lùn,lún",
    "諗": "shěn",
    "諘": "biǎo",
    "諙": "huà",
    "諚": "biàn",
    "諛": "yú",
    "諜": "dié",
    "諝": "xū",
    "諞": "piǎn",
    "諟": "shì,dì",
    "諠": "xuān",
    "諡": "shì",
    "諢": "hùn",
    "諣": "huà,guā",
    "諤": "è",
    "諥": "zhòng",
    "諦": "dì",
    "諧": "xié",
    "諨": "fú",
    "諩": "pǔ",
    "諪": "tíng",
    "諫": "jiàn",
    "諬": "qǐ",
    "諭": "yù",
    "諮": "zī",
    "諯": "zhuān",
    "諰": "xǐ,shāi,āi",
    "諱": "huì",
    "諲": "yīn",
    "諳": "ān",
    "諴": "xián",
    "諵": "nán,nàn",
    "諶": "chén",
    "諷": "fěng",
    "諸": "zhū",
    "諹": "yáng",
    "諺": "yàn",
    "諻": "huáng",
    "諼": "xuān",
    "諽": "gé",
    "諾": "nuò",
    "諿": "xǔ",
    "謀": "móu",
    "謁": "yè",
    "謂": "wèi",
    "謃": "xīng",
    "謄": "téng",
    "謅": "zhōu",
    "謆": "shàn",
    "謇": "jiǎn",
    "謈": "bó",
    "謉": "kuì",
    "謊": "huǎng",
    "謋": "huò",
    "謌": "gē",
    "謍": "yíng",
    "謎": "mí",
    "謏": "xiǎo",
    "謐": "mì",
    "謑": "xǐ",
    "謒": "qiāng",
    "謓": "chēn",
    "謔": "xuè",
    "謕": "tí",
    "謖": "sù",
    "謗": "bàng",
    "謘": "chí",
    "謙": "qiān",
    "謚": "shì",
    "講": "jiǎng",
    "謜": "yuán",
    "謝": "xiè",
    "謞": "hè",
    "謟": "tāo",
    "謠": "yáo",
    "謡": "yáo",
    "謢": "lū",
    "謣": "yú",
    "謤": "biāo",
    "謥": "còng",
    "謦": "qǐng",
    "謧": "lí",
    "謨": "mó",
    "謩": "mó",
    "謪": "shāng",
    "謫": "zhé",
    "謬": "miù",
    "謭": "jiǎn",
    "謮": "zé",
    "謯": "jiē",
    "謰": "lián",
    "謱": "lóu",
    "謲": "càn",
    "謳": "ōu",
    "謴": "gùn",
    "謵": "xí",
    "謶": "zhuó",
    "謷": "áo",
    "謸": "áo",
    "謹": "jǐn",
    "謺": "zhé",
    "謻": "yí",
    "謼": "hū",
    "謽": "jiàng",
    "謾": "mán",
    "謿": "cháo",
    "譀": "hàn",
    "譁": "huá",
    "譂": "chǎn",
    "譃": "xū",
    "譄": "zēng",
    "譅": "sè",
    "譆": "xī",
    "譇": "zhā",
    "譈": "duì",
    "證": "zhèng",
    "譊": "náo",
    "譋": "lán",
    "譌": "é",
    "譍": "yīng",
    "譎": "jué",
    "譏": "jī",
    "譐": "zǔn",
    "譑": "jiǎo",
    "譒": "bò",
    "譓": "huì",
    "譔": "zhuàn",
    "譕": "wú",
    "譖": "zèn",
    "譗": "zhá",
    "識": "shí",
    "譙": "qiáo",
    "譚": "tán",
    "譛": "jiàn",
    "譜": "pǔ",
    "譝": "shéng",
    "譞": "xuān",
    "譟": "zào",
    "譠": "tán",
    "譡": "dǎng",
    "譢": "suì",
    "譣": "xiǎn",
    "譤": "jī",
    "譥": "jiào",
    "警": "jǐng",
    "譧": "zhàn",
    "譨": "nóng",
    "譩": "yī",
    "譪": "ǎi",
    "譫": "zhān",
    "譬": "pì",
    "譭": "huǐ",
    "譮": "huà",
    "譯": "yì",
    "議": "yì",
    "譱": "shàn",
    "譲": "ràng",
    "譳": "ròu",
    "譴": "qiǎn",
    "譵": "duì",
    "譶": "tà",
    "護": "hù",
    "譸": "zhōu",
    "譹": "háo",
    "譺": "ài",
    "譻": "yīng",
    "譼": "jiān",
    "譽": "yù",
    "譾": "jiǎn",
    "譿": "huì",
    "讀": "dú",
    "讁": "zhé",
    "讂": "juàn,xuān",
    "讃": "zàn",
    "讄": "lěi",
    "讅": "shěn",
    "讆": "wèi",
    "讇": "chǎn",
    "讈": "lì",
    "讉": "yí,tuī",
    "變": "biàn",
    "讋": "zhé",
    "讌": "yàn",
    "讍": "è",
    "讎": "chóu",
    "讏": "wèi",
    "讐": "chóu",
    "讑": "yào",
    "讒": "chán",
    "讓": "ràng",
    "讔": "yǐn",
    "讕": "lán",
    "讖": "chèn",
    "讗": "xié",
    "讘": "niè",
    "讙": "huān",
    "讚": "zàn",
    "讛": "yì",
    "讜": "dǎng",
    "讝": "zhán",
    "讞": "yàn",
    "讟": "dú",
    "讠": "yán",
    "计": "jì",
    "订": "dìng",
    "讣": "fù",
    "认": "rèn",
    "讥": "jī",
    "讦": "jié",
    "讧": "hòng",
    "讨": "tǎo",
    "让": "ràng",
    "讪": "shàn",
    "讫": "qì",
    "讬": "tuō",
    "训": "xùn",
    "议": "yì",
    "讯": "xùn",
    "记": "jì",
    "讱": "rèn",
    "讲": "jiǎng",
    "讳": "huì",
    "讴": "ōu",
    "讵": "jù",
    "讶": "yà",
    "讷": "nè",
    "许": "xǔ,hǔ",
    "讹": "é",
    "论": "lùn,lún",
    "讻": "xiōng",
    "讼": "sòng",
    "讽": "fěng",
    "设": "shè",
    "访": "fǎng",
    "诀": "jué",
    "证": "zhèng",
    "诂": "gǔ",
    "诃": "hē",
    "评": "píng",
    "诅": "zǔ",
    "识": "shí,zhì",
    "诇": "xiòng",
    "诈": "zhà",
    "诉": "sù",
    "诊": "zhěn",
    "诋": "dǐ",
    "诌": "zhōu",
    "词": "cí",
    "诎": "qū",
    "诏": "zhào",
    "诐": "bì",
    "译": "yì",
    "诒": "yí,dài",
    "诓": "kuāng",
    "诔": "lěi",
    "试": "shì",
    "诖": "guà",
    "诗": "shī",
    "诘": "jié,jí",
    "诙": "huī",
    "诚": "chéng",
    "诛": "zhū",
    "诜": "shēn",
    "话": "huà",
    "诞": "dàn",
    "诟": "gòu",
    "诠": "quán",
    "诡": "guǐ",
    "询": "xún",
    "诣": "yì",
    "诤": "zhèng",
    "该": "gāi",
    "详": "xiáng,yáng",
    "诧": "chà",
    "诨": "hùn",
    "诩": "xǔ",
    "诪": "zhōu,chóu",
    "诫": "jiè",
    "诬": "wū",
    "语": "yǔ,yù",
    "诮": "qiào",
    "误": "wù",
    "诰": "gào",
    "诱": "yòu",
    "诲": "huì",
    "诳": "kuáng",
    "说": "shuō,shuì,yuè",
    "诵": "sòng",
    "诶": "ēi,éi,ěi,èi,xī",
    "请": "qǐng",
    "诸": "zhū",
    "诹": "zōu",
    "诺": "nuò",
    "读": "dú,dòu",
    "诼": "zhuó",
    "诽": "fěi",
    "课": "kè",
    "诿": "wěi",
    "谀": "yú",
    "谁": "shuí",
    "谂": "shěn",
    "调": "tiáo,diào,zhōu",
    "谄": "chǎn",
    "谅": "liàng",
    "谆": "zhūn",
    "谇": "suì",
    "谈": "tán",
    "谉": "shěn",
    "谊": "yì",
    "谋": "móu",
    "谌": "chén,shèn",
    "谍": "dié",
    "谎": "huǎng",
    "谏": "jiàn",
    "谐": "xié",
    "谑": "xuè",
    "谒": "yè",
    "谓": "wèi",
    "谔": "è",
    "谕": "yù",
    "谖": "xuān",
    "谗": "chán",
    "谘": "zī",
    "谙": "ān",
    "谚": "yàn",
    "谛": "dì",
    "谜": "mí",
    "谝": "piǎn",
    "谞": "xū",
    "谟": "mó",
    "谠": "dǎng",
    "谡": "sù",
    "谢": "xiè",
    "谣": "yáo",
    "谤": "bàng",
    "谥": "shì",
    "谦": "qiān",
    "谧": "mì",
    "谨": "jǐn",
    "谩": "mán",
    "谪": "zhé",
    "谫": "jiǎn",
    "谬": "miù",
    "谭": "tán",
    "谮": "zèn",
    "谯": "qiáo",
    "谰": "lán",
    "谱": "pǔ",
    "谲": "jué",
    "谳": "yàn",
    "谴": "qiǎn",
    "谵": "zhān",
    "谶": "chèn",
    "谷": "gǔ",
    "谸": "qiān",
    "谹": "hóng",
    "谺": "xiā",
    "谻": "jí",
    "谼": "hóng",
    "谽": "hān",
    "谾": "hōng",
    "谿": "xī",
    "豀": "xī",
    "豁": "huō,huò,huá",
    "豂": "liáo",
    "豃": "hǎn",
    "豄": "dú",
    "豅": "lóng",
    "豆": "dòu",
    "豇": "jiāng",
    "豈": "qǐ,kǎi",
    "豉": "chǐ",
    "豊": "lǐ",
    "豋": "dēng",
    "豌": "wān",
    "豍": "bī",
    "豎": "shù",
    "豏": "xiàn",
    "豐": "fēng",
    "豑": "zhì",
    "豒": "zhì",
    "豓": "yàn",
    "豔": "yàn",
    "豕": "shǐ",
    "豖": "chù",
    "豗": "huī",
    "豘": "tún",
    "豙": "yì",
    "豚": "tún",
    "豛": "yì",
    "豜": "jiān",
    "豝": "bā",
    "豞": "hòu",
    "豟": "è",
    "豠": "chú",
    "象": "xiàng",
    "豢": "huàn",
    "豣": "jiān,yàn",
    "豤": "kěn",
    "豥": "gāi",
    "豦": "jù",
    "豧": "fú",
    "豨": "xī",
    "豩": "bīn",
    "豪": "háo",
    "豫": "yù",
    "豬": "zhū",
    "豭": "jiā",
    "豮": "fén",
    "豯": "xī",
    "豰": "hù",
    "豱": "wēn",
    "豲": "huán",
    "豳": "bīn",
    "豴": "dí",
    "豵": "zōng",
    "豶": "fén",
    "豷": "yì",
    "豸": "zhì",
    "豹": "bào",
    "豺": "chái",
    "豻": "àn",
    "豼": "pí",
    "豽": "nà",
    "豾": "pī",
    "豿": "gǒu",
    "貀": "nà",
    "貁": "yòu",
    "貂": "diāo",
    "貃": "mò",
    "貄": "sì",
    "貅": "xiū",
    "貆": "huán,huān",
    "貇": "kěn,kūn",
    "貈": "hé,mò",
    "貉": "hé,háo,mò",
    "貊": "mò",
    "貋": "àn",
    "貌": "mào",
    "貍": "lí",
    "貎": "ní",
    "貏": "bǐ",
    "貐": "yǔ",
    "貑": "jiā",
    "貒": "tuān,tuàn",
    "貓": "māo,máo",
    "貔": "pí",
    "貕": "xī",
    "貖": "yì",
    "貗": "jù,lóu",
    "貘": "mò",
    "貙": "chū",
    "貚": "tán",
    "貛": "huān",
    "貜": "jué",
    "貝": "bèi",
    "貞": "zhēn",
    "貟": "yuán,yún,yùn",
    "負": "fù",
    "財": "cái",
    "貢": "gòng",
    "貣": "dài",
    "貤": "yì,yí",
    "貥": "háng",
    "貦": "wán",
    "貧": "pín",
    "貨": "huò",
    "販": "fàn",
    "貪": "tān",
    "貫": "guàn",
    "責": "zé,zhài",
    "貭": "zhì",
    "貮": "èr",
    "貯": "zhù",
    "貰": "shì",
    "貱": "bì",
    "貲": "zī",
    "貳": "èr",
    "貴": "guì",
    "貵": "piǎn",
    "貶": "biǎn",
    "買": "mǎi",
    "貸": "dài",
    "貹": "shèng",
    "貺": "kuàng",
    "費": "fèi",
    "貼": "tiē",
    "貽": "yí",
    "貾": "chí",
    "貿": "mào",
    "賀": "hè",
    "賁": "bì,bēn",
    "賂": "lù",
    "賃": "lìn",
    "賄": "huì",
    "賅": "gāi",
    "賆": "pián",
    "資": "zī",
    "賈": "jiǎ,gǔ,jià",
    "賉": "xù",
    "賊": "zéi",
    "賋": "jiǎo",
    "賌": "gāi",
    "賍": "zāng",
    "賎": "jiàn",
    "賏": "yīng",
    "賐": "jùn",
    "賑": "zhèn",
    "賒": "shē",
    "賓": "bīn",
    "賔": "bīn",
    "賕": "qiú",
    "賖": "shē",
    "賗": "chuàn",
    "賘": "zāng",
    "賙": "zhōu",
    "賚": "lài",
    "賛": "zàn",
    "賜": "cì",
    "賝": "chēn",
    "賞": "shǎng",
    "賟": "tiǎn",
    "賠": "péi",
    "賡": "gēng",
    "賢": "xián",
    "賣": "mài",
    "賤": "jiàn",
    "賥": "suì",
    "賦": "fù",
    "賧": "dǎn",
    "賨": "cóng",
    "賩": "cóng",
    "質": "zhì",
    "賫": "jī",
    "賬": "zhàng",
    "賭": "dǔ",
    "賮": "jìn",
    "賯": "xiōng,mín",
    "賰": "chǔn",
    "賱": "yǔn",
    "賲": "bǎo",
    "賳": "zāi",
    "賴": "lài",
    "賵": "fèng",
    "賶": "càng",
    "賷": "jī",
    "賸": "shèng",
    "賹": "ài",
    "賺": "zhuàn,zuàn",
    "賻": "fù",
    "購": "gòu",
    "賽": "sài",
    "賾": "zé",
    "賿": "liáo",
    "贀": "yì",
    "贁": "bài",
    "贂": "chěn",
    "贃": "wàn,zhuàn",
    "贄": "zhì",
    "贅": "zhuì",
    "贆": "biāo",
    "贇": "yūn",
    "贈": "zèng",
    "贉": "dàn",
    "贊": "zàn",
    "贋": "yàn",
    "贌": "pú",
    "贍": "shàn",
    "贎": "wàn",
    "贏": "yíng",
    "贐": "jìn",
    "贑": "gàn",
    "贒": "xián",
    "贓": "zāng",
    "贔": "bì",
    "贕": "dú",
    "贖": "shú",
    "贗": "yàn",
    "贘": "shǎng",
    "贙": "xuàn",
    "贚": "lòng",
    "贛": "gàn",
    "贜": "zāng",
    "贝": "bèi",
    "贞": "zhēn",
    "负": "fù",
    "贠": "yuán,yùn",
    "贡": "gòng",
    "财": "cái",
    "责": "zé,zhài",
    "贤": "xián",
    "败": "bài",
    "账": "zhàng",
    "货": "huò",
    "质": "zhì",
    "贩": "fàn",
    "贪": "tān",
    "贫": "pín",
    "贬": "biǎn",
    "购": "gòu",
    "贮": "zhù",
    "贯": "guàn",
    "贰": "èr",
    "贱": "jiàn",
    "贲": "bì,bēn",
    "贳": "shì",
    "贴": "tiē",
    "贵": "guì",
    "贶": "kuàng",
    "贷": "dài",
    "贸": "mào",
    "费": "fèi",
    "贺": "hè",
    "贻": "yí",
    "贼": "zéi",
    "贽": "zhì",
    "贾": "jiǎ,gǔ",
    "贿": "huì",
    "赀": "zī",
    "赁": "lìn",
    "赂": "lù",
    "赃": "zāng",
    "资": "zī",
    "赅": "gāi",
    "赆": "jìn",
    "赇": "qiú",
    "赈": "zhèn",
    "赉": "lài",
    "赊": "shē",
    "赋": "fù",
    "赌": "dǔ",
    "赍": "jī",
    "赎": "shú",
    "赏": "shǎng",
    "赐": "cì",
    "赑": "bì",
    "赒": "zhōu",
    "赓": "gēng",
    "赔": "péi",
    "赕": "dǎn",
    "赖": "lài",
    "赗": "fèng",
    "赘": "zhuì",
    "赙": "fù",
    "赚": "zhuàn",
    "赛": "sài",
    "赜": "zé",
    "赝": "yàn",
    "赞": "zàn",
    "赟": "yūn",
    "赠": "zèng",
    "赡": "shàn",
    "赢": "yíng",
    "赣": "gàn",
    "赤": "chì",
    "赥": "xī",
    "赦": "shè",
    "赧": "nǎn",
    "赨": "tóng",
    "赩": "xì",
    "赪": "chēng",
    "赫": "hè",
    "赬": "chēng",
    "赭": "zhě",
    "赮": "xiá",
    "赯": "táng",
    "走": "zǒu",
    "赱": "zǒu",
    "赲": "lì",
    "赳": "jiū",
    "赴": "fù",
    "赵": "zhào",
    "赶": "gǎn",
    "起": "qǐ",
    "赸": "shàn",
    "赹": "qióng",
    "赺": "yǐn",
    "赻": "xiǎn",
    "赼": "zī",
    "赽": "jué",
    "赾": "qǐn",
    "赿": "chí",
    "趀": "cī",
    "趁": "chèn",
    "趂": "chèn",
    "趃": "dié,tú",
    "趄": "qiè,jū",
    "超": "chāo",
    "趆": "dī",
    "趇": "xì",
    "趈": "zhān",
    "趉": "jué",
    "越": "yuè",
    "趋": "qū,cù",
    "趌": "jí,jié",
    "趍": "qū",
    "趎": "chú",
    "趏": "guā,huó",
    "趐": "xuè",
    "趑": "zī",
    "趒": "tiào",
    "趓": "duǒ",
    "趔": "liè",
    "趕": "gǎn",
    "趖": "suō",
    "趗": "cù",
    "趘": "xí",
    "趙": "zhào",
    "趚": "sù",
    "趛": "yǐn",
    "趜": "jú",
    "趝": "jiàn",
    "趞": "què,qì,jí",
    "趟": "tàng,tāng",
    "趠": "chuō,zhuó",
    "趡": "cuǐ",
    "趢": "lù",
    "趣": "qù,cù",
    "趤": "dàng",
    "趥": "qiū",
    "趦": "zī",
    "趧": "tí",
    "趨": "qū,cù",
    "趩": "chì",
    "趪": "huáng",
    "趫": "qiáo",
    "趬": "qiāo",
    "趭": "jiào",
    "趮": "zào",
    "趯": "tì,yuè",
    "趰": "ěr",
    "趱": "zǎn",
    "趲": "zǎn",
    "足": "zú",
    "趴": "pā",
    "趵": "bào,bō",
    "趶": "kuà,wù",
    "趷": "kē",
    "趸": "dǔn",
    "趹": "jué,guì",
    "趺": "fū",
    "趻": "chěn",
    "趼": "jiǎn",
    "趽": "fāng,fàng,páng",
    "趾": "zhǐ",
    "趿": "tā",
    "跀": "yuè",
    "跁": "bà,páo",
    "跂": "qí,qǐ",
    "跃": "yuè",
    "跄": "qiāng,qiàng",
    "跅": "tuò",
    "跆": "tái",
    "跇": "yì",
    "跈": "jiàn,chén",
    "跉": "líng",
    "跊": "mèi",
    "跋": "bá",
    "跌": "diē",
    "跍": "kū",
    "跎": "tuó",
    "跏": "jiā",
    "跐": "cī,cǐ",
    "跑": "pǎo,páo",
    "跒": "qiǎ",
    "跓": "zhù",
    "跔": "jū",
    "跕": "diǎn,tiē,dié",
    "跖": "zhí",
    "跗": "fū",
    "跘": "pán,bàn",
    "跙": "jū,jù,qiè",
    "跚": "shān",
    "跛": "bǒ",
    "跜": "ní",
    "距": "jù",
    "跞": "lì,luò",
    "跟": "gēn",
    "跠": "yí",
    "跡": "jì",
    "跢": "dài,duò,duō,chí",
    "跣": "xiǎn",
    "跤": "jiāo",
    "跥": "duò",
    "跦": "zhū",
    "跧": "quán",
    "跨": "kuà",
    "跩": "zhuǎi",
    "跪": "guì",
    "跫": "qióng",
    "跬": "kuǐ",
    "跭": "xiáng",
    "跮": "dié",
    "路": "lù",
    "跰": "pián,bèng",
    "跱": "zhì",
    "跲": "jié",
    "跳": "tiào,táo",
    "跴": "cǎi",
    "践": "jiàn",
    "跶": "dá",
    "跷": "qiāo",
    "跸": "bì",
    "跹": "xiān",
    "跺": "duò",
    "跻": "jī",
    "跼": "jú",
    "跽": "jì",
    "跾": "shū,chōu",
    "跿": "tú",
    "踀": "chuò",
    "踁": "jìng",
    "踂": "niè",
    "踃": "xiāo",
    "踄": "bù",
    "踅": "xué",
    "踆": "qūn",
    "踇": "mǔ",
    "踈": "shū",
    "踉": "liáng,liàng",
    "踊": "yǒng",
    "踋": "jiǎo",
    "踌": "chóu",
    "踍": "qiāo",
    "踎": "móu",
    "踏": "tà",
    "踐": "jiàn",
    "踑": "jī",
    "踒": "wō",
    "踓": "wěi",
    "踔": "chuō",
    "踕": "jié",
    "踖": "jí",
    "踗": "niè",
    "踘": "jū",
    "踙": "niè",
    "踚": "lún",
    "踛": "lù",
    "踜": "lèng",
    "踝": "huái",
    "踞": "jù",
    "踟": "chí",
    "踠": "wǎn",
    "踡": "quán",
    "踢": "tī",
    "踣": "bó",
    "踤": "zú",
    "踥": "qiè",
    "踦": "qī",
    "踧": "cù",
    "踨": "zōng",
    "踩": "cǎi",
    "踪": "zōng",
    "踫": "pèng",
    "踬": "zhì",
    "踭": "zhēng",
    "踮": "diǎn",
    "踯": "zhí",
    "踰": "yú",
    "踱": "duó",
    "踲": "dùn",
    "踳": "chuǎn",
    "踴": "yǒng",
    "踵": "zhǒng",
    "踶": "dì",
    "踷": "zhě",
    "踸": "chěn",
    "踹": "chuài",
    "踺": "jiàn",
    "踻": "guā",
    "踼": "táng",
    "踽": "jǔ",
    "踾": "fú",
    "踿": "cù",
    "蹀": "dié",
    "蹁": "pián",
    "蹂": "róu",
    "蹃": "nuò",
    "蹄": "tí",
    "蹅": "chǎ",
    "蹆": "tuǐ",
    "蹇": "jiǎn",
    "蹈": "dǎo",
    "蹉": "cuō",
    "蹊": "qī,xī",
    "蹋": "tà",
    "蹌": "qiāng",
    "蹍": "niǎn",
    "蹎": "diān",
    "蹏": "tí",
    "蹐": "jí",
    "蹑": "niè",
    "蹒": "pán",
    "蹓": "liū",
    "蹔": "zàn",
    "蹕": "bì",
    "蹖": "chōng",
    "蹗": "lù",
    "蹘": "liáo",
    "蹙": "cù",
    "蹚": "tāng",
    "蹛": "dài",
    "蹜": "sù",
    "蹝": "xǐ",
    "蹞": "kuǐ",
    "蹟": "jì",
    "蹠": "zhí",
    "蹡": "qiāng",
    "蹢": "dí",
    "蹣": "pán",
    "蹤": "zōng",
    "蹥": "lián",
    "蹦": "bèng",
    "蹧": "zāo",
    "蹨": "niǎn",
    "蹩": "bié",
    "蹪": "tuí",
    "蹫": "jú",
    "蹬": "dēng",
    "蹭": "cèng",
    "蹮": "xiān",
    "蹯": "fán",
    "蹰": "chú",
    "蹱": "zhōng",
    "蹲": "dūn",
    "蹳": "bō",
    "蹴": "cù",
    "蹵": "cù",
    "蹶": "jué,juě",
    "蹷": "jué",
    "蹸": "lìn",
    "蹹": "tà",
    "蹺": "qiāo",
    "蹻": "qiāo",
    "蹼": "pǔ",
    "蹽": "liāo",
    "蹾": "dūn",
    "蹿": "cuān",
    "躀": "guàn",
    "躁": "zào",
    "躂": "tà",
    "躃": "bì",
    "躄": "bì",
    "躅": "zhú",
    "躆": "jù",
    "躇": "chú",
    "躈": "qiào",
    "躉": "dǔn",
    "躊": "chóu",
    "躋": "jī",
    "躌": "wǔ",
    "躍": "yuè",
    "躎": "niǎn",
    "躏": "lìn",
    "躐": "liè",
    "躑": "zhí",
    "躒": "lì,luò",
    "躓": "zhì",
    "躔": "chán",
    "躕": "chú",
    "躖": "duàn",
    "躗": "wèi",
    "躘": "lóng,lǒng",
    "躙": "lìn",
    "躚": "xiān",
    "躛": "wèi",
    "躜": "zuān",
    "躝": "lán",
    "躞": "xiè",
    "躟": "ráng",
    "躠": "sǎ,xiè",
    "躡": "niè",
    "躢": "tà",
    "躣": "qú",
    "躤": "jí",
    "躥": "cuān",
    "躦": "zuān",
    "躧": "xǐ",
    "躨": "kuí",
    "躩": "jué",
    "躪": "lìn",
    "身": "shēn",
    "躬": "gōng",
    "躭": "dān",
    "躮": "fēn",
    "躯": "qū",
    "躰": "tǐ",
    "躱": "duǒ",
    "躲": "duǒ",
    "躳": "gōng",
    "躴": "láng",
    "躵": "rěn",
    "躶": "luǒ",
    "躷": "ǎi",
    "躸": "jī",
    "躹": "jū",
    "躺": "tǎng",
    "躻": "kōng",
    "躼": "lào",
    "躽": "yǎn",
    "躾": "měi",
    "躿": "kāng",
    "軀": "qū",
    "軁": "lóu",
    "軂": "lào",
    "軃": "duǒ",
    "軄": "zhí",
    "軅": "yàn",
    "軆": "tǐ",
    "軇": "dào",
    "軈": "yīng",
    "軉": "yù",
    "車": "chē,jū",
    "軋": "yà,zhá,gá",
    "軌": "guǐ",
    "軍": "jūn",
    "軎": "wèi",
    "軏": "yuè",
    "軐": "xìn,xiàn",
    "軑": "dài",
    "軒": "xuān",
    "軓": "fàn,guǐ",
    "軔": "rèn",
    "軕": "shān",
    "軖": "kuáng",
    "軗": "shū",
    "軘": "tún",
    "軙": "chén",
    "軚": "dài",
    "軛": "è",
    "軜": "nà",
    "軝": "qí",
    "軞": "máo",
    "軟": "ruǎn",
    "軠": "kuáng",
    "軡": "qián",
    "転": "zhuàn,zhuǎn",
    "軣": "hōng",
    "軤": "hū",
    "軥": "qú",
    "軦": "kuàng",
    "軧": "dǐ",
    "軨": "líng",
    "軩": "dài",
    "軪": "āo,ào",
    "軫": "zhěn",
    "軬": "fàn",
    "軭": "kuāng",
    "軮": "yǎng",
    "軯": "pēng",
    "軰": "bèi",
    "軱": "gū",
    "軲": "gū",
    "軳": "páo",
    "軴": "zhù",
    "軵": "rǒng",
    "軶": "è",
    "軷": "bá",
    "軸": "zhóu,zhòu",
    "軹": "zhǐ",
    "軺": "yáo",
    "軻": "kē,kě",
    "軼": "yì,dié",
    "軽": "qīng",
    "軾": "shì",
    "軿": "píng",
    "輀": "ér",
    "輁": "gǒng",
    "輂": "jú",
    "較": "jiào",
    "輄": "guāng",
    "輅": "lù",
    "輆": "kǎi",
    "輇": "quán",
    "輈": "zhōu",
    "載": "zài",
    "輊": "zhì",
    "輋": "shē",
    "輌": "liàng",
    "輍": "yù",
    "輎": "shāo",
    "輏": "yóu",
    "輐": "wàn",
    "輑": "yǐn",
    "輒": "zhé",
    "輓": "wǎn",
    "輔": "fǔ",
    "輕": "qīng",
    "輖": "zhōu",
    "輗": "ní",
    "輘": "líng",
    "輙": "zhé",
    "輚": "hàn",
    "輛": "liàng",
    "輜": "zī",
    "輝": "huī",
    "輞": "wǎng",
    "輟": "chuò",
    "輠": "guǒ",
    "輡": "kǎn",
    "輢": "yǐ",
    "輣": "péng",
    "輤": "qiàn",
    "輥": "gǔn",
    "輦": "niǎn",
    "輧": "píng",
    "輨": "guǎn",
    "輩": "bèi",
    "輪": "lún",
    "輫": "pái",
    "輬": "liáng",
    "輭": "ruǎn",
    "輮": "róu",
    "輯": "jí",
    "輰": "yáng",
    "輱": "xián",
    "輲": "chuán",
    "輳": "còu",
    "輴": "chūn",
    "輵": "gé",
    "輶": "yóu",
    "輷": "hōng",
    "輸": "shū",
    "輹": "fù",
    "輺": "zī",
    "輻": "fú",
    "輼": "wēn",
    "輽": "fàn",
    "輾": "zhǎn",
    "輿": "yú",
    "轀": "wēn",
    "轁": "tāo",
    "轂": "gǔ",
    "轃": "zhēn",
    "轄": "xiá",
    "轅": "yuán",
    "轆": "lù",
    "轇": "jiāo",
    "轈": "cháo",
    "轉": "zhuǎn",
    "轊": "wèi",
    "轋": "hūn",
    "轌": "xuě",
    "轍": "zhé",
    "轎": "jiào",
    "轏": "zhàn",
    "轐": "bú",
    "轑": "lǎo",
    "轒": "fén",
    "轓": "fān",
    "轔": "lín",
    "轕": "gé",
    "轖": "sè",
    "轗": "kǎn",
    "轘": "huàn",
    "轙": "yǐ",
    "轚": "jí",
    "轛": "duì",
    "轜": "ér",
    "轝": "yú",
    "轞": "jiàn",
    "轟": "hōng",
    "轠": "léi",
    "轡": "pèi",
    "轢": "lì",
    "轣": "lì",
    "轤": "lú",
    "轥": "lìn",
    "车": "chē,jū",
    "轧": "yà,zhá",
    "轨": "guǐ",
    "轩": "xuān",
    "轪": "dài",
    "轫": "rèn",
    "转": "zhuǎn,zhuàn,zhuǎi",
    "轭": "è",
    "轮": "lún",
    "软": "ruǎn",
    "轰": "hōng",
    "轱": "gū",
    "轲": "kē",
    "轳": "lú",
    "轴": "zhóu,zhòu",
    "轵": "zhǐ",
    "轶": "yì",
    "轷": "hū",
    "轸": "zhěn",
    "轹": "lì",
    "轺": "yáo",
    "轻": "qīng",
    "轼": "shì",
    "载": "zài,zǎi",
    "轾": "zhì",
    "轿": "jiào",
    "辀": "zhōu",
    "辁": "quán",
    "辂": "lù",
    "较": "jiào",
    "辄": "zhé",
    "辅": "fǔ",
    "辆": "liàng",
    "辇": "niǎn",
    "辈": "bèi",
    "辉": "huī",
    "辊": "gǔn",
    "辋": "wǎng",
    "辌": "liáng",
    "辍": "chuò",
    "辎": "zī",
    "辏": "còu",
    "辐": "fú",
    "辑": "jí",
    "辒": "wēn",
    "输": "shū",
    "辔": "pèi",
    "辕": "yuán",
    "辖": "xiá",
    "辗": "zhǎn,niǎn",
    "辘": "lù",
    "辙": "zhé",
    "辚": "lín",
    "辛": "xīn",
    "辜": "gū",
    "辝": "cí",
    "辞": "cí",
    "辟": "pì,bì",
    "辠": "zuì",
    "辡": "biàn",
    "辢": "là",
    "辣": "là",
    "辤": "cí",
    "辥": "xuē",
    "辦": "bàn",
    "辧": "biàn",
    "辨": "biàn",
    "辩": "biàn",
    "辪": "xuē",
    "辫": "biàn",
    "辬": "bān",
    "辭": "cí",
    "辮": "biàn",
    "辯": "biàn",
    "辰": "chén",
    "辱": "rǔ",
    "農": "nóng",
    "辳": "nóng",
    "辴": "zhěn",
    "辵": "chuò",
    "辶": "chuò",
    "辷": "yī",
    "辸": "réng",
    "边": "biān",
    "辺": "dào,biān",
    "辻": "shi",
    "込": "yū",
    "辽": "liáo",
    "达": "dá",
    "辿": "chān",
    "迀": "gān",
    "迁": "qiān",
    "迂": "yū",
    "迃": "yū",
    "迄": "qì",
    "迅": "xùn",
    "迆": "yǐ,yí",
    "过": "guò,guo,guō",
    "迈": "mài",
    "迉": "qī",
    "迊": "zā",
    "迋": "wàng,kuāng",
    "迌": "tù",
    "迍": "zhūn",
    "迎": "yíng",
    "迏": "dá",
    "运": "yùn",
    "近": "jìn",
    "迒": "háng",
    "迓": "yà",
    "返": "fǎn",
    "迕": "wǔ",
    "迖": "dá",
    "迗": "é",
    "还": "hái,huán",
    "这": "zhè,zhèi",
    "迚": "dá",
    "进": "jìn",
    "远": "yuǎn,yuàn",
    "违": "wéi",
    "连": "lián",
    "迟": "chí",
    "迠": "chè",
    "迡": "chí",
    "迢": "tiáo",
    "迣": "zhì,lì",
    "迤": "yǐ,yí",
    "迥": "jiǒng",
    "迦": "jiā",
    "迧": "chén",
    "迨": "dài",
    "迩": "ěr",
    "迪": "dí",
    "迫": "pò,pǎi",
    "迬": "zhù,wǎng",
    "迭": "dié",
    "迮": "zé",
    "迯": "táo",
    "述": "shù",
    "迱": "yǐ,yí",
    "迲": "null",
    "迳": "jìng",
    "迴": "huí",
    "迵": "dòng",
    "迶": "yòu",
    "迷": "mí",
    "迸": "bèng",
    "迹": "jì",
    "迺": "nǎi",
    "迻": "yí",
    "迼": "jié",
    "追": "zhuī,duī",
    "迾": "liè",
    "迿": "xùn",
    "退": "tuì",
    "送": "sòng",
    "适": "shì",
    "逃": "táo",
    "逄": "páng",
    "逅": "hòu",
    "逆": "nì",
    "逇": "dùn",
    "逈": "jiǒng",
    "选": "xuǎn",
    "逊": "xùn",
    "逋": "bū",
    "逌": "yōu",
    "逍": "xiāo",
    "逎": "qiú",
    "透": "tòu",
    "逐": "zhú",
    "逑": "qiú",
    "递": "dì",
    "逓": "dì",
    "途": "tú",
    "逕": "jìng",
    "逖": "tì",
    "逗": "dòu",
    "逘": "yǐ",
    "這": "zhè",
    "通": "tōng",
    "逛": "guàng",
    "逜": "wǔ",
    "逝": "shì",
    "逞": "chěng",
    "速": "sù",
    "造": "zào",
    "逡": "qūn",
    "逢": "féng",
    "連": "lián",
    "逤": "suò",
    "逥": "huí",
    "逦": "lǐ",
    "逧": "gǔ",
    "逨": "lái",
    "逩": "bèn",
    "逪": "cuò",
    "逫": "zhú",
    "逬": "bèng",
    "逭": "huàn",
    "逮": "dài",
    "逯": "lù",
    "逰": "yóu",
    "週": "zhōu",
    "進": "jìn",
    "逳": "yù",
    "逴": "chuō",
    "逵": "kuí",
    "逶": "wēi",
    "逷": "tì",
    "逸": "yì",
    "逹": "dá",
    "逺": "yuǎn",
    "逻": "luó",
    "逼": "bī",
    "逽": "nuò",
    "逾": "yú",
    "逿": "dàng",
    "遀": "suí",
    "遁": "dùn",
    "遂": "suì",
    "遃": "yǎn",
    "遄": "chuán",
    "遅": "chí",
    "遆": "dì,tí",
    "遇": "yù",
    "遈": "shí",
    "遉": "zhēn",
    "遊": "yóu",
    "運": "yùn",
    "遌": "è",
    "遍": "biàn",
    "過": "guò",
    "遏": "è",
    "遐": "xiá",
    "遑": "huáng",
    "遒": "qiú",
    "道": "dào",
    "達": "dá",
    "違": "wéi",
    "遖": "nán",
    "遗": "yí",
    "遘": "gòu",
    "遙": "yáo",
    "遚": "chòu",
    "遛": "liù",
    "遜": "xùn",
    "遝": "tà",
    "遞": "dì",
    "遟": "chí",
    "遠": "yuǎn",
    "遡": "sù",
    "遢": "tà",
    "遣": "qiǎn",
    "遤": "mǎ",
    "遥": "yáo",
    "遦": "guàn",
    "遧": "zhāng",
    "遨": "áo",
    "適": "shì",
    "遪": "cà",
    "遫": "chì",
    "遬": "sù",
    "遭": "zāo",
    "遮": "zhē",
    "遯": "dùn",
    "遰": "dì",
    "遱": "lóu",
    "遲": "chí",
    "遳": "cuō",
    "遴": "lín",
    "遵": "zūn",
    "遶": "rào",
    "遷": "qiān",
    "選": "xuǎn",
    "遹": "yù",
    "遺": "yí",
    "遻": "è",
    "遼": "liáo",
    "遽": "jù",
    "遾": "shì",
    "避": "bì",
    "邀": "yāo",
    "邁": "mài",
    "邂": "xiè",
    "邃": "suì",
    "還": "huán,hái",
    "邅": "zhān",
    "邆": "téng",
    "邇": "ěr",
    "邈": "miǎo",
    "邉": "biān",
    "邊": "biān",
    "邋": "lā",
    "邌": "lí,chí",
    "邍": "yuán",
    "邎": "yáo",
    "邏": "luó",
    "邐": "lǐ",
    "邑": "yì",
    "邒": "tíng",
    "邓": "dèng",
    "邔": "qǐ",
    "邕": "yōng",
    "邖": "shān",
    "邗": "hán",
    "邘": "yú",
    "邙": "máng",
    "邚": "rú",
    "邛": "qióng",
    "邜": "xī",
    "邝": "kuàng",
    "邞": "fū",
    "邟": "kàng,háng",
    "邠": "bīn",
    "邡": "fāng",
    "邢": "xíng",
    "那": "nà,nǎ,nèi,nā",
    "邤": "xīn",
    "邥": "shěn",
    "邦": "bāng",
    "邧": "yuán",
    "邨": "cūn",
    "邩": "huǒ",
    "邪": "xié,yá,yé,yú,xú",
    "邫": "bāng",
    "邬": "wū",
    "邭": "jù",
    "邮": "yóu",
    "邯": "hán",
    "邰": "tái",
    "邱": "qiū",
    "邲": "bì",
    "邳": "pī",
    "邴": "bǐng",
    "邵": "shào",
    "邶": "bèi",
    "邷": "wǎ",
    "邸": "dǐ",
    "邹": "zōu",
    "邺": "yè",
    "邻": "lín",
    "邼": "kuāng",
    "邽": "guī",
    "邾": "zhū",
    "邿": "shī",
    "郀": "kū",
    "郁": "yù",
    "郂": "gāi,hái",
    "郃": "hé",
    "郄": "qiè,xì",
    "郅": "zhì",
    "郆": "jí",
    "郇": "xún,huán",
    "郈": "hòu",
    "郉": "xíng",
    "郊": "jiāo",
    "郋": "xí",
    "郌": "guī",
    "郍": "nà",
    "郎": "láng,làng",
    "郏": "jiá",
    "郐": "kuài",
    "郑": "zhèng",
    "郒": "láng",
    "郓": "yùn",
    "郔": "yán",
    "郕": "chéng",
    "郖": "dòu",
    "郗": "xī",
    "郘": "lǚ",
    "郙": "fǔ",
    "郚": "wú",
    "郛": "fú",
    "郜": "gào",
    "郝": "hǎo",
    "郞": "láng",
    "郟": "jiá",
    "郠": "gěng",
    "郡": "jùn",
    "郢": "yǐng",
    "郣": "bó",
    "郤": "xì",
    "郥": "bèi",
    "郦": "lì,zhí",
    "郧": "yún",
    "部": "bù",
    "郩": "xiáo,ǎo",
    "郪": "qī",
    "郫": "pí",
    "郬": "qīng",
    "郭": "guō",
    "郮": "zhōu",
    "郯": "tán",
    "郰": "zōu",
    "郱": "píng",
    "郲": "lái",
    "郳": "ní",
    "郴": "chēn",
    "郵": "yóu",
    "郶": "bù",
    "郷": "xiāng",
    "郸": "dān",
    "郹": "jú",
    "郺": "yōng",
    "郻": "qiāo",
    "郼": "yī",
    "都": "dōu,dū",
    "郾": "yǎn",
    "郿": "méi",
    "鄀": "ruò",
    "鄁": "bèi",
    "鄂": "è",
    "鄃": "shū",
    "鄄": "juàn",
    "鄅": "yǔ",
    "鄆": "yùn",
    "鄇": "hóu",
    "鄈": "kuí",
    "鄉": "xiāng",
    "鄊": "xiāng",
    "鄋": "sōu",
    "鄌": "táng",
    "鄍": "míng",
    "鄎": "xī",
    "鄏": "rǔ",
    "鄐": "chù",
    "鄑": "zī",
    "鄒": "zōu",
    "鄓": "yì",
    "鄔": "wū",
    "鄕": "xiāng",
    "鄖": "yún",
    "鄗": "hào",
    "鄘": "yōng",
    "鄙": "bǐ",
    "鄚": "mào",
    "鄛": "cháo",
    "鄜": "fū",
    "鄝": "liǎo",
    "鄞": "yín",
    "鄟": "zhuān",
    "鄠": "hù",
    "鄡": "qiāo",
    "鄢": "yān",
    "鄣": "zhāng",
    "鄤": "màn",
    "鄥": "qiāo",
    "鄦": "xǔ",
    "鄧": "dèng",
    "鄨": "bì",
    "鄩": "xún",
    "鄪": "bì",
    "鄫": "zēng",
    "鄬": "wéi",
    "鄭": "zhèng",
    "鄮": "mào",
    "鄯": "shàn",
    "鄰": "lín",
    "鄱": "pó",
    "鄲": "dān",
    "鄳": "méng",
    "鄴": "yè",
    "鄵": "cào",
    "鄶": "kuài",
    "鄷": "fēng",
    "鄸": "méng",
    "鄹": "zōu",
    "鄺": "kuàng",
    "鄻": "liǎn",
    "鄼": "zàn",
    "鄽": "chán",
    "鄾": "yōu",
    "鄿": "qí",
    "酀": "yàn",
    "酁": "chán",
    "酂": "cuó,zàn",
    "酃": "líng",
    "酄": "huān",
    "酅": "xī",
    "酆": "fēng",
    "酇": "cuó,zàn",
    "酈": "lì",
    "酉": "yǒu",
    "酊": "dīng,dǐng",
    "酋": "qiú",
    "酌": "zhuó",
    "配": "pèi",
    "酎": "zhòu",
    "酏": "yǐ",
    "酐": "gān",
    "酑": "yú",
    "酒": "jiǔ",
    "酓": "yǎn",
    "酔": "zuì",
    "酕": "máo",
    "酖": "dān",
    "酗": "xù",
    "酘": "dòu",
    "酙": "zhēn",
    "酚": "fēn",
    "酛": "yuán",
    "酜": "fū",
    "酝": "yùn",
    "酞": "tài",
    "酟": "tiān",
    "酠": "qiǎ",
    "酡": "tuó",
    "酢": "zuò",
    "酣": "hān",
    "酤": "gū",
    "酥": "sū",
    "酦": "pō",
    "酧": "chóu",
    "酨": "zài",
    "酩": "mǐng",
    "酪": "lào",
    "酫": "chuò",
    "酬": "chóu",
    "酭": "yòu",
    "酮": "tóng",
    "酯": "zhǐ",
    "酰": "xiān",
    "酱": "jiàng",
    "酲": "chéng",
    "酳": "yìn",
    "酴": "tú",
    "酵": "jiào",
    "酶": "méi",
    "酷": "kù",
    "酸": "suān",
    "酹": "lèi",
    "酺": "pú",
    "酻": "zuì",
    "酼": "hǎi",
    "酽": "yàn",
    "酾": "shī",
    "酿": "niàng",
    "醀": "wéi",
    "醁": "lù",
    "醂": "lǎn",
    "醃": "yān",
    "醄": "táo",
    "醅": "pēi",
    "醆": "zhǎn",
    "醇": "chún",
    "醈": "tán,dàn",
    "醉": "zuì",
    "醊": "zhuì",
    "醋": "cù",
    "醌": "kūn",
    "醍": "tí,tǐ",
    "醎": "xián",
    "醏": "dū",
    "醐": "hú",
    "醑": "xǔ",
    "醒": "xǐng",
    "醓": "tǎn",
    "醔": "qiú,chōu",
    "醕": "chún",
    "醖": "yùn",
    "醗": "pō,fā",
    "醘": "kē",
    "醙": "sōu",
    "醚": "mí",
    "醛": "quán",
    "醜": "chǒu",
    "醝": "cuō",
    "醞": "yùn",
    "醟": "yòng",
    "醠": "àng",
    "醡": "zhà",
    "醢": "hǎi",
    "醣": "táng",
    "醤": "jiàng",
    "醥": "piǎo",
    "醦": "chǎn,chěn",
    "醧": "yù",
    "醨": "lí",
    "醩": "zāo",
    "醪": "láo",
    "醫": "yī",
    "醬": "jiàng",
    "醭": "bú",
    "醮": "jiào",
    "醯": "xī",
    "醰": "tán",
    "醱": "pō,fā",
    "醲": "nóng",
    "醳": "yì,shì",
    "醴": "lǐ",
    "醵": "jù",
    "醶": "yàn,liǎn,xiān",
    "醷": "yì",
    "醸": "niàng",
    "醹": "rú",
    "醺": "xūn",
    "醻": "chóu",
    "醼": "yàn",
    "醽": "líng",
    "醾": "mí",
    "醿": "mí",
    "釀": "niàng,niáng",
    "釁": "xìn",
    "釂": "jiào",
    "釃": "shī",
    "釄": "mí",
    "釅": "yàn",
    "釆": "biàn",
    "采": "cǎi,cài",
    "釈": "shì",
    "釉": "yòu",
    "释": "shì",
    "釋": "shì",
    "里": "lǐ",
    "重": "zhòng,chóng",
    "野": "yě",
    "量": "liàng,liáng,liang",
    "釐": "lí,xǐ,xī",
    "金": "jīn",
    "釒": "jīn",
    "釓": "gá",
    "釔": "yǐ",
    "釕": "liǎo,liào",
    "釖": "dāo",
    "釗": "zhāo",
    "釘": "dīng,dìng",
    "釙": "pō",
    "釚": "qiú",
    "釛": "hé",
    "釜": "fǔ",
    "針": "zhēn",
    "釞": "zhí",
    "釟": "bā",
    "釠": "luàn",
    "釡": "fǔ",
    "釢": "nǎi",
    "釣": "diào",
    "釤": "shān,shàn",
    "釥": "qiǎo,jiǎo",
    "釦": "kòu",
    "釧": "chuàn",
    "釨": "zǐ",
    "釩": "fán",
    "釪": "huá,yú",
    "釫": "huá,wū",
    "釬": "hàn",
    "釭": "gāng",
    "釮": "qí",
    "釯": "máng",
    "釰": "rì,rèn,jiàn",
    "釱": "dì,dài",
    "釲": "sì",
    "釳": "xì",
    "釴": "yì",
    "釵": "chāi",
    "釶": "shī,yí",
    "釷": "tǔ",
    "釸": "xī",
    "釹": "nǚ",
    "釺": "qiān",
    "釻": "qiú",
    "釼": "rì,rèn,jiàn",
    "釽": "pī,zhāo",
    "釾": "yé,yá",
    "釿": "jīn",
    "鈀": "bǎ",
    "鈁": "fāng",
    "鈂": "chén",
    "鈃": "xíng",
    "鈄": "dǒu",
    "鈅": "yuè",
    "鈆": "qiān",
    "鈇": "fū",
    "鈈": "bù",
    "鈉": "nà",
    "鈊": "xīn",
    "鈋": "é",
    "鈌": "jué",
    "鈍": "dùn",
    "鈎": "gōu",
    "鈏": "yǐn",
    "鈐": "qián",
    "鈑": "bǎn",
    "鈒": "sà",
    "鈓": "rèn",
    "鈔": "chāo",
    "鈕": "niǔ",
    "鈖": "fēn",
    "鈗": "yǔn",
    "鈘": "yǐ",
    "鈙": "qín",
    "鈚": "pī",
    "鈛": "guō",
    "鈜": "hóng",
    "鈝": "yín",
    "鈞": "jūn",
    "鈟": "diào",
    "鈠": "yì",
    "鈡": "zhōng",
    "鈢": "xǐ",
    "鈣": "gài",
    "鈤": "rì",
    "鈥": "huǒ",
    "鈦": "tài",
    "鈧": "kàng",
    "鈨": "yuán",
    "鈩": "lú",
    "鈪": "è",
    "鈫": "qín",
    "鈬": "duó",
    "鈭": "zī",
    "鈮": "ní",
    "鈯": "tú",
    "鈰": "shì",
    "鈱": "mín",
    "鈲": "gū",
    "鈳": "kē",
    "鈴": "líng",
    "鈵": "bǐng",
    "鈶": "sì",
    "鈷": "gǔ",
    "鈸": "bó",
    "鈹": "pí",
    "鈺": "yù",
    "鈻": "sì",
    "鈼": "zuó",
    "鈽": "bū",
    "鈾": "yóu",
    "鈿": "diàn",
    "鉀": "jiǎ",
    "鉁": "zhēn",
    "鉂": "shǐ",
    "鉃": "shì",
    "鉄": "tiě",
    "鉅": "jù",
    "鉆": "zuān",
    "鉇": "shī",
    "鉈": "tā,tuó",
    "鉉": "xuàn",
    "鉊": "zhāo",
    "鉋": "bào,páo",
    "鉌": "hé",
    "鉍": "bì",
    "鉎": "shēng",
    "鉏": "chú",
    "鉐": "shí",
    "鉑": "bó",
    "鉒": "zhù",
    "鉓": "chì",
    "鉔": "zā",
    "鉕": "pǒ",
    "鉖": "tóng",
    "鉗": "qián",
    "鉘": "fú",
    "鉙": "zhǎi",
    "鉚": "mǎo",
    "鉛": "qiān",
    "鉜": "fú",
    "鉝": "lì",
    "鉞": "yuè",
    "鉟": "pī",
    "鉠": "yāng",
    "鉡": "bàn",
    "鉢": "bō",
    "鉣": "jié",
    "鉤": "gōu",
    "鉥": "shù",
    "鉦": "zhēng",
    "鉧": "mǔ",
    "鉨": "xǐ",
    "鉩": "xǐ",
    "鉪": "dì",
    "鉫": "jiā",
    "鉬": "mù",
    "鉭": "tǎn",
    "鉮": "shén",
    "鉯": "yǐ",
    "鉰": "sī",
    "鉱": "kuàng",
    "鉲": "kǎ",
    "鉳": "běi",
    "鉴": "jiàn",
    "鉵": "tóng",
    "鉶": "xíng",
    "鉷": "hóng",
    "鉸": "jiǎo",
    "鉹": "chǐ",
    "鉺": "ěr",
    "鉻": "gè",
    "鉼": "bǐng,píng",
    "鉽": "shì",
    "鉾": "máo",
    "鉿": "hā,kē",
    "銀": "yín",
    "銁": "jūn",
    "銂": "zhōu",
    "銃": "chòng",
    "銄": "xiǎng,jiōng",
    "銅": "tóng",
    "銆": "mò",
    "銇": "lèi",
    "銈": "jī",
    "銉": "yù,sì",
    "銊": "xù,huì",
    "銋": "rén,rěn",
    "銌": "zùn",
    "銍": "zhì",
    "銎": "qióng",
    "銏": "shàn,shuò",
    "銐": "chì,lì",
    "銑": "xiǎn,xǐ",
    "銒": "xíng",
    "銓": "quán",
    "銔": "pī",
    "銕": "tiě",
    "銖": "zhū",
    "銗": "hóu,xiàng",
    "銘": "míng",
    "銙": "kuǎ",
    "銚": "diào,tiáo,yáo",
    "銛": "xiān,kuò,tiǎn,guā",
    "銜": "xián",
    "銝": "xiū",
    "銞": "jūn",
    "銟": "chā",
    "銠": "lǎo",
    "銡": "jí",
    "銢": "pǐ",
    "銣": "rú",
    "銤": "mǐ",
    "銥": "yī",
    "銦": "yīn",
    "銧": "guāng",
    "銨": "ǎn",
    "銩": "diū",
    "銪": "yǒu",
    "銫": "sè",
    "銬": "kào",
    "銭": "qián",
    "銮": "luán",
    "銯": "sī",
    "銰": "āi",
    "銱": "diào",
    "銲": "hàn",
    "銳": "ruì",
    "銴": "shì,zhì",
    "銵": "kēng",
    "銶": "qiú",
    "銷": "xiāo",
    "銸": "zhé,niè",
    "銹": "xiù",
    "銺": "zàng",
    "銻": "tī",
    "銼": "cuò",
    "銽": "xiān,kuò,tiǎn,guā",
    "銾": "hòng,gǒng",
    "銿": "zhōng,yōng",
    "鋀": "tōu,tù,dòu",
    "鋁": "lǚ",
    "鋂": "méi,méng",
    "鋃": "láng",
    "鋄": "wàn,jiǎn",
    "鋅": "xīn",
    "鋆": "yún",
    "鋇": "bèi",
    "鋈": "wù",
    "鋉": "sù",
    "鋊": "yù",
    "鋋": "chán",
    "鋌": "tǐng,dìng",
    "鋍": "bó",
    "鋎": "hàn",
    "鋏": "jiá",
    "鋐": "hóng",
    "鋑": "juān,jiān,cuān",
    "鋒": "fēng",
    "鋓": "chān",
    "鋔": "wǎn",
    "鋕": "zhì",
    "鋖": "sī,tuó",
    "鋗": "xuān,juān,juàn",
    "鋘": "huá,wú,wū",
    "鋙": "wú",
    "鋚": "tiáo",
    "鋛": "kuàng",
    "鋜": "zhuó,chuò",
    "鋝": "lüè",
    "鋞": "xíng,xìng,jīng",
    "鋟": "qǐn",
    "鋠": "shèn",
    "鋡": "hán",
    "鋢": "lüè",
    "鋣": "yé",
    "鋤": "chú",
    "鋥": "zèng",
    "鋦": "jū,jú",
    "鋧": "xiàn",
    "鋨": "é",
    "鋩": "máng",
    "鋪": "pū,pù",
    "鋫": "lí",
    "鋬": "pàn",
    "鋭": "ruì",
    "鋮": "chéng",
    "鋯": "gào",
    "鋰": "lǐ",
    "鋱": "tè",
    "鋲": "bīng",
    "鋳": "zhù",
    "鋴": "zhèn",
    "鋵": "tū",
    "鋶": "liǔ",
    "鋷": "zuì,niè",
    "鋸": "jù,jū",
    "鋹": "chǎng",
    "鋺": "yuǎn,yuān,wǎn,wān",
    "鋻": "jiān,jiàn",
    "鋼": "gāng,gàng",
    "鋽": "diào",
    "鋾": "táo",
    "鋿": "shǎng",
    "錀": "lún",
    "錁": "kè",
    "錂": "líng",
    "錃": "pī",
    "錄": "lù",
    "錅": "lí",
    "錆": "qīng",
    "錇": "péi",
    "錈": "juǎn",
    "錉": "mín",
    "錊": "zuì",
    "錋": "péng",
    "錌": "àn",
    "錍": "pī",
    "錎": "xiàn",
    "錏": "yā",
    "錐": "zhuī",
    "錑": "lèi",
    "錒": "ā",
    "錓": "kōng",
    "錔": "tà",
    "錕": "kūn",
    "錖": "dú",
    "錗": "nèi",
    "錘": "chuí",
    "錙": "zī",
    "錚": "zhēng",
    "錛": "bēn",
    "錜": "niè",
    "錝": "cóng",
    "錞": "chún",
    "錟": "tán",
    "錠": "dìng",
    "錡": "qí",
    "錢": "qián",
    "錣": "zhuì",
    "錤": "jī",
    "錥": "yù",
    "錦": "jǐn",
    "錧": "guǎn",
    "錨": "máo",
    "錩": "chāng",
    "錪": "tiǎn",
    "錫": "xī",
    "錬": "liàn",
    "錭": "diāo",
    "錮": "gù",
    "錯": "cuò",
    "錰": "shù",
    "錱": "zhēn",
    "録": "lù",
    "錳": "měng",
    "錴": "lù",
    "錵": "huā",
    "錶": "biǎo",
    "錷": "gá",
    "錸": "lái",
    "錹": "kěn",
    "錺": "fāng",
    "錻": "bū",
    "錼": "nài",
    "錽": "wàn",
    "錾": "zàn",
    "錿": "hǔ",
    "鍀": "dé",
    "鍁": "xiān",
    "鍂": "piān",
    "鍃": "huò",
    "鍄": "liàng",
    "鍅": "fǎ",
    "鍆": "mén",
    "鍇": "kǎi",
    "鍈": "yāng",
    "鍉": "chí",
    "鍊": "liàn",
    "鍋": "guō",
    "鍌": "xiǎn",
    "鍍": "dù",
    "鍎": "tú",
    "鍏": "wéi",
    "鍐": "zōng",
    "鍑": "fù",
    "鍒": "róu",
    "鍓": "jí",
    "鍔": "è",
    "鍕": "jūn",
    "鍖": "chěn",
    "鍗": "tí",
    "鍘": "zhá",
    "鍙": "hù",
    "鍚": "yáng",
    "鍛": "duàn",
    "鍜": "xiá",
    "鍝": "yú",
    "鍞": "kēng",
    "鍟": "shēng",
    "鍠": "huáng",
    "鍡": "wěi",
    "鍢": "fù",
    "鍣": "zhāo",
    "鍤": "chā",
    "鍥": "qiè",
    "鍦": "shī",
    "鍧": "hōng",
    "鍨": "kuí",
    "鍩": "nuò",
    "鍪": "móu",
    "鍫": "qiāo",
    "鍬": "qiāo",
    "鍭": "hóu",
    "鍮": "tōu",
    "鍯": "cōng",
    "鍰": "huán",
    "鍱": "yè",
    "鍲": "mín",
    "鍳": "jiàn",
    "鍴": "duān",
    "鍵": "jiàn",
    "鍶": "sī",
    "鍷": "kuí",
    "鍸": "hú",
    "鍹": "xuān",
    "鍺": "zhě",
    "鍻": "jié",
    "鍼": "zhēn",
    "鍽": "biān",
    "鍾": "zhōng",
    "鍿": "zī",
    "鎀": "xiū",
    "鎁": "yé",
    "鎂": "měi",
    "鎃": "pài",
    "鎄": "āi",
    "鎅": "jiè",
    "鎆": "qián",
    "鎇": "méi",
    "鎈": "cuō,chā",
    "鎉": "dā,tà",
    "鎊": "bàng",
    "鎋": "xiá",
    "鎌": "lián",
    "鎍": "suǒ,sè",
    "鎎": "kài",
    "鎏": "liú",
    "鎐": "yáo,zú",
    "鎑": "yè,tà,gé",
    "鎒": "nòu",
    "鎓": "wēng",
    "鎔": "róng",
    "鎕": "táng",
    "鎖": "suǒ",
    "鎗": "qiāng,chēng",
    "鎘": "gé,lì",
    "鎙": "shuò",
    "鎚": "chuí",
    "鎛": "bó",
    "鎜": "pán",
    "鎝": "dā",
    "鎞": "bī,bì,pī",
    "鎟": "sǎng",
    "鎠": "gāng",
    "鎡": "zī",
    "鎢": "wū",
    "鎣": "yíng",
    "鎤": "huàng",
    "鎥": "tiáo",
    "鎦": "liú,liù",
    "鎧": "kǎi",
    "鎨": "sǔn",
    "鎩": "shā",
    "鎪": "sōu",
    "鎫": "wàn,jiǎn",
    "鎬": "gǎo,hào",
    "鎭": "zhèn",
    "鎮": "zhèn",
    "鎯": "láng",
    "鎰": "yì",
    "鎱": "yuán",
    "鎲": "tǎng",
    "鎳": "niè",
    "鎴": "xí",
    "鎵": "jiā",
    "鎶": "gē",
    "鎷": "mǎ",
    "鎸": "juān",
    "鎹": "sòng",
    "鎺": "zǔ",
    "鎻": "suǒ",
    "鎼": "xià",
    "鎽": "fēng",
    "鎾": "wēn",
    "鎿": "ná",
    "鏀": "lǔ",
    "鏁": "suǒ",
    "鏂": "ōu",
    "鏃": "zú,chuò",
    "鏄": "tuán",
    "鏅": "xiū,xiù",
    "鏆": "guàn",
    "鏇": "xuàn",
    "鏈": "liàn",
    "鏉": "shòu,sōu",
    "鏊": "ào",
    "鏋": "mǎn",
    "鏌": "mò",
    "鏍": "luó",
    "鏎": "bì",
    "鏏": "wèi",
    "鏐": "liú",
    "鏑": "dí,dī",
    "鏒": "sǎn,qiāo,càn",
    "鏓": "cōng",
    "鏔": "yí",
    "鏕": "lù,áo",
    "鏖": "áo",
    "鏗": "kēng",
    "鏘": "qiāng",
    "鏙": "cuī",
    "鏚": "qī",
    "鏛": "shǎng",
    "鏜": "tāng,táng",
    "鏝": "màn",
    "鏞": "yōng",
    "鏟": "chǎn",
    "鏠": "fēng",
    "鏡": "jìng",
    "鏢": "biāo",
    "鏣": "shù",
    "鏤": "lòu",
    "鏥": "xiù",
    "鏦": "cōng",
    "鏧": "lóng",
    "鏨": "zàn",
    "鏩": "jiàn,zàn",
    "鏪": "cáo",
    "鏫": "lí",
    "鏬": "xià",
    "鏭": "xī",
    "鏮": "kāng",
    "鏯": "shuǎng",
    "鏰": "bèng",
    "鏱": "zhāng",
    "鏲": "qiān",
    "鏳": "zhēng",
    "鏴": "lù",
    "鏵": "huá",
    "鏶": "jí",
    "鏷": "pú",
    "鏸": "huì,suì,ruì",
    "鏹": "qiǎng,qiāng",
    "鏺": "pō",
    "鏻": "lín",
    "鏼": "sè",
    "鏽": "xiù",
    "鏾": "sǎn,xiàn,sà",
    "鏿": "chēng",
    "鐀": "guì",
    "鐁": "sī",
    "鐂": "liú",
    "鐃": "náo",
    "鐄": "huáng",
    "鐅": "piě",
    "鐆": "suì",
    "鐇": "fán",
    "鐈": "qiáo",
    "鐉": "quān",
    "鐊": "xī",
    "鐋": "tàng",
    "鐌": "xiàng",
    "鐍": "jué",
    "鐎": "jiāo",
    "鐏": "zūn",
    "鐐": "liào",
    "鐑": "qì",
    "鐒": "láo",
    "鐓": "duī",
    "鐔": "xín",
    "鐕": "zān",
    "鐖": "jī",
    "鐗": "jiǎn",
    "鐘": "zhōng",
    "鐙": "dèng",
    "鐚": "yā",
    "鐛": "yǐng",
    "鐜": "duī",
    "鐝": "jué",
    "鐞": "nòu",
    "鐟": "zān",
    "鐠": "pǔ",
    "鐡": "tiě",
    "鐢": "fán",
    "鐣": "chēng",
    "鐤": "dǐng",
    "鐥": "shàn",
    "鐦": "kāi",
    "鐧": "jiǎn",
    "鐨": "fèi",
    "鐩": "suì",
    "鐪": "lǔ",
    "鐫": "juān",
    "鐬": "huì",
    "鐭": "yù",
    "鐮": "lián",
    "鐯": "zhuō",
    "鐰": "qiāo",
    "鐱": "jiàn",
    "鐲": "zhuó",
    "鐳": "léi",
    "鐴": "bì",
    "鐵": "tiě",
    "鐶": "huán",
    "鐷": "yè",
    "鐸": "duó",
    "鐹": "guò",
    "鐺": "dāng,chēng",
    "鐻": "jù",
    "鐼": "fén",
    "鐽": "dá",
    "鐾": "bèi",
    "鐿": "yì",
    "鑀": "ài",
    "鑁": "zōng",
    "鑂": "xùn",
    "鑃": "diào",
    "鑄": "zhù",
    "鑅": "héng",
    "鑆": "zhuì",
    "鑇": "jī",
    "鑈": "niè",
    "鑉": "hé",
    "鑊": "huò",
    "鑋": "qīng",
    "鑌": "bīn",
    "鑍": "yīng",
    "鑎": "guì",
    "鑏": "níng",
    "鑐": "xū",
    "鑑": "jiàn",
    "鑒": "jiàn",
    "鑓": "qiǎn",
    "鑔": "chǎ",
    "鑕": "zhì",
    "鑖": "miè",
    "鑗": "lí",
    "鑘": "léi",
    "鑙": "jī",
    "鑚": "zuān",
    "鑛": "kuàng",
    "鑜": "shǎng",
    "鑝": "péng",
    "鑞": "là",
    "鑟": "dú",
    "鑠": "shuò",
    "鑡": "chuò",
    "鑢": "lǜ",
    "鑣": "biāo",
    "鑤": "bào",
    "鑥": "lǔ",
    "鑦": "xián",
    "鑧": "kuān",
    "鑨": "lóng",
    "鑩": "è",
    "鑪": "lú",
    "鑫": "xīn",
    "鑬": "jiàn",
    "鑭": "lán",
    "鑮": "bó",
    "鑯": "jiān",
    "鑰": "yuè",
    "鑱": "chán",
    "鑲": "xiāng",
    "鑳": "jiàn",
    "鑴": "xī",
    "鑵": "guàn",
    "鑶": "cáng",
    "鑷": "niè",
    "鑸": "lěi",
    "鑹": "cuān",
    "鑺": "qú",
    "鑻": "pàn",
    "鑼": "luó",
    "鑽": "zuān",
    "鑾": "luán",
    "鑿": "záo",
    "钀": "niè",
    "钁": "jué",
    "钂": "tǎng",
    "钃": "zhú",
    "钄": "làn",
    "钅": "jīn",
    "钆": "gá",
    "钇": "yǐ",
    "针": "zhēn",
    "钉": "dīng,dìng",
    "钊": "zhāo",
    "钋": "pō",
    "钌": "liǎo,liào",
    "钍": "tǔ",
    "钎": "qiān",
    "钏": "chuàn",
    "钐": "shān,shàn",
    "钑": "sà,xì",
    "钒": "fán",
    "钓": "diào",
    "钔": "mén",
    "钕": "nǚ",
    "钖": "yáng",
    "钗": "chāi",
    "钘": "xíng",
    "钙": "gài",
    "钚": "bù",
    "钛": "tài",
    "钜": "jù",
    "钝": "dùn",
    "钞": "chāo",
    "钟": "zhōng",
    "钠": "nà",
    "钡": "bèi",
    "钢": "gāng,gàng",
    "钣": "bǎn",
    "钤": "qián",
    "钥": "yuè,yào",
    "钦": "qīn",
    "钧": "jūn",
    "钨": "wū",
    "钩": "gōu",
    "钪": "kàng",
    "钫": "fāng",
    "钬": "huǒ",
    "钭": "dǒu",
    "钮": "niǔ",
    "钯": "bǎ,pá",
    "钰": "yù",
    "钱": "qián",
    "钲": "zhēng,zhèng",
    "钳": "qián",
    "钴": "gǔ",
    "钵": "bō",
    "钶": "kē",
    "钷": "pǒ",
    "钸": "bū",
    "钹": "bó",
    "钺": "yuè",
    "钻": "zuān,zuàn",
    "钼": "mù",
    "钽": "tǎn",
    "钾": "jiǎ",
    "钿": "diàn,tián",
    "铀": "yóu",
    "铁": "tiě",
    "铂": "bó",
    "铃": "líng",
    "铄": "shuò",
    "铅": "qiān,yán",
    "铆": "mǎo",
    "铇": "bào,páo",
    "铈": "shì",
    "铉": "xuàn",
    "铊": "tā,tuó",
    "铋": "bì",
    "铌": "ní",
    "铍": "pí,pī",
    "铎": "duó",
    "铏": "xíng",
    "铐": "kào",
    "铑": "lǎo",
    "铒": "ěr",
    "铓": "máng",
    "铔": "yā,yà",
    "铕": "yǒu",
    "铖": "chéng",
    "铗": "jiá",
    "铘": "yé",
    "铙": "náo",
    "铚": "zhì",
    "铛": "dāng,chēng",
    "铜": "tóng",
    "铝": "lǚ",
    "铞": "diào",
    "铟": "yīn",
    "铠": "kǎi",
    "铡": "zhá",
    "铢": "zhū",
    "铣": "xiǎn,xǐ",
    "铤": "tǐng,dìng",
    "铥": "diū",
    "铦": "xiān,kuò,tiǎn,guā",
    "铧": "huá",
    "铨": "quán",
    "铩": "shā",
    "铪": "hā,kē",
    "铫": "diào,tiáo,yáo",
    "铬": "gè",
    "铭": "míng",
    "铮": "zhēng",
    "铯": "sè",
    "铰": "jiǎo",
    "铱": "yī",
    "铲": "chǎn",
    "铳": "chòng",
    "铴": "tàng,tāng",
    "铵": "ǎn",
    "银": "yín",
    "铷": "rú",
    "铸": "zhù",
    "铹": "láo",
    "铺": "pū,pù",
    "铻": "wú",
    "铼": "lái",
    "铽": "tè",
    "链": "liàn",
    "铿": "kēng",
    "销": "xiāo",
    "锁": "suǒ",
    "锂": "lǐ",
    "锃": "zèng",
    "锄": "chú",
    "锅": "guō",
    "锆": "gào",
    "锇": "é",
    "锈": "xiù",
    "锉": "cuò",
    "锊": "lüè",
    "锋": "fēng",
    "锌": "xīn",
    "锍": "liǔ",
    "锎": "kāi",
    "锏": "jiǎn",
    "锐": "ruì",
    "锑": "tī",
    "锒": "láng",
    "锓": "qǐn",
    "锔": "jū",
    "锕": "ā",
    "锖": "qiāng",
    "锗": "zhě",
    "锘": "nuò",
    "错": "cuò",
    "锚": "máo",
    "锛": "bēn",
    "锜": "qí",
    "锝": "dé",
    "锞": "kè",
    "锟": "kūn",
    "锠": "chāng",
    "锡": "xī",
    "锢": "gù",
    "锣": "luó",
    "锤": "chuí",
    "锥": "zhuī",
    "锦": "jǐn",
    "锧": "zhì",
    "锨": "xiān",
    "锩": "juǎn",
    "锪": "huò",
    "锫": "péi",
    "锬": "tán",
    "锭": "dìng",
    "键": "jiàn",
    "锯": "jù",
    "锰": "měng",
    "锱": "zī",
    "锲": "qiè",
    "锳": "yīng",
    "锴": "kǎi",
    "锵": "qiāng",
    "锶": "sī",
    "锷": "è",
    "锸": "chā",
    "锹": "qiāo",
    "锺": "zhōng",
    "锻": "duàn",
    "锼": "sōu",
    "锽": "huáng",
    "锾": "huán",
    "锿": "āi",
    "镀": "dù",
    "镁": "měi",
    "镂": "lòu",
    "镃": "zī",
    "镄": "fèi",
    "镅": "méi",
    "镆": "mò",
    "镇": "zhèn",
    "镈": "bó",
    "镉": "gé,lì",
    "镊": "niè",
    "镋": "tǎng",
    "镌": "juān",
    "镍": "niè",
    "镎": "ná",
    "镏": "liú",
    "镐": "gǎo,hào",
    "镑": "bàng",
    "镒": "yì",
    "镓": "jiā",
    "镔": "bīn",
    "镕": "róng",
    "镖": "biāo",
    "镗": "tāng",
    "镘": "màn",
    "镙": "luó",
    "镚": "bèng",
    "镛": "yōng",
    "镜": "jìng",
    "镝": "dí",
    "镞": "zú",
    "镟": "xuàn",
    "镠": "liú",
    "镡": "xín",
    "镢": "jué",
    "镣": "liào",
    "镤": "pú",
    "镥": "lǔ",
    "镦": "duī",
    "镧": "lán",
    "镨": "pǔ",
    "镩": "cuān",
    "镪": "qiǎng",
    "镫": "dèng",
    "镬": "huò",
    "镭": "léi",
    "镮": "huán",
    "镯": "zhuó",
    "镰": "lián",
    "镱": "yì",
    "镲": "chǎ",
    "镳": "biāo",
    "镴": "là",
    "镵": "chán",
    "镶": "xiāng",
    "長": "cháng,zhǎng",
    "镸": "cháng",
    "镹": "jiǔ",
    "镺": "ǎo",
    "镻": "dié",
    "镼": "jié",
    "镽": "liǎo",
    "镾": "mí",
    "长": "cháng,zhǎng",
    "門": "mén",
    "閁": "mà",
    "閂": "shuān",
    "閃": "shǎn",
    "閄": "huò,shǎn",
    "閅": "mén",
    "閆": "yán",
    "閇": "bì",
    "閈": "hàn,bì",
    "閉": "bì",
    "閊": "shān",
    "開": "kāi",
    "閌": "kāng,kàng",
    "閍": "bēng",
    "閎": "hóng",
    "閏": "rùn",
    "閐": "sàn",
    "閑": "xián",
    "閒": "xián,jiān,jiàn",
    "間": "jiān,jiàn",
    "閔": "mǐn",
    "閕": "xiā,xiǎ",
    "閖": "shuǐ",
    "閗": "dòu",
    "閘": "zhá",
    "閙": "nào",
    "閚": "zhān",
    "閛": "pēng,pèng",
    "閜": "xiǎ,kě",
    "閝": "líng",
    "閞": "biàn,guān",
    "閟": "bì",
    "閠": "rùn",
    "閡": "hé",
    "関": "guān",
    "閣": "gé",
    "閤": "hé,gé",
    "閥": "fá",
    "閦": "chù",
    "閧": "hòng,xiàng",
    "閨": "guī",
    "閩": "mǐn",
    "閪": "sē,xī",
    "閫": "kǔn",
    "閬": "làng",
    "閭": "lǘ",
    "閮": "tíng,tǐng",
    "閯": "shà",
    "閰": "jú",
    "閱": "yuè",
    "閲": "yuè",
    "閳": "chǎn",
    "閴": "qù",
    "閵": "lìn",
    "閶": "chāng",
    "閷": "shā",
    "閸": "kǔn",
    "閹": "yān",
    "閺": "wén",
    "閻": "yán",
    "閼": "è,yān",
    "閽": "hūn",
    "閾": "yù",
    "閿": "wén",
    "闀": "hòng",
    "闁": "bāo",
    "闂": "hòng,juǎn,xiàng",
    "闃": "qù",
    "闄": "yǎo",
    "闅": "wén",
    "闆": "bǎn,pàn",
    "闇": "àn",
    "闈": "wéi",
    "闉": "yīn",
    "闊": "kuò",
    "闋": "què",
    "闌": "lán",
    "闍": "dū,shé",
    "闎": "quán",
    "闏": "null",
    "闐": "tián",
    "闑": "niè",
    "闒": "tà",
    "闓": "kǎi",
    "闔": "hé",
    "闕": "què,quē",
    "闖": "chuǎng",
    "闗": "guān",
    "闘": "dòu",
    "闙": "qǐ",
    "闚": "kuī",
    "闛": "táng,tāng,chāng",
    "關": "guān",
    "闝": "piáo",
    "闞": "kàn,hǎn",
    "闟": "xì,sè,tà",
    "闠": "huì",
    "闡": "chǎn",
    "闢": "pì",
    "闣": "dāng,dàng",
    "闤": "huán",
    "闥": "tà",
    "闦": "wén",
    "闧": "tā",
    "门": "mén",
    "闩": "shuān",
    "闪": "shǎn",
    "闫": "yán",
    "闬": "hàn,bì",
    "闭": "bì",
    "问": "wèn",
    "闯": "chuǎng",
    "闰": "rùn",
    "闱": "wéi",
    "闲": "xián",
    "闳": "hóng",
    "间": "jiān,jiàn",
    "闵": "mǐn",
    "闶": "kàng,kāng",
    "闷": "mèn,mēn",
    "闸": "zhá",
    "闹": "nào",
    "闺": "guī",
    "闻": "wén",
    "闼": "tà",
    "闽": "mǐn",
    "闾": "lǘ",
    "闿": "kǎi",
    "阀": "fá",
    "阁": "gé",
    "阂": "hé",
    "阃": "kǔn",
    "阄": "jiū",
    "阅": "yuè",
    "阆": "làng",
    "阇": "dū,shé",
    "阈": "yù",
    "阉": "yān",
    "阊": "chāng",
    "阋": "xì",
    "阌": "wén",
    "阍": "hūn",
    "阎": "yán",
    "阏": "è",
    "阐": "chǎn",
    "阑": "lán",
    "阒": "qù",
    "阓": "huì",
    "阔": "kuò",
    "阕": "què",
    "阖": "hé",
    "阗": "tián",
    "阘": "tà",
    "阙": "quē,què",
    "阚": "kàn",
    "阛": "huán",
    "阜": "fù",
    "阝": "fǔ",
    "阞": "lè",
    "队": "duì",
    "阠": "xìn",
    "阡": "qiān",
    "阢": "wù",
    "阣": "yì",
    "阤": "tuó",
    "阥": "yīn",
    "阦": "yáng",
    "阧": "dǒu",
    "阨": "è",
    "阩": "shēng",
    "阪": "bǎn",
    "阫": "péi",
    "阬": "kēng",
    "阭": "yǔn",
    "阮": "ruǎn",
    "阯": "zhǐ",
    "阰": "pí",
    "阱": "jǐng",
    "防": "fáng",
    "阳": "yáng",
    "阴": "yīn",
    "阵": "zhèn",
    "阶": "jiē",
    "阷": "chēng",
    "阸": "è",
    "阹": "qū",
    "阺": "dǐ",
    "阻": "zǔ",
    "阼": "zuò",
    "阽": "diàn",
    "阾": "lín",
    "阿": "ā,ē",
    "陀": "tuó",
    "陁": "tuó",
    "陂": "bēi,pí,pō",
    "陃": "bǐng",
    "附": "fù",
    "际": "jì",
    "陆": "lù",
    "陇": "lǒng",
    "陈": "chén",
    "陉": "xíng",
    "陊": "duò",
    "陋": "lòu",
    "陌": "mò",
    "降": "jiàng,xiáng",
    "陎": "shū",
    "陏": "duò",
    "限": "xiàn",
    "陑": "ér",
    "陒": "guǐ",
    "陓": "yū",
    "陔": "gāi",
    "陕": "shǎn",
    "陖": "jùn",
    "陗": "qiào",
    "陘": "xíng",
    "陙": "chún",
    "陚": "wǔ",
    "陛": "bì",
    "陜": "xiá",
    "陝": "shǎn",
    "陞": "shēng",
    "陟": "zhì",
    "陠": "pū",
    "陡": "dǒu",
    "院": "yuàn",
    "陣": "zhèn",
    "除": "chú",
    "陥": "xiàn",
    "陦": "dǎo",
    "陧": "niè",
    "陨": "yǔn",
    "险": "xiǎn",
    "陪": "péi",
    "陫": "fèi",
    "陬": "zōu",
    "陭": "qí",
    "陮": "duì",
    "陯": "lún",
    "陰": "yīn",
    "陱": "jū",
    "陲": "chuí",
    "陳": "chén",
    "陴": "pī",
    "陵": "líng",
    "陶": "táo",
    "陷": "xiàn",
    "陸": "lù",
    "陹": "shēng",
    "険": "xiǎn",
    "陻": "yīn",
    "陼": "zhǔ",
    "陽": "yáng",
    "陾": "réng",
    "陿": "xiá",
    "隀": "chóng",
    "隁": "yàn,yǎn",
    "隂": "yīn",
    "隃": "yú,yáo,shù",
    "隄": "dī",
    "隅": "yú",
    "隆": "lóng",
    "隇": "wēi",
    "隈": "wēi",
    "隉": "niè",
    "隊": "duì,zhuì",
    "隋": "suí,duò",
    "隌": "àn",
    "隍": "huáng",
    "階": "jiē",
    "随": "suí",
    "隐": "yǐn,yìn",
    "隑": "qí,gāi,ái",
    "隒": "yǎn",
    "隓": "huī,duò",
    "隔": "gé",
    "隕": "yǔn",
    "隖": "wù",
    "隗": "wěi,kuí",
    "隘": "ài",
    "隙": "xì",
    "隚": "táng",
    "際": "jì",
    "障": "zhàng",
    "隝": "dǎo",
    "隞": "áo",
    "隟": "xì",
    "隠": "yǐn,yìn",
    "隡": "sà",
    "隢": "rǎo",
    "隣": "lín",
    "隤": "tuí",
    "隥": "dèng",
    "隦": "pí",
    "隧": "suì",
    "隨": "suí",
    "隩": "ào,yù",
    "險": "xiǎn",
    "隫": "fén",
    "隬": "nǐ",
    "隭": "ér",
    "隮": "jī",
    "隯": "dǎo",
    "隰": "xí",
    "隱": "yǐn,yìn",
    "隲": "zhì",
    "隳": "huī,duò",
    "隴": "lǒng",
    "隵": "xī",
    "隶": "lì",
    "隷": "lì",
    "隸": "lì",
    "隹": "zhuī,cuī,wéi",
    "隺": "hú,hè",
    "隻": "zhī",
    "隼": "sǔn",
    "隽": "jùn,juàn",
    "难": "nán,nàn,nuó",
    "隿": "yì",
    "雀": "què,qiāo,qiǎo",
    "雁": "yàn",
    "雂": "qín",
    "雃": "jiān",
    "雄": "xióng",
    "雅": "yǎ",
    "集": "jí",
    "雇": "gù",
    "雈": "huán",
    "雉": "zhì",
    "雊": "gòu",
    "雋": "jùn,juàn",
    "雌": "cí",
    "雍": "yōng",
    "雎": "jū",
    "雏": "chú",
    "雐": "hū",
    "雑": "zá",
    "雒": "luò",
    "雓": "yú",
    "雔": "chóu",
    "雕": "diāo",
    "雖": "suī",
    "雗": "hàn",
    "雘": "huò",
    "雙": "shuāng",
    "雚": "guàn,huán",
    "雛": "chú",
    "雜": "zá",
    "雝": "yōng",
    "雞": "jī",
    "雟": "guī,xī",
    "雠": "chóu",
    "雡": "liù",
    "離": "lí",
    "難": "nán,nàn,nuó",
    "雤": "yù",
    "雥": "zá",
    "雦": "chóu",
    "雧": "jí",
    "雨": "yǔ,yù",
    "雩": "yú",
    "雪": "xuě",
    "雫": "nǎ",
    "雬": "fǒu",
    "雭": "sè,xí",
    "雮": "mù",
    "雯": "wén",
    "雰": "fēn",
    "雱": "pāng",
    "雲": "yún",
    "雳": "lì",
    "雴": "chì",
    "雵": "yāng",
    "零": "líng",
    "雷": "léi",
    "雸": "án",
    "雹": "báo",
    "雺": "wù,méng",
    "電": "diàn",
    "雼": "dàng",
    "雽": "hū,hù",
    "雾": "wù",
    "雿": "diào",
    "需": "xū",
    "霁": "jì",
    "霂": "mù",
    "霃": "chén",
    "霄": "xiāo",
    "霅": "zhá",
    "霆": "tíng",
    "震": "zhèn",
    "霈": "pèi",
    "霉": "méi",
    "霊": "líng",
    "霋": "qī",
    "霌": "zhōu",
    "霍": "huò",
    "霎": "shà",
    "霏": "fēi",
    "霐": "hóng",
    "霑": "zhān",
    "霒": "yīn",
    "霓": "ní",
    "霔": "shù",
    "霕": "tún",
    "霖": "lín",
    "霗": "líng",
    "霘": "dòng",
    "霙": "yīng",
    "霚": "wù",
    "霛": "líng",
    "霜": "shuāng",
    "霝": "líng",
    "霞": "xiá",
    "霟": "hóng",
    "霠": "yīn",
    "霡": "mài",
    "霢": "mài",
    "霣": "yǔn",
    "霤": "liù",
    "霥": "mèng",
    "霦": "bīn",
    "霧": "wù",
    "霨": "wèi",
    "霩": "kuò",
    "霪": "yín",
    "霫": "xí",
    "霬": "yì",
    "霭": "ǎi",
    "霮": "dàn",
    "霯": "tèng",
    "霰": "xiàn",
    "霱": "yù",
    "露": "lòu,lù",
    "霳": "lóng",
    "霴": "dài",
    "霵": "jí",
    "霶": "pāng",
    "霷": "yáng",
    "霸": "bà",
    "霹": "pī",
    "霺": "wēi",
    "霻": "fēng",
    "霼": "xì",
    "霽": "jì",
    "霾": "mái",
    "霿": "méng",
    "靀": "méng",
    "靁": "léi",
    "靂": "lì",
    "靃": "huò",
    "靄": "ǎi",
    "靅": "fèi",
    "靆": "dài",
    "靇": "lóng",
    "靈": "lìng",
    "靉": "ài",
    "靊": "fēng",
    "靋": "lì",
    "靌": "bǎo",
    "靍": "hè",
    "靎": "hè",
    "靏": "hè",
    "靐": "bìng",
    "靑": "qīng",
    "青": "qīng",
    "靓": "jìng,liàng",
    "靔": "tiān",
    "靕": "zhèng",
    "靖": "jìng",
    "靗": "chēng",
    "靘": "qìng",
    "静": "jìng",
    "靚": "jìng",
    "靛": "diàn",
    "靜": "jìng",
    "靝": "tiān",
    "非": "fēi",
    "靟": "fēi",
    "靠": "kào",
    "靡": "mí",
    "面": "miàn",
    "靣": "miàn",
    "靤": "pào",
    "靥": "yè",
    "靦": "miǎn",
    "靧": "huì",
    "靨": "yè",
    "革": "gé",
    "靪": "dīng",
    "靫": "chá",
    "靬": "jiān",
    "靭": "rèn",
    "靮": "dí",
    "靯": "dù",
    "靰": "wù",
    "靱": "rèn",
    "靲": "qín",
    "靳": "jìn",
    "靴": "xuē",
    "靵": "niǔ",
    "靶": "bǎ",
    "靷": "yǐn",
    "靸": "sǎ",
    "靹": "nà",
    "靺": "mò",
    "靻": "zǔ",
    "靼": "dá",
    "靽": "bàn",
    "靾": "xiè",
    "靿": "yào",
    "鞀": "táo",
    "鞁": "bèi",
    "鞂": "jiē",
    "鞃": "hóng",
    "鞄": "páo",
    "鞅": "yāng,yàng",
    "鞆": "bǐng",
    "鞇": "yīn",
    "鞈": "gé,tà,sǎ",
    "鞉": "táo",
    "鞊": "jié,jí",
    "鞋": "xié",
    "鞌": "ān",
    "鞍": "ān",
    "鞎": "hén",
    "鞏": "gǒng",
    "鞐": "qiǎ",
    "鞑": "dá",
    "鞒": "qiáo",
    "鞓": "tīng",
    "鞔": "mán,mèn",
    "鞕": "biān,yìng",
    "鞖": "suī",
    "鞗": "tiáo",
    "鞘": "qiào,shāo",
    "鞙": "xuān,juān",
    "鞚": "kòng",
    "鞛": "běng",
    "鞜": "tà",
    "鞝": "shàng,zhǎng",
    "鞞": "bǐng,pí,bì,bēi",
    "鞟": "kuò",
    "鞠": "jū",
    "鞡": "la",
    "鞢": "xiè,dié",
    "鞣": "róu",
    "鞤": "bāng",
    "鞥": "null",
    "鞦": "qiū",
    "鞧": "qiū",
    "鞨": "hé",
    "鞩": "qiào",
    "鞪": "mù,móu",
    "鞫": "jū",
    "鞬": "jiàn,jiān",
    "鞭": "biān",
    "鞮": "dī",
    "鞯": "jiān",
    "鞰": "wēn,yùn",
    "鞱": "tāo",
    "鞲": "gōu",
    "鞳": "tà",
    "鞴": "bèi",
    "鞵": "xié",
    "鞶": "pán",
    "鞷": "gé",
    "鞸": "bì,bǐng",
    "鞹": "kuò",
    "鞺": "tāng",
    "鞻": "lóu",
    "鞼": "guì",
    "鞽": "qiáo",
    "鞾": "xuē",
    "鞿": "jī",
    "韀": "jiān",
    "韁": "jiāng",
    "韂": "chàn",
    "韃": "dá",
    "韄": "huò",
    "韅": "xiǎn",
    "韆": "qiān",
    "韇": "dú",
    "韈": "wā",
    "韉": "jiān",
    "韊": "lán",
    "韋": "wéi",
    "韌": "rèn",
    "韍": "fú",
    "韎": "mèi,wà",
    "韏": "quàn",
    "韐": "gé",
    "韑": "wěi",
    "韒": "qiào",
    "韓": "hán",
    "韔": "chàng",
    "韕": "kuò",
    "韖": "rǒu",
    "韗": "yùn",
    "韘": "shè,xiè",
    "韙": "wěi",
    "韚": "gé",
    "韛": "bài",
    "韜": "tāo",
    "韝": "gōu",
    "韞": "yùn",
    "韟": "gāo",
    "韠": "bì",
    "韡": "wěi",
    "韢": "suì",
    "韣": "dú",
    "韤": "wà",
    "韥": "dú",
    "韦": "wéi",
    "韧": "rèn",
    "韨": "fú",
    "韩": "hán",
    "韪": "wěi",
    "韫": "yùn,wēn",
    "韬": "tāo",
    "韭": "jiǔ",
    "韮": "jiǔ",
    "韯": "xiān",
    "韰": "xiè",
    "韱": "xiān",
    "韲": "jī",
    "音": "yīn",
    "韴": "zá",
    "韵": "yùn",
    "韶": "sháo",
    "韷": "lè",
    "韸": "péng",
    "韹": "huáng",
    "韺": "yīng",
    "韻": "yùn",
    "韼": "péng",
    "韽": "ān",
    "韾": "yīn",
    "響": "xiǎng",
    "頀": "hù",
    "頁": "yè",
    "頂": "dǐng",
    "頃": "qǐng",
    "頄": "qiú",
    "項": "xiàng",
    "順": "shùn",
    "頇": "hān",
    "須": "xū",
    "頉": "yí",
    "頊": "xù",
    "頋": "ě",
    "頌": "sòng",
    "頍": "kuǐ",
    "頎": "qí",
    "頏": "háng",
    "預": "yù",
    "頑": "wán",
    "頒": "bān",
    "頓": "dùn",
    "頔": "dí",
    "頕": "dān",
    "頖": "pàn",
    "頗": "pō",
    "領": "lǐng",
    "頙": "chè",
    "頚": "jǐng",
    "頛": "lèi",
    "頜": "hé",
    "頝": "qiāo",
    "頞": "è",
    "頟": "é",
    "頠": "wěi",
    "頡": "jié",
    "頢": "kuò",
    "頣": "shěn",
    "頤": "yí",
    "頥": "yí",
    "頦": "kē",
    "頧": "duǐ",
    "頨": "yǔ",
    "頩": "pīng",
    "頪": "lèi",
    "頫": "fǔ",
    "頬": "jiá",
    "頭": "tóu",
    "頮": "huì",
    "頯": "kuí",
    "頰": "jiá",
    "頱": "luō",
    "頲": "tǐng",
    "頳": "chēng",
    "頴": "yǐng",
    "頵": "jūn",
    "頶": "hú",
    "頷": "hàn",
    "頸": "jǐng",
    "頹": "tuí",
    "頺": "tuí",
    "頻": "bīn",
    "頼": "lài",
    "頽": "tuí",
    "頾": "zī",
    "頿": "zī",
    "顀": "chuí",
    "顁": "dìng",
    "顂": "lài",
    "顃": "tán",
    "顄": "hàn",
    "顅": "qiān",
    "顆": "kē",
    "顇": "cuì",
    "顈": "jiǒng",
    "顉": "qīn",
    "顊": "yí",
    "顋": "sāi",
    "題": "tí",
    "額": "é",
    "顎": "è",
    "顏": "yán",
    "顐": "wèn",
    "顑": "kǎn",
    "顒": "yóng",
    "顓": "zhuān",
    "顔": "yán",
    "顕": "xiǎn",
    "顖": "xìn",
    "顗": "yǐ",
    "願": "yuàn",
    "顙": "sǎng",
    "顚": "diān",
    "顛": "diān",
    "顜": "jiǎng",
    "顝": "kuī",
    "類": "lèi",
    "顟": "láo",
    "顠": "piǎo",
    "顡": "wài",
    "顢": "mān",
    "顣": "cù",
    "顤": "yáo",
    "顥": "hào",
    "顦": "qiáo",
    "顧": "gù",
    "顨": "xùn",
    "顩": "yǎn",
    "顪": "huì",
    "顫": "chàn",
    "顬": "rú",
    "顭": "méng",
    "顮": "bīn",
    "顯": "xiǎn",
    "顰": "pín",
    "顱": "lú",
    "顲": "lǎn",
    "顳": "niè",
    "顴": "quán",
    "页": "yè",
    "顶": "dǐng",
    "顷": "qǐng",
    "顸": "hān",
    "项": "xiàng",
    "顺": "shùn",
    "须": "xū",
    "顼": "xū",
    "顽": "wán",
    "顾": "gù",
    "顿": "dùn",
    "颀": "qí",
    "颁": "bān",
    "颂": "sòng",
    "颃": "háng",
    "预": "yù",
    "颅": "lú",
    "领": "lǐng",
    "颇": "pō",
    "颈": "jǐng,gěng",
    "颉": "jié,xié,jiá",
    "颊": "jiá",
    "颋": "tǐng",
    "颌": "hé,gé",
    "颍": "yǐng",
    "颎": "jiǒng",
    "颏": "kē",
    "颐": "yí",
    "频": "pín,bīn",
    "颒": "huì",
    "颓": "tuí",
    "颔": "hàn",
    "颕": "yǐng",
    "颖": "yǐng",
    "颗": "kē",
    "题": "tí",
    "颙": "yóng",
    "颚": "è",
    "颛": "zhuān",
    "颜": "yán",
    "额": "é",
    "颞": "niè",
    "颟": "mān",
    "颠": "diān",
    "颡": "sǎng",
    "颢": "hào",
    "颣": "lèi",
    "颤": "chàn,zhàn",
    "颥": "rú",
    "颦": "pín",
    "颧": "quán",
    "風": "fēng,fěng",
    "颩": "biāo,diū",
    "颪": "guā",
    "颫": "fú",
    "颬": "xiā",
    "颭": "zhǎn",
    "颮": "biāo",
    "颯": "sà",
    "颰": "bá,fú",
    "颱": "tái",
    "颲": "liè",
    "颳": "guā",
    "颴": "xuàn",
    "颵": "xiāo",
    "颶": "jù",
    "颷": "biāo",
    "颸": "sī",
    "颹": "wěi",
    "颺": "yáng",
    "颻": "yáo",
    "颼": "sōu",
    "颽": "kǎi",
    "颾": "sāo,sōu",
    "颿": "fān",
    "飀": "liú",
    "飁": "xí",
    "飂": "liù,liáo",
    "飃": "piāo",
    "飄": "piāo",
    "飅": "liú",
    "飆": "biāo",
    "飇": "biāo",
    "飈": "biāo",
    "飉": "liáo",
    "飊": "biāo",
    "飋": "sè",
    "飌": "fēng",
    "飍": "xiū",
    "风": "fēng,fěng",
    "飏": "yáng",
    "飐": "zhǎn",
    "飑": "biāo",
    "飒": "sà",
    "飓": "jù",
    "飔": "sī",
    "飕": "sōu",
    "飖": "yáo",
    "飗": "liú",
    "飘": "piāo",
    "飙": "biāo",
    "飚": "biāo",
    "飛": "fēi",
    "飜": "fān",
    "飝": "fēi",
    "飞": "fēi",
    "食": "shí,sì,yì",
    "飠": "shí",
    "飡": "cān",
    "飢": "jī",
    "飣": "dìng",
    "飤": "sì",
    "飥": "tuō",
    "飦": "zhān",
    "飧": "sūn",
    "飨": "xiǎng",
    "飩": "tún",
    "飪": "rèn",
    "飫": "yù",
    "飬": "yǎng,juàn",
    "飭": "chì",
    "飮": "yǐn,yìn",
    "飯": "fàn",
    "飰": "fàn",
    "飱": "sūn",
    "飲": "yǐn,yìn",
    "飳": "zhù,tǒu",
    "飴": "yí,sì",
    "飵": "zuò,zé,zhā",
    "飶": "bì",
    "飷": "jiě",
    "飸": "tāo",
    "飹": "bǎo",
    "飺": "cí",
    "飻": "tiè",
    "飼": "sì",
    "飽": "bǎo",
    "飾": "shì",
    "飿": "duò",
    "餀": "hài",
    "餁": "rèn",
    "餂": "tiǎn",
    "餃": "jiǎo",
    "餄": "hé",
    "餅": "bǐng",
    "餆": "yáo",
    "餇": "tóng",
    "餈": "cí",
    "餉": "xiǎng",
    "養": "yǎng",
    "餋": "juàn",
    "餌": "ěr",
    "餍": "yàn",
    "餎": "lè",
    "餏": "xī",
    "餐": "cān",
    "餑": "bō",
    "餒": "něi",
    "餓": "è",
    "餔": "bū",
    "餕": "jùn",
    "餖": "dòu",
    "餗": "sù",
    "餘": "yú",
    "餙": "shì",
    "餚": "yáo",
    "餛": "hún",
    "餜": "guǒ",
    "餝": "shì",
    "餞": "jiàn",
    "餟": "chuò",
    "餠": "bǐng",
    "餡": "xiàn",
    "餢": "bù",
    "餣": "yè",
    "餤": "dàn",
    "餥": "fēi",
    "餦": "zhāng",
    "餧": "wèi",
    "館": "guǎn",
    "餩": "è",
    "餪": "nuǎn",
    "餫": "yùn",
    "餬": "hú",
    "餭": "huáng",
    "餮": "tiè",
    "餯": "huì",
    "餰": "jiān",
    "餱": "hóu",
    "餲": "ài",
    "餳": "xíng",
    "餴": "fēn",
    "餵": "wèi",
    "餶": "gǔ",
    "餷": "chā",
    "餸": "sòng",
    "餹": "táng",
    "餺": "bó",
    "餻": "gāo",
    "餼": "xì",
    "餽": "kuì",
    "餾": "liù",
    "餿": "sōu",
    "饀": "táo",
    "饁": "yè",
    "饂": "wēn",
    "饃": "mó",
    "饄": "táng",
    "饅": "mán",
    "饆": "bì",
    "饇": "yù",
    "饈": "xiū",
    "饉": "jǐn",
    "饊": "sǎn",
    "饋": "kuì",
    "饌": "zhuàn",
    "饍": "shàn",
    "饎": "xī",
    "饏": "dàn",
    "饐": "yì",
    "饑": "jī",
    "饒": "ráo",
    "饓": "chēng",
    "饔": "yōng",
    "饕": "tāo",
    "饖": "wèi",
    "饗": "xiǎng",
    "饘": "zhān",
    "饙": "fēn",
    "饚": "hài",
    "饛": "méng",
    "饜": "yàn",
    "饝": "mó",
    "饞": "chán",
    "饟": "xiǎng,náng",
    "饠": "luó",
    "饡": "zàn",
    "饢": "náng",
    "饣": "shí",
    "饤": "dìng",
    "饥": "jī",
    "饦": "tuō",
    "饧": "xíng",
    "饨": "tún",
    "饩": "xì",
    "饪": "rèn",
    "饫": "yù",
    "饬": "chì",
    "饭": "fàn",
    "饮": "yǐn",
    "饯": "jiàn",
    "饰": "shì",
    "饱": "bǎo",
    "饲": "sì",
    "饳": "duò",
    "饴": "yí",
    "饵": "ěr",
    "饶": "ráo",
    "饷": "xiǎng",
    "饸": "hé",
    "饹": "gē,le",
    "饺": "jiǎo",
    "饻": "xī",
    "饼": "bǐng",
    "饽": "bō",
    "饾": "dòu",
    "饿": "è",
    "馀": "yú",
    "馁": "něi",
    "馂": "jùn",
    "馃": "guǒ",
    "馄": "hún",
    "馅": "xiàn",
    "馆": "guǎn",
    "馇": "chā",
    "馈": "kuì",
    "馉": "gǔ",
    "馊": "sōu",
    "馋": "chán",
    "馌": "yè",
    "馍": "mó",
    "馎": "bó",
    "馏": "liù,liú",
    "馐": "xiū",
    "馑": "jǐn",
    "馒": "mán",
    "馓": "sǎn",
    "馔": "zhuàn",
    "馕": "náng,nǎng",
    "首": "shǒu",
    "馗": "kuí",
    "馘": "guó",
    "香": "xiāng",
    "馚": "fēn",
    "馛": "bó",
    "馜": "ní",
    "馝": "bì",
    "馞": "bó",
    "馟": "tú",
    "馠": "hān",
    "馡": "fēi",
    "馢": "jiān",
    "馣": "ān",
    "馤": "ài",
    "馥": "fù",
    "馦": "xiān",
    "馧": "yūn,wò",
    "馨": "xīn",
    "馩": "fén",
    "馪": "pīn",
    "馫": "xīn",
    "馬": "mǎ",
    "馭": "yù",
    "馮": "féng,píng",
    "馯": "hàn,hán",
    "馰": "dí",
    "馱": "tuó,duò",
    "馲": "tuō,zhé",
    "馳": "chí",
    "馴": "xùn",
    "馵": "zhù",
    "馶": "zhī,shì",
    "馷": "pèi",
    "馸": "xìn,jìn",
    "馹": "rì",
    "馺": "sà",
    "馻": "yǔn",
    "馼": "wén",
    "馽": "zhí",
    "馾": "dǎn,dàn",
    "馿": "lú",
    "駀": "yóu",
    "駁": "bó",
    "駂": "bǎo",
    "駃": "jué,kuài",
    "駄": "tuó,duò",
    "駅": "yì",
    "駆": "qū",
    "駇": "wén",
    "駈": "qū",
    "駉": "jiōng",
    "駊": "pǒ",
    "駋": "zhāo",
    "駌": "yuān",
    "駍": "pēng",
    "駎": "zhòu",
    "駏": "jù",
    "駐": "zhù",
    "駑": "nú",
    "駒": "jū",
    "駓": "pī",
    "駔": "zǎng",
    "駕": "jià",
    "駖": "líng",
    "駗": "zhěn",
    "駘": "tái,dài",
    "駙": "fù",
    "駚": "yǎng",
    "駛": "shǐ",
    "駜": "bì",
    "駝": "tuó",
    "駞": "tuó",
    "駟": "sì",
    "駠": "liú",
    "駡": "mà",
    "駢": "pián",
    "駣": "táo",
    "駤": "zhì",
    "駥": "róng",
    "駦": "téng",
    "駧": "dòng",
    "駨": "xún,xuān",
    "駩": "quán",
    "駪": "shēn",
    "駫": "jiōng",
    "駬": "ěr",
    "駭": "hài",
    "駮": "bó",
    "駯": "zhū",
    "駰": "yīn",
    "駱": "luò",
    "駲": "zhōu",
    "駳": "dàn",
    "駴": "hài",
    "駵": "liú",
    "駶": "jú",
    "駷": "sǒng",
    "駸": "qīn",
    "駹": "máng",
    "駺": "liáng,láng",
    "駻": "hàn",
    "駼": "tú",
    "駽": "xuān",
    "駾": "tuì",
    "駿": "jùn",
    "騀": "ě",
    "騁": "chěng",
    "騂": "xīng",
    "騃": "sì",
    "騄": "lù",
    "騅": "zhuī",
    "騆": "zhōu",
    "騇": "shè",
    "騈": "pián",
    "騉": "kūn",
    "騊": "táo",
    "騋": "lái",
    "騌": "zōng",
    "騍": "kè",
    "騎": "qí",
    "騏": "qí",
    "騐": "yàn",
    "騑": "fēi",
    "騒": "sāo",
    "験": "yàn",
    "騔": "gé",
    "騕": "yǎo",
    "騖": "wù",
    "騗": "piàn",
    "騘": "cōng",
    "騙": "piàn",
    "騚": "qián",
    "騛": "fēi",
    "騜": "huáng",
    "騝": "qián",
    "騞": "huō",
    "騟": "yú",
    "騠": "tí",
    "騡": "quán",
    "騢": "xiá",
    "騣": "zōng",
    "騤": "kuí",
    "騥": "róu",
    "騦": "sī",
    "騧": "guā",
    "騨": "tuó",
    "騩": "guī",
    "騪": "sōu",
    "騫": "qiān",
    "騬": "chéng",
    "騭": "zhì",
    "騮": "liú",
    "騯": "péng",
    "騰": "téng",
    "騱": "xí",
    "騲": "cǎo",
    "騳": "dú",
    "騴": "yàn",
    "騵": "yuán",
    "騶": "zōu",
    "騷": "sāo",
    "騸": "shàn",
    "騹": "qí",
    "騺": "zhì",
    "騻": "shuāng",
    "騼": "lù",
    "騽": "xí",
    "騾": "luó",
    "騿": "zhāng",
    "驀": "mò",
    "驁": "ào",
    "驂": "cān",
    "驃": "piào",
    "驄": "cōng",
    "驅": "qū",
    "驆": "bì",
    "驇": "zhì",
    "驈": "yù",
    "驉": "xū",
    "驊": "huá",
    "驋": "bō",
    "驌": "sù",
    "驍": "xiāo",
    "驎": "lín",
    "驏": "zhàn",
    "驐": "dūn",
    "驑": "liú",
    "驒": "tuó",
    "驓": "céng",
    "驔": "diàn",
    "驕": "jiāo",
    "驖": "tiě",
    "驗": "yàn",
    "驘": "luó",
    "驙": "zhān",
    "驚": "jīng",
    "驛": "yì",
    "驜": "yè",
    "驝": "tuó",
    "驞": "pīn",
    "驟": "zhòu",
    "驠": "yàn",
    "驡": "lóng",
    "驢": "lǘ",
    "驣": "téng",
    "驤": "xiāng",
    "驥": "jì",
    "驦": "shuāng",
    "驧": "jú",
    "驨": "xí",
    "驩": "huān",
    "驪": "lí",
    "驫": "biāo",
    "马": "mǎ",
    "驭": "yù",
    "驮": "tuó",
    "驯": "xùn",
    "驰": "chí",
    "驱": "qū",
    "驲": "rì",
    "驳": "bó",
    "驴": "lǘ",
    "驵": "zǎng",
    "驶": "shǐ",
    "驷": "sì",
    "驸": "fù",
    "驹": "jū",
    "驺": "zōu",
    "驻": "zhù",
    "驼": "tuó",
    "驽": "nú",
    "驾": "jià",
    "驿": "yì",
    "骀": "tái",
    "骁": "xiāo",
    "骂": "mà",
    "骃": "yīn",
    "骄": "jiāo",
    "骅": "huá",
    "骆": "luò",
    "骇": "hài",
    "骈": "pián",
    "骉": "biāo",
    "骊": "lí",
    "骋": "chěng",
    "验": "yàn",
    "骍": "xīng",
    "骎": "qīn",
    "骏": "jùn",
    "骐": "qí",
    "骑": "qí",
    "骒": "kè",
    "骓": "zhuī",
    "骔": "zōng",
    "骕": "sù",
    "骖": "cān",
    "骗": "piàn",
    "骘": "zhì",
    "骙": "kuí",
    "骚": "sāo,sǎo",
    "骛": "wù",
    "骜": "áo",
    "骝": "liú",
    "骞": "qiān",
    "骟": "shàn",
    "骠": "biāo,piào",
    "骡": "luó",
    "骢": "cōng",
    "骣": "chǎn",
    "骤": "zhòu",
    "骥": "jì",
    "骦": "shuāng",
    "骧": "xiāng",
    "骨": "gǔ,gū",
    "骩": "wěi",
    "骪": "wěi",
    "骫": "wěi",
    "骬": "yú",
    "骭": "gàn",
    "骮": "yì",
    "骯": "āng",
    "骰": "tóu",
    "骱": "jiè",
    "骲": "bào",
    "骳": "bèi,mó",
    "骴": "cī",
    "骵": "tǐ",
    "骶": "dǐ",
    "骷": "kū",
    "骸": "hái",
    "骹": "qiāo,xiāo",
    "骺": "hóu",
    "骻": "kuà",
    "骼": "gé",
    "骽": "tuǐ",
    "骾": "gěng",
    "骿": "pián",
    "髀": "bì",
    "髁": "kē",
    "髂": "qià",
    "髃": "yú",
    "髄": "suí",
    "髅": "lóu",
    "髆": "bó",
    "髇": "xiāo",
    "髈": "bǎng",
    "髉": "bó,jué",
    "髊": "cī",
    "髋": "kuān",
    "髌": "bìn",
    "髍": "mó",
    "髎": "liáo",
    "髏": "lóu",
    "髐": "xiāo",
    "髑": "dú",
    "髒": "zāng",
    "髓": "suǐ",
    "體": "tǐ,tī",
    "髕": "bìn",
    "髖": "kuān",
    "髗": "lú",
    "高": "gāo",
    "髙": "gāo",
    "髚": "qiào",
    "髛": "kāo",
    "髜": "qiǎo",
    "髝": "láo",
    "髞": "sào",
    "髟": "biāo",
    "髠": "kūn",
    "髡": "kūn",
    "髢": "dí",
    "髣": "fǎng",
    "髤": "xiū",
    "髥": "rán",
    "髦": "máo",
    "髧": "dàn",
    "髨": "kūn",
    "髩": "bìn",
    "髪": "fà",
    "髫": "tiáo",
    "髬": "pī",
    "髭": "zī",
    "髮": "fà",
    "髯": "rán",
    "髰": "tì",
    "髱": "bào",
    "髲": "bì,pǒ",
    "髳": "máo,méng",
    "髴": "fú",
    "髵": "ér",
    "髶": "èr",
    "髷": "qū",
    "髸": "gōng",
    "髹": "xiū",
    "髺": "kuò,yuè",
    "髻": "jì",
    "髼": "péng",
    "髽": "zhuā",
    "髾": "shāo",
    "髿": "shā",
    "鬀": "tì",
    "鬁": "lì",
    "鬂": "bìn",
    "鬃": "zōng",
    "鬄": "tì",
    "鬅": "péng",
    "鬆": "sōng",
    "鬇": "zhēng",
    "鬈": "quán",
    "鬉": "zōng",
    "鬊": "shùn",
    "鬋": "jiǎn",
    "鬌": "duǒ",
    "鬍": "hú",
    "鬎": "là",
    "鬏": "jiū",
    "鬐": "qí",
    "鬑": "lián",
    "鬒": "zhěn",
    "鬓": "bìn",
    "鬔": "péng",
    "鬕": "mà",
    "鬖": "sān",
    "鬗": "mán",
    "鬘": "mán",
    "鬙": "sēng",
    "鬚": "xū",
    "鬛": "liè",
    "鬜": "qiān",
    "鬝": "qiān",
    "鬞": "nóng",
    "鬟": "huán",
    "鬠": "kuò",
    "鬡": "níng",
    "鬢": "bìn",
    "鬣": "liè",
    "鬤": "ráng",
    "鬥": "dòu",
    "鬦": "dòu",
    "鬧": "nào",
    "鬨": "hòng",
    "鬩": "xì",
    "鬪": "dòu",
    "鬫": "kàn",
    "鬬": "dòu",
    "鬭": "dòu",
    "鬮": "jiū",
    "鬯": "chàng",
    "鬰": "yù",
    "鬱": "yù",
    "鬲": "gé,lì",
    "鬳": "yàn",
    "鬴": "fǔ",
    "鬵": "zèng",
    "鬶": "guī",
    "鬷": "zōng",
    "鬸": "liù",
    "鬹": "guī",
    "鬺": "shāng",
    "鬻": "yù",
    "鬼": "guǐ",
    "鬽": "mèi",
    "鬾": "jì",
    "鬿": "qí",
    "魀": "gà",
    "魁": "kuí",
    "魂": "hún",
    "魃": "bá",
    "魄": "pò",
    "魅": "mèi",
    "魆": "xū",
    "魇": "yǎn",
    "魈": "xiāo",
    "魉": "liǎng",
    "魊": "yù",
    "魋": "tuí",
    "魌": "qī",
    "魍": "wǎng",
    "魎": "liǎng",
    "魏": "wèi",
    "魐": "gān",
    "魑": "chī",
    "魒": "piāo",
    "魓": "bì",
    "魔": "mó",
    "魕": "jī",
    "魖": "xū",
    "魗": "chǒu",
    "魘": "yǎn",
    "魙": "zhān",
    "魚": "yú",
    "魛": "dāo",
    "魜": "rén",
    "魝": "jì",
    "魞": "bā,bà",
    "魟": "hóng",
    "魠": "tuō",
    "魡": "diào",
    "魢": "jǐ",
    "魣": "yú",
    "魤": "é",
    "魥": "jì",
    "魦": "shā",
    "魧": "háng",
    "魨": "tún",
    "魩": "mò",
    "魪": "jiè",
    "魫": "shěn",
    "魬": "bǎn",
    "魭": "yuán",
    "魮": "pí",
    "魯": "lǔ",
    "魰": "wén",
    "魱": "hú",
    "魲": "lú",
    "魳": "zā",
    "魴": "fáng",
    "魵": "fén",
    "魶": "nà",
    "魷": "yóu",
    "魸": "piàn",
    "魹": "mó",
    "魺": "hé",
    "魻": "xiá",
    "魼": "qū",
    "魽": "hān",
    "魾": "pī",
    "魿": "líng",
    "鮀": "tuó",
    "鮁": "bà",
    "鮂": "qiú",
    "鮃": "píng",
    "鮄": "fú",
    "鮅": "bì",
    "鮆": "cǐ,jì",
    "鮇": "wèi",
    "鮈": "jū",
    "鮉": "diāo",
    "鮊": "bó,bà",
    "鮋": "yóu",
    "鮌": "gǔn",
    "鮍": "pí",
    "鮎": "nián",
    "鮏": "xīng",
    "鮐": "tái",
    "鮑": "bào",
    "鮒": "fù",
    "鮓": "zhǎ,zhà",
    "鮔": "jù",
    "鮕": "gū",
    "鮖": "shí",
    "鮗": "dōng",
    "鮘": "chou,dài",
    "鮙": "tǎ",
    "鮚": "jié",
    "鮛": "shū",
    "鮜": "hòu",
    "鮝": "xiǎng",
    "鮞": "ér",
    "鮟": "ān",
    "鮠": "wéi",
    "鮡": "zhào",
    "鮢": "zhū",
    "鮣": "yìn",
    "鮤": "liè",
    "鮥": "luò,gé",
    "鮦": "tóng",
    "鮧": "yí",
    "鮨": "yì",
    "鮩": "bìng",
    "鮪": "wěi",
    "鮫": "jiāo",
    "鮬": "kū",
    "鮭": "guī,xié",
    "鮮": "xiān,xiǎn",
    "鮯": "gé",
    "鮰": "huí",
    "鮱": "lǎo",
    "鮲": "fú",
    "鮳": "kào",
    "鮴": "xiū",
    "鮵": "tuō",
    "鮶": "jūn",
    "鮷": "tí",
    "鮸": "miǎn",
    "鮹": "shāo",
    "鮺": "zhǎ",
    "鮻": "suō",
    "鮼": "qīn",
    "鮽": "yú",
    "鮾": "něi",
    "鮿": "zhé",
    "鯀": "gǔn",
    "鯁": "gěng",
    "鯂": "sū",
    "鯃": "wú",
    "鯄": "qiú",
    "鯅": "shān",
    "鯆": "pū,bū",
    "鯇": "huàn",
    "鯈": "tiáo",
    "鯉": "lǐ",
    "鯊": "shā",
    "鯋": "shā",
    "鯌": "kào",
    "鯍": "méng",
    "鯎": "chéng",
    "鯏": "lí",
    "鯐": "zǒu",
    "鯑": "xī",
    "鯒": "yǒng",
    "鯓": "shēn",
    "鯔": "zī",
    "鯕": "qí",
    "鯖": "qīng",
    "鯗": "xiǎng",
    "鯘": "něi",
    "鯙": "chún",
    "鯚": "jì",
    "鯛": "diāo",
    "鯜": "qiè",
    "鯝": "gù",
    "鯞": "zhǒu",
    "鯟": "dōng",
    "鯠": "lái",
    "鯡": "fēi",
    "鯢": "ní",
    "鯣": "yì,sī",
    "鯤": "kūn",
    "鯥": "lù",
    "鯦": "jiù",
    "鯧": "chāng",
    "鯨": "jīng",
    "鯩": "lún",
    "鯪": "líng",
    "鯫": "zōu",
    "鯬": "lí",
    "鯭": "měng",
    "鯮": "zōng",
    "鯯": "zhì",
    "鯰": "nián",
    "鯱": "hǔ",
    "鯲": "yú",
    "鯳": "dǐ",
    "鯴": "shī",
    "鯵": "shēn",
    "鯶": "huàn",
    "鯷": "tí",
    "鯸": "hóu",
    "鯹": "xīng",
    "鯺": "zhū",
    "鯻": "là",
    "鯼": "zōng",
    "鯽": "jì",
    "鯾": "biān",
    "鯿": "biān",
    "鰀": "huàn",
    "鰁": "quán",
    "鰂": "zéi",
    "鰃": "wēi",
    "鰄": "wēi",
    "鰅": "yú",
    "鰆": "chūn",
    "鰇": "róu",
    "鰈": "dié",
    "鰉": "huáng",
    "鰊": "liàn",
    "鰋": "yǎn",
    "鰌": "qiū",
    "鰍": "qiū",
    "鰎": "jiǎn",
    "鰏": "bī",
    "鰐": "è",
    "鰑": "yáng",
    "鰒": "fù",
    "鰓": "sāi,xǐ",
    "鰔": "jiān",
    "鰕": "xiā",
    "鰖": "tuǒ",
    "鰗": "hú",
    "鰘": "shì",
    "鰙": "ruò",
    "鰚": "xuān",
    "鰛": "wēn",
    "鰜": "jiān",
    "鰝": "hào",
    "鰞": "wū",
    "鰟": "páng",
    "鰠": "sāo",
    "鰡": "liú",
    "鰢": "mǎ",
    "鰣": "shí",
    "鰤": "shī",
    "鰥": "guān",
    "鰦": "zī",
    "鰧": "téng",
    "鰨": "tǎ",
    "鰩": "yáo",
    "鰪": "è",
    "鰫": "yóng",
    "鰬": "qián",
    "鰭": "qí",
    "鰮": "wēn",
    "鰯": "ruò",
    "鰰": "shén",
    "鰱": "lián",
    "鰲": "áo",
    "鰳": "lè",
    "鰴": "huī",
    "鰵": "mǐn",
    "鰶": "jì",
    "鰷": "tiáo",
    "鰸": "qū",
    "鰹": "jiān",
    "鰺": "shēn",
    "鰻": "mán",
    "鰼": "xí",
    "鰽": "qiú",
    "鰾": "piào",
    "鰿": "jì",
    "鱀": "jì",
    "鱁": "zhú",
    "鱂": "jiāng",
    "鱃": "xiū",
    "鱄": "zhuān",
    "鱅": "yōng",
    "鱆": "zhāng",
    "鱇": "kāng",
    "鱈": "xuě",
    "鱉": "biē",
    "鱊": "yù",
    "鱋": "qū",
    "鱌": "xiàng",
    "鱍": "bō",
    "鱎": "jiǎo",
    "鱏": "xún",
    "鱐": "sù",
    "鱑": "huáng",
    "鱒": "zūn",
    "鱓": "shàn",
    "鱔": "shàn",
    "鱕": "fān",
    "鱖": "guì",
    "鱗": "lín",
    "鱘": "xún",
    "鱙": "yáo",
    "鱚": "xǐ",
    "鱛": "zēng",
    "鱜": "xiāng",
    "鱝": "fèn",
    "鱞": "guān",
    "鱟": "hòu",
    "鱠": "kuài",
    "鱡": "zéi",
    "鱢": "sāo",
    "鱣": "zhān",
    "鱤": "gǎn",
    "鱥": "guì",
    "鱦": "yìng",
    "鱧": "lǐ",
    "鱨": "cháng",
    "鱩": "léi",
    "鱪": "shǔ",
    "鱫": "ài",
    "鱬": "rú",
    "鱭": "jì",
    "鱮": "xù",
    "鱯": "hù",
    "鱰": "shǔ",
    "鱱": "lǐ",
    "鱲": "liè",
    "鱳": "lè",
    "鱴": "miè",
    "鱵": "zhēn",
    "鱶": "xiǎng",
    "鱷": "è",
    "鱸": "lú",
    "鱹": "guàn",
    "鱺": "lí",
    "鱻": "xiān",
    "鱼": "yú",
    "鱽": "dāo",
    "鱾": "jǐ",
    "鱿": "yóu",
    "鲀": "tún",
    "鲁": "lǔ",
    "鲂": "fáng",
    "鲃": "bā,bà",
    "鲄": "hé,gě",
    "鲅": "bà",
    "鲆": "píng",
    "鲇": "nián",
    "鲈": "lú",
    "鲉": "yóu",
    "鲊": "zhǎ,zhà",
    "鲋": "fù",
    "鲌": "bó,bà",
    "鲍": "bào",
    "鲎": "hòu",
    "鲏": "pí",
    "鲐": "tái",
    "鲑": "guī,xié",
    "鲒": "jié",
    "鲓": "kào",
    "鲔": "wěi",
    "鲕": "ér",
    "鲖": "tóng",
    "鲗": "zéi",
    "鲘": "hòu",
    "鲙": "kuài",
    "鲚": "jì",
    "鲛": "jiāo",
    "鲜": "xiān,xiǎn",
    "鲝": "zhǎ",
    "鲞": "xiǎng",
    "鲟": "xún",
    "鲠": "gěng",
    "鲡": "lí",
    "鲢": "lián",
    "鲣": "jiān",
    "鲤": "lǐ",
    "鲥": "shí",
    "鲦": "tiáo",
    "鲧": "gǔn",
    "鲨": "shā",
    "鲩": "huàn",
    "鲪": "jūn",
    "鲫": "jì",
    "鲬": "yǒng",
    "鲭": "qīng",
    "鲮": "líng",
    "鲯": "qí",
    "鲰": "zōu",
    "鲱": "fēi",
    "鲲": "kūn",
    "鲳": "chāng",
    "鲴": "gù",
    "鲵": "ní",
    "鲶": "nián",
    "鲷": "diāo",
    "鲸": "jīng",
    "鲹": "shēn",
    "鲺": "shī",
    "鲻": "zī",
    "鲼": "fèn",
    "鲽": "dié",
    "鲾": "bī",
    "鲿": "cháng",
    "鳀": "tí",
    "鳁": "wēn",
    "鳂": "wēi",
    "鳃": "sāi,xǐ",
    "鳄": "è",
    "鳅": "qiū",
    "鳆": "fù",
    "鳇": "huáng",
    "鳈": "quán",
    "鳉": "jiāng",
    "鳊": "biān",
    "鳋": "sāo",
    "鳌": "áo",
    "鳍": "qí",
    "鳎": "tǎ",
    "鳏": "guān",
    "鳐": "yáo",
    "鳑": "páng",
    "鳒": "jiān",
    "鳓": "lè",
    "鳔": "biào",
    "鳕": "xuě",
    "鳖": "biē",
    "鳗": "mán",
    "鳘": "mǐn",
    "鳙": "yōng",
    "鳚": "wèi",
    "鳛": "xí",
    "鳜": "guì,jué",
    "鳝": "shàn",
    "鳞": "lín",
    "鳟": "zūn",
    "鳠": "hù",
    "鳡": "gǎn",
    "鳢": "lǐ",
    "鳣": "zhān,shàn",
    "鳤": "guǎn",
    "鳥": "niǎo,diǎo",
    "鳦": "yǐ",
    "鳧": "fú",
    "鳨": "lì",
    "鳩": "jiū",
    "鳪": "bú",
    "鳫": "yàn",
    "鳬": "fú",
    "鳭": "diāo,zhāo",
    "鳮": "jī",
    "鳯": "fèng",
    "鳰": "rù",
    "鳱": "gān,hàn,yàn",
    "鳲": "shī",
    "鳳": "fèng",
    "鳴": "míng",
    "鳵": "bǎo",
    "鳶": "yuān",
    "鳷": "zhī",
    "鳸": "hù",
    "鳹": "qín",
    "鳺": "fū,guī",
    "鳻": "bān,fén",
    "鳼": "wén",
    "鳽": "jiān,qiān,zhān",
    "鳾": "shī",
    "鳿": "yù",
    "鴀": "fǒu",
    "鴁": "yāo",
    "鴂": "jué",
    "鴃": "jué",
    "鴄": "pǐ",
    "鴅": "huān",
    "鴆": "zhèn",
    "鴇": "bǎo",
    "鴈": "yàn",
    "鴉": "yā",
    "鴊": "zhèng",
    "鴋": "fāng",
    "鴌": "fèng",
    "鴍": "wén",
    "鴎": "ōu",
    "鴏": "dài",
    "鴐": "jiā",
    "鴑": "rú",
    "鴒": "líng",
    "鴓": "miè",
    "鴔": "fú",
    "鴕": "tuó",
    "鴖": "mín",
    "鴗": "lì",
    "鴘": "biǎn",
    "鴙": "zhì",
    "鴚": "gē",
    "鴛": "yuān",
    "鴜": "cí",
    "鴝": "qú",
    "鴞": "xiāo",
    "鴟": "chī",
    "鴠": "dàn",
    "鴡": "jū",
    "鴢": "yāo",
    "鴣": "gū",
    "鴤": "zhōng",
    "鴥": "yù",
    "鴦": "yāng",
    "鴧": "yù",
    "鴨": "yā",
    "鴩": "dié",
    "鴪": "yù",
    "鴫": "tián",
    "鴬": "yīng",
    "鴭": "duī",
    "鴮": "wū",
    "鴯": "ér",
    "鴰": "guā",
    "鴱": "ài",
    "鴲": "zhī",
    "鴳": "yàn",
    "鴴": "héng",
    "鴵": "xiāo",
    "鴶": "jiá",
    "鴷": "liè",
    "鴸": "zhū",
    "鴹": "yáng",
    "鴺": "yí",
    "鴻": "hóng",
    "鴼": "lù",
    "鴽": "rú",
    "鴾": "móu",
    "鴿": "gē",
    "鵀": "rén",
    "鵁": "jiāo",
    "鵂": "xiū",
    "鵃": "zhōu",
    "鵄": "chī",
    "鵅": "luò",
    "鵆": "héng",
    "鵇": "nián",
    "鵈": "ě",
    "鵉": "luán",
    "鵊": "jiá",
    "鵋": "jì",
    "鵌": "tú",
    "鵍": "huān",
    "鵎": "tuǒ",
    "鵏": "bū",
    "鵐": "wú",
    "鵑": "jiān",
    "鵒": "yù",
    "鵓": "bó",
    "鵔": "jùn",
    "鵕": "jùn",
    "鵖": "bī",
    "鵗": "xī",
    "鵘": "jùn",
    "鵙": "jú",
    "鵚": "tū",
    "鵛": "jìng",
    "鵜": "tí",
    "鵝": "é",
    "鵞": "é",
    "鵟": "kuáng",
    "鵠": "hú",
    "鵡": "wǔ",
    "鵢": "shēn",
    "鵣": "lài",
    "鵤": "zān",
    "鵥": "pàn",
    "鵦": "lù",
    "鵧": "pí",
    "鵨": "shū",
    "鵩": "fú",
    "鵪": "ān",
    "鵫": "zhuó",
    "鵬": "péng",
    "鵭": "qín",
    "鵮": "qiān",
    "鵯": "bēi",
    "鵰": "diāo",
    "鵱": "lù",
    "鵲": "què",
    "鵳": "jiān",
    "鵴": "jú",
    "鵵": "tù",
    "鵶": "yā",
    "鵷": "yuān",
    "鵸": "qí",
    "鵹": "lí",
    "鵺": "yè",
    "鵻": "zhuī",
    "鵼": "kōng",
    "鵽": "duò",
    "鵾": "kūn",
    "鵿": "shēng",
    "鶀": "qí",
    "鶁": "jīng",
    "鶂": "yì",
    "鶃": "yì",
    "鶄": "jīng",
    "鶅": "zī",
    "鶆": "lái",
    "鶇": "dōng",
    "鶈": "qī",
    "鶉": "chún",
    "鶊": "gēng",
    "鶋": "jū",
    "鶌": "qū",
    "鶍": "yì",
    "鶎": "zūn",
    "鶏": "jī",
    "鶐": "shù",
    "鶑": "yīng",
    "鶒": "chì",
    "鶓": "miáo",
    "鶔": "róu",
    "鶕": "ān",
    "鶖": "qiū",
    "鶗": "tí,chí",
    "鶘": "hú",
    "鶙": "tí,chí",
    "鶚": "è",
    "鶛": "jiē",
    "鶜": "máo",
    "鶝": "fú,bì",
    "鶞": "chūn",
    "鶟": "tú",
    "鶠": "yǎn",
    "鶡": "hé,jiè",
    "鶢": "yuán",
    "鶣": "piān,biǎn",
    "鶤": "kūn",
    "鶥": "méi",
    "鶦": "hú",
    "鶧": "yīng",
    "鶨": "chuàn,zhì",
    "鶩": "wù",
    "鶪": "jú",
    "鶫": "dōng",
    "鶬": "cāng,qiāng",
    "鶭": "fǎng",
    "鶮": "hè,hú",
    "鶯": "yīng",
    "鶰": "yuán",
    "鶱": "xiān",
    "鶲": "wēng",
    "鶳": "shī",
    "鶴": "hè",
    "鶵": "chú",
    "鶶": "táng",
    "鶷": "xiá",
    "鶸": "ruò",
    "鶹": "liú",
    "鶺": "jī",
    "鶻": "gǔ,hú",
    "鶼": "jiān",
    "鶽": "sǔn,xùn",
    "鶾": "hàn",
    "鶿": "cí",
    "鷀": "cí",
    "鷁": "yì",
    "鷂": "yào",
    "鷃": "yàn",
    "鷄": "jī",
    "鷅": "lì",
    "鷆": "tián",
    "鷇": "kòu",
    "鷈": "tī",
    "鷉": "tī",
    "鷊": "yì",
    "鷋": "tú",
    "鷌": "mǎ",
    "鷍": "xiāo",
    "鷎": "gāo",
    "鷏": "tián",
    "鷐": "chén",
    "鷑": "jì",
    "鷒": "tuán",
    "鷓": "zhè",
    "鷔": "áo",
    "鷕": "yǎo",
    "鷖": "yī",
    "鷗": "ōu",
    "鷘": "chì",
    "鷙": "zhì",
    "鷚": "liù",
    "鷛": "yōng",
    "鷜": "lóu,lǚ",
    "鷝": "bì",
    "鷞": "shuāng",
    "鷟": "zhuó",
    "鷠": "yú",
    "鷡": "wú",
    "鷢": "jué",
    "鷣": "yín",
    "鷤": "tí",
    "鷥": "sī",
    "鷦": "jiāo",
    "鷧": "yì",
    "鷨": "huá",
    "鷩": "bì",
    "鷪": "yīng",
    "鷫": "sù",
    "鷬": "huáng",
    "鷭": "fán",
    "鷮": "jiāo",
    "鷯": "liáo",
    "鷰": "yàn",
    "鷱": "gāo",
    "鷲": "jiù",
    "鷳": "xián",
    "鷴": "xián",
    "鷵": "tú",
    "鷶": "mǎi",
    "鷷": "zūn",
    "鷸": "yù",
    "鷹": "yīng",
    "鷺": "lù",
    "鷻": "tuán",
    "鷼": "xián",
    "鷽": "xué",
    "鷾": "yì",
    "鷿": "pì",
    "鸀": "zhǔ",
    "鸁": "luó",
    "鸂": "xī",
    "鸃": "yì",
    "鸄": "jī",
    "鸅": "zé",
    "鸆": "yú",
    "鸇": "zhān",
    "鸈": "yè",
    "鸉": "yáng",
    "鸊": "pì",
    "鸋": "níng",
    "鸌": "hù",
    "鸍": "mí",
    "鸎": "yīng",
    "鸏": "méng",
    "鸐": "dí",
    "鸑": "yuè",
    "鸒": "yù",
    "鸓": "lěi",
    "鸔": "bǔ",
    "鸕": "lú",
    "鸖": "hè",
    "鸗": "lóng",
    "鸘": "shuāng",
    "鸙": "yuè",
    "鸚": "yīng",
    "鸛": "guàn",
    "鸜": "qú",
    "鸝": "lí",
    "鸞": "luán",
    "鸟": "niǎo",
    "鸠": "jiū",
    "鸡": "jī",
    "鸢": "yuān",
    "鸣": "míng",
    "鸤": "shī",
    "鸥": "ōu",
    "鸦": "yā",
    "鸧": "cāng",
    "鸨": "bǎo",
    "鸩": "zhèn",
    "鸪": "gū",
    "鸫": "dōng",
    "鸬": "lú",
    "鸭": "yā",
    "鸮": "xiāo",
    "鸯": "yāng",
    "鸰": "líng",
    "鸱": "chī",
    "鸲": "qú",
    "鸳": "yuān",
    "鸴": "xué",
    "鸵": "tuó",
    "鸶": "sī",
    "鸷": "zhì",
    "鸸": "ér",
    "鸹": "guā",
    "鸺": "xiū",
    "鸻": "héng",
    "鸼": "zhōu",
    "鸽": "gē",
    "鸾": "luán",
    "鸿": "hóng",
    "鹀": "wú",
    "鹁": "bó",
    "鹂": "lí",
    "鹃": "juān",
    "鹄": "hú",
    "鹅": "é",
    "鹆": "yù",
    "鹇": "xián",
    "鹈": "tí",
    "鹉": "wǔ",
    "鹊": "què",
    "鹋": "miáo",
    "鹌": "ān",
    "鹍": "kūn",
    "鹎": "bēi",
    "鹏": "péng",
    "鹐": "qiān",
    "鹑": "chún",
    "鹒": "gēng",
    "鹓": "yuān",
    "鹔": "sù",
    "鹕": "hú",
    "鹖": "hé",
    "鹗": "è",
    "鹘": "gǔ",
    "鹙": "qiū",
    "鹚": "cí",
    "鹛": "méi",
    "鹜": "wù",
    "鹝": "yì",
    "鹞": "yào",
    "鹟": "wēng",
    "鹠": "liú",
    "鹡": "jī",
    "鹢": "yì",
    "鹣": "jiān",
    "鹤": "hè",
    "鹥": "yī",
    "鹦": "yīng",
    "鹧": "zhè",
    "鹨": "liù",
    "鹩": "liáo",
    "鹪": "jiāo",
    "鹫": "jiù",
    "鹬": "yù",
    "鹭": "lù",
    "鹮": "huán",
    "鹯": "zhān",
    "鹰": "yīng",
    "鹱": "hù",
    "鹲": "méng",
    "鹳": "guàn",
    "鹴": "shuāng",
    "鹵": "lǔ",
    "鹶": "jīn",
    "鹷": "líng",
    "鹸": "jiǎn",
    "鹹": "xián",
    "鹺": "cuó",
    "鹻": "jiǎn",
    "鹼": "jiǎn",
    "鹽": "yán",
    "鹾": "cuó",
    "鹿": "lù",
    "麀": "yōu",
    "麁": "cū",
    "麂": "jǐ",
    "麃": "páo,biāo",
    "麄": "cū",
    "麅": "páo",
    "麆": "zhù,cū",
    "麇": "jūn,qún",
    "麈": "zhǔ",
    "麉": "jiān",
    "麊": "mí",
    "麋": "mí",
    "麌": "yǔ",
    "麍": "liú",
    "麎": "chén",
    "麏": "jūn",
    "麐": "lín",
    "麑": "ní",
    "麒": "qí",
    "麓": "lù",
    "麔": "jiù",
    "麕": "jūn",
    "麖": "jīng",
    "麗": "lì,lí",
    "麘": "xiāng",
    "麙": "xián",
    "麚": "jiā",
    "麛": "mí",
    "麜": "lì",
    "麝": "shè",
    "麞": "zhāng",
    "麟": "lín",
    "麠": "jīng",
    "麡": "qí",
    "麢": "líng",
    "麣": "yán",
    "麤": "cū",
    "麥": "mài",
    "麦": "mài",
    "麧": "hé",
    "麨": "chǎo",
    "麩": "fū",
    "麪": "miàn",
    "麫": "miàn",
    "麬": "fū",
    "麭": "pào",
    "麮": "qù",
    "麯": "qū",
    "麰": "móu",
    "麱": "fū",
    "麲": "xiàn",
    "麳": "lái",
    "麴": "qū",
    "麵": "miàn",
    "麶": "chi",
    "麷": "fēng",
    "麸": "fū",
    "麹": "qū",
    "麺": "miàn",
    "麻": "má",
    "麼": "me,mó",
    "麽": "me,mó",
    "麾": "huī",
    "麿": "mí",
    "黀": "zōu",
    "黁": "nún",
    "黂": "fén",
    "黃": "huáng",
    "黄": "huáng",
    "黅": "jīn",
    "黆": "guāng",
    "黇": "tiān",
    "黈": "tǒu",
    "黉": "hóng",
    "黊": "huà",
    "黋": "kuàng",
    "黌": "hóng",
    "黍": "shǔ",
    "黎": "lí",
    "黏": "nián",
    "黐": "chī",
    "黑": "hēi",
    "黒": "hēi",
    "黓": "yì",
    "黔": "qián",
    "黕": "dǎn",
    "黖": "xì",
    "黗": "tún",
    "默": "mò",
    "黙": "mò",
    "黚": "qián",
    "黛": "dài",
    "黜": "chù",
    "黝": "yǒu",
    "點": "diǎn",
    "黟": "yī",
    "黠": "xiá",
    "黡": "yǎn",
    "黢": "qū",
    "黣": "měi",
    "黤": "yǎn",
    "黥": "qíng",
    "黦": "yuè",
    "黧": "lí",
    "黨": "dǎng",
    "黩": "dú",
    "黪": "cǎn",
    "黫": "yān",
    "黬": "yǎn",
    "黭": "yǎn",
    "黮": "dàn,shèn",
    "黯": "àn",
    "黰": "zhěn,yān",
    "黱": "dài",
    "黲": "cǎn",
    "黳": "yī",
    "黴": "méi",
    "黵": "dǎn,zhǎn",
    "黶": "yǎn",
    "黷": "dú",
    "黸": "lú",
    "黹": "zhǐ",
    "黺": "fěn",
    "黻": "fú",
    "黼": "fǔ",
    "黽": "mǐn,miǎn,měng",
    "黾": "mǐn,miǎn,měng",
    "黿": "yuán",
    "鼀": "cù",
    "鼁": "qù",
    "鼂": "cháo",
    "鼃": "wā",
    "鼄": "zhū",
    "鼅": "zhī",
    "鼆": "měng",
    "鼇": "áo",
    "鼈": "biē",
    "鼉": "tuó",
    "鼊": "bì",
    "鼋": "yuán",
    "鼌": "cháo",
    "鼍": "tuó",
    "鼎": "dǐng",
    "鼏": "mì",
    "鼐": "nài",
    "鼑": "dǐng",
    "鼒": "zī",
    "鼓": "gǔ",
    "鼔": "gǔ",
    "鼕": "dōng",
    "鼖": "fén",
    "鼗": "táo",
    "鼘": "yuān",
    "鼙": "pí",
    "鼚": "chāng",
    "鼛": "gāo",
    "鼜": "cào",
    "鼝": "yuān",
    "鼞": "tāng",
    "鼟": "tēng",
    "鼠": "shǔ",
    "鼡": "shǔ",
    "鼢": "fén",
    "鼣": "fèi",
    "鼤": "wén",
    "鼥": "bá",
    "鼦": "diāo",
    "鼧": "tuó",
    "鼨": "zhōng",
    "鼩": "qú",
    "鼪": "shēng",
    "鼫": "shí",
    "鼬": "yòu",
    "鼭": "shí",
    "鼮": "tíng",
    "鼯": "wú",
    "鼰": "jú",
    "鼱": "jīng",
    "鼲": "hún",
    "鼳": "jú",
    "鼴": "yǎn",
    "鼵": "tū",
    "鼶": "sī",
    "鼷": "xī",
    "鼸": "xiàn",
    "鼹": "yǎn",
    "鼺": "léi",
    "鼻": "bí",
    "鼼": "yào",
    "鼽": "qiú",
    "鼾": "hān",
    "鼿": "wù",
    "齀": "wù",
    "齁": "hōu",
    "齂": "xiè",
    "齃": "è",
    "齄": "zhā",
    "齅": "xiù",
    "齆": "wèng",
    "齇": "zhā",
    "齈": "nòng",
    "齉": "nàng",
    "齊": "qí",
    "齋": "zhāi",
    "齌": "jì",
    "齍": "zī",
    "齎": "jí",
    "齏": "jī",
    "齐": "qí",
    "齑": "jī",
    "齒": "chǐ",
    "齓": "chèn",
    "齔": "chèn",
    "齕": "hé",
    "齖": "yá",
    "齗": "yīn",
    "齘": "xiè",
    "齙": "bāo",
    "齚": "zé",
    "齛": "xiè",
    "齜": "zī",
    "齝": "chī",
    "齞": "yàn",
    "齟": "jǔ",
    "齠": "tiáo",
    "齡": "líng",
    "齢": "líng",
    "齣": "chū",
    "齤": "quán",
    "齥": "xiè",
    "齦": "yín",
    "齧": "niè",
    "齨": "jiù",
    "齩": "yǎo",
    "齪": "chuò",
    "齫": "yǔn",
    "齬": "yǔ",
    "齭": "chǔ",
    "齮": "yǐ",
    "齯": "ní",
    "齰": "zé",
    "齱": "zōu",
    "齲": "qǔ",
    "齳": "yǔn",
    "齴": "yǎn",
    "齵": "yú",
    "齶": "è",
    "齷": "wò",
    "齸": "yì",
    "齹": "cī",
    "齺": "zōu",
    "齻": "diān",
    "齼": "chǔ",
    "齽": "jìn",
    "齾": "yà",
    "齿": "chǐ",
    "龀": "chèn",
    "龁": "hé",
    "龂": "yín,kěn",
    "龃": "jǔ",
    "龄": "líng",
    "龅": "bāo",
    "龆": "tiáo",
    "龇": "zī",
    "龈": "yín,kěn",
    "龉": "yǔ",
    "龊": "chuò",
    "龋": "qǔ",
    "龌": "wò",
    "龍": "lóng,lǒng",
    "龎": "páng",
    "龏": "gōng,wò",
    "龐": "páng",
    "龑": "yǎn",
    "龒": "lóng",
    "龓": "lóng,lǒng",
    "龔": "gōng",
    "龕": "kān",
    "龖": "dá",
    "龗": "líng",
    "龘": "dá",
    "龙": "lóng",
    "龚": "gōng",
    "龛": "kān",
    "龜": "guī,jūn,qiū",
    "龝": "qiū",
    "龞": "biē",
    "龟": "guī,jūn,qiū",
    "龠": "yuè",
    "龡": "chuī",
    "龢": "hé",
    "龣": "jiǎo",
    "龤": "xié",
    "龥": "yuè"
};